const rd = `@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scale-z:1;--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-pan-x:initial;--tw-pan-y:initial;--tw-pinch-zoom:initial;--tw-space-y-reverse:0;--tw-space-x-reverse:0;--tw-divide-x-reverse:0;--tw-border-style:solid;--tw-divide-y-reverse:0;--tw-gradient-position:initial;--tw-gradient-from:#0000;--tw-gradient-via:#0000;--tw-gradient-to:#0000;--tw-gradient-stops:initial;--tw-gradient-via-stops:initial;--tw-gradient-from-position:0%;--tw-gradient-via-position:50%;--tw-gradient-to-position:100%;--tw-leading:initial;--tw-font-weight:initial;--tw-tracking:initial;--tw-ordinal:initial;--tw-slashed-zero:initial;--tw-numeric-figure:initial;--tw-numeric-spacing:initial;--tw-numeric-fraction:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid;--tw-blur:initial;--tw-brightness:initial;--tw-contrast:initial;--tw-grayscale:initial;--tw-hue-rotate:initial;--tw-invert:initial;--tw-opacity:initial;--tw-saturate:initial;--tw-sepia:initial;--tw-drop-shadow:initial;--tw-drop-shadow-color:initial;--tw-drop-shadow-alpha:100%;--tw-drop-shadow-size:initial;--tw-backdrop-blur:initial;--tw-backdrop-brightness:initial;--tw-backdrop-contrast:initial;--tw-backdrop-grayscale:initial;--tw-backdrop-hue-rotate:initial;--tw-backdrop-invert:initial;--tw-backdrop-opacity:initial;--tw-backdrop-saturate:initial;--tw-backdrop-sepia:initial;--tw-duration:initial;--tw-ease:initial;--tw-content:""}}}@layer theme{:root,:host{--font-sans:"Chivo",ui-sans-serif,system-ui,sans-serif;--font-mono:"Chivo Mono",ui-monospace,"SF Mono",monospace;--color-red-50:oklch(97.1% .013 17.38);--color-red-500:oklch(63.7% .237 25.331);--color-red-600:oklch(57.7% .245 27.325);--color-red-700:oklch(50.5% .213 27.518);--color-orange-700:oklch(74.65% .167 63.99);--color-orange-800:oklch(78.85% .164 66.55);--color-orange-900:oklch(82.07% .141 70.35);--color-yellow-500:oklch(79.5% .184 86.047);--color-yellow-600:oklch(68.1% .162 75.834);--color-green-50:oklch(98.2% .018 155.826);--color-green-500:oklch(72.3% .219 149.579);--color-green-600:oklch(62.7% .194 149.214);--color-blue-400:oklch(70.7% .165 254.624);--color-blue-500:oklch(62.3% .214 259.815);--color-blue-600:oklch(54.6% .245 262.881);--color-purple-500:oklch(85.95% .072 284.79);--color-purple-600:oklch(80.78% .095 284.73);--color-gray-500:oklch(55.1% .027 264.364);--color-gray-600:oklch(44.6% .03 256.802);--color-neutral-100:oklch(97% 0 0);--color-black:#000;--color-white:#fff;--spacing:.25rem;--container-xs:20rem;--container-sm:24rem;--container-md:28rem;--container-lg:32rem;--container-2xl:42rem;--container-3xl:48rem;--container-4xl:56rem;--container-6xl:72rem;--container-7xl:80rem;--text-xs:.75rem;--text-xs--line-height:calc(1/.75);--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--text-base:1rem;--text-base--line-height: 1.5 ;--text-lg:1.125rem;--text-lg--line-height:calc(1.75/1.125);--text-xl:1.25rem;--text-xl--line-height:calc(1.75/1.25);--text-2xl:1.5rem;--text-2xl--line-height:calc(2/1.5);--text-3xl:1.875rem;--text-3xl--line-height: 1.2 ;--text-4xl:2.25rem;--text-4xl--line-height:calc(2.5/2.25);--text-5xl:3rem;--text-5xl--line-height:1;--font-weight-light:300;--font-weight-normal:400;--font-weight-medium:500;--font-weight-semibold:600;--font-weight-bold:700;--font-weight-black:900;--tracking-wide:.025em;--leading-tight:1.25;--leading-snug:1.375;--leading-normal:1.5;--leading-relaxed:1.625;--radius-sm:.25rem;--radius-lg:.5rem;--radius-xl:.75rem;--radius-2xl:1rem;--radius-3xl:1.5rem;--ease-in:cubic-bezier(.4,0,1,1);--ease-out:cubic-bezier(0,0,.2,1);--ease-in-out:cubic-bezier(.4,0,.2,1);--animate-spin:spin 1s linear infinite;--animate-pulse:pulse 2s cubic-bezier(.4,0,.6,1)infinite;--blur-sm:8px;--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4,0,.2,1);--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono);--text-2xs:.625rem;--font-header:"Mona Sans",ui-sans-serif,system-ui,sans-serif;--color-brown-50:oklch(98.23% .003 84.56);--color-brown-100:oklch(95.88% .005 78.3);--color-brown-200:oklch(90.71% .016 58.62);--color-brown-600:oklch(58.96% .054 55.49);--color-brown-700:oklch(50.12% .052 55.33);--color-brown-800:oklch(41.02% .05 54.08);--color-brown-900:oklch(31.29% .048 53.3);--color-brown-975:oklch(23.21% .035 45.9);--color-brown-990:oklch(19% .029 38.11);--color-foreground:var(--color-brown-975);--color-foreground-secondary:var(--color-brown-700);--color-foreground-tertiary:var(--color-brown-800);--color-foreground-quaternary:var(--color-brown-50);--color-border-soft:oklch(89.44% .004 91.45);--color-border-hard:var(--color-brown-600);--color-border-softer:oklch(92.71% .004 106.48);--color-border:var(--color-border-soft);--color-background:var(--color-brown-50);--color-background-low:var(--color-brown-100);--color-background-brown:var(--color-brown-900);--color-background-product:oklch(95.48% .005 95.1);--color-alpha-soft:oklch(31.29% .048 53.3/.02);--color-alpha-mid:oklch(31.29% .048 53.3/.03);--color-alpha-hard:oklch(31.29% .048 53.3/.06);--color-alpha-intense:oklch(31.29% .048 53.3/.12);--color-ring:#2b180f4d}@supports (color:color-mix(in lab,red,red)){:root,:host{--color-ring:color-mix(in oklab,var(--color-foreground)30%,transparent)}}:root,:host{--color-accent-orange:var(--color-orange-800);--color-accent-purple:var(--color-purple-600);--color-accent-secondary-orange:var(--color-orange-900);--color-accent-secondary-purple:var(--color-purple-500);--color-accent:var(--color-accent-orange);--color-accent-secondary:var(--color-accent-secondary-orange);--color-orange:var(--color-orange-700);--color-brown:var(--color-brown-900);--color-background-orange:var(--color-accent-orange);--ease-emphasized-accelerate:cubic-bezier(.3,0,.8,.15);--ease-emphasized-decelerate:cubic-bezier(.05,.7,.1,1);--container-8xl:90rem;--spacing-container-padding:1rem}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}::-webkit-calendar-picker-indicator{line-height:1}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){appearance:button}::file-selector-button{appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}}@layer components;@layer utilities{.pointer-events-auto{pointer-events:auto}.pointer-events-none{pointer-events:none}.collapse{visibility:collapse}.invisible{visibility:hidden}.visible{visibility:visible}.sr-only{clip-path:inset(50%);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.not-sr-only{clip-path:none;white-space:normal;width:auto;height:auto;margin:0;padding:0;position:static;overflow:visible}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.static{position:static}.sticky{position:sticky}.inset-0{inset:calc(var(--spacing)*0)}.inset-x-0{inset-inline:calc(var(--spacing)*0)}.inset-x-5{inset-inline:calc(var(--spacing)*5)}.-top-1{top:calc(var(--spacing)*-1)}.-top-1\\.5{top:calc(var(--spacing)*-1.5)}.-top-2{top:calc(var(--spacing)*-2)}.top-\\(--site-header-height\\){top:var(--site-header-height)}.top-0{top:calc(var(--spacing)*0)}.top-1{top:calc(var(--spacing)*1)}.top-1\\/2{top:50%}.top-3{top:calc(var(--spacing)*3)}.top-5{top:calc(var(--spacing)*5)}.top-13{top:calc(var(--spacing)*13)}.top-13\\.5{top:calc(var(--spacing)*13.5)}.top-25{top:calc(var(--spacing)*25)}.top-27{top:calc(var(--spacing)*27)}.top-27\\.5{top:calc(var(--spacing)*27.5)}.-right-1{right:calc(var(--spacing)*-1)}.-right-1\\.5{right:calc(var(--spacing)*-1.5)}.-right-2{right:calc(var(--spacing)*-2)}.right-0{right:calc(var(--spacing)*0)}.right-1{right:calc(var(--spacing)*1)}.right-2{right:calc(var(--spacing)*2)}.right-3{right:calc(var(--spacing)*3)}.right-4{right:calc(var(--spacing)*4)}.bottom-0{bottom:calc(var(--spacing)*0)}.bottom-5{bottom:calc(var(--spacing)*5)}.bottom-auto{bottom:auto}.left-0{left:calc(var(--spacing)*0)}.left-1{left:calc(var(--spacing)*1)}.left-1\\/2{left:50%}.left-3{left:calc(var(--spacing)*3)}.left-4{left:calc(var(--spacing)*4)}.isolate{isolation:isolate}.isolation-auto{isolation:auto}.z-0{z-index:0}.z-5{z-index:5}.z-6{z-index:6}.z-10{z-index:10}.z-20{z-index:20}.z-40{z-index:40}.z-50{z-index:50}.col-span-1{grid-column:span 1/span 1}.col-span-2{grid-column:span 2/span 2}.col-span-full{grid-column:1/-1}.container{width:100%}@media(min-width:40rem){.container{max-width:40rem}}@media(min-width:48rem){.container{max-width:48rem}}@media(min-width:64rem){.container{max-width:64rem}}@media(min-width:80rem){.container{max-width:80rem}}@media(min-width:96rem){.container{max-width:96rem}}.-m-px{margin:-1px}.m-0{margin:calc(var(--spacing)*0)}.m-0\\!{margin:calc(var(--spacing)*0)!important}.m-auto{margin:auto}.container-3xl{width:100%;max-width:var(--container-3xl);padding-inline:var(--spacing-container-padding);margin-inline:auto}.container-8xl{width:100%;max-width:var(--container-8xl);padding-inline:var(--spacing-container-padding);margin-inline:auto}.-mx-\\(--drawer-p\\){margin-inline:calc(var(--drawer-p)*-1)}.-mx-1{margin-inline:calc(var(--spacing)*-1)}.-mx-1\\.5{margin-inline:calc(var(--spacing)*-1.5)}.-mx-2{margin-inline:calc(var(--spacing)*-2)}.-mx-3{margin-inline:calc(var(--spacing)*-3)}.-mx-4{margin-inline:calc(var(--spacing)*-4)}.mx-1{margin-inline:calc(var(--spacing)*1)}.mx-1\\.5{margin-inline:calc(var(--spacing)*1.5)}.mx-auto{margin-inline:auto}.my-1{margin-block:calc(var(--spacing)*1)}.my-8{margin-block:calc(var(--spacing)*8)}.mt-0{margin-top:calc(var(--spacing)*0)}.mt-0\\.5{margin-top:calc(var(--spacing)*.5)}.mt-1{margin-top:calc(var(--spacing)*1)}.mt-1\\.5{margin-top:calc(var(--spacing)*1.5)}.mt-2{margin-top:calc(var(--spacing)*2)}.mt-2\\.5{margin-top:calc(var(--spacing)*2.5)}.mt-3{margin-top:calc(var(--spacing)*3)}.mt-4{margin-top:calc(var(--spacing)*4)}.mt-5{margin-top:calc(var(--spacing)*5)}.mt-6{margin-top:calc(var(--spacing)*6)}.mt-8{margin-top:calc(var(--spacing)*8)}.mt-10{margin-top:calc(var(--spacing)*10)}.mt-12{margin-top:calc(var(--spacing)*12)}.mt-14{margin-top:calc(var(--spacing)*14)}.mt-25{margin-top:calc(var(--spacing)*25)}.mt-auto{margin-top:auto}.-mr-3{margin-right:calc(var(--spacing)*-3)}.mr-1{margin-right:calc(var(--spacing)*1)}.mr-1\\.5{margin-right:calc(var(--spacing)*1.5)}.mr-2{margin-right:calc(var(--spacing)*2)}.mr-3{margin-right:calc(var(--spacing)*3)}.mr-4{margin-right:calc(var(--spacing)*4)}.mr-8{margin-right:calc(var(--spacing)*8)}.mb-\\(--drawer-p\\){margin-bottom:var(--drawer-p)}.mb-0{margin-bottom:calc(var(--spacing)*0)}.mb-0\\!{margin-bottom:calc(var(--spacing)*0)!important}.mb-1{margin-bottom:calc(var(--spacing)*1)}.mb-1\\.5{margin-bottom:calc(var(--spacing)*1.5)}.mb-2{margin-bottom:calc(var(--spacing)*2)}.mb-3{margin-bottom:calc(var(--spacing)*3)}.mb-3\\.5{margin-bottom:calc(var(--spacing)*3.5)}.mb-4{margin-bottom:calc(var(--spacing)*4)}.mb-4\\.5{margin-bottom:calc(var(--spacing)*4.5)}.mb-5{margin-bottom:calc(var(--spacing)*5)}.mb-6{margin-bottom:calc(var(--spacing)*6)}.mb-8{margin-bottom:calc(var(--spacing)*8)}.mb-9{margin-bottom:calc(var(--spacing)*9)}.mb-10{margin-bottom:calc(var(--spacing)*10)}.mb-12{margin-bottom:calc(var(--spacing)*12)}.mb-25{margin-bottom:calc(var(--spacing)*25)}.-ml-px{margin-left:-1px}.ml-1{margin-left:calc(var(--spacing)*1)}.ml-2{margin-left:calc(var(--spacing)*2)}.line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.block{display:block}.contents{display:contents}.flex{display:flex}.flex\\!{display:flex!important}.flow-root{display:flow-root}.grid{display:grid}.hidden{display:none}.inline{display:inline}.inline-block{display:inline-block}.inline-flex{display:inline-flex}.inline-grid{display:inline-grid}.inline-table{display:inline-table}.list-item{display:list-item}.table{display:table}.table-caption{display:table-caption}.table-cell{display:table-cell}.table-column{display:table-column}.table-column-group{display:table-column-group}.table-footer-group{display:table-footer-group}.table-header-group{display:table-header-group}.table-row{display:table-row}.table-row-group{display:table-row-group}.aspect-4\\/5{aspect-ratio:4/5}.aspect-326\\/420{aspect-ratio:326/420}.aspect-340\\/464{aspect-ratio:340/464}.aspect-480\\/480{aspect-ratio:480/480}.aspect-480\\/580{aspect-ratio:480/580}.aspect-1440\\/500{aspect-ratio:1440/500}.aspect-square{aspect-ratio:1}.size-\\(--ck-icon-size\\){width:var(--ck-icon-size);height:var(--ck-icon-size)}.size-0{width:calc(var(--spacing)*0);height:calc(var(--spacing)*0)}.size-1{width:calc(var(--spacing)*1);height:calc(var(--spacing)*1)}.size-2{width:calc(var(--spacing)*2);height:calc(var(--spacing)*2)}.size-3{width:calc(var(--spacing)*3);height:calc(var(--spacing)*3)}.size-3\\.5{width:calc(var(--spacing)*3.5);height:calc(var(--spacing)*3.5)}.size-4{width:calc(var(--spacing)*4);height:calc(var(--spacing)*4)}.size-4\\.5{width:calc(var(--spacing)*4.5);height:calc(var(--spacing)*4.5)}.size-5{width:calc(var(--spacing)*5);height:calc(var(--spacing)*5)}.size-6{width:calc(var(--spacing)*6);height:calc(var(--spacing)*6)}.size-8{width:calc(var(--spacing)*8);height:calc(var(--spacing)*8)}.size-10{width:calc(var(--spacing)*10);height:calc(var(--spacing)*10)}.size-14{width:calc(var(--spacing)*14);height:calc(var(--spacing)*14)}.size-15{width:calc(var(--spacing)*15);height:calc(var(--spacing)*15)}.size-\\[15px\\]{width:15px;height:15px}.size-\\[154px\\]{width:154px;height:154px}.size-full{width:100%;height:100%}.h-\\(--button-height\\){height:var(--button-height)}.h-0{height:calc(var(--spacing)*0)}.h-1{height:calc(var(--spacing)*1)}.h-4{height:calc(var(--spacing)*4)}.h-4\\.5{height:calc(var(--spacing)*4.5)}.h-5{height:calc(var(--spacing)*5)}.h-6{height:calc(var(--spacing)*6)}.h-6\\.5{height:calc(var(--spacing)*6.5)}.h-8{height:calc(var(--spacing)*8)}.h-10{height:calc(var(--spacing)*10)}.h-10\\.5{height:calc(var(--spacing)*10.5)}.h-11{height:calc(var(--spacing)*11)}.h-12{height:calc(var(--spacing)*12)}.h-13{height:calc(var(--spacing)*13)}.h-13\\.5{height:calc(var(--spacing)*13.5)}.h-14{height:calc(var(--spacing)*14)}.h-17{height:calc(var(--spacing)*17)}.h-17\\.5{height:calc(var(--spacing)*17.5)}.h-20{height:calc(var(--spacing)*20)}.h-31{height:calc(var(--spacing)*31)}.h-32{height:calc(var(--spacing)*32)}.h-\\[52px\\]{height:52px}.h-\\[112px\\]{height:112px}.h-\\[220px\\]{height:220px}.h-\\[380px\\]{height:380px}.h-\\[390px\\]{height:390px}.h-\\[400px\\]{height:400px}.h-\\[520px\\]{height:520px}.h-\\[calc\\(100dvh-var\\(--site-header-height\\)\\)\\]{height:calc(100dvh - var(--site-header-height))}.h-\\[calc\\(100vh-150px\\)\\]{height:calc(100vh - 150px)}.h-auto{height:auto}.h-full{height:100%}.h-max{height:max-content}.h-px{height:1px}.h-screen{height:100vh}.max-h-\\(--max-height\\){max-height:var(--max-height)}.max-h-60{max-height:calc(var(--spacing)*60)}.max-h-\\[112px\\]{max-height:112px}.max-h-\\[calc\\(100dvh-var\\(--site-header-height\\)\\)\\]{max-height:calc(100dvh - var(--site-header-height))}.max-h-\\[calc\\(100svh-2rem\\)\\]{max-height:calc(100svh - 2rem)}.max-h-full{max-height:100%}.max-h-none{max-height:none}.max-h-none\\!{max-height:none!important}.max-h-screen{max-height:100vh}.min-h-0{min-height:calc(var(--spacing)*0)}.min-h-\\[1em\\]{min-height:1em}.min-h-\\[400px\\]{min-height:400px}.min-h-\\[420px\\]{min-height:420px}.min-h-screen{min-height:100vh}.w-\\(--button-height\\){width:var(--button-height)}.w-0{width:calc(var(--spacing)*0)}.w-1{width:calc(var(--spacing)*1)}.w-4{width:calc(var(--spacing)*4)}.w-5{width:calc(var(--spacing)*5)}.w-10{width:calc(var(--spacing)*10)}.w-11{width:calc(var(--spacing)*11)}.w-12{width:calc(var(--spacing)*12)}.w-20{width:calc(var(--spacing)*20)}.w-22{width:calc(var(--spacing)*22)}.w-22\\.5{width:calc(var(--spacing)*22.5)}.w-31{width:calc(var(--spacing)*31)}.w-32{width:calc(var(--spacing)*32)}.w-35{width:calc(var(--spacing)*35)}.w-40{width:calc(var(--spacing)*40)}.w-60{width:calc(var(--spacing)*60)}.w-72{width:calc(var(--spacing)*72)}.w-80{width:calc(var(--spacing)*80)}.w-90{width:calc(var(--spacing)*90)}.w-96{width:calc(var(--spacing)*96)}.w-\\[32\\%\\]{width:32%}.w-\\[34\\%\\]{width:34%}.w-\\[42px\\]{width:42px}.w-\\[82\\%\\]{width:82%}.w-\\[87px\\]{width:87px}.w-\\[100px\\]{width:100px}.w-\\[145px\\]{width:145px}.w-\\[340px\\]{width:340px}.w-\\[343px\\]{width:343px}.w-\\[440px\\]{width:440px}.w-\\[480px\\]{width:480px}.w-\\[716px\\]{width:716px}.w-\\[776px\\]{width:776px}.w-\\[calc\\(50\\%-0\\.25rem\\)\\]{width:calc(50% - .25rem)}.w-\\[calc\\(100\\%-calc\\(var\\(--spacing\\)\\*2\\)\\)\\]{width:calc(100% - calc(var(--spacing)*2))}.w-auto{width:auto}.w-full{width:100%}.w-px{width:1px}.w-screen{width:100vw}.max-w-2xl{max-width:var(--container-2xl)}.max-w-4xl{max-width:var(--container-4xl)}.max-w-6xl{max-width:var(--container-6xl)}.max-w-7xl{max-width:var(--container-7xl)}.max-w-\\[180px\\]{max-width:180px}.max-w-\\[347px\\]{max-width:347px}.max-w-\\[440px\\]{max-width:440px}.max-w-\\[536px\\]{max-width:536px}.max-w-\\[calc\\(100vw-32px\\)\\]{max-width:calc(100vw - 32px)}.max-w-full{max-width:100%}.max-w-lg{max-width:var(--container-lg)}.max-w-md{max-width:var(--container-md)}.max-w-none{max-width:none}.max-w-none\\!{max-width:none!important}.max-w-prose{max-width:65ch}.max-w-screen{max-width:100vw}.max-w-sm{max-width:var(--container-sm)}.max-w-xs{max-width:var(--container-xs)}.min-w-0{min-width:calc(var(--spacing)*0)}.min-w-32{min-width:calc(var(--spacing)*32)}.min-w-40{min-width:calc(var(--spacing)*40)}.min-w-\\[130px\\]{min-width:130px}.min-w-\\[145px\\]{min-width:145px}.min-w-\\[280px\\]{min-width:280px}.min-w-max{min-width:max-content}.min-w-sm{min-width:var(--container-sm)}.min-w-xs{min-width:var(--container-xs)}.flex-1{flex:1}.flex-\\[1_1_calc\\(50\\%-0\\.25rem\\)\\]{flex:calc(50% - .25rem)}.shrink{flex-shrink:1}.shrink-0{flex-shrink:0}.grow{flex-grow:1}.border-collapse{border-collapse:collapse}.origin-\\(--transform-origin\\){transform-origin:var(--transform-origin)}.-translate-x-1{--tw-translate-x:calc(var(--spacing)*-1);translate:var(--tw-translate-x)var(--tw-translate-y)}.-translate-x-1\\/2{--tw-translate-x: -50% ;translate:var(--tw-translate-x)var(--tw-translate-y)}.-translate-x-full{--tw-translate-x:-100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-x-0{--tw-translate-x:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-x-full{--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.-translate-y-1{--tw-translate-y:calc(var(--spacing)*-1);translate:var(--tw-translate-x)var(--tw-translate-y)}.-translate-y-1\\/2{--tw-translate-y: -50% ;translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-y-0{--tw-translate-y:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-y-2{--tw-translate-y:calc(var(--spacing)*2);translate:var(--tw-translate-x)var(--tw-translate-y)}.translate-none{translate:none}.scale-150{--tw-scale-x:150%;--tw-scale-y:150%;--tw-scale-z:150%;scale:var(--tw-scale-x)var(--tw-scale-y)}.scale-3d{scale:var(--tw-scale-x)var(--tw-scale-y)var(--tw-scale-z)}.rotate-180{rotate:180deg}.transform{transform:var(--tw-rotate-x,)var(--tw-rotate-y,)var(--tw-rotate-z,)var(--tw-skew-x,)var(--tw-skew-y,)}.animate-pulse{animation:var(--animate-pulse)}.animate-spin{animation:var(--animate-spin)}.cursor-help{cursor:help}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.touch-pinch-zoom{--tw-pinch-zoom:pinch-zoom;touch-action:var(--tw-pan-x,)var(--tw-pan-y,)var(--tw-pinch-zoom,)}.resize{resize:both}.resize-none{resize:none}.list-inside{list-style-position:inside}.list-disc{list-style-type:disc}.\\[appearance\\:textfield\\]{appearance:textfield}.appearance-none{appearance:none}.auto-cols-fr{grid-auto-columns:minmax(0,1fr)}.grid-flow-col{grid-auto-flow:column}.grid-flow-row{grid-auto-flow:row}.auto-rows-max{grid-auto-rows:max-content}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.grid-cols-\\[1fr_auto\\]{grid-template-columns:1fr auto}.grid-cols-\\[repeat\\(auto-fit\\,minmax\\(0\\,1fr\\)\\)\\]{grid-template-columns:repeat(auto-fit,minmax(0,1fr))}.flex-col{flex-direction:column}.flex-row{flex-direction:row}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.items-baseline{align-items:baseline}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.items-stretch{align-items:stretch}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.justify-end{justify-content:flex-end}.justify-start{justify-content:flex-start}.gap-0{gap:calc(var(--spacing)*0)}.gap-0\\.5{gap:calc(var(--spacing)*.5)}.gap-1{gap:calc(var(--spacing)*1)}.gap-1\\.5{gap:calc(var(--spacing)*1.5)}.gap-2{gap:calc(var(--spacing)*2)}.gap-3{gap:calc(var(--spacing)*3)}.gap-4{gap:calc(var(--spacing)*4)}.gap-4\\.5{gap:calc(var(--spacing)*4.5)}.gap-5{gap:calc(var(--spacing)*5)}.gap-6{gap:calc(var(--spacing)*6)}.gap-7{gap:calc(var(--spacing)*7)}.gap-8{gap:calc(var(--spacing)*8)}.gap-10{gap:calc(var(--spacing)*10)}.gap-px{gap:1px}:where(.space-y-0>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*0)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*0)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-0\\!>:not(:last-child)){--tw-space-y-reverse:0!important;margin-block-start:calc(calc(var(--spacing)*0)*var(--tw-space-y-reverse))!important;margin-block-end:calc(calc(var(--spacing)*0)*calc(1 - var(--tw-space-y-reverse)))!important}:where(.space-y-0\\.5>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*.5)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*.5)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-1>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*1)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*1)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-1\\.5>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*1.5)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*1.5)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-2>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*2)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*2)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-3>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*3)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*3)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-4>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*4)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*4)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-5>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*5)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*5)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-6>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*6)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*6)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-8>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*8)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*8)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-reverse>:not(:last-child)){--tw-space-y-reverse:1}.gap-x-4{column-gap:calc(var(--spacing)*4)}.gap-x-6{column-gap:calc(var(--spacing)*6)}:where(.space-x-2>:not(:last-child)){--tw-space-x-reverse:0;margin-inline-start:calc(calc(var(--spacing)*2)*var(--tw-space-x-reverse));margin-inline-end:calc(calc(var(--spacing)*2)*calc(1 - var(--tw-space-x-reverse)))}:where(.space-x-reverse>:not(:last-child)){--tw-space-x-reverse:1}.gap-y-6{row-gap:calc(var(--spacing)*6)}.gap-y-8{row-gap:calc(var(--spacing)*8)}.gap-y-20{row-gap:calc(var(--spacing)*20)}:where(.divide-x>:not(:last-child)){--tw-divide-x-reverse:0;border-inline-style:var(--tw-border-style);border-inline-start-width:calc(1px*var(--tw-divide-x-reverse));border-inline-end-width:calc(1px*calc(1 - var(--tw-divide-x-reverse)))}:where(.divide-y>:not(:last-child)){--tw-divide-y-reverse:0;border-bottom-style:var(--tw-border-style);border-top-style:var(--tw-border-style);border-top-width:calc(1px*var(--tw-divide-y-reverse));border-bottom-width:calc(1px*calc(1 - var(--tw-divide-y-reverse)))}:where(.divide-y-reverse>:not(:last-child)){--tw-divide-y-reverse:1}:where(.divide-dashed>:not(:last-child)){--tw-border-style:dashed;border-style:dashed}:where(.divide-border>:not(:last-child)){border-color:var(--color-border)}:where(.divide-border-hard>:not(:last-child)){border-color:var(--color-border-hard)}:where(.divide-border-hard\\/30>:not(:last-child)){border-color:#97755e4d}@supports (color:color-mix(in lab,red,red)){:where(.divide-border-hard\\/30>:not(:last-child)){border-color:color-mix(in oklab,var(--color-border-hard)30%,transparent)}}.truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-x-hidden{overflow-x:hidden}.overflow-x-hidden\\!{overflow-x:hidden!important}.overflow-y-auto{overflow-y:auto}.overscroll-contain{overscroll-behavior:contain}.rounded{border-radius:.25rem}.rounded-2xl{border-radius:var(--radius-2xl)}.rounded-3xl{border-radius:var(--radius-3xl)}.rounded-full{border-radius:3.40282e38px}.rounded-lg{border-radius:var(--radius-lg)}.rounded-none{border-radius:0}.rounded-none\\!{border-radius:0!important}.rounded-sm{border-radius:var(--radius-sm)}.rounded-xl{border-radius:var(--radius-xl)}.rounded-s{border-start-start-radius:.25rem;border-end-start-radius:.25rem}.rounded-ss{border-start-start-radius:.25rem}.rounded-e{border-start-end-radius:.25rem;border-end-end-radius:.25rem}.rounded-se{border-start-end-radius:.25rem}.rounded-ee{border-end-end-radius:.25rem}.rounded-es{border-end-start-radius:.25rem}.rounded-t{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.rounded-t-lg{border-top-left-radius:var(--radius-lg);border-top-right-radius:var(--radius-lg)}.rounded-l{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.rounded-tl{border-top-left-radius:.25rem}.rounded-r{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.rounded-tr{border-top-right-radius:.25rem}.rounded-b{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.rounded-br{border-bottom-right-radius:.25rem}.rounded-bl{border-bottom-left-radius:.25rem}.border{border-style:var(--tw-border-style);border-width:1px}.border-0{border-style:var(--tw-border-style);border-width:0}.border-x{border-inline-style:var(--tw-border-style);border-inline-width:1px}.border-x-0{border-inline-style:var(--tw-border-style);border-inline-width:0}.border-y{border-block-style:var(--tw-border-style);border-block-width:1px}.border-s{border-inline-start-style:var(--tw-border-style);border-inline-start-width:1px}.border-e{border-inline-end-style:var(--tw-border-style);border-inline-end-width:1px}.border-t{border-top-style:var(--tw-border-style);border-top-width:1px}.border-r{border-right-style:var(--tw-border-style);border-right-width:1px}.border-r-0{border-right-style:var(--tw-border-style);border-right-width:0}.border-r-0\\!{border-right-style:var(--tw-border-style)!important;border-right-width:0!important}.border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.border-b-0{border-bottom-style:var(--tw-border-style);border-bottom-width:0}.border-b-0\\!{border-bottom-style:var(--tw-border-style)!important;border-bottom-width:0!important}.border-l{border-left-style:var(--tw-border-style);border-left-width:1px}.border-dashed{--tw-border-style:dashed;border-style:dashed}.border-none{--tw-border-style:none;border-style:none}.border-none\\!{--tw-border-style:none!important;border-style:none!important}.border-background-brown{border-color:var(--color-background-brown)}.border-border{border-color:var(--color-border)}.border-border-hard{border-color:var(--color-border-hard)}.border-border-hard\\/30{border-color:#97755e4d}@supports (color:color-mix(in lab,red,red)){.border-border-hard\\/30{border-color:color-mix(in oklab,var(--color-border-hard)30%,transparent)}}.border-border-soft{border-color:var(--color-border-soft)}.border-border-softer{border-color:var(--color-border-softer)}.border-foreground{border-color:var(--color-foreground)}.border-foreground-secondary{border-color:var(--color-foreground-secondary)}.border-foreground\\/20{border-color:#2b180f33}@supports (color:color-mix(in lab,red,red)){.border-foreground\\/20{border-color:color-mix(in oklab,var(--color-foreground)20%,transparent)}}.border-green-500{border-color:var(--color-green-500)}.border-red-500{border-color:var(--color-red-500)}.border-transparent{border-color:#0000}.border-white{border-color:var(--color-white)}.border-white\\/12{border-color:#ffffff1f}@supports (color:color-mix(in lab,red,red)){.border-white\\/12{border-color:color-mix(in oklab,var(--color-white)12%,transparent)}}.bg-\\(--color-accent\\){background-color:var(--color-accent)}.bg-\\(--color-accent-secondary\\){background-color:var(--color-accent-secondary)}.bg-alpha-mid{background-color:var(--color-alpha-mid)}.bg-background{background-color:var(--color-background)}.bg-background\\!{background-color:var(--color-background)!important}.bg-background-brown{background-color:var(--color-background-brown)}.bg-background-low{background-color:var(--color-background-low)}.bg-background-orange{background-color:var(--color-background-orange)}.bg-background-product{background-color:var(--color-background-product)}.bg-background\\/80{background-color:#faf9f7cc}@supports (color:color-mix(in lab,red,red)){.bg-background\\/80{background-color:color-mix(in oklab,var(--color-background)80%,transparent)}}.bg-blue-400{background-color:var(--color-blue-400)}.bg-blue-400\\/20{background-color:#54a2ff33}@supports (color:color-mix(in lab,red,red)){.bg-blue-400\\/20{background-color:color-mix(in oklab,var(--color-blue-400)20%,transparent)}}.bg-blue-500{background-color:var(--color-blue-500)}.bg-border{background-color:var(--color-border)}.bg-border-hard{background-color:var(--color-border-hard)}.bg-border-hard\\/50{background-color:#97755e80}@supports (color:color-mix(in lab,red,red)){.bg-border-hard\\/50{background-color:color-mix(in oklab,var(--color-border-hard)50%,transparent)}}.bg-border-soft{background-color:var(--color-border-soft)}.bg-brown{background-color:var(--color-brown)}.bg-brown-200{background-color:var(--color-brown-200)}.bg-current,.bg-current\\/10{background-color:currentColor}@supports (color:color-mix(in lab,red,red)){.bg-current\\/10{background-color:color-mix(in oklab,currentcolor 10%,transparent)}}.bg-foreground{background-color:var(--color-foreground)}.bg-foreground-secondary{background-color:var(--color-foreground-secondary)}.bg-foreground\\/5{background-color:#2b180f0d}@supports (color:color-mix(in lab,red,red)){.bg-foreground\\/5{background-color:color-mix(in oklab,var(--color-foreground)5%,transparent)}}.bg-foreground\\/20{background-color:#2b180f33}@supports (color:color-mix(in lab,red,red)){.bg-foreground\\/20{background-color:color-mix(in oklab,var(--color-foreground)20%,transparent)}}.bg-green-50{background-color:var(--color-green-50)}.bg-green-500{background-color:var(--color-green-500)}.bg-neutral-100{background-color:var(--color-neutral-100)}.bg-orange{background-color:var(--color-orange)}.bg-orange-900{background-color:var(--color-orange-900)}.bg-red-50{background-color:var(--color-red-50)}.bg-red-500{background-color:var(--color-red-500)}.bg-red-600{background-color:var(--color-red-600)}.bg-ring{background-color:var(--color-ring)}.bg-transparent{background-color:#0000}.bg-white{background-color:var(--color-white)}.bg-yellow-500{background-color:var(--color-yellow-500)}.bg-linear-to-t{--tw-gradient-position:to top}@supports (background-image:linear-gradient(in lab,red,red)){.bg-linear-to-t{--tw-gradient-position:to top in oklab}}.bg-linear-to-t{background-image:linear-gradient(var(--tw-gradient-stops))}.bg-image{background-image:linear-gradient(#0000 60%,#0000008c)}.to-transparent{--tw-gradient-to:transparent;--tw-gradient-stops:var(--tw-gradient-via-stops,var(--tw-gradient-position),var(--tw-gradient-from)var(--tw-gradient-from-position),var(--tw-gradient-to)var(--tw-gradient-to-position))}.bg-no-repeat{background-repeat:no-repeat}.bg-repeat{background-repeat:repeat}.mask-no-clip{-webkit-mask-clip:no-clip;mask-clip:no-clip}.mask-repeat{-webkit-mask-repeat:repeat;mask-repeat:repeat}.object-contain{object-fit:contain}.object-cover{object-fit:cover}.object-center{object-position:center}.object-left{object-position:left}.object-right{object-position:right}.p-\\(--drawer-p\\){padding:var(--drawer-p)}.p-0{padding:calc(var(--spacing)*0)}.p-0\\!{padding:calc(var(--spacing)*0)!important}.p-1{padding:calc(var(--spacing)*1)}.p-2{padding:calc(var(--spacing)*2)}.p-3{padding:calc(var(--spacing)*3)}.p-3\\.5{padding:calc(var(--spacing)*3.5)}.p-4{padding:calc(var(--spacing)*4)}.p-5{padding:calc(var(--spacing)*5)}.p-6{padding:calc(var(--spacing)*6)}.p-8{padding:calc(var(--spacing)*8)}.p-10{padding:calc(var(--spacing)*10)}.px-\\(--drawer-p\\){padding-inline:var(--drawer-p)}.px-\\(--spacing-container-padding\\){padding-inline:var(--spacing-container-padding)}.px-0{padding-inline:calc(var(--spacing)*0)}.px-1{padding-inline:calc(var(--spacing)*1)}.px-1\\.5{padding-inline:calc(var(--spacing)*1.5)}.px-2{padding-inline:calc(var(--spacing)*2)}.px-2\\.5{padding-inline:calc(var(--spacing)*2.5)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-3\\.5{padding-inline:calc(var(--spacing)*3.5)}.px-4{padding-inline:calc(var(--spacing)*4)}.px-5{padding-inline:calc(var(--spacing)*5)}.px-6{padding-inline:calc(var(--spacing)*6)}.px-9{padding-inline:calc(var(--spacing)*9)}.py-0{padding-block:calc(var(--spacing)*0)}.py-0\\!{padding-block:calc(var(--spacing)*0)!important}.py-0\\.5{padding-block:calc(var(--spacing)*.5)}.py-1{padding-block:calc(var(--spacing)*1)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.py-2\\.5{padding-block:calc(var(--spacing)*2.5)}.py-3{padding-block:calc(var(--spacing)*3)}.py-3\\.5{padding-block:calc(var(--spacing)*3.5)}.py-4{padding-block:calc(var(--spacing)*4)}.py-5{padding-block:calc(var(--spacing)*5)}.py-6{padding-block:calc(var(--spacing)*6)}.py-6\\.5{padding-block:calc(var(--spacing)*6.5)}.py-7{padding-block:calc(var(--spacing)*7)}.py-8{padding-block:calc(var(--spacing)*8)}.py-10{padding-block:calc(var(--spacing)*10)}.py-12{padding-block:calc(var(--spacing)*12)}.py-14{padding-block:calc(var(--spacing)*14)}.py-16{padding-block:calc(var(--spacing)*16)}.py-18{padding-block:calc(var(--spacing)*18)}.py-18\\.75{padding-block:calc(var(--spacing)*18.75)}.py-20{padding-block:calc(var(--spacing)*20)}.pt-0{padding-top:calc(var(--spacing)*0)}.pt-1{padding-top:calc(var(--spacing)*1)}.pt-3{padding-top:calc(var(--spacing)*3)}.pt-4{padding-top:calc(var(--spacing)*4)}.pt-6{padding-top:calc(var(--spacing)*6)}.pt-10{padding-top:calc(var(--spacing)*10)}.pt-24{padding-top:calc(var(--spacing)*24)}.pr-0{padding-right:calc(var(--spacing)*0)}.pr-4{padding-right:calc(var(--spacing)*4)}.pr-8{padding-right:calc(var(--spacing)*8)}.pr-10{padding-right:calc(var(--spacing)*10)}.pr-\\[var\\(--suffix-width\\,calc\\(var\\(--spacing\\)\\*4\\)\\)\\]{padding-right:var(--suffix-width,calc(var(--spacing)*4))}.pb-0{padding-bottom:calc(var(--spacing)*0)}.pb-1{padding-bottom:calc(var(--spacing)*1)}.pb-2{padding-bottom:calc(var(--spacing)*2)}.pb-3{padding-bottom:calc(var(--spacing)*3)}.pb-3\\.5{padding-bottom:calc(var(--spacing)*3.5)}.pb-4{padding-bottom:calc(var(--spacing)*4)}.pb-5{padding-bottom:calc(var(--spacing)*5)}.pb-6{padding-bottom:calc(var(--spacing)*6)}.pb-8{padding-bottom:calc(var(--spacing)*8)}.pb-10{padding-bottom:calc(var(--spacing)*10)}.pb-12{padding-bottom:calc(var(--spacing)*12)}.pl-9{padding-left:calc(var(--spacing)*9)}.pl-\\[var\\(--prefix-width\\,calc\\(var\\(--spacing\\)\\*4\\)\\)\\]{padding-left:var(--prefix-width,calc(var(--spacing)*4))}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.font-header{font-family:var(--font-header)}.font-mono{font-family:var(--font-mono)}.font-mono\\!{font-family:var(--font-mono)!important}.font-sans{font-family:var(--font-sans)}.font-sans\\!{font-family:var(--font-sans)!important}.text-2xl{font-size:var(--text-2xl);line-height:var(--tw-leading,var(--text-2xl--line-height))}.text-3xl{font-size:var(--text-3xl);line-height:var(--tw-leading,var(--text-3xl--line-height))}.text-4xl{font-size:var(--text-4xl);line-height:var(--tw-leading,var(--text-4xl--line-height))}.text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.text-base\\!{font-size:var(--text-base)!important;line-height:var(--tw-leading,var(--text-base--line-height))!important}.text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-sm\\!{font-size:var(--text-sm)!important;line-height:var(--tw-leading,var(--text-sm--line-height))!important}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading,var(--text-xl--line-height))}.text-xs{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.text-2xs{font-size:var(--text-2xs)}.leading-5{--tw-leading:calc(var(--spacing)*5);line-height:calc(var(--spacing)*5)}.leading-14{--tw-leading:calc(var(--spacing)*14);line-height:calc(var(--spacing)*14)}.leading-none{--tw-leading:1;line-height:1}.leading-normal{--tw-leading:var(--leading-normal);line-height:var(--leading-normal)}.leading-relaxed{--tw-leading:var(--leading-relaxed);line-height:var(--leading-relaxed)}.leading-snug{--tw-leading:var(--leading-snug);line-height:var(--leading-snug)}.leading-tight{--tw-leading:var(--leading-tight);line-height:var(--leading-tight)}.font-black{--tw-font-weight:var(--font-weight-black);font-weight:var(--font-weight-black)}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-light{--tw-font-weight:var(--font-weight-light);font-weight:var(--font-weight-light)}.font-medium{--tw-font-weight:var(--font-weight-medium);font-weight:var(--font-weight-medium)}.font-normal{--tw-font-weight:var(--font-weight-normal);font-weight:var(--font-weight-normal)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.tracking-\\[0\\.3em\\]{--tw-tracking:.3em;letter-spacing:.3em}.tracking-wide{--tw-tracking:var(--tracking-wide);letter-spacing:var(--tracking-wide)}.text-wrap{text-wrap:wrap}.wrap-break-word{overflow-wrap:break-word}.text-clip{text-overflow:clip}.text-ellipsis{text-overflow:ellipsis}.whitespace-nowrap{white-space:nowrap}.text-\\(--ck-icon-color\\){color:var(--ck-icon-color)}.text-\\(--color-accent-secondary\\){color:var(--color-accent-secondary)}.text-background{color:var(--color-background)}.text-background\\/55{color:#faf9f78c}@supports (color:color-mix(in lab,red,red)){.text-background\\/55{color:color-mix(in oklab,var(--color-background)55%,transparent)}}.text-blue-600{color:var(--color-blue-600)}.text-brown{color:var(--color-brown)}.text-brown-975{color:var(--color-brown-975)}.text-brown-990{color:var(--color-brown-990)}.text-current{color:currentColor}.text-foreground{color:var(--color-foreground)}.text-foreground-quaternary{color:var(--color-foreground-quaternary)}.text-foreground-secondary{color:var(--color-foreground-secondary)}.text-foreground-tertiary{color:var(--color-foreground-tertiary)}.text-foreground\\/40{color:#2b180f66}@supports (color:color-mix(in lab,red,red)){.text-foreground\\/40{color:color-mix(in oklab,var(--color-foreground)40%,transparent)}}.text-foreground\\/50{color:#2b180f80}@supports (color:color-mix(in lab,red,red)){.text-foreground\\/50{color:color-mix(in oklab,var(--color-foreground)50%,transparent)}}.text-foreground\\/55{color:#2b180f8c}@supports (color:color-mix(in lab,red,red)){.text-foreground\\/55{color:color-mix(in oklab,var(--color-foreground)55%,transparent)}}.text-foreground\\/80{color:#2b180fcc}@supports (color:color-mix(in lab,red,red)){.text-foreground\\/80{color:color-mix(in oklab,var(--color-foreground)80%,transparent)}}.text-gray-500{color:var(--color-gray-500)}.text-gray-600{color:var(--color-gray-600)}.text-green-600{color:var(--color-green-600)}.text-inherit{color:inherit}.text-inherit\\!{color:inherit!important}.text-orange-900{color:var(--color-orange-900)}.text-red-500{color:var(--color-red-500)}.text-red-600{color:var(--color-red-600)}.text-white{color:var(--color-white)}.capitalize{text-transform:capitalize}.lowercase{text-transform:lowercase}.normal-case{text-transform:none}.normal-case\\!{text-transform:none!important}.uppercase{text-transform:uppercase}.italic{font-style:italic}.not-italic{font-style:normal}.diagonal-fractions{--tw-numeric-fraction:diagonal-fractions;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.lining-nums{--tw-numeric-figure:lining-nums;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.oldstyle-nums{--tw-numeric-figure:oldstyle-nums;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.ordinal{--tw-ordinal:ordinal;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.proportional-nums{--tw-numeric-spacing:proportional-nums;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.slashed-zero{--tw-slashed-zero:slashed-zero;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.stacked-fractions{--tw-numeric-fraction:stacked-fractions;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.tabular-nums{--tw-numeric-spacing:tabular-nums;font-variant-numeric:var(--tw-ordinal,)var(--tw-slashed-zero,)var(--tw-numeric-figure,)var(--tw-numeric-spacing,)var(--tw-numeric-fraction,)}.normal-nums{font-variant-numeric:normal}.line-through{text-decoration-line:line-through}.no-underline{text-decoration-line:none}.overline{text-decoration-line:overline}.underline{text-decoration-line:underline}.underline-offset-4{text-underline-offset:4px}.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.opacity-0{opacity:0}.opacity-30{opacity:.3}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.opacity-60{opacity:.6}.opacity-80{opacity:.8}.opacity-85{opacity:.85}.opacity-100{opacity:1}.shadow-lg{--tw-shadow:0 2px 4px var(--tw-shadow-color,oklch(0% 0 0/.02)),0 4px 8px var(--tw-shadow-color,oklch(0% 0 0/.02)),0 8px 16px var(--tw-shadow-color,oklch(0% 0 0/.02));box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-md{--tw-shadow:0 2px 3px var(--tw-shadow-color,oklch(0% 0 0/.02)),0 3px 6px var(--tw-shadow-color,oklch(0% 0 0/.02));box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-none{--tw-shadow:0 0 #0000;box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-sm{--tw-shadow:0 1px 2px var(--tw-shadow-color,oklch(0% 0 0/.02)),0 2px 4px var(--tw-shadow-color,oklch(0% 0 0/.02));box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-xs{--tw-shadow:0 1px 2px var(--tw-shadow-color,oklch(0% 0 0/.03));box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.ring{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(1px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.ring-0{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(0px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.ring-2{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(2px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.inset-ring{--tw-inset-ring-shadow:inset 0 0 0 1px var(--tw-inset-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.ring-alpha-intense{--tw-ring-color:var(--color-alpha-intense)}.ring-red-600{--tw-ring-color:var(--color-red-600)}.ring-red-600\\/50{--tw-ring-color:#e4001480}@supports (color:color-mix(in lab,red,red)){.ring-red-600\\/50{--tw-ring-color:color-mix(in oklab,var(--color-red-600)50%,transparent)}}.ring-ring{--tw-ring-color:var(--color-ring)}.ring-offset-2{--tw-ring-offset-width:2px;--tw-ring-offset-shadow:var(--tw-ring-inset,)0 0 0 var(--tw-ring-offset-width)var(--tw-ring-offset-color)}.outline{outline-style:var(--tw-outline-style);outline-width:1px}.blur{--tw-blur:blur(8px);filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}.drop-shadow{--tw-drop-shadow-size:drop-shadow(0 1px 2px var(--tw-drop-shadow-color,#0000001a))drop-shadow(0 1px 1px var(--tw-drop-shadow-color,#0000000f));--tw-drop-shadow:drop-shadow(0 1px 2px #0000001a)drop-shadow(0 1px 1px #0000000f);filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}.grayscale{--tw-grayscale:grayscale(100%);filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}.invert{--tw-invert:invert(100%);filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}.sepia{--tw-sepia:sepia(100%);filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}.filter{filter:var(--tw-blur,)var(--tw-brightness,)var(--tw-contrast,)var(--tw-grayscale,)var(--tw-hue-rotate,)var(--tw-invert,)var(--tw-saturate,)var(--tw-sepia,)var(--tw-drop-shadow,)}.backdrop-blur{--tw-backdrop-blur:blur(8px);-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.backdrop-grayscale{--tw-backdrop-grayscale:grayscale(100%);-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.backdrop-invert{--tw-backdrop-invert:invert(100%);-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.backdrop-sepia{--tw-backdrop-sepia:sepia(100%);-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.backdrop-filter{-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter,display,content-visibility,overlay,pointer-events;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-\\[width\\,opacity\\,transform\\]{transition-property:width,opacity,transform;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-\\[width\\]{transition-property:width;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-all{transition-property:all;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-colors{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-opacity{transition-property:opacity;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-transform{transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.duration-100{--tw-duration:.1s;transition-duration:.1s}.duration-200{--tw-duration:.2s;transition-duration:.2s}.duration-300{--tw-duration:.3s;transition-duration:.3s}.duration-400{--tw-duration:.4s;transition-duration:.4s}.duration-450{--tw-duration:.45s;transition-duration:.45s}.duration-500{--tw-duration:.5s;transition-duration:.5s}.ease-\\[cubic-bezier\\(0\\.22\\,1\\,0\\.36\\,1\\)\\]{--tw-ease:cubic-bezier(.22,1,.36,1);transition-timing-function:cubic-bezier(.22,1,.36,1)}.ease-emphasized-decelerate{--tw-ease:var(--ease-emphasized-decelerate);transition-timing-function:var(--ease-emphasized-decelerate)}.ease-in{--tw-ease:var(--ease-in);transition-timing-function:var(--ease-in)}.ease-in-out{--tw-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out)}.ease-out{--tw-ease:var(--ease-out);transition-timing-function:var(--ease-out)}.outline-none{--tw-outline-style:none;outline-style:none}.select-none{-webkit-user-select:none;user-select:none}.\\[--button-height\\:--spacing\\(6\\)\\]{--button-height:calc(var(--spacing)*6)}.\\[--button-height\\:--spacing\\(8\\)\\]{--button-height:calc(var(--spacing)*8)}.\\[--button-height\\:--spacing\\(10\\.5\\)\\]{--button-height:calc(var(--spacing)*10.5)}.\\[--button-height\\:--spacing\\(14\\)\\]{--button-height:calc(var(--spacing)*14)}.\\[--drawer-p\\:--spacing\\(5\\)\\]{--drawer-p:calc(var(--spacing)*5)}:where(.divide-x-reverse>:not(:last-child)){--tw-divide-x-reverse:1}.ring-inset{--tw-ring-inset:inset}:is(.\\*\\:shrink-0>*){flex-shrink:0}.not-data-\\[status\\=open\\]\\:pointer-events-none:not([data-status=open]){pointer-events:none}.not-data-\\[status\\=open\\]\\:translate-y-2:not([data-status=open]){--tw-translate-y:calc(var(--spacing)*2);translate:var(--tw-translate-x)var(--tw-translate-y)}.not-data-\\[status\\=open\\]\\:scale-95:not([data-status=open]){--tw-scale-x:95%;--tw-scale-y:95%;--tw-scale-z:95%;scale:var(--tw-scale-x)var(--tw-scale-y)}.not-data-\\[status\\=open\\]\\:opacity-0:not([data-status=open]){opacity:0}.not-data-\\[status\\=open\\]\\:duration-150:not([data-status=open]){--tw-duration:.15s;transition-duration:.15s}.not-data-\\[status\\=open\\]\\:duration-250:not([data-status=open]){--tw-duration:.25s;transition-duration:.25s}.not-data-\\[status\\=open\\]\\:ease-emphasized-accelerate:not([data-status=open]){--tw-ease:var(--ease-emphasized-accelerate);transition-timing-function:var(--ease-emphasized-accelerate)}@media(hover:hover){.group-hover\\:pointer-events-auto:is(:where(.group):hover *){pointer-events:auto}.group-hover\\:visible:is(:where(.group):hover *){visibility:visible}.group-hover\\:translate-y-0:is(:where(.group):hover *){--tw-translate-y:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.group-hover\\:text-foreground:is(:where(.group):hover *){color:var(--color-foreground)}.group-hover\\:opacity-100:is(:where(.group):hover *){opacity:1}}.placeholder\\:text-foreground-secondary::placeholder{color:var(--color-foreground-secondary)}.placeholder\\:text-foreground\\/55::placeholder{color:#2b180f8c}@supports (color:color-mix(in lab,red,red)){.placeholder\\:text-foreground\\/55::placeholder{color:color-mix(in oklab,var(--color-foreground)55%,transparent)}}.placeholder\\:text-ring::placeholder{color:var(--color-ring)}.backdrop\\:bg-black\\/20::backdrop{background-color:#0003}@supports (color:color-mix(in lab,red,red)){.backdrop\\:bg-black\\/20::backdrop{background-color:color-mix(in oklab,var(--color-black)20%,transparent)}}.backdrop\\:bg-foreground\\/20::backdrop{background-color:#2b180f33}@supports (color:color-mix(in lab,red,red)){.backdrop\\:bg-foreground\\/20::backdrop{background-color:color-mix(in oklab,var(--color-foreground)20%,transparent)}}.backdrop\\:backdrop-blur-sm::backdrop{--tw-backdrop-blur:blur(var(--blur-sm));-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.backdrop\\:transition-all::backdrop{transition-property:all;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.backdrop\\:transition-opacity::backdrop{transition-property:opacity;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.backdrop\\:ease-in-out::backdrop{--tw-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out)}.not-data-\\[status\\=open\\]\\:backdrop\\:opacity-0:not([data-status=open])::backdrop{opacity:0}.not-data-\\[status\\=open\\]\\:backdrop\\:delay-150:not([data-status=open])::backdrop{transition-delay:.15s}.not-data-\\[status\\=open\\]\\:backdrop\\:duration-200:not([data-status=open])::backdrop{--tw-duration:.2s;transition-duration:.2s}.before\\:absolute:before{content:var(--tw-content);position:absolute}.before\\:top-0:before{content:var(--tw-content);top:calc(var(--spacing)*0)}.before\\:top-0\\.5:before{content:var(--tw-content);top:calc(var(--spacing)*.5)}.before\\:left-0:before{content:var(--tw-content);left:calc(var(--spacing)*0)}.before\\:left-0\\.5:before{content:var(--tw-content);left:calc(var(--spacing)*.5)}.before\\:block:before{content:var(--tw-content);display:block}.before\\:size-5:before{content:var(--tw-content);width:calc(var(--spacing)*5);height:calc(var(--spacing)*5)}.before\\:size-full:before{content:var(--tw-content);width:100%;height:100%}.before\\:origin-left:before{content:var(--tw-content);transform-origin:0}.before\\:rounded-full:before{content:var(--tw-content);border-radius:3.40282e38px}.before\\:rounded-xl:before{content:var(--tw-content);border-radius:var(--radius-xl)}.before\\:border:before{content:var(--tw-content);border-style:var(--tw-border-style);border-width:1px}.before\\:border-2:before{content:var(--tw-content);border-style:var(--tw-border-style);border-width:2px}.before\\:border-current:before{content:var(--tw-content);border-color:currentColor}.before\\:bg-background:before{content:var(--tw-content);background-color:var(--color-background)}.before\\:text-white:before{content:var(--tw-content);color:var(--color-white)}.before\\:opacity-40:before{content:var(--tw-content);opacity:.4}.before\\:transition-transform:before{content:var(--tw-content);transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.before\\:duration-200:before{content:var(--tw-content);--tw-duration:.2s;transition-duration:.2s}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:top-0:after{content:var(--tw-content);top:calc(var(--spacing)*0)}.after\\:left-0:after{content:var(--tw-content);left:calc(var(--spacing)*0)}.after\\:block:after{content:var(--tw-content);display:block}.after\\:size-full:after{content:var(--tw-content);width:100%;height:100%}.after\\:rounded-full:after{content:var(--tw-content);border-radius:3.40282e38px}.after\\:border:after{content:var(--tw-content);border-style:var(--tw-border-style);border-width:1px}.after\\:border-2:after{content:var(--tw-content);border-style:var(--tw-border-style);border-width:2px}.after\\:border-transparent:after{content:var(--tw-content);border-color:#0000}.after\\:border-t-current:after{content:var(--tw-content);border-top-color:currentColor}.after\\:border-r-current:after{content:var(--tw-content);border-right-color:currentColor}.last\\:border-b-0:last-child{border-bottom-style:var(--tw-border-style);border-bottom-width:0}.first-of-type\\:mt-1:first-of-type{margin-top:calc(var(--spacing)*1)}.last-of-type\\:mb-1:last-of-type{margin-bottom:calc(var(--spacing)*1)}.checked\\:bg-blue-500:checked{background-color:var(--color-blue-500)}.checked\\:bg-foreground:checked{background-color:var(--color-foreground)}.checked\\:before\\:absolute:checked:before{content:var(--tw-content);position:absolute}.checked\\:before\\:h-2:checked:before{content:var(--tw-content);height:calc(var(--spacing)*2)}.checked\\:before\\:w-2:checked:before{content:var(--tw-content);width:calc(var(--spacing)*2)}.checked\\:before\\:translate-x-full:checked:before{content:var(--tw-content);--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.checked\\:before\\:rounded-full:checked:before{content:var(--tw-content);border-radius:3.40282e38px}.checked\\:before\\:bg-foreground-tertiary:checked:before{content:var(--tw-content);background-color:var(--color-foreground-tertiary)}.checked\\:before\\:text-xs:checked:before{content:var(--tw-content);font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.checked\\:before\\:font-bold:checked:before{content:var(--tw-content);--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.checked\\:before\\:content-\\[\\'✓\\'\\]:checked:before{--tw-content:"✓";content:var(--tw-content)}.indeterminate\\:before\\:h-0\\.5:indeterminate:before{content:var(--tw-content);height:calc(var(--spacing)*.5)}.indeterminate\\:before\\:w-1\\.5:indeterminate:before{content:var(--tw-content);width:calc(var(--spacing)*1.5)}.indeterminate\\:before\\:bg-white:indeterminate:before{content:var(--tw-content);background-color:var(--color-white)}.focus-within\\:ring-4:focus-within{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(4px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus-within\\:ring-ring:focus-within{--tw-ring-color:var(--color-ring)}.focus-within\\:ring-offset-2:focus-within{--tw-ring-offset-width:2px;--tw-ring-offset-shadow:var(--tw-ring-inset,)0 0 0 var(--tw-ring-offset-width)var(--tw-ring-offset-color)}.focus-within\\:ring-offset-background:focus-within{--tw-ring-offset-color:var(--color-background)}@media(hover:hover){.hover\\:-translate-y-0\\.5:hover{--tw-translate-y:calc(var(--spacing)*-.5);translate:var(--tw-translate-x)var(--tw-translate-y)}.hover\\:border-border-hard:hover{border-color:var(--color-border-hard)}.hover\\:border-foreground\\/20:hover{border-color:#2b180f33}@supports (color:color-mix(in lab,red,red)){.hover\\:border-foreground\\/20:hover{border-color:color-mix(in oklab,var(--color-foreground)20%,transparent)}}.hover\\:border-foreground\\/50:hover{border-color:#2b180f80}@supports (color:color-mix(in lab,red,red)){.hover\\:border-foreground\\/50:hover{border-color:color-mix(in oklab,var(--color-foreground)50%,transparent)}}.hover\\:border-mix-border\\/8:hover{border-color:#dddcd9}@supports (color:color-mix(in lab,red,red)){.hover\\:border-mix-border\\/8:hover{border-color:color-mix(in oklab,var(--color-border),var(--color-mix-with,var(--color-foreground)) 8%)}}.hover\\:bg-alpha-hard:hover{background-color:var(--color-alpha-hard)}.hover\\:bg-alpha-mid:hover{background-color:var(--color-alpha-mid)}.hover\\:bg-alpha-soft:hover{background-color:var(--color-alpha-soft)}.hover\\:bg-background-low:hover{background-color:var(--color-background-low)}.hover\\:bg-foreground-tertiary:hover{background-color:var(--color-foreground-tertiary)}.hover\\:bg-foreground\\/5:hover{background-color:#2b180f0d}@supports (color:color-mix(in lab,red,red)){.hover\\:bg-foreground\\/5:hover{background-color:color-mix(in oklab,var(--color-foreground)5%,transparent)}}.hover\\:bg-red-700:hover{background-color:var(--color-red-700)}.hover\\:bg-transparent:hover{background-color:#0000}.hover\\:bg-yellow-600:hover{background-color:var(--color-yellow-600)}.hover\\:text-accent:hover{color:var(--color-accent)}.hover\\:text-foreground:hover{color:var(--color-foreground)}.hover\\:text-foreground\\/80:hover{color:#2b180fcc}@supports (color:color-mix(in lab,red,red)){.hover\\:text-foreground\\/80:hover{color:color-mix(in oklab,var(--color-foreground)80%,transparent)}}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:opacity-70:hover{opacity:.7}.hover\\:opacity-90:hover{opacity:.9}}.focus\\:border-foreground:focus{border-color:var(--color-foreground)}.focus\\:ring:focus{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(1px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus\\:ring-0:focus{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(0px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus\\:ring-1:focus{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(1px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus\\:ring-border-hard:focus{--tw-ring-color:var(--color-border-hard)}.focus\\:ring-ring:focus{--tw-ring-color:var(--color-ring)}.focus\\:outline-none:focus{--tw-outline-style:none;outline-style:none}.focus-visible\\:border-none:focus-visible{--tw-border-style:none;border-style:none}.focus-visible\\:border-border:focus-visible{border-color:var(--color-border)}.focus-visible\\:border-foreground:focus-visible{border-color:var(--color-foreground)}.focus-visible\\:bg-background:focus-visible{background-color:var(--color-background)}.focus-visible\\:text-foreground:focus-visible{color:var(--color-foreground)}.focus-visible\\:ring-0:focus-visible{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(0px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus-visible\\:ring-2:focus-visible{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(2px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus-visible\\:ring-4:focus-visible{--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(4px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus-visible\\:ring-ring:focus-visible{--tw-ring-color:var(--color-ring)}.focus-visible\\:ring-offset-0:focus-visible{--tw-ring-offset-width:0px;--tw-ring-offset-shadow:var(--tw-ring-inset,)0 0 0 var(--tw-ring-offset-width)var(--tw-ring-offset-color)}.focus-visible\\:ring-offset-2:focus-visible{--tw-ring-offset-width:2px;--tw-ring-offset-shadow:var(--tw-ring-inset,)0 0 0 var(--tw-ring-offset-width)var(--tw-ring-offset-color)}.focus-visible\\:ring-offset-background:focus-visible{--tw-ring-offset-color:var(--color-background)}.focus-visible\\:outline-2:focus-visible{outline-style:var(--tw-outline-style);outline-width:2px}.focus-visible\\:outline-offset-2:focus-visible{outline-offset:2px}.focus-visible\\:outline-none:focus-visible{--tw-outline-style:none;outline-style:none}.active\\:bg-\\(--color-accent\\):active{background-color:var(--color-accent)}.active\\:bg-brown:active{background-color:var(--color-brown)}.active\\:before\\:scale-x-110:active:before{content:var(--tw-content);--tw-scale-x:110%;scale:var(--tw-scale-x)var(--tw-scale-y)}.active\\:before\\:rounded-\\[calc\\(var\\(--spacing\\)\\*2\\.25\\)\\]:active:before{content:var(--tw-content);border-radius:calc(var(--spacing)*2.25)}.active\\:checked\\:before\\:origin-right:active:checked:before{content:var(--tw-content);transform-origin:100%}.enabled\\:cursor-pointer:enabled{cursor:pointer}.checked\\:enabled\\:border-foreground-tertiary:checked:enabled{border-color:var(--color-foreground-tertiary)}.checked\\:enabled\\:bg-foreground-tertiary:checked:enabled{background-color:var(--color-foreground-tertiary)}.checked\\:enabled\\:bg-white:checked:enabled{background-color:var(--color-white)}.indeterminate\\:enabled\\:border-foreground-tertiary:indeterminate:enabled{border-color:var(--color-foreground-tertiary)}.indeterminate\\:enabled\\:bg-foreground-tertiary:indeterminate:enabled{background-color:var(--color-foreground-tertiary)}@media(hover:hover){.enabled\\:not-checked\\:hover\\:border-mix-border\\/8:enabled:not(:checked):hover{border-color:#dddcd9}@supports (color:color-mix(in lab,red,red)){.enabled\\:not-checked\\:hover\\:border-mix-border\\/8:enabled:not(:checked):hover{border-color:color-mix(in oklab,var(--color-border),var(--color-mix-with,var(--color-foreground)) 8%)}}.checked\\:enabled\\:hover\\:border-mix-foreground\\/8:checked:enabled:hover{border-color:#2b180f}@supports (color:color-mix(in lab,red,red)){.checked\\:enabled\\:hover\\:border-mix-foreground\\/8:checked:enabled:hover{border-color:color-mix(in oklab,var(--color-foreground),var(--color-mix-with,var(--color-foreground)) 8%)}}.checked\\:enabled\\:hover\\:mix-with-foreground-secondary:checked:enabled:hover{--color-mix-with:var(--color-foreground-secondary)}.indeterminate\\:enabled\\:hover\\:border-mix-foreground\\/8:indeterminate:enabled:hover{border-color:#2b180f}@supports (color:color-mix(in lab,red,red)){.indeterminate\\:enabled\\:hover\\:border-mix-foreground\\/8:indeterminate:enabled:hover{border-color:color-mix(in oklab,var(--color-foreground),var(--color-mix-with,var(--color-foreground)) 8%)}}.indeterminate\\:enabled\\:hover\\:mix-with-foreground-secondary:indeterminate:enabled:hover{--color-mix-with:var(--color-foreground-secondary)}}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:cursor-wait:disabled{cursor:wait}.disabled\\:border-foreground\\/5:disabled{border-color:#2b180f0d}@supports (color:color-mix(in lab,red,red)){.disabled\\:border-foreground\\/5:disabled{border-color:color-mix(in oklab,var(--color-foreground)5%,transparent)}}.disabled\\:bg-foreground\\/10:disabled{background-color:#2b180f1a}@supports (color:color-mix(in lab,red,red)){.disabled\\:bg-foreground\\/10:disabled{background-color:color-mix(in oklab,var(--color-foreground)10%,transparent)}}.disabled\\:opacity-30:disabled{opacity:.3}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:before\\:opacity-30:disabled:before{content:var(--tw-content);opacity:.3}.disabled\\:checked\\:before\\:bg-foreground\\/50:disabled:checked:before{content:var(--tw-content);background-color:#2b180f80}@supports (color:color-mix(in lab,red,red)){.disabled\\:checked\\:before\\:bg-foreground\\/50:disabled:checked:before{background-color:color-mix(in oklab,var(--color-foreground)50%,transparent)}}.disabled\\:checked\\:before\\:text-foreground\\/50:disabled:checked:before{content:var(--tw-content);color:#2b180f80}@supports (color:color-mix(in lab,red,red)){.disabled\\:checked\\:before\\:text-foreground\\/50:disabled:checked:before{color:color-mix(in oklab,var(--color-foreground)50%,transparent)}}.disabled\\:indeterminate\\:before\\:bg-foreground\\/50:disabled:indeterminate:before{content:var(--tw-content);background-color:#2b180f80}@supports (color:color-mix(in lab,red,red)){.disabled\\:indeterminate\\:before\\:bg-foreground\\/50:disabled:indeterminate:before{background-color:color-mix(in oklab,var(--color-foreground)50%,transparent)}}.has-focus-visible\\:ring-4:has(:focus-visible){--tw-ring-shadow:var(--tw-ring-inset,)0 0 0 calc(4px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.has-\\[\\[data-drawer-actions\\]\\:last-child\\]\\:pb-0:has([data-drawer-actions]:last-child){padding-bottom:calc(var(--spacing)*0)}.has-\\[\\[data-drawer-focus-catcher\\]\\:first-child\\+\\[data-drawer-header\\]\\,\\[data-drawer-header\\]\\:first-child\\]\\:pt-0:has(:is([data-drawer-focus-catcher]:first-child+[data-drawer-header],[data-drawer-header]:first-child)){padding-top:calc(var(--spacing)*0)}.data-disabled\\:pointer-events-none[data-disabled]{pointer-events:none}.data-disabled\\:opacity-50[data-disabled]{opacity:.5}.data-highlighted\\:bg-background-low[data-highlighted]{background-color:var(--color-background-low)}.data-invalid\\:border-red-500[data-invalid]{border-color:var(--color-red-500)}@media(hover:hover){.data-invalid\\:hover\\:border-red-600[data-invalid]:hover{border-color:var(--color-red-600)}}.data-invalid\\:focus-visible\\:border-red-500[data-invalid]:focus-visible{border-color:var(--color-red-500)}.data-invalid\\:focus-visible\\:ring-red-500\\/20[data-invalid]:focus-visible{--tw-ring-color:#fb2c3633}@supports (color:color-mix(in lab,red,red)){.data-invalid\\:focus-visible\\:ring-red-500\\/20[data-invalid]:focus-visible{--tw-ring-color:color-mix(in oklab,var(--color-red-500)20%,transparent)}}.data-selected\\:text-foreground[data-selected]{color:var(--color-foreground)}.data-\\[delivery-visible\\=true\\]\\:border-t-0[data-delivery-visible=true]{border-top-style:var(--tw-border-style);border-top-width:0}.data-\\[delivery-visible\\=true\\]\\:pt-2\\.5[data-delivery-visible=true]{padding-top:calc(var(--spacing)*2.5)}.data-\\[invalid\\]\\:border-red-500[data-invalid]{border-color:var(--color-red-500)}@media(hover:hover){.data-\\[invalid\\]\\:hover\\:border-red-600[data-invalid]:hover{border-color:var(--color-red-600)}}.data-\\[invalid\\]\\:focus-visible\\:border-red-500[data-invalid]:focus-visible{border-color:var(--color-red-500)}.data-\\[invalid\\]\\:focus-visible\\:ring-red-500\\/20[data-invalid]:focus-visible{--tw-ring-color:#fb2c3633}@supports (color:color-mix(in lab,red,red)){.data-\\[invalid\\]\\:focus-visible\\:ring-red-500\\/20[data-invalid]:focus-visible{--tw-ring-color:color-mix(in oklab,var(--color-red-500)20%,transparent)}}.data-\\[state\\=closed\\]\\:scale-95[data-state=closed]{--tw-scale-x:95%;--tw-scale-y:95%;--tw-scale-z:95%;scale:var(--tw-scale-x)var(--tw-scale-y)}.data-\\[state\\=closed\\]\\:opacity-0[data-state=closed]{opacity:0}.data-\\[state\\=closed\\]\\:duration-150[data-state=closed]{--tw-duration:.15s;transition-duration:.15s}.data-\\[state\\=closed\\]\\:data-\\[side\\=bottom\\]\\:-translate-y-2[data-state=closed][data-side=bottom]{--tw-translate-y:calc(var(--spacing)*-2);translate:var(--tw-translate-x)var(--tw-translate-y)}.data-\\[state\\=closed\\]\\:data-\\[side\\=left\\]\\:translate-x-2[data-state=closed][data-side=left]{--tw-translate-x:calc(var(--spacing)*2);translate:var(--tw-translate-x)var(--tw-translate-y)}.data-\\[state\\=closed\\]\\:data-\\[side\\=right\\]\\:-translate-x-2[data-state=closed][data-side=right]{--tw-translate-x:calc(var(--spacing)*-2);translate:var(--tw-translate-x)var(--tw-translate-y)}.data-\\[state\\=closed\\]\\:data-\\[side\\=top\\]\\:translate-y-2[data-state=closed][data-side=top]{--tw-translate-y:calc(var(--spacing)*2);translate:var(--tw-translate-x)var(--tw-translate-y)}.data-\\[state\\=open\\]\\:translate-x-0[data-state=open]{--tw-translate-x:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.data-\\[state\\=open\\]\\:translate-y-0[data-state=open]{--tw-translate-y:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.data-\\[state\\=open\\]\\:scale-100[data-state=open]{--tw-scale-x:100%;--tw-scale-y:100%;--tw-scale-z:100%;scale:var(--tw-scale-x)var(--tw-scale-y)}.data-\\[state\\=open\\]\\:opacity-100[data-state=open]{opacity:1}@media(prefers-reduced-motion:reduce){.motion-reduce\\:transition-none,.motion-reduce\\:backdrop\\:transition-none::backdrop{transition-property:none}}@media not all and (min-width:48rem){.max-md\\:mb-0{margin-bottom:calc(var(--spacing)*0)}.max-md\\:w-full{width:100%}.max-md\\:not-data-\\[status\\=open\\]\\:translate-y-full:not([data-status=open]){--tw-translate-y:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}}@media not all and (min-width:40rem){.max-sm\\:w-\\[calc\\(100vw-32px\\)\\]{width:calc(100vw - 32px)}.max-sm\\:max-w-\\[calc\\(100vw-32px\\)\\]{max-width:calc(100vw - 32px)}.max-sm\\:items-stretch{align-items:stretch}}@media(min-width:40rem){.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:justify-start{justify-content:flex-start}.sm\\:overflow-x-hidden{overflow-x:hidden}}@media(min-width:48rem){.md\\:mr-0{margin-right:calc(var(--spacing)*0)}.md\\:flex{display:flex}.md\\:hidden{display:none}.md\\:inline{display:inline}.md\\:w-\\[480px\\]{width:480px}.md\\:w-full{width:100%}.md\\:max-w-\\[578px\\]{max-width:578px}.md\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:items-center{align-items:center}.md\\:justify-center{justify-content:center}.md\\:gap-2{gap:calc(var(--spacing)*2)}.md\\:border-r{border-right-style:var(--tw-border-style);border-right-width:1px}.md\\:border-b-0{border-bottom-style:var(--tw-border-style);border-bottom-width:0}.md\\:p-4{padding:calc(var(--spacing)*4)}.md\\:p-5{padding:calc(var(--spacing)*5)}.md\\:px-0{padding-inline:calc(var(--spacing)*0)}.md\\:py-4{padding-block:calc(var(--spacing)*4)}.md\\:text-center{text-align:center}.md\\:text-3xl{font-size:var(--text-3xl);line-height:var(--tw-leading,var(--text-3xl--line-height))}.md\\:text-4xl{font-size:var(--text-4xl);line-height:var(--tw-leading,var(--text-4xl--line-height))}.md\\:text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.md\\:text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.md\\:text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.md\\:not-data-\\[status\\=open\\]\\:translate-x-full:not([data-status=open]){--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.even\\:md\\:border-r-0:nth-child(2n){border-right-style:var(--tw-border-style);border-right-width:0}}@media(min-width:64rem){.lg\\:sticky{position:sticky}.lg\\:top-\\(--site-header-height\\){top:var(--site-header-height)}.lg\\:bottom-auto{bottom:auto}.lg\\:mt-4{margin-top:calc(var(--spacing)*4)}.lg\\:mt-6{margin-top:calc(var(--spacing)*6)}.lg\\:mt-10{margin-top:calc(var(--spacing)*10)}.lg\\:mt-12{margin-top:calc(var(--spacing)*12)}.lg\\:mt-25{margin-top:calc(var(--spacing)*25)}.lg\\:mb-8{margin-bottom:calc(var(--spacing)*8)}.lg\\:mb-10{margin-bottom:calc(var(--spacing)*10)}.lg\\:mb-25{margin-bottom:calc(var(--spacing)*25)}.lg\\:ml-1{margin-left:calc(var(--spacing)*1)}.lg\\:block{display:block}.lg\\:flex{display:flex}.lg\\:grid{display:grid}.lg\\:hidden{display:none}.lg\\:inline-block{display:inline-block}.lg\\:inline-flex{display:inline-flex}.lg\\:aspect-360\\/420{aspect-ratio:360/420}.lg\\:aspect-360\\/480{aspect-ratio:360/480}.lg\\:h-14{height:calc(var(--spacing)*14)}.lg\\:h-20{height:calc(var(--spacing)*20)}.lg\\:h-\\[280px\\]{height:280px}.lg\\:h-\\[580px\\]{height:580px}.lg\\:h-\\[616px\\]{height:616px}.lg\\:h-auto{height:auto}.lg\\:h-fit{height:fit-content}.lg\\:max-h-\\[calc\\(100dvh-var\\(--site-header-height\\)\\)\\]{max-height:calc(100dvh - var(--site-header-height))}.lg\\:min-h-0{min-height:calc(var(--spacing)*0)}.lg\\:w-\\[82\\%\\]{width:82%}.lg\\:w-\\[107px\\]{width:107px}.lg\\:w-\\[360px\\]{width:360px}.lg\\:w-auto{width:auto}.lg\\:max-w-\\[82\\%\\]{max-width:82%}.lg\\:min-w-\\[360px\\]{min-width:360px}.lg\\:flex-1{flex:1}.lg\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.lg\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.lg\\:grid-cols-\\[1fr_360px\\]{grid-template-columns:1fr 360px}.lg\\:grid-cols-\\[2fr_1fr\\]{grid-template-columns:2fr 1fr}.lg\\:grid-cols-\\[2fr_1fr_1fr\\]{grid-template-columns:2fr 1fr 1fr}.lg\\:grid-cols-\\[11fr_9fr\\]{grid-template-columns:11fr 9fr}.lg\\:grid-cols-\\[520px_1fr\\]{grid-template-columns:520px 1fr}.lg\\:flex-col{flex-direction:column}.lg\\:flex-row{flex-direction:row}.lg\\:flex-nowrap{flex-wrap:nowrap}.lg\\:items-center{align-items:center}.lg\\:gap-4{gap:calc(var(--spacing)*4)}.lg\\:gap-10{gap:calc(var(--spacing)*10)}.lg\\:gap-12{gap:calc(var(--spacing)*12)}:where(.lg\\:divide-x>:not(:last-child)){--tw-divide-x-reverse:0;border-inline-style:var(--tw-border-style);border-inline-start-width:calc(1px*var(--tw-divide-x-reverse));border-inline-end-width:calc(1px*calc(1 - var(--tw-divide-x-reverse)))}:where(.lg\\:divide-y-0>:not(:last-child)){--tw-divide-y-reverse:0;border-bottom-style:var(--tw-border-style);border-top-style:var(--tw-border-style);border-top-width:calc(0px*var(--tw-divide-y-reverse));border-bottom-width:calc(0px*calc(1 - var(--tw-divide-y-reverse)))}.lg\\:self-start{align-self:flex-start}.lg\\:overflow-visible{overflow:visible}.lg\\:overflow-y-auto{overflow-y:auto}.lg\\:border-r{border-right-style:var(--tw-border-style);border-right-width:1px}.lg\\:bg-transparent{background-color:#0000}.lg\\:object-left{object-position:left}.lg\\:p-0{padding:calc(var(--spacing)*0)}.lg\\:p-5{padding:calc(var(--spacing)*5)}.lg\\:p-10{padding:calc(var(--spacing)*10)}.lg\\:px-2{padding-inline:calc(var(--spacing)*2)}.lg\\:px-4{padding-inline:calc(var(--spacing)*4)}.lg\\:px-5{padding-inline:calc(var(--spacing)*5)}.lg\\:px-10{padding-inline:calc(var(--spacing)*10)}.lg\\:py-0{padding-block:calc(var(--spacing)*0)}.lg\\:py-6{padding-block:calc(var(--spacing)*6)}.lg\\:py-16{padding-block:calc(var(--spacing)*16)}.lg\\:py-20{padding-block:calc(var(--spacing)*20)}.lg\\:py-25{padding-block:calc(var(--spacing)*25)}.lg\\:pt-7\\.5{padding-top:calc(var(--spacing)*7.5)}.lg\\:pt-25{padding-top:calc(var(--spacing)*25)}.lg\\:pb-0{padding-bottom:calc(var(--spacing)*0)}.lg\\:text-3xl{font-size:var(--text-3xl);line-height:var(--tw-leading,var(--text-3xl--line-height))}.lg\\:text-5xl{font-size:var(--text-5xl);line-height:var(--tw-leading,var(--text-5xl--line-height))}.lg\\:text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.lg\\:text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.even\\:lg\\:border-r:nth-child(2n){border-right-style:var(--tw-border-style);border-right-width:1px}}@media(min-width:80rem){.xl\\:grid{display:grid}.xl\\:w-auto{width:auto}.xl\\:w-fit{width:fit-content}.xl\\:flex-none{flex:none}.xl\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.xl\\:grid-cols-\\[1fr_auto\\]{grid-template-columns:1fr auto}.xl\\:grid-cols-\\[repeat\\(2\\,480px\\)\\]{grid-template-columns:repeat(2,480px)}.xl\\:justify-center{justify-content:center}.xl\\:justify-start{justify-content:flex-start}.xl\\:p-14{padding:calc(var(--spacing)*14)}.xl\\:text-4xl{font-size:var(--text-4xl);line-height:var(--tw-leading,var(--text-4xl--line-height))}}@media(min-width:96rem){.\\32xl\\:h-\\[700px\\]{height:700px}}.\\[\\&_a\\]\\:text-xs a{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.\\[\\&_a\\]\\:tracking-wide a{--tw-tracking:var(--tracking-wide);letter-spacing:var(--tracking-wide)}.\\[\\&_a\\]\\:text-foreground a{color:var(--color-foreground)}.\\[\\&_a\\]\\:uppercase a{text-transform:uppercase}.\\[\\&_a\\]\\:no-underline a{text-decoration-line:none}.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button{appearance:none}.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button{appearance:none}.\\[\\&\\>\\*\\:not\\(\\[data-tab-indicator\\]\\)\\]\\:z-10>:not([data-tab-indicator]){z-index:10}}body{font-family:var(--font-sans);background-color:var(--color-background);color:var(--color-foreground);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}h1,h2,h3,h4,h5,h6{font-family:var(--font-header)}body:has(dialog[open]){scrollbar-gutter:stable;overflow:hidden}dialog{display:none}dialog[open]{display:block}dialog::backdrop{background-color:#442a191a}dialog[open].max-h-none\\!,dialog[open][class*=max-h-none]{max-height:none!important}.hide-scrollbar{-ms-overflow-style:none;scrollbar-width:none}.hide-scrollbar::-webkit-scrollbar{display:none}@media(min-width:64rem){:root{--spacing-container-padding:1.5rem}}:root[data-theme=b2b],html[data-theme=b2b],[data-theme=b2b]{--color-accent:var(--color-accent-purple)!important;--color-accent-secondary:var(--color-accent-secondary-purple)!important}@property --tw-translate-x{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-y{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-z{syntax:"*";inherits:false;initial-value:0}@property --tw-scale-x{syntax:"*";inherits:false;initial-value:1}@property --tw-scale-y{syntax:"*";inherits:false;initial-value:1}@property --tw-scale-z{syntax:"*";inherits:false;initial-value:1}@property --tw-rotate-x{syntax:"*";inherits:false}@property --tw-rotate-y{syntax:"*";inherits:false}@property --tw-rotate-z{syntax:"*";inherits:false}@property --tw-skew-x{syntax:"*";inherits:false}@property --tw-skew-y{syntax:"*";inherits:false}@property --tw-pan-x{syntax:"*";inherits:false}@property --tw-pan-y{syntax:"*";inherits:false}@property --tw-pinch-zoom{syntax:"*";inherits:false}@property --tw-space-y-reverse{syntax:"*";inherits:false;initial-value:0}@property --tw-space-x-reverse{syntax:"*";inherits:false;initial-value:0}@property --tw-divide-x-reverse{syntax:"*";inherits:false;initial-value:0}@property --tw-border-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-divide-y-reverse{syntax:"*";inherits:false;initial-value:0}@property --tw-gradient-position{syntax:"*";inherits:false}@property --tw-gradient-from{syntax:"<color>";inherits:false;initial-value:#0000}@property --tw-gradient-via{syntax:"<color>";inherits:false;initial-value:#0000}@property --tw-gradient-to{syntax:"<color>";inherits:false;initial-value:#0000}@property --tw-gradient-stops{syntax:"*";inherits:false}@property --tw-gradient-via-stops{syntax:"*";inherits:false}@property --tw-gradient-from-position{syntax:"<length-percentage>";inherits:false;initial-value:0%}@property --tw-gradient-via-position{syntax:"<length-percentage>";inherits:false;initial-value:50%}@property --tw-gradient-to-position{syntax:"<length-percentage>";inherits:false;initial-value:100%}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-tracking{syntax:"*";inherits:false}@property --tw-ordinal{syntax:"*";inherits:false}@property --tw-slashed-zero{syntax:"*";inherits:false}@property --tw-numeric-figure{syntax:"*";inherits:false}@property --tw-numeric-spacing{syntax:"*";inherits:false}@property --tw-numeric-fraction{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-blur{syntax:"*";inherits:false}@property --tw-brightness{syntax:"*";inherits:false}@property --tw-contrast{syntax:"*";inherits:false}@property --tw-grayscale{syntax:"*";inherits:false}@property --tw-hue-rotate{syntax:"*";inherits:false}@property --tw-invert{syntax:"*";inherits:false}@property --tw-opacity{syntax:"*";inherits:false}@property --tw-saturate{syntax:"*";inherits:false}@property --tw-sepia{syntax:"*";inherits:false}@property --tw-drop-shadow{syntax:"*";inherits:false}@property --tw-drop-shadow-color{syntax:"*";inherits:false}@property --tw-drop-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-drop-shadow-size{syntax:"*";inherits:false}@property --tw-backdrop-blur{syntax:"*";inherits:false}@property --tw-backdrop-brightness{syntax:"*";inherits:false}@property --tw-backdrop-contrast{syntax:"*";inherits:false}@property --tw-backdrop-grayscale{syntax:"*";inherits:false}@property --tw-backdrop-hue-rotate{syntax:"*";inherits:false}@property --tw-backdrop-invert{syntax:"*";inherits:false}@property --tw-backdrop-opacity{syntax:"*";inherits:false}@property --tw-backdrop-saturate{syntax:"*";inherits:false}@property --tw-backdrop-sepia{syntax:"*";inherits:false}@property --tw-duration{syntax:"*";inherits:false}@property --tw-ease{syntax:"*";inherits:false}@property --tw-content{syntax:"*";inherits:false;initial-value:""}@keyframes spin{to{transform:rotate(360deg)}}@keyframes pulse{50%{opacity:.5}}`;
const ai = globalThis, kr = ai.ShadowRoot && (ai.ShadyCSS === void 0 || ai.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, _r = Symbol(), no = /* @__PURE__ */ new WeakMap();
let xa = class {
  constructor(t, e, r) {
    if (this._$cssResult$ = !0, r !== _r) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (kr && t === void 0) {
      const r = e !== void 0 && e.length === 1;
      r && (t = no.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), r && no.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Ca = (s) => new xa(typeof s == "string" ? s : s + "", void 0, _r), N = (s, ...t) => {
  const e = s.length === 1 ? s[0] : t.reduce(((r, i, n) => r + ((o) => {
    if (o._$cssResult$ === !0) return o.cssText;
    if (typeof o == "number") return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + s[n + 1]), s[0]);
  return new xa(e, s, _r);
}, nd = (s, t) => {
  if (kr) s.adoptedStyleSheets = t.map(((e) => e instanceof CSSStyleSheet ? e : e.styleSheet));
  else for (const e of t) {
    const r = document.createElement("style"), i = ai.litNonce;
    i !== void 0 && r.setAttribute("nonce", i), r.textContent = e.cssText, s.appendChild(r);
  }
}, oo = kr ? (s) => s : (s) => s instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const r of t.cssRules) e += r.cssText;
  return Ca(e);
})(s) : s;
const { is: od, defineProperty: ad, getOwnPropertyDescriptor: ld, getOwnPropertyNames: cd, getOwnPropertySymbols: dd, getPrototypeOf: hd } = Object, ki = globalThis, ao = ki.trustedTypes, ud = ao ? ao.emptyScript : "", pd = ki.reactiveElementPolyfillSupport, cs = (s, t) => s, di = { toAttribute(s, t) {
  switch (t) {
    case Boolean:
      s = s ? ud : null;
      break;
    case Object:
    case Array:
      s = s == null ? s : JSON.stringify(s);
  }
  return s;
}, fromAttribute(s, t) {
  let e = s;
  switch (t) {
    case Boolean:
      e = s !== null;
      break;
    case Number:
      e = s === null ? null : Number(s);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(s);
      } catch {
        e = null;
      }
  }
  return e;
} }, Er = (s, t) => !od(s, t), lo = { attribute: !0, type: String, converter: di, reflect: !1, useDefault: !1, hasChanged: Er };
Symbol.metadata ??= Symbol("metadata"), ki.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
let ke = class extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ??= []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = lo) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((e = Object.create(e)).wrapped = !0), this.elementProperties.set(t, e), !e.noAccessor) {
      const r = Symbol(), i = this.getPropertyDescriptor(t, r, e);
      i !== void 0 && ad(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, e, r) {
    const { get: i, set: n } = ld(this.prototype, t) ?? { get() {
      return this[e];
    }, set(o) {
      this[e] = o;
    } };
    return { get: i, set(o) {
      const a = i?.call(this);
      n?.call(this, o), this.requestUpdate(t, a, r);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? lo;
  }
  static _$Ei() {
    if (this.hasOwnProperty(cs("elementProperties"))) return;
    const t = hd(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(cs("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(cs("properties"))) {
      const e = this.properties, r = [...cd(e), ...dd(e)];
      for (const i of r) this.createProperty(i, e[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [r, i] of e) this.elementProperties.set(r, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, r] of this.elementProperties) {
      const i = this._$Eu(e, r);
      i !== void 0 && this._$Eh.set(i, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const r = new Set(t.flat(1 / 0).reverse());
      for (const i of r) e.unshift(oo(i));
    } else t !== void 0 && e.push(oo(t));
    return e;
  }
  static _$Eu(t, e) {
    const r = e.attribute;
    return r === !1 ? void 0 : typeof r == "string" ? r : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise(((t) => this.enableUpdating = t)), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach(((t) => t(this)));
  }
  addController(t) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && t.hostConnected?.();
  }
  removeController(t) {
    this._$EO?.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const r of e.keys()) this.hasOwnProperty(r) && (t.set(r, this[r]), delete this[r]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return nd(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach(((t) => t.hostConnected?.()));
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    this._$EO?.forEach(((t) => t.hostDisconnected?.()));
  }
  attributeChangedCallback(t, e, r) {
    this._$AK(t, r);
  }
  _$ET(t, e) {
    const r = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, r);
    if (i !== void 0 && r.reflect === !0) {
      const n = (r.converter?.toAttribute !== void 0 ? r.converter : di).toAttribute(e, r.type);
      this._$Em = t, n == null ? this.removeAttribute(i) : this.setAttribute(i, n), this._$Em = null;
    }
  }
  _$AK(t, e) {
    const r = this.constructor, i = r._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const n = r.getPropertyOptions(i), o = typeof n.converter == "function" ? { fromAttribute: n.converter } : n.converter?.fromAttribute !== void 0 ? n.converter : di;
      this._$Em = i;
      const a = o.fromAttribute(e, n.type);
      this[i] = a ?? this._$Ej?.get(i) ?? a, this._$Em = null;
    }
  }
  requestUpdate(t, e, r) {
    if (t !== void 0) {
      const i = this.constructor, n = this[t];
      if (r ??= i.getPropertyOptions(t), !((r.hasChanged ?? Er)(n, e) || r.useDefault && r.reflect && n === this._$Ej?.get(t) && !this.hasAttribute(i._$Eu(t, r)))) return;
      this.C(t, e, r);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, e, { useDefault: r, reflect: i, wrapped: n }, o) {
    r && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, o ?? e ?? this[t]), n !== !0 || o !== void 0) || (this._$AL.has(t) || (this.hasUpdated || r || (e = void 0), this._$AL.set(t, e)), i === !0 && this._$Em !== t && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [i, n] of this._$Ep) this[i] = n;
        this._$Ep = void 0;
      }
      const r = this.constructor.elementProperties;
      if (r.size > 0) for (const [i, n] of r) {
        const { wrapped: o } = n, a = this[i];
        o !== !0 || this._$AL.has(i) || a === void 0 || this.C(i, void 0, n, a);
      }
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), this._$EO?.forEach(((r) => r.hostUpdate?.())), this.update(e)) : this._$EM();
    } catch (r) {
      throw t = !1, this._$EM(), r;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    this._$EO?.forEach(((e) => e.hostUpdated?.())), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq &&= this._$Eq.forEach(((e) => this._$ET(e, this[e]))), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
ke.elementStyles = [], ke.shadowRootOptions = { mode: "open" }, ke[cs("elementProperties")] = /* @__PURE__ */ new Map(), ke[cs("finalized")] = /* @__PURE__ */ new Map(), pd?.({ ReactiveElement: ke }), (ki.reactiveElementVersions ??= []).push("2.1.1");
const Ar = globalThis, hi = Ar.trustedTypes, co = hi ? hi.createPolicy("lit-html", { createHTML: (s) => s }) : void 0, ka = "$lit$", Bt = `lit$${Math.random().toFixed(9).slice(2)}$`, _a = "?" + Bt, fd = `<${_a}>`, ae = document, us = () => ae.createComment(""), ps = (s) => s === null || typeof s != "object" && typeof s != "function", Sr = Array.isArray, gd = (s) => Sr(s) || typeof s?.[Symbol.iterator] == "function", ji = `[ 	
\f\r]`, os = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, ho = /-->/g, uo = />/g, te = RegExp(`>|${ji}(?:([^\\s"'>=/]+)(${ji}*=${ji}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), po = /'/g, fo = /"/g, Ea = /^(?:script|style|textarea|title)$/i, md = (s) => (t, ...e) => ({ _$litType$: s, strings: t, values: e }), f = md(1), jt = Symbol.for("lit-noChange"), W = Symbol.for("lit-nothing"), go = /* @__PURE__ */ new WeakMap(), se = ae.createTreeWalker(ae, 129);
function Aa(s, t) {
  if (!Sr(s) || !s.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return co !== void 0 ? co.createHTML(t) : t;
}
const bd = (s, t) => {
  const e = s.length - 1, r = [];
  let i, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = os;
  for (let a = 0; a < e; a++) {
    const l = s[a];
    let d, c, h = -1, p = 0;
    for (; p < l.length && (o.lastIndex = p, c = o.exec(l), c !== null); ) p = o.lastIndex, o === os ? c[1] === "!--" ? o = ho : c[1] !== void 0 ? o = uo : c[2] !== void 0 ? (Ea.test(c[2]) && (i = RegExp("</" + c[2], "g")), o = te) : c[3] !== void 0 && (o = te) : o === te ? c[0] === ">" ? (o = i ?? os, h = -1) : c[1] === void 0 ? h = -2 : (h = o.lastIndex - c[2].length, d = c[1], o = c[3] === void 0 ? te : c[3] === '"' ? fo : po) : o === fo || o === po ? o = te : o === ho || o === uo ? o = os : (o = te, i = void 0);
    const m = o === te && s[a + 1].startsWith("/>") ? " " : "";
    n += o === os ? l + fd : h >= 0 ? (r.push(d), l.slice(0, h) + ka + l.slice(h) + Bt + m) : l + Bt + (h === -2 ? a : m);
  }
  return [Aa(s, n + (s[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), r];
};
class fs {
  constructor({ strings: t, _$litType$: e }, r) {
    let i;
    this.parts = [];
    let n = 0, o = 0;
    const a = t.length - 1, l = this.parts, [d, c] = bd(t, e);
    if (this.el = fs.createElement(d, r), se.currentNode = this.el.content, e === 2 || e === 3) {
      const h = this.el.content.firstChild;
      h.replaceWith(...h.childNodes);
    }
    for (; (i = se.nextNode()) !== null && l.length < a; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const h of i.getAttributeNames()) if (h.endsWith(ka)) {
          const p = c[o++], m = i.getAttribute(h).split(Bt), v = /([.?@])?(.*)/.exec(p);
          l.push({ type: 1, index: n, name: v[2], strings: m, ctor: v[1] === "." ? yd : v[1] === "?" ? wd : v[1] === "@" ? xd : _i }), i.removeAttribute(h);
        } else h.startsWith(Bt) && (l.push({ type: 6, index: n }), i.removeAttribute(h));
        if (Ea.test(i.tagName)) {
          const h = i.textContent.split(Bt), p = h.length - 1;
          if (p > 0) {
            i.textContent = hi ? hi.emptyScript : "";
            for (let m = 0; m < p; m++) i.append(h[m], us()), se.nextNode(), l.push({ type: 2, index: ++n });
            i.append(h[p], us());
          }
        }
      } else if (i.nodeType === 8) if (i.data === _a) l.push({ type: 2, index: n });
      else {
        let h = -1;
        for (; (h = i.data.indexOf(Bt, h + 1)) !== -1; ) l.push({ type: 7, index: n }), h += Bt.length - 1;
      }
      n++;
    }
  }
  static createElement(t, e) {
    const r = ae.createElement("template");
    return r.innerHTML = t, r;
  }
}
function $e(s, t, e = s, r) {
  if (t === jt) return t;
  let i = r !== void 0 ? e._$Co?.[r] : e._$Cl;
  const n = ps(t) ? void 0 : t._$litDirective$;
  return i?.constructor !== n && (i?._$AO?.(!1), n === void 0 ? i = void 0 : (i = new n(s), i._$AT(s, e, r)), r !== void 0 ? (e._$Co ??= [])[r] = i : e._$Cl = i), i !== void 0 && (t = $e(s, i._$AS(s, t.values), i, r)), t;
}
class vd {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: e }, parts: r } = this._$AD, i = (t?.creationScope ?? ae).importNode(e, !0);
    se.currentNode = i;
    let n = se.nextNode(), o = 0, a = 0, l = r[0];
    for (; l !== void 0; ) {
      if (o === l.index) {
        let d;
        l.type === 2 ? d = new Vs(n, n.nextSibling, this, t) : l.type === 1 ? d = new l.ctor(n, l.name, l.strings, this, t) : l.type === 6 && (d = new Cd(n, this, t)), this._$AV.push(d), l = r[++a];
      }
      o !== l?.index && (n = se.nextNode(), o++);
    }
    return se.currentNode = ae, i;
  }
  p(t) {
    let e = 0;
    for (const r of this._$AV) r !== void 0 && (r.strings !== void 0 ? (r._$AI(t, r, e), e += r.strings.length - 2) : r._$AI(t[e])), e++;
  }
}
class Vs {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t, e, r, i) {
    this.type = 2, this._$AH = W, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = r, this.options = i, this._$Cv = i?.isConnected ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && t?.nodeType === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = $e(this, t, e), ps(t) ? t === W || t == null || t === "" ? (this._$AH !== W && this._$AR(), this._$AH = W) : t !== this._$AH && t !== jt && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : gd(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== W && ps(this._$AH) ? this._$AA.nextSibling.data = t : this.T(ae.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    const { values: e, _$litType$: r } = t, i = typeof r == "number" ? this._$AC(t) : (r.el === void 0 && (r.el = fs.createElement(Aa(r.h, r.h[0]), this.options)), r);
    if (this._$AH?._$AD === i) this._$AH.p(e);
    else {
      const n = new vd(i, this), o = n.u(this.options);
      n.p(e), this.T(o), this._$AH = n;
    }
  }
  _$AC(t) {
    let e = go.get(t.strings);
    return e === void 0 && go.set(t.strings, e = new fs(t)), e;
  }
  k(t) {
    Sr(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let r, i = 0;
    for (const n of t) i === e.length ? e.push(r = new Vs(this.O(us()), this.O(us()), this, this.options)) : r = e[i], r._$AI(n), i++;
    i < e.length && (this._$AR(r && r._$AB.nextSibling, i), e.length = i);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    for (this._$AP?.(!1, !0, e); t !== this._$AB; ) {
      const r = t.nextSibling;
      t.remove(), t = r;
    }
  }
  setConnected(t) {
    this._$AM === void 0 && (this._$Cv = t, this._$AP?.(t));
  }
}
class _i {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, r, i, n) {
    this.type = 1, this._$AH = W, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = n, r.length > 2 || r[0] !== "" || r[1] !== "" ? (this._$AH = Array(r.length - 1).fill(new String()), this.strings = r) : this._$AH = W;
  }
  _$AI(t, e = this, r, i) {
    const n = this.strings;
    let o = !1;
    if (n === void 0) t = $e(this, t, e, 0), o = !ps(t) || t !== this._$AH && t !== jt, o && (this._$AH = t);
    else {
      const a = t;
      let l, d;
      for (t = n[0], l = 0; l < n.length - 1; l++) d = $e(this, a[r + l], e, l), d === jt && (d = this._$AH[l]), o ||= !ps(d) || d !== this._$AH[l], d === W ? t = W : t !== W && (t += (d ?? "") + n[l + 1]), this._$AH[l] = d;
    }
    o && !i && this.j(t);
  }
  j(t) {
    t === W ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class yd extends _i {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === W ? void 0 : t;
  }
}
class wd extends _i {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== W);
  }
}
class xd extends _i {
  constructor(t, e, r, i, n) {
    super(t, e, r, i, n), this.type = 5;
  }
  _$AI(t, e = this) {
    if ((t = $e(this, t, e, 0) ?? W) === jt) return;
    const r = this._$AH, i = t === W && r !== W || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive, n = t !== W && (r === W || i);
    i && this.element.removeEventListener(this.name, this, r), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class Cd {
  constructor(t, e, r) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = r;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    $e(this, t);
  }
}
const kd = Ar.litHtmlPolyfillSupport;
kd?.(fs, Vs), (Ar.litHtmlVersions ??= []).push("3.3.1");
const _d = (s, t, e) => {
  const r = e?.renderBefore ?? t;
  let i = r._$litPart$;
  if (i === void 0) {
    const n = e?.renderBefore ?? null;
    r._$litPart$ = i = new Vs(t.insertBefore(us(), n), n, void 0, e ?? {});
  }
  return i._$AI(s), i;
};
const $r = globalThis;
let rt = class extends ke {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t.firstChild, t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = _d(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return jt;
  }
};
rt._$litElement$ = !0, rt.finalized = !0, $r.litElementHydrateSupport?.({ LitElement: rt });
const Ed = $r.litElementPolyfillSupport;
Ed?.({ LitElement: rt });
($r.litElementVersions ??= []).push("4.2.1");
const $n = class $n extends rt {
};
$n.styles = [Ca(rd)];
let b = $n;
const Ad = (s, t) => {
  const e = new Array(s.length + t.length);
  for (let r = 0; r < s.length; r++)
    e[r] = s[r];
  for (let r = 0; r < t.length; r++)
    e[s.length + r] = t[r];
  return e;
}, Sd = (s, t) => ({
  classGroupId: s,
  validator: t
}), Sa = (s = /* @__PURE__ */ new Map(), t = null, e) => ({
  nextPart: s,
  validators: t,
  classGroupId: e
}), ui = "-", mo = [], $d = "arbitrary..", Td = (s) => {
  const t = Id(s), {
    conflictingClassGroups: e,
    conflictingClassGroupModifiers: r
  } = s;
  return {
    getClassGroupId: (o) => {
      if (o.startsWith("[") && o.endsWith("]"))
        return Od(o);
      const a = o.split(ui), l = a[0] === "" && a.length > 1 ? 1 : 0;
      return $a(a, l, t);
    },
    getConflictingClassGroupIds: (o, a) => {
      if (a) {
        const l = r[o], d = e[o];
        return l ? d ? Ad(d, l) : l : d || mo;
      }
      return e[o] || mo;
    }
  };
}, $a = (s, t, e) => {
  if (s.length - t === 0)
    return e.classGroupId;
  const i = s[t], n = e.nextPart.get(i);
  if (n) {
    const d = $a(s, t + 1, n);
    if (d) return d;
  }
  const o = e.validators;
  if (o === null)
    return;
  const a = t === 0 ? s.join(ui) : s.slice(t).join(ui), l = o.length;
  for (let d = 0; d < l; d++) {
    const c = o[d];
    if (c.validator(a))
      return c.classGroupId;
  }
}, Od = (s) => s.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = s.slice(1, -1), e = t.indexOf(":"), r = t.slice(0, e);
  return r ? $d + r : void 0;
})(), Id = (s) => {
  const {
    theme: t,
    classGroups: e
  } = s;
  return Vd(e, t);
}, Vd = (s, t) => {
  const e = Sa();
  for (const r in s) {
    const i = s[r];
    Tr(i, e, r, t);
  }
  return e;
}, Tr = (s, t, e, r) => {
  const i = s.length;
  for (let n = 0; n < i; n++) {
    const o = s[n];
    Pd(o, t, e, r);
  }
}, Pd = (s, t, e, r) => {
  if (typeof s == "string") {
    Md(s, t, e);
    return;
  }
  if (typeof s == "function") {
    Ld(s, t, e, r);
    return;
  }
  Rd(s, t, e, r);
}, Md = (s, t, e) => {
  const r = s === "" ? t : Ta(t, s);
  r.classGroupId = e;
}, Ld = (s, t, e, r) => {
  if (Hd(s)) {
    Tr(s(r), t, e, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(Sd(e, s));
}, Rd = (s, t, e, r) => {
  const i = Object.entries(s), n = i.length;
  for (let o = 0; o < n; o++) {
    const [a, l] = i[o];
    Tr(l, Ta(t, a), e, r);
  }
}, Ta = (s, t) => {
  let e = s;
  const r = t.split(ui), i = r.length;
  for (let n = 0; n < i; n++) {
    const o = r[n];
    let a = e.nextPart.get(o);
    a || (a = Sa(), e.nextPart.set(o, a)), e = a;
  }
  return e;
}, Hd = (s) => "isThemeGetter" in s && s.isThemeGetter === !0, Dd = (s) => {
  if (s < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, e = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const i = (n, o) => {
    e[n] = o, t++, t > s && (t = 0, r = e, e = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(n) {
      let o = e[n];
      if (o !== void 0)
        return o;
      if ((o = r[n]) !== void 0)
        return i(n, o), o;
    },
    set(n, o) {
      n in e ? e[n] = o : i(n, o);
    }
  };
}, Ji = "!", bo = ":", zd = [], vo = (s, t, e, r, i) => ({
  modifiers: s,
  hasImportantModifier: t,
  baseClassName: e,
  maybePostfixModifierPosition: r,
  isExternal: i
}), Nd = (s) => {
  const {
    prefix: t,
    experimentalParseClassName: e
  } = s;
  let r = (i) => {
    const n = [];
    let o = 0, a = 0, l = 0, d;
    const c = i.length;
    for (let w = 0; w < c; w++) {
      const x = i[w];
      if (o === 0 && a === 0) {
        if (x === bo) {
          n.push(i.slice(l, w)), l = w + 1;
          continue;
        }
        if (x === "/") {
          d = w;
          continue;
        }
      }
      x === "[" ? o++ : x === "]" ? o-- : x === "(" ? a++ : x === ")" && a--;
    }
    const h = n.length === 0 ? i : i.slice(l);
    let p = h, m = !1;
    h.endsWith(Ji) ? (p = h.slice(0, -1), m = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      h.startsWith(Ji) && (p = h.slice(1), m = !0)
    );
    const v = d && d > l ? d - l : void 0;
    return vo(n, m, p, v);
  };
  if (t) {
    const i = t + bo, n = r;
    r = (o) => o.startsWith(i) ? n(o.slice(i.length)) : vo(zd, !1, o, void 0, !0);
  }
  if (e) {
    const i = r;
    r = (n) => e({
      className: n,
      parseClassName: i
    });
  }
  return r;
}, Bd = (s) => {
  const t = /* @__PURE__ */ new Map();
  return s.orderSensitiveModifiers.forEach((e, r) => {
    t.set(e, 1e6 + r);
  }), (e) => {
    const r = [];
    let i = [];
    for (let n = 0; n < e.length; n++) {
      const o = e[n], a = o[0] === "[", l = t.has(o);
      a || l ? (i.length > 0 && (i.sort(), r.push(...i), i = []), r.push(o)) : i.push(o);
    }
    return i.length > 0 && (i.sort(), r.push(...i)), r;
  };
}, jd = (s) => ({
  cache: Dd(s.cacheSize),
  parseClassName: Nd(s),
  sortModifiers: Bd(s),
  ...Td(s)
}), Fd = /\s+/, Wd = (s, t) => {
  const {
    parseClassName: e,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: n
  } = t, o = [], a = s.trim().split(Fd);
  let l = "";
  for (let d = a.length - 1; d >= 0; d -= 1) {
    const c = a[d], {
      isExternal: h,
      modifiers: p,
      hasImportantModifier: m,
      baseClassName: v,
      maybePostfixModifierPosition: w
    } = e(c);
    if (h) {
      l = c + (l.length > 0 ? " " + l : l);
      continue;
    }
    let x = !!w, C = r(x ? v.substring(0, w) : v);
    if (!C) {
      if (!x) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (C = r(v), !C) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      x = !1;
    }
    const $ = p.length === 0 ? "" : p.length === 1 ? p[0] : n(p).join(":"), S = m ? $ + Ji : $, T = S + C;
    if (o.indexOf(T) > -1)
      continue;
    o.push(T);
    const k = i(C, x);
    for (let O = 0; O < k.length; ++O) {
      const P = k[O];
      o.push(S + P);
    }
    l = c + (l.length > 0 ? " " + l : l);
  }
  return l;
}, Ud = (...s) => {
  let t = 0, e, r, i = "";
  for (; t < s.length; )
    (e = s[t++]) && (r = Oa(e)) && (i && (i += " "), i += r);
  return i;
}, Oa = (s) => {
  if (typeof s == "string")
    return s;
  let t, e = "";
  for (let r = 0; r < s.length; r++)
    s[r] && (t = Oa(s[r])) && (e && (e += " "), e += t);
  return e;
}, qd = (s, ...t) => {
  let e, r, i, n;
  const o = (l) => {
    const d = t.reduce((c, h) => h(c), s());
    return e = jd(d), r = e.cache.get, i = e.cache.set, n = a, a(l);
  }, a = (l) => {
    const d = r(l);
    if (d)
      return d;
    const c = Wd(l, e);
    return i(l, c), c;
  };
  return n = o, (...l) => n(Ud(...l));
}, Kd = [], Z = (s) => {
  const t = (e) => e[s] || Kd;
  return t.isThemeGetter = !0, t;
}, Ia = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Va = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Zd = /^\d+\/\d+$/, Gd = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Yd = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Xd = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Jd = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Qd = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, xe = (s) => Zd.test(s), M = (s) => !!s && !Number.isNaN(Number(s)), zt = (s) => !!s && Number.isInteger(Number(s)), Fi = (s) => s.endsWith("%") && M(s.slice(0, -1)), Vt = (s) => Gd.test(s), th = () => !0, eh = (s) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Yd.test(s) && !Xd.test(s)
), Pa = () => !1, sh = (s) => Jd.test(s), ih = (s) => Qd.test(s), rh = (s) => !E(s) && !A(s), nh = (s) => Le(s, Ra, Pa), E = (s) => Ia.test(s), ee = (s) => Le(s, Ha, eh), Wi = (s) => Le(s, dh, M), yo = (s) => Le(s, Ma, Pa), oh = (s) => Le(s, La, ih), ei = (s) => Le(s, Da, sh), A = (s) => Va.test(s), as = (s) => Re(s, Ha), ah = (s) => Re(s, hh), wo = (s) => Re(s, Ma), lh = (s) => Re(s, Ra), ch = (s) => Re(s, La), si = (s) => Re(s, Da, !0), Le = (s, t, e) => {
  const r = Ia.exec(s);
  return r ? r[1] ? t(r[1]) : e(r[2]) : !1;
}, Re = (s, t, e = !1) => {
  const r = Va.exec(s);
  return r ? r[1] ? t(r[1]) : e : !1;
}, Ma = (s) => s === "position" || s === "percentage", La = (s) => s === "image" || s === "url", Ra = (s) => s === "length" || s === "size" || s === "bg-size", Ha = (s) => s === "length", dh = (s) => s === "number", hh = (s) => s === "family-name", Da = (s) => s === "shadow", uh = () => {
  const s = Z("color"), t = Z("font"), e = Z("text"), r = Z("font-weight"), i = Z("tracking"), n = Z("leading"), o = Z("breakpoint"), a = Z("container"), l = Z("spacing"), d = Z("radius"), c = Z("shadow"), h = Z("inset-shadow"), p = Z("text-shadow"), m = Z("drop-shadow"), v = Z("blur"), w = Z("perspective"), x = Z("aspect"), C = Z("ease"), $ = Z("animate"), S = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], k = () => [...T(), A, E], O = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", "contain", "none"], y = () => [A, E, l], V = () => [xe, "full", "auto", ...y()], D = () => [zt, "none", "subgrid", A, E], K = () => ["auto", {
    span: ["full", zt, A, E]
  }, zt, A, E], et = () => [zt, "auto", A, E], ot = () => ["auto", "min", "max", "fr", A, E], ht = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], gt = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], Y = () => ["auto", ...y()], z = () => [xe, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...y()], _ = () => [s, A, E], st = () => [...T(), wo, yo, {
    position: [A, E]
  }], Jt = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ns = () => ["auto", "cover", "contain", lh, nh, {
    size: [A, E]
  }], we = () => [Fi, as, ee], G = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    A,
    E
  ], X = () => ["", M, as, ee], Ct = () => ["solid", "dashed", "dotted", "double"], Qt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], B = () => [M, Fi, wo, yo], Dt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    v,
    A,
    E
  ], kt = () => ["none", M, A, E], Qs = () => ["none", M, A, E], Bi = () => [M, A, E], ti = () => [xe, "full", ...y()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Vt],
      breakpoint: [Vt],
      color: [th],
      container: [Vt],
      "drop-shadow": [Vt],
      ease: ["in", "out", "in-out"],
      font: [rh],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Vt],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Vt],
      shadow: [Vt],
      spacing: ["px", M],
      text: [Vt],
      "text-shadow": [Vt],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", xe, E, A, x]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [M, E, A, a]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": S()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": S()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: k()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: V()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": V()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": V()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: V()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: V()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: V()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: V()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: V()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: V()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [zt, "auto", A, E]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [xe, "full", "auto", a, ...y()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [M, xe, "auto", "initial", "none", E]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", M, A, E]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", M, A, E]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [zt, "first", "last", "none", A, E]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": D()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: K()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": et()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": et()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": D()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: K()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": et()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": et()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ot()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ot()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: y()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": y()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": y()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...ht(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...gt(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...gt()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ht()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...gt(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...gt(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": ht()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...gt(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...gt()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: y()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: y()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: y()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: y()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: y()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: y()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: y()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: y()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: y()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: Y()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: Y()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: Y()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: Y()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: Y()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: Y()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: Y()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: Y()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: Y()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": y()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": y()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: z()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [a, "screen", ...z()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          a,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...z()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          a,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [o]
          },
          ...z()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...z()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...z()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...z()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", e, as, ee]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, A, Wi]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Fi, E]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ah, E, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, A, E]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [M, "none", A, Wi]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          n,
          ...y()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", A, E]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", A, E]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: _()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: _()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ct(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [M, "from-font", "auto", A, ee]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: _()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [M, "auto", A, E]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: y()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", A, E]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", A, E]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: st()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Jt()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ns()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, zt, A, E],
          radial: ["", A, E],
          conic: [zt, A, E]
        }, ch, oh]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: _()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: we()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: we()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: we()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: _()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: _()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: _()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: G()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": G()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": G()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": G()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": G()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": G()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": G()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": G()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": G()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": G()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": G()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": G()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": G()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": G()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": G()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: X()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": X()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": X()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": X()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": X()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": X()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": X()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": X()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": X()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": X()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": X()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ct(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Ct(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: _()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": _()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": _()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": _()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": _()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": _()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": _()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": _()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": _()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: _()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Ct(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [M, A, E]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", M, as, ee]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: _()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          c,
          si,
          ei
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: _()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", h, si, ei]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": _()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: X()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: _()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [M, ee]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": _()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": X()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": _()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", p, si, ei]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": _()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [M, A, E]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Qt(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Qt()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [M]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": B()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": B()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": _()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": _()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": B()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": B()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": _()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": _()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": B()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": B()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": _()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": _()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": B()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": B()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": _()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": _()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": B()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": B()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": _()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": _()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": B()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": B()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": _()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": _()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": B()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": B()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": _()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": _()
      }],
      "mask-image-radial": [{
        "mask-radial": [A, E]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": B()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": B()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": _()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": _()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": T()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [M]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": B()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": B()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": _()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": _()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: st()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Jt()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ns()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", A, E]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          A,
          E
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Dt()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [M, A, E]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [M, A, E]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          m,
          si,
          ei
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": _()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", M, A, E]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [M, A, E]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", M, A, E]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [M, A, E]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", M, A, E]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          A,
          E
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Dt()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [M, A, E]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [M, A, E]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", M, A, E]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [M, A, E]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", M, A, E]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [M, A, E]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [M, A, E]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", M, A, E]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": y()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": y()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": y()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", A, E]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [M, "initial", A, E]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", C, A, E]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [M, A, E]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", $, A, E]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [w, A, E]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": k()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: kt()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": kt()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": kt()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": kt()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Qs()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Qs()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Qs()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Qs()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: Bi()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": Bi()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": Bi()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [A, E, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: k()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: ti()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": ti()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": ti()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": ti()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: _()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: _()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", A, E]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": y()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": y()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": y()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": y()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": y()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": y()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": y()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": y()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": y()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": y()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": y()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": y()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": y()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": y()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": y()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": y()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": y()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": y()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", A, E]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ..._()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [M, as, ee, Wi]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ..._()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, ph = /* @__PURE__ */ qd(uh), g = (...s) => ph(s.filter(Boolean).join(" "));
function H(s) {
  if (!s) return [];
  const t = [], e = s.split(/\s+/).filter(Boolean), r = "(?:hover|focus|active|disabled|visited|checked|group-hover|group-focus|peer-hover|peer-focus|dark|light|sm|md|lg|xl|2xl|max-sm|max-md|max-lg|max-xl|max-2xl|min-sm|min-md|min-lg|min-xl|min-2xl|data-\\[?[^\\]]+\\]?):", i = [
    new RegExp(`^(?:${r})?bg-`),
    // background (bg-blue-500, bg-background, hover:bg-foreground/5, etc.)
    new RegExp(`^(?:${r})?from-`),
    // gradient from
    new RegExp(`^(?:${r})?via-`),
    // gradient via
    new RegExp(`^(?:${r})?to-`),
    // gradient to
    new RegExp(`^(?:${r})?border`),
    // border, border-2, border-t, border-border, border-red-500, hover:border-mix-border/8, data-invalid:border-red-500, etc.
    new RegExp(
      `^(?:${r})?p[tblrxy]?-\\d+(\\.\\d+)?|^(?:${r})?p[tblrxy]?-\\[`
    ),
    // padding (p-4, px-2, hover:px-1.5, focus:py-[10px], etc.)
    new RegExp(
      `^(?:${r})?m[tblrxy]?-\\d+(\\.\\d+)?|^(?:${r})?m[tblrxy]?-\\[`
    ),
    // margin (m-4, mx-2, hover:mx-1.5, focus:my-[10px], etc.) - space-x/y don't match this pattern
    new RegExp(`^(?:${r})?text-[a-z]`),
    // text color (text-red-500, text-foreground/80, hover:text-foreground, etc.) - but NOT text sizes (checked inline)
    new RegExp(`^(?:${r})?opacity-`),
    // opacity
    new RegExp(`^(?:${r})?shadow-`),
    // shadow (shadow-xs, shadow-sm, hover:shadow-md, etc.)
    new RegExp(`^(?:${r})?rounded(-[trbl])?(-\\d+)?$`),
    // rounded, rounded-lg, hover:rounded-t, etc.
    new RegExp(
      `^(?:${r})?w-|^(?:${r})?h-|^(?:${r})?min-w-|^(?:${r})?max-w-|^(?:${r})?min-h-|^(?:${r})?max-h-`
    )
    // width/height (w-4, h-full, hover:min-w-0, focus:max-w-xs, etc.)
  ];
  for (const n of e) {
    let o = !1;
    for (const a of i)
      if (a.test(n)) {
        if (a.source.includes("text-")) {
          const l = n.replace(new RegExp(`^(?:${r})`), "");
          if (/^text-(\d+)?(xs|sm|base|lg|xl)$/.test(l))
            continue;
        }
        o = !0;
        break;
      }
    o || t.push(n);
  }
  return t;
}
function o0(s) {
  return H(s);
}
function a0(s, t = []) {
  const e = {};
  for (const [r, i] of Object.entries(s))
    t.includes(r) || i != null && (e[r] = i);
  return e;
}
const fh = { attribute: !0, type: String, converter: di, reflect: !1, hasChanged: Er }, gh = (s = fh, t, e) => {
  const { kind: r, metadata: i } = e;
  let n = globalThis.litPropertyMetadata.get(i);
  if (n === void 0 && globalThis.litPropertyMetadata.set(i, n = /* @__PURE__ */ new Map()), r === "setter" && ((s = Object.create(s)).wrapped = !0), n.set(e.name, s), r === "accessor") {
    const { name: o } = e;
    return { set(a) {
      const l = t.get.call(this);
      t.set.call(this, a), this.requestUpdate(o, l, s);
    }, init(a) {
      return a !== void 0 && this.C(o, void 0, s, a), a;
    } };
  }
  if (r === "setter") {
    const { name: o } = e;
    return function(a) {
      const l = this[o];
      t.call(this, a), this.requestUpdate(o, l, s);
    };
  }
  throw Error("Unsupported decorator location: " + r);
};
function u(s) {
  return (t, e) => typeof e == "object" ? gh(s, t, e) : ((r, i, n) => {
    const o = i.hasOwnProperty(n);
    return i.constructor.createProperty(n, r), o ? Object.getOwnPropertyDescriptor(i, n) : void 0;
  })(s, t, e);
}
function R(s) {
  return u({ ...s, state: !0, attribute: !1 });
}
const za = (s, t, e) => (e.configurable = !0, e.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(s, t, e), e);
function Kt(s, t) {
  return (e, r, i) => {
    const n = (o) => o.renderRoot?.querySelector(s) ?? null;
    return za(e, r, { get() {
      return n(this);
    } });
  };
}
function mh(s) {
  return (t, e) => {
    const { slot: r, selector: i } = s ?? {}, n = "slot" + (r ? `[name=${r}]` : ":not([name])");
    return za(t, e, { get() {
      const o = this.renderRoot?.querySelector(n), a = o?.assignedElements(s) ?? [];
      return i === void 0 ? a : a.filter(((l) => l.matches(i)));
    } });
  };
}
var bh = Object.defineProperty, vh = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && bh(t, e, i), i;
};
const Tn = class Tn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.defaultClasses = "block relative w-[480px] aspect-480/580 text-inherit focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2", this.container = null, this._handleMouseEnter = () => {
      this.setAttribute("data-hovered", "true");
    }, this._handleMouseLeave = () => {
      this.removeAttribute("data-hovered");
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
  }
  disconnectedCallback() {
    this._removeHoverListener(), super.disconnectedCallback();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), requestAnimationFrame(() => {
      this._setupHoverListener();
    });
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), t.has("asChild") && (this._removeHoverListener(), requestAnimationFrame(() => {
      this._setupHoverListener();
    }));
  }
  _getContainer() {
    if (this.asChild) {
      const t = this.children[0];
      return t instanceof HTMLElement ? t : null;
    }
    return this.shadowRoot?.querySelector("div") || null;
  }
  _setupHoverListener() {
    this.container = this._getContainer(), this.container && (this.container.addEventListener("mouseenter", this._handleMouseEnter), this.container.addEventListener("mouseleave", this._handleMouseLeave));
  }
  _removeHoverListener() {
    this.container && (this.container.removeEventListener("mouseenter", this._handleMouseEnter), this.container.removeEventListener("mouseleave", this._handleMouseLeave), this.container = null);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.defaultClasses, this.originalCustomClass);
    return f`
      <div class="${t}">
        <slot></slot>
      </div>
    `;
  }
};
Tn.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
      }

      :host([as-child]) {
        display: contents;
      }

      :host([data-hovered='true']) ::slotted(ck-product-card-footer) {
        --button-visible: 1;
      }
    `
];
let pi = Tn;
vh([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], pi.prototype, "asChild");
customElements.get("ck-product-card") || customElements.define("ck-product-card", pi);
const On = class On extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.defaultClasses = "block size-full overflow-hidden bg-neutral-100";
  }
  connectedCallback() {
    super.connectedCallback(), this.style.display || (this.style.display = "block"), this.style.width || (this.style.width = "100%"), this.style.height || (this.style.height = "100%"), this.originalCustomClass = this.getAttribute("class") || "";
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || "");
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "");
  }
  render() {
    return f`
      <div class="${g(this.defaultClasses, this.originalCustomClass)}">
        <slot></slot>
      </div>
    `;
  }
};
On.styles = b.styles;
let Qi = On;
customElements.get("ck-product-card-body") || customElements.define("ck-product-card-body", Qi);
function Zt(s, t, e = {}) {
  if (!s || !t) return null;
  if (e.className) {
    const r = t.className || "";
    t.className = g(r, e.className);
  }
  return e.style && (typeof e.style == "string" ? t.style.cssText += ` ${e.style}` : Object.assign(t.style, e.style)), Object.keys(e).forEach((r) => {
    if (r !== "className" && r !== "style" && r !== "asChild" && !r.startsWith("on")) {
      const i = e[r];
      i != null && (typeof i == "boolean" ? i ? t.setAttribute(r, "") : t.removeAttribute(r) : t.setAttribute(r, String(i)));
    }
  }), t;
}
function q(s, t, e = []) {
  Object.keys(s).filter(
    (i) => i.startsWith("on") && typeof s[i] == "function" && !e.includes(i)
  ).forEach((i) => {
    t[i] = s[i];
  });
}
function yh(s, t, e, r) {
  if (t) {
    const i = s.firstElementChild;
    return i ? i.tagName === e.toUpperCase() && i.shadowRoot?.querySelector(r) || i : null;
  } else {
    const i = s.shadowRoot;
    if (i) {
      const n = i.querySelector(e);
      if (n) {
        const o = n.shadowRoot;
        return o && o.querySelector(r) || n;
      }
    }
    return s;
  }
}
var wh = Object.defineProperty, xh = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && wh(t, e, i), i;
};
class Na extends b {
  constructor() {
    super(...arguments), this.size = "md";
  }
  createRenderRoot() {
    return this;
  }
  getSpinnerClasses() {
    return g(
      "relative",
      "animate-spin",
      "before:absolute before:left-0 before:top-0 before:block before:size-full before:rounded-full before:border-current before:opacity-40",
      "after:absolute after:left-0 after:top-0 after:block after:size-full after:rounded-full after:border-transparent after:border-r-current after:border-t-current",
      {
        xs: "size-2 before:border after:border",
        sm: "size-3 before:border after:border",
        md: "size-4 before:border-2 after:border-2",
        lg: "size-5 before:border-2 after:border-2"
      }[this.size]
    );
  }
  render() {
    return f`
      <div aria-label="loading" role="progressbar" class="${this.getSpinnerClasses()}"></div>
    `;
  }
}
xh([
  u({ type: String })
], Na.prototype, "size");
customElements.get("ck-spinner") || customElements.define("ck-spinner", Na);
var Ch = Object.defineProperty, He = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ch(t, e, i), i;
};
const kh = /* @__PURE__ */ new Set([
  "variant",
  "size",
  "square",
  "disabled",
  "loading",
  "class",
  // Handle class separately by merging with generated classes
  "id"
  // ID should stay on the custom element, not be copied to inner button (prevents duplicate IDs)
]), Ci = class Ci extends b {
  constructor() {
    super(), this.variant = "primary", this.size = "md", this.square = !1, this.disabled = !1, this.loading = !1, this.label = "Button", this._handleClick = (t) => {
      const e = this.onClick;
      if (typeof e == "function" && e(t), this.getAttribute("type") === "submit") {
        const r = this.internals.form;
        r && (t.preventDefault(), r.requestSubmit());
      }
    }, this.internals = this.attachInternals();
  }
  // Event handlers are accepted dynamically - any property starting with "on" will be passed through
  // Note: TypeScript doesn't allow index signatures on HTMLElement subclasses, so we use
  // dynamic property access via syncEventHandlers helper function
  firstUpdated() {
    this.buttonElement = this.shadowRoot?.querySelector("button"), this.syncAttributes(), this.syncEventHandlers();
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers();
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes) {
        const e = kh.has(t.name), r = t.name.toLowerCase().startsWith("on");
        !e && !r && this.buttonElement.setAttribute(t.name, t.value);
      }
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  getButtonClasses() {
    const t = "shrink-0 font-mono tracking-wide uppercase relative whitespace-nowrap inline-flex items-center justify-center gap-1.5 shadow-xs transition focus-visible:outline-none focus-visible:ring-4 disabled:opacity-50 disabled:cursor-not-allowed enabled:cursor-pointer h-(--button-height) ring-ring transition-all duration-200", e = {
      primary: "ck-button--primary bg-brown text-(--color-accent-secondary) hover:bg-foreground-tertiary active:bg-brown disabled:opacity-30 ring-alpha-intense",
      outline: "border border-border bg-background text-foreground focus-visible:border-border",
      ghost: "border-none bg-transparent ring-0 shadow-none text-foreground hover:bg-foreground/5",
      destructive: "bg-red-600 text-foreground-quaternary ring-red-600/50 hover:bg-red-700",
      secondary: "bg-(--color-accent) text-foreground hover:bg-foreground-tertiary active:bg-(--color-accent) disabled:opacity-30 ring-alpha-intense"
    }, r = {
      xs: "px-2 text-sm [--button-height:--spacing(6)]",
      sm: "px-3 text-sm [--button-height:--spacing(8)]",
      md: "px-4 text-sm [--button-height:--spacing(10.5)]",
      lg: "px-5 text-sm [--button-height:--spacing(14)]"
    }, i = this.getAttribute("class") || "";
    return g(
      t,
      e[this.variant || "primary"],
      r[this.size || "md"],
      this.square && "aspect-square w-(--button-height) px-0",
      i
    );
  }
  getSpinnerSize() {
    return {
      xs: "xs",
      sm: "sm",
      md: "sm",
      lg: "md"
    }[this.size || "md"] || "sm";
  }
  render() {
    const t = this.disabled || this.loading;
    return f`
      <button
        class="${this.getButtonClasses()}"
        ?disabled="${t}"
        type="${this.getAttribute("type") || "button"}"
        @click="${this._handleClick}"
      >
        <span class="ck-button__content">
          ${this.loading ? f`<ck-spinner size="${this.getSpinnerSize()}" class="text-current"></ck-spinner>` : f`<slot></slot>`}
        </span>
      </button>
    `;
  }
};
Ci.formAssociated = !0, Ci.styles = [
  ...b.styles,
  N`
      .ck-button__content {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    `
];
let Mt = Ci;
He([
  u({ type: String })
], Mt.prototype, "variant");
He([
  u({ type: String })
], Mt.prototype, "size");
He([
  u({ type: Boolean })
], Mt.prototype, "square");
He([
  u({ type: Boolean })
], Mt.prototype, "disabled");
He([
  u({ type: Boolean })
], Mt.prototype, "loading");
He([
  u({ type: String })
], Mt.prototype, "label");
customElements.get("ck-button") || customElements.define("ck-button", Mt);
var _h = Object.defineProperty, dt = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && _h(t, e, i), i;
};
const In = class In extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.defaultClasses = "absolute inset-x-5 bottom-5 block bg-white", this.title = "", this.price = "", this.compareAtPrice = "", this.variantId = "", this.ckAddToCart = !1, this.disabled = !1, this.isAdding = !1, this.justAdded = !1, this._resetTimer = null, this._parentClickHandler = null;
  }
  /**
   * Get product image URL from product card body
   */
  _getProductImage() {
    const t = this.closest("ck-product-card");
    if (!t) return null;
    const e = t.querySelector("ck-product-card-body");
    if (!e) return null;
    const r = e.querySelector("img");
    return r && r.src || null;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.disabled && this._preventParentNavigation();
  }
  disconnectedCallback() {
    if (this._resetTimer != null && (window.clearTimeout(this._resetTimer), this._resetTimer = null), this._parentClickHandler) {
      const t = this.closest("a");
      t && t.removeEventListener("click", this._parentClickHandler, !0), this._parentClickHandler = null;
    }
    super.disconnectedCallback();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || "");
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), t.has("disabled") && this._preventParentNavigation();
  }
  _preventParentNavigation() {
    if (this._parentClickHandler) {
      const e = this.closest("a");
      e && this._parentClickHandler && e.removeEventListener("click", this._parentClickHandler, !0), this._parentClickHandler = null;
    }
    if (!this.disabled) return;
    const t = this.closest("a");
    t && (this._parentClickHandler = (e) => {
      const r = e.composedPath(), i = e.target, n = i?.closest?.("a.BIS_trigger.notify-me-button") || (i?.classList?.contains("BIS_trigger") ? i : null) || t.querySelector("a.BIS_trigger.notify-me-button");
      n && (r.includes(n) || i === n) && e.preventDefault();
    }, t.addEventListener("click", this._parentClickHandler, !0));
  }
  _handleNotifyMeClick(t) {
    t.preventDefault(), t.stopPropagation();
    const e = this.closest("ck-product-card");
    if (!e) return;
    const i = e.querySelector("a.BIS_trigger.notify-me-button") || e.parentElement?.querySelector("a.BIS_trigger.notify-me-button") || document.querySelector(`a.BIS_trigger[data-variant-id="${this.variantId}"]`);
    i && i.click();
  }
  async _handleAddToCart(t) {
    if (t.preventDefault?.(), t.stopPropagation?.(), t.stopImmediatePropagation?.(), this.disabled || this.isAdding) return;
    const e = (r, i) => {
      this.dispatchEvent(
        new CustomEvent("ck-add-to-cart", {
          bubbles: !0,
          composed: !0,
          detail: {
            status: r,
            title: this.title,
            price: this.price,
            variantId: this.variantId || null,
            error: r === "error" ? i instanceof Error ? i.message : String(i) : null
          }
        })
      );
    };
    
    if (e("requested"), !this.ckAddToCart) {
      this.onaddtocart && this.onaddtocart();
      return;
    }
    if (!this.variantId) {
      const r = new Error("Missing variant-id for add to cart");
      console.error("[ck-product-card-footer] add-to-cart failed:", r), window.ckToast?.error?.("addToCart", r), e("error", r);
      return;
    }
    this.isAdding = !0, this.justAdded = !1;
    try {
      const r = {};
      this.roastLevelProperty && (r["Roast level"] = this.roastLevelProperty), this.brewMethodProperty && (r["Brew method"] = this.brewMethodProperty), this.grindSizeProperty && (r["Grind size"] = this.grindSizeProperty);
      const i = [
        {
          id: this.variantId,
          quantity: 1,
          ...this.sellingPlanId ? { selling_plan: this.sellingPlanId } : {},
          ...Object.keys(r).length > 0 ? { properties: r } : {}
        }
      ], n = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: i })
      });
      if (!n.ok) {
        const c = await n.json().catch(() => ({})), h = c.description || c.message || "Failed to add to cart. Please try again.";
        throw new Error(h);
      }
      await n.json().catch(() => null), window.dispatchEvent(new CustomEvent("cart:refresh"));
      const o = this._getProductImage(), a = o ? {
        product: {
          name: this.title,
          image: o
        }
      } : {};
      window.ckToast?.success?.("addToCart", a);
      const d = document.getElementById("cart-drawer")?.querySelector?.("ck-drawer-trigger");
      d && window.setTimeout(() => d.click(), 250), this.onaddtocart && this.onaddtocart(), this.justAdded = !0, e("success"), this._resetTimer = window.setTimeout(() => {
        this.isAdding = !1, this.justAdded = !1, this._resetTimer = null;
      }, 1200);
    } catch (r) {
      console.error("[ck-product-card-footer] add-to-cart failed:", r), window.ckToast?.error?.("addToCart", r), e("error", r), this.isAdding = !1, this.justAdded = !1;
    }
  }
  render() {
    const t = this.isAdding ? f`<slot name="label-adding">Adding...</slot>` : this.justAdded ? f`<slot name="label-added">Added!</slot>` : f`<slot name="label-add-to-cart">Add to cart</slot>`;
    return f`
      <div class="add-to-cart-wrapper">
        ${this.disabled ? f`
          <ck-button
            type="button"
            variant="primary"
            class="w-full"
            @click="${this._handleNotifyMeClick}"
          >
            <slot name="label-notify-me">Notify me</slot>
          </ck-button>
        ` : f`
          <ck-button
            type="button"
            variant="primary"
            class="w-full"
            ?disabled="${this.isAdding}"
            @click="${this._handleAddToCart}"
          >
            ${t}
          </ck-button>
          <a
            href="/cart/${ this.variantId }:1"
            class="button w-full buy-now-button"
          >
            <span>
              Buy it now
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="51" height="20" aria-labelledby="shop-logo" viewBox="0 -2 206 81">
              <title id="shop-logo">Shop</title>
              <path id="shop-logo" fill="#fff" d="M29.514 35.18c-7.934-1.697-11.469-2.36-11.469-5.374 0-2.834 2.392-4.246 7.176-4.246 4.207 0 7.283 1.813 9.546 5.363.171.274.524.369.812.222l8.927-4.447a.616.616 0 0 0 .256-.864c-3.705-6.332-10.55-9.798-19.562-9.798-11.843 0-19.2 5.752-19.2 14.898 0 9.714 8.96 12.169 16.904 13.865 7.944 1.697 11.49 2.36 11.49 5.373 0 3.014-2.584 4.436-7.742 4.436-4.763 0-8.297-2.15-10.433-6.321a.63.63 0 0 0-.843-.274L6.47 52.364a.623.623 0 0 0-.278.843c3.535 7.006 10.785 10.947 20.47 10.947 12.334 0 19.787-5.658 19.787-15.088s-9.001-12.169-16.935-13.865v-.021ZM77.353 16.036c-5.062 0-9.536 1.77-12.75 4.92-.203.19-.534.053-.534-.221V.622a.62.62 0 0 0-.63-.622h-11.17a.62.62 0 0 0-.63.622v62.426a.62.62 0 0 0 .63.621h11.17a.62.62 0 0 0 .63-.621V35.664c0-5.289 4.11-9.345 9.653-9.345 5.542 0 9.557 3.972 9.557 9.345v27.384a.62.62 0 0 0 .63.621h11.17a.62.62 0 0 0 .63-.621V35.664c0-11.505-7.646-19.618-18.356-19.618v-.01ZM118.389 14.255c-6.065 0-11.767 1.823-15.847 4.467a.618.618 0 0 0-.202.833l4.922 8.292c.182.295.566.4.865.22a19.82 19.82 0 0 1 10.262-2.78c9.749 0 16.914 6.785 16.914 15.75 0 7.64-5.734 13.297-13.006 13.297-5.926 0-10.037-3.403-10.037-8.207 0-2.75 1.185-5.005 4.271-6.596a.607.607 0 0 0 .246-.864l-4.645-7.754a.632.632 0 0 0-.759-.264c-6.225 2.276-10.593 7.755-10.593 15.109 0 11.126 8.981 19.428 21.507 19.428 14.629 0 25.147-9.998 25.147-24.338 0-15.372-12.237-26.603-29.066-26.603l.021.01ZM180.098 15.951c-5.649 0-10.689 2.055-14.373 5.68a.313.313 0 0 1-.534-.222v-4.362a.62.62 0 0 0-.63-.621H153.68a.62.62 0 0 0-.63.621v62.331a.62.62 0 0 0 .63.622h11.169a.62.62 0 0 0 .631-.622v-20.44c0-.274.331-.41.533-.231 3.674 3.371 8.532 5.342 14.096 5.342 13.102 0 23.321-10.463 23.321-24.054 0-13.592-10.23-24.054-23.321-24.054l-.011.01Zm-2.103 37.54c-7.454 0-13.103-5.847-13.103-13.58 0-7.734 5.638-13.582 13.103-13.582 7.464 0 13.091 5.753 13.091 13.581 0 7.829-5.553 13.581-13.102 13.581h.011Z"></path>
            </svg>
          </a>
        `}
      </div>
    `;
  }
};
In.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
      }

      /* Buttons are always visible: the product card is a stacked layout on every breakpoint */

      .add-to-cart-wrapper .buy-now-button{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        gap: 3px;
        white-space: nowrap;
        margin-top: 10px;
        min-height: 44px;
        background: #f49320;
        font-size: 16px;
        color: white;
      }
    `
];
let Q = In;

dt([
  u({ type: String })
], Q.prototype, "title");
dt([
  u({ type: String })
], Q.prototype, "price");
dt([
  u({ type: String, attribute: "compare-at-price" })
], Q.prototype, "compareAtPrice");
dt([
  u({ type: String, attribute: "variant-id" })
], Q.prototype, "variantId");
dt([
  u({ type: String, attribute: "data-property-roast-level" })
], Q.prototype, "roastLevelProperty");
dt([
  u({ type: String, attribute: "data-property-brew-method" })
], Q.prototype, "brewMethodProperty");
dt([
  u({ type: String, attribute: "data-property-grind-size" })
], Q.prototype, "grindSizeProperty");
dt([
  u({ type: String, attribute: "data-selling-plan-id" })
], Q.prototype, "sellingPlanId");
dt([
  u({ type: Boolean, reflect: !0, attribute: "ck-add-to-cart" })
], Q.prototype, "ckAddToCart");
dt([
  u({ type: Boolean, reflect: !0 })
], Q.prototype, "disabled");
dt([
  u({ type: Function, attribute: !1 })
], Q.prototype, "onaddtocart");
dt([
  R()
], Q.prototype, "isAdding");
dt([
  R()
], Q.prototype, "justAdded");
customElements.get("ck-product-card-actions") || customElements.define("ck-product-card-actions", Q);
const Ba = { ATTRIBUTE: 1, CHILD: 2 }, ja = (s) => (...t) => ({ _$litDirective$: s, values: t });
let Fa = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, e, r) {
    this._$Ct = t, this._$AM = e, this._$Ci = r;
  }
  _$AS(t, e) {
    return this.update(t, e);
  }
  update(t, e) {
    return this.render(...e);
  }
};
const Wa = "important", Eh = " !" + Wa, Ee = ja(class extends Fa {
  constructor(s) {
    if (super(s), s.type !== Ba.ATTRIBUTE || s.name !== "style" || s.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(s) {
    return Object.keys(s).reduce(((t, e) => {
      const r = s[e];
      return r == null ? t : t + `${e = e.includes("-") ? e : e.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${r};`;
    }), "");
  }
  update(s, [t]) {
    const { style: e } = s.element;
    if (this.ft === void 0) return this.ft = new Set(Object.keys(t)), this.render(t);
    for (const r of this.ft) t[r] == null && (this.ft.delete(r), r.includes("-") ? e.removeProperty(r) : e[r] = null);
    for (const r in t) {
      const i = t[r];
      if (i != null) {
        this.ft.add(r);
        const n = typeof i == "string" && i.endsWith(Eh);
        r.includes("-") || n ? e.setProperty(r, n ? i.slice(0, -11) : i, n ? Wa : "") : e[r] = i;
      }
    }
    return jt;
  }
});
let tr = class extends Fa {
  constructor(t) {
    if (super(t), this.it = W, t.type !== Ba.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === W || t == null) return this._t = void 0, this.it = t;
    if (t === jt) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const e = [t];
    return e.raw = e, this._t = { _$litType$: this.constructor.resultType, strings: e, values: [] };
  }
};
tr.directiveName = "unsafeHTML", tr.resultType = 1;
class er extends tr {
}
er.directiveName = "unsafeSVG", er.resultType = 2;
const sr = ja(er);
var Ah = Object.defineProperty, Gt = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ah(t, e, i), i;
};
const Sh = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.36936 1.13111C8.31923 0.224311 10.0658 1.47868 10.4217 1.76354C14.0119 4.68235 12.2763 13.309 6.53269 13.357C4.91369 9.65964 8.5962 7.34151 8.73422 3.97219C8.77233 3.0656 8.41953 2.03783 8.36936 1.13111ZM7.42395 0.638725C7.76423 2.30855 7.99939 3.84376 7.61113 5.52689C7.08328 7.83956 3.91962 10.2904 5.89403 13.1532C5.33887 13.4086 4.14727 12.518 3.69441 12.1151C-0.0528387 8.78059 1.73949 1.29363 7.42395 0.638725Z" fill="currentColor"/>
</svg>
`, $h = `
<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.39548 5.46447L13.2475 5.63697C13.492 5.64747 13.696 5.80197 13.771 6.03597C13.8475 6.26997 13.774 6.51447 13.582 6.66747L10.567 9.06897L11.5945 12.7845C11.659 13.0215 11.575 13.263 11.377 13.407C11.1775 13.5525 10.9225 13.557 10.717 13.422L7.50098 11.2965L4.28498 13.422C4.07948 13.557 3.82448 13.5525 3.62498 13.407C3.42698 13.263 3.34298 13.0215 3.40748 12.7845L4.43498 9.06897L1.41998 6.66747C1.22798 6.51447 1.15448 6.26997 1.23098 6.03597C1.30598 5.80197 1.50998 5.64747 1.75448 5.63697L5.60648 5.46447L6.95948 1.85547C7.04498 1.62597 7.25498 1.48047 7.50098 1.48047C7.74698 1.48047 7.95698 1.62597 8.04248 1.85547L9.39548 5.46447Z" fill="currentColor"/>
</svg>
`, Vn = class Vn extends b {
  constructor() {
    super(...arguments), this.variant = "star", this.value = 0, this.step = 0.5, this.max = 5, this.defaultColor = "", this.defaultColorAttr = "", this.filledColor = "var(--color-foreground-tertiary)", this.filledColorAttr = "", this.originalCustomClass = "";
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses());
  }
  _syncHostClasses() {
    const t = g("inline-flex items-center gap-1", this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _getSvg() {
    return this.variant === "roast" ? Sh : $h;
  }
  _getSafeMax() {
    return !Number.isFinite(this.max) || this.max <= 0 ? 5 : Math.max(1, Math.floor(this.max));
  }
  _getSafeValue(t) {
    return !Number.isFinite(this.value) || this.value <= 0 ? 0 : this.value >= t ? t : this.value;
  }
  _getFillPercentage(t, e) {
    const r = e - t;
    return r <= 0 ? 0 : r >= 1 ? 100 : r * 100;
  }
  _getDefaultColor() {
    return this.defaultColorAttr ? this.defaultColorAttr : this.defaultColor ? this.defaultColor : `color-mix(in srgb, ${this._getFilledColor() || "var(--color-foreground-tertiary)"} 30%, transparent)`;
  }
  _getFilledColor() {
    return this.filledColorAttr || this.filledColor;
  }
  _renderStar(t, e) {
    const r = this._getSvg(), i = this._getFillPercentage(t, e), n = this._getDefaultColor(), o = this._getFilledColor(), a = r.replace(/fill="currentColor"/g, `fill="${n}"`), l = r.replace(/fill="currentColor"/g, `fill="${o}"`), d = i > 0 ? Ee({ width: i + "%" }) : void 0;
    return f`
      <div class="relative inline-flex items-center justify-center shrink-0">
        ${sr(a)}
        ${i > 0 ? f`
              <div class="absolute top-0 left-0 overflow-hidden" style=${d}>
                ${sr(l)}
              </div>
            ` : null}
      </div>
    `;
  }
  render() {
    const t = this._getSafeMax(), e = this._getSafeValue(t), r = Array.from({ length: t }, (n, o) => o), i = g("inline-flex items-center gap-1", this.originalCustomClass);
    return f`
      <div
        class="${i}"
        role="img"
        aria-label="Rating: ${e} out of ${t}"
      >
        ${r.map((n) => this._renderStar(n, e))}
      </div>
    `;
  }
};
Vn.styles = [...b.styles];
let bt = Vn;
Gt([
  u({ type: String })
], bt.prototype, "variant");
Gt([
  u({ type: Number })
], bt.prototype, "value");
Gt([
  u({ type: Number })
], bt.prototype, "step");
Gt([
  u({ type: Number })
], bt.prototype, "max");
Gt([
  u({ type: String })
], bt.prototype, "defaultColor");
Gt([
  u({ type: String, attribute: "default-color" })
], bt.prototype, "defaultColorAttr");
Gt([
  u({ type: String })
], bt.prototype, "filledColor");
Gt([
  u({ type: String, attribute: "filled-color" })
], bt.prototype, "filledColorAttr");
customElements.get("ck-rating") || customElements.define("ck-rating", bt);
var Th = Object.defineProperty, fe = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Th(t, e, i), i;
};
const Pn = class Pn extends b {
  constructor() {
    super(...arguments), this.name = "", this.value = "", this.type = "square", this.disabled = !1, this.readonly = !1, this.originalCustomClass = "";
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.name || (this.name = `color-picker-${Math.random().toString(36).substring(2, 9)}`), this._syncOptionsState();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncOptionsState();
  }
  updated(t) {
    (t.has("name") || t.has("value") || t.has("type") || t.has("disabled") || t.has("readonly")) && this._syncOptionsState();
  }
  _handleSlotChange() {
    this._syncOptionsState();
  }
  _handleOptionChange(t) {
    if (this.readonly || this.disabled) {
      t.preventDefault();
      return;
    }
    const e = t.detail?.value;
    !e || this.value === e || (this.value = e, this.dispatchEvent(
      new CustomEvent("ck-change", {
        detail: { value: this.value },
        bubbles: !0,
        composed: !0
      })
    ));
  }
  _getOptionComparableValue(t) {
    return t && (t.optionValue || t.value || t.label) || null;
  }
  _syncOptionsState() {
    (this.optionElements || []).forEach((e, r) => {
      e.name = this.name, e.type = this.type, e.disabled = this.disabled, e.readonly = this.readonly, e.checked = this._getOptionComparableValue(e) === this.value, e.optionId = `${this.name}-${r}`;
    });
  }
  render() {
    const t = g("inline-flex items-center gap-2", this.originalCustomClass);
    return f`
      <div
        class="${t}"
        role="radiogroup"
        aria-label=${this.ariaLabelledBy ? void 0 : "Color picker"}
        aria-labelledby=${this.ariaLabelledBy && this.ariaLabelledBy.trim() ? this.ariaLabelledBy : void 0}
        @ck-option-change="${this._handleOptionChange}"
      >
        <slot @slotchange="${this._handleSlotChange}"></slot>
      </div>
    `;
  }
};
Pn.styles = [...b.styles];
let At = Pn;
fe([
  u({ type: String })
], At.prototype, "name");
fe([
  u({ type: String })
], At.prototype, "value");
fe([
  u({ type: String })
], At.prototype, "type");
fe([
  u({ type: Boolean })
], At.prototype, "disabled");
fe([
  u({ type: Boolean })
], At.prototype, "readonly");
fe([
  u({ type: String, attribute: "aria-labelledby" })
], At.prototype, "ariaLabelledBy");
fe([
  mh({ selector: "ck-color-picker-option", flatten: !0 })
], At.prototype, "optionElements");
customElements.get("ck-color-picker") || customElements.define("ck-color-picker", At);
var Oh = Object.defineProperty, Tt = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Oh(t, e, i), i;
};
const Mn = class Mn extends b {
  constructor() {
    super(...arguments), this.label = "", this.value = "", this.optionValue = "", this.name = "", this.type = "square", this.size = "md", this.disabled = !1, this.readonly = !1, this.checked = !1, this.optionId = "";
  }
  _handleInputChange(t) {
    if (this.readonly || this.disabled) {
      t.preventDefault();
      return;
    }
    this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 })), this.dispatchEvent(
      new CustomEvent("ck-option-change", {
        detail: { value: this.optionValue || this.value || this.label },
        bubbles: !0,
        composed: !0
      })
    );
  }
  render() {
    const t = this.label || this.value, e = this.disabled ? "cursor-not-allowed opacity-50" : this.readonly ? "" : "cursor-pointer", r = this.checked && !this.readonly, i = this.optionId || `${this.name}-${this.value}`, n = this._getSizeClass();
    return f`
      <label
        for="${i}"
        class="relative inline-flex items-center justify-center ${e}"
      >
        <input
          type="radio"
          id="${i}"
          name="${this.name}"
          value="${this.optionValue || this.value}"
          .checked=${this.checked}
          ?disabled="${this.disabled}"
          class="absolute w-0 h-0 opacity-0"
          aria-label="${t}"
          @change="${this._handleInputChange}"
        />
        <span
          class="inline-block ${n} transition-all border border-border-softer ${this.type === "circle" ? "rounded-full" : "rounded-none"} ${r ? "border-foreground ring-2 ring-ring ring-offset-2" : "hover:border-foreground/50"}"
          style="background-color: ${this.value};"
          title="${t}"
        ></span>
      </label>
    `;
  }
  _getSizeClass() {
    switch (this.size) {
      case "sm":
        return "size-3.5";
      case "lg":
        return "size-6";
      case "md":
      default:
        return "size-5";
    }
  }
};
Mn.styles = [...b.styles];
let ct = Mn;
Tt([
  u({ type: String })
], ct.prototype, "label");
Tt([
  u({ type: String })
], ct.prototype, "value");
Tt([
  u({ type: String, attribute: "option-value" })
], ct.prototype, "optionValue");
Tt([
  u({ type: String })
], ct.prototype, "name");
Tt([
  u({ type: String })
], ct.prototype, "type");
Tt([
  u({ type: String })
], ct.prototype, "size");
Tt([
  u({ type: Boolean })
], ct.prototype, "disabled");
Tt([
  u({ type: Boolean })
], ct.prototype, "readonly");
Tt([
  u({ type: Boolean })
], ct.prototype, "checked");
Tt([
  u({ type: String, attribute: "option-id" })
], ct.prototype, "optionId");
customElements.get("ck-color-picker-option") || customElements.define("ck-color-picker-option", ct);
let Ua = class extends Event {
  constructor(t, e, r, i) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = e, this.callback = r, this.subscribe = i ?? !1;
  }
};
let xo = class {
  constructor(t, e, r, i) {
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (n, o) => {
      this.unsubscribe && (this.unsubscribe !== o && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = n, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(n, o)), this.unsubscribe = o;
    }, this.host = t, e.context !== void 0) {
      const n = e;
      this.context = n.context, this.callback = n.callback, this.subscribe = n.subscribe ?? !1;
    } else this.context = e, this.callback = r, this.subscribe = i ?? !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new Ua(this.context, this.host, this.t, this.subscribe));
  }
};
class Ih {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, e = !1) {
    const r = e || !Object.is(t, this.o);
    this.o = t, r && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [e, { disposer: r }] of this.subscriptions) e(this.o, r);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, e, r) {
    if (!r) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: e });
    const { disposer: i } = this.subscriptions.get(t);
    t(this.value, i);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
let Vh = class extends Event {
  constructor(t, e) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = e;
  }
};
class ft extends Ih {
  constructor(t, e, r) {
    super(e.context !== void 0 ? e.initialValue : r), this.onContextRequest = (i) => {
      if (i.context !== this.context) return;
      const n = i.contextTarget ?? i.composedPath()[0];
      n !== this.host && (i.stopPropagation(), this.addCallback(i.callback, n, i.subscribe));
    }, this.onProviderRequest = (i) => {
      if (i.context !== this.context || (i.contextTarget ?? i.composedPath()[0]) === this.host) return;
      const n = /* @__PURE__ */ new Set();
      for (const [o, { consumerHost: a }] of this.subscriptions) n.has(o) || (n.add(o), a.dispatchEvent(new Ua(this.context, a, o, !0)));
      i.stopPropagation();
    }, this.host = t, e.context !== void 0 ? this.context = e.context : this.context = e, this.attachListeners(), this.host.addController?.(this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new Vh(this.context, this.host));
  }
}
function qa({ context: s }) {
  return (t, e) => {
    const r = /* @__PURE__ */ new WeakMap();
    if (typeof e == "object") return { get() {
      return t.get.call(this);
    }, set(i) {
      return r.get(this).setValue(i), t.set.call(this, i);
    }, init(i) {
      return r.set(this, new ft(this, { context: s, initialValue: i })), i;
    } };
    {
      t.constructor.addInitializer(((o) => {
        r.set(o, new ft(o, { context: s }));
      }));
      const i = Object.getOwnPropertyDescriptor(t, e);
      let n;
      if (i === void 0) {
        const o = /* @__PURE__ */ new WeakMap();
        n = { get() {
          return o.get(this);
        }, set(a) {
          r.get(this).setValue(a), o.set(this, a);
        }, configurable: !0, enumerable: !0 };
      } else {
        const o = i.set;
        n = { ...i, set(a) {
          r.get(this).setValue(a), o?.call(this, a);
        } };
      }
      return void Object.defineProperty(t, e, n);
    }
  };
}
function L({ context: s, subscribe: t }) {
  return (e, r) => {
    typeof r == "object" ? r.addInitializer((function() {
      new xo(this, { context: s, callback: (i) => {
        e.set.call(this, i);
      }, subscribe: t });
    })) : e.constructor.addInitializer(((i) => {
      new xo(i, { context: s, callback: (n) => {
        i[r] = n;
      }, subscribe: t });
    }));
  };
}
const Ph = {
  // social icons
  tiktok: f`<svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.413 0.644531C11.4361 0.628906 12.4517 0.637031 13.4667 0.628906C13.5005 1.89828 14.0155 3.04078 14.8349 3.88703L14.8336 3.88578C15.7155 4.68016 16.863 5.19516 18.128 5.28266L18.1455 5.28391V8.43141C16.9505 8.40141 15.8267 8.12578 14.8136 7.65203L14.8649 7.67328C14.3749 7.43766 13.9605 7.19578 13.5667 6.92578L13.5992 6.94703C13.5917 9.22766 13.6067 11.5083 13.5836 13.7808C13.5192 14.9389 13.1342 15.9952 12.5167 16.877L12.5292 16.8577C11.4967 18.3364 9.82424 19.307 7.92237 19.3645H7.91362C7.83674 19.3683 7.74612 19.3702 7.65487 19.3702C6.57362 19.3702 5.56299 19.0689 4.70175 18.5458L4.72674 18.5602C3.15925 17.617 2.07799 16.0033 1.87799 14.1264L1.87549 14.1008C1.85987 13.7102 1.85237 13.3195 1.86799 12.937C2.17424 9.95016 4.67674 7.63953 7.71862 7.63953C8.06049 7.63953 8.39549 7.66891 8.72112 7.72453L8.68612 7.71953C8.70174 8.87516 8.65487 10.0314 8.65487 11.187C8.3905 11.0914 8.08549 11.0358 7.76737 11.0358C6.59987 11.0358 5.60675 11.782 5.23924 12.8239L5.23362 12.8427C5.1505 13.1095 5.10237 13.4164 5.10237 13.7339C5.10237 13.8627 5.11049 13.9902 5.12549 14.1152L5.12425 14.1002C5.33175 15.3789 6.428 16.3439 7.74987 16.3439C7.788 16.3439 7.8255 16.3433 7.863 16.3414H7.85737C8.77175 16.3139 9.56549 15.822 10.0142 15.0952L10.0205 15.0839C10.1874 14.8514 10.3017 14.5702 10.3399 14.2645L10.3405 14.2558C10.4186 12.8577 10.3874 11.4677 10.3949 10.0695C10.4024 6.92203 10.3874 3.78203 10.4105 0.642656L10.413 0.644531Z"
      fill="currentColor"
    />
  </svg> `,
  pinterest: f`<svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75495 11.9052C5.28223 14.3833 4.70534 16.759 2.99583 18C2.46772 14.2545 3.7704 11.4415 4.37539 8.45503C3.34378 6.71871 4.49929 3.22418 6.67454 4.08504C9.35107 5.14412 4.35694 10.5411 7.70922 11.2152C11.21 11.9188 12.6392 5.13972 10.4688 2.9354C7.33226 -0.24796 1.33898 2.86291 2.07579 7.42054C2.25504 8.53457 3.40576 8.87252 2.53579 10.4106C0.528384 9.96499 -0.0704478 8.38162 0.00643114 6.27047C0.130747 2.81461 3.1105 0.395391 6.09983 0.0605416C9.88004 -0.362652 13.4278 1.44834 13.9177 5.0053C14.4696 9.02018 12.2117 13.3681 8.16922 13.0552C7.07345 12.97 6.61344 12.4268 5.75495 11.9052Z"
      fill="currentColor"
    />
  </svg> `,
  instagram: f`<svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3.46667C12.1333 3.46667 12.4 3.46667 13.2667 3.53333C15.4667 3.6 16.4667 4.66667 16.5333 6.8C16.6 7.66667 16.6 7.86667 16.6 10C16.6 12.1333 16.6 12.4 16.5333 13.2C16.4667 15.3333 15.4 16.4 13.2667 16.4667C12.4 16.5333 12.2 16.5333 10 16.5333C7.86667 16.5333 7.6 16.5333 6.8 16.4667C4.6 16.4 3.6 15.3333 3.53333 13.2C3.46667 12.3333 3.46667 12.1333 3.46667 10C3.46667 7.86667 3.46667 7.6 3.53333 6.8C3.6 4.66667 4.66667 3.6 6.8 3.53333C7.6 3.46667 7.86667 3.46667 10 3.46667ZM10 2C7.8 2 7.53333 2 6.73333 2.06667C3.8 2.2 2.2 3.8 2.06667 6.73333C2 7.53333 2 7.8 2 10C2 12.2 2 12.4667 2.06667 13.2667C2.2 16.2 3.8 17.8 6.73333 17.9333C7.53333 18 7.8 18 10 18C12.2 18 12.4667 18 13.2667 17.9333C16.2 17.8 17.8 16.2 17.9333 13.2667C18 12.4667 18 12.2 18 10C18 7.8 18 7.53333 17.9333 6.73333C17.8 3.8 16.2 2.2 13.2667 2.06667C12.4667 2 12.2 2 10 2ZM10 5.86667C7.73333 5.86667 5.86667 7.73333 5.86667 10C5.86667 12.2667 7.73333 14.1333 10 14.1333C12.2667 14.1333 14.1333 12.2667 14.1333 10C14.1333 7.73333 12.2667 5.86667 10 5.86667ZM10 12.6667C8.53333 12.6667 7.33333 11.4667 7.33333 10C7.33333 8.53333 8.53333 7.33333 10 7.33333C11.4667 7.33333 12.6667 8.53333 12.6667 10C12.6667 11.4667 11.4667 12.6667 10 12.6667ZM14.2667 4.8C13.7333 4.8 13.3333 5.2 13.3333 5.73333C13.3333 6.26667 13.7333 6.66667 14.2667 6.66667C14.8 6.66667 15.2 6.26667 15.2 5.73333C15.2 5.2 14.8 4.8 14.2667 4.8Z"
      fill="currentColor"
    />
  </svg> `,
  facebook: f`<svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 7.33333H6V10H8V18H11.3333V10H13.7333L14 7.33333H11.3333V6.2C11.3333 5.6 11.4667 5.33333 12.0667 5.33333H14V2H11.4667C9.06667 2 8 3.06667 8 5.06667V7.33333Z"
      fill="currentColor"
    />
  </svg> `,
  // miscellaneous icons
  "gluten-free": f`<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 4.00001V9.00001C13.5005 9.6504 13.3851 10.2957 13.1594 10.9056C13.1442 10.9456 13.119 10.981 13.0863 11.0085C13.0535 11.0359 13.0142 11.0546 12.9722 11.0625C12.9302 11.0705 12.8869 11.0675 12.8463 11.054C12.8058 11.0404 12.7694 11.0167 12.7406 10.985L10.1575 8.14376C10.1324 8.11596 10.1139 8.08288 10.1033 8.04696C10.0928 8.01105 10.0904 7.97322 10.0964 7.93626C10.1024 7.89931 10.1166 7.86417 10.138 7.83345C10.1594 7.80273 10.1874 7.7772 10.22 7.75876C10.9162 7.34778 11.6949 7.09653 12.5 7.02313V4.52813C11.8769 4.59899 11.2753 4.79872 10.7335 5.11463C10.1918 5.43054 9.72168 5.85572 9.35312 6.36313C9.31171 6.42062 9.25855 6.46865 9.19716 6.50403C9.13578 6.53942 9.06758 6.56135 8.99708 6.56839C8.92658 6.57542 8.85538 6.56739 8.78822 6.54482C8.72106 6.52226 8.65946 6.48568 8.6075 6.43751C8.51819 6.35139 8.46328 6.2357 8.45305 6.11205C8.44281 5.98841 8.47794 5.86527 8.55188 5.76563C8.97379 5.18712 9.50455 4.69649 10.1144 4.32126C9.53875 3.11251 8.46562 2.35876 8 2.07501C7.45105 2.41238 6.9577 2.83279 6.5375 3.32126C6.49179 3.37553 6.43505 3.41946 6.37105 3.45011C6.30705 3.48077 6.23725 3.49744 6.16631 3.49904C6.09537 3.50064 6.02489 3.48711 5.95958 3.45937C5.89427 3.43163 5.83561 3.3903 5.7875 3.33813C5.70498 3.24528 5.65908 3.12556 5.65839 3.00134C5.6577 2.87712 5.70226 2.75689 5.78375 2.66313C6.34321 2.00895 7.01818 1.46321 7.775 1.05313C7.84447 1.01837 7.92107 1.00027 7.99875 1.00027C8.07643 1.00027 8.15303 1.01837 8.2225 1.05313C8.305 1.09438 10.1144 2.01751 11.0094 3.87501C11.6418 3.62848 12.3144 3.50133 12.9931 3.50001C13.0594 3.4991 13.1251 3.51136 13.1866 3.53608C13.248 3.5608 13.304 3.59748 13.3511 3.644C13.3983 3.69052 13.4357 3.74595 13.4613 3.80706C13.4868 3.86818 13.5 3.93376 13.5 4.00001ZM13.37 13.1638C13.4151 13.2122 13.4501 13.2691 13.473 13.3311C13.496 13.3932 13.5064 13.4592 13.5036 13.5253C13.5008 13.5914 13.485 13.6563 13.4569 13.7163C13.4289 13.7762 13.3893 13.83 13.3403 13.8745C13.2913 13.919 13.234 13.9533 13.1717 13.9755C13.1094 13.9977 13.0432 14.0073 12.9772 14.0037C12.9111 14.0002 12.8464 13.9835 12.7868 13.9548C12.7272 13.926 12.6739 13.8858 12.63 13.8363L11.8237 12.9494C10.8076 13.9364 9.44906 14.492 8.0325 14.5C4.98938 14.5175 2.5 11.9694 2.5 8.92688V4.00001C2.5 3.93387 2.51311 3.86839 2.53859 3.80736C2.56407 3.74633 2.6014 3.69095 2.64843 3.64445C2.69546 3.59795 2.75124 3.56124 2.81256 3.53644C2.87387 3.51165 2.93949 3.49926 3.00562 3.50001C3.08375 3.50001 3.16062 3.50001 3.23812 3.50563L2.63 2.83626C2.58492 2.78783 2.54989 2.73093 2.52696 2.66887C2.50403 2.60681 2.49364 2.54081 2.4964 2.4747C2.49917 2.40859 2.51502 2.34369 2.54305 2.28375C2.57108 2.22382 2.61073 2.17004 2.65969 2.12554C2.70866 2.08105 2.76597 2.04671 2.82831 2.02452C2.89064 2.00233 2.95676 1.99274 3.02283 1.99629C3.0889 1.99985 3.15361 2.01648 3.2132 2.04523C3.27279 2.07397 3.32609 2.11426 3.37 2.16376L13.37 13.1638ZM8.52 9.31563L4.32375 4.69938C4.0552 4.61624 3.77939 4.55869 3.5 4.52751V7.02376C4.46396 7.11297 5.38741 7.45456 6.17739 8.01413C6.96737 8.5737 7.596 9.3315 8 10.2113C8.14485 9.89706 8.31895 9.5972 8.52 9.31563Z"
      fill="currentColor"
    />
  </svg> `,
  vegan: f`<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9656 2.50439C13.9585 2.38206 13.9067 2.26662 13.82 2.17998C13.7334 2.09334 13.6179 2.04153 13.4956 2.03439C8.7375 1.75501 4.92625 3.18751 3.30125 5.87501C2.73798 6.79433 2.46041 7.86022 2.50375 8.93751C2.53204 9.62641 2.6722 10.3061 2.91875 10.95C2.93324 10.9896 2.95752 11.025 2.98933 11.0527C3.02114 11.0804 3.05945 11.0996 3.10069 11.1085C3.14193 11.1174 3.18475 11.1158 3.22518 11.1037C3.2656 11.0916 3.30231 11.0695 3.33188 11.0394L8.64438 5.64564C8.69083 5.59918 8.74598 5.56233 8.80668 5.53719C8.86738 5.51205 8.93243 5.49911 8.99813 5.49911C9.06382 5.49911 9.12888 5.51205 9.18958 5.53719C9.25027 5.56233 9.30542 5.59918 9.35188 5.64564C9.39833 5.69209 9.43518 5.74724 9.46032 5.80794C9.48546 5.86863 9.4984 5.93369 9.4984 5.99939C9.4984 6.06508 9.48546 6.13014 9.46032 6.19083C9.43518 6.25153 9.39833 6.30668 9.35188 6.35314L3.54625 12.2463L2.65938 13.1331C2.56714 13.2229 2.51208 13.3441 2.50513 13.4727C2.49818 13.6012 2.53986 13.7277 2.62188 13.8269C2.66679 13.8789 2.72195 13.9211 2.78391 13.9508C2.84586 13.9806 2.91328 13.9972 2.98196 13.9998C3.05064 14.0023 3.1191 13.9906 3.18307 13.9655C3.24704 13.9404 3.30514 13.9023 3.35375 13.8538L4.40313 12.8044C5.28688 13.2319 6.17875 13.465 7.06313 13.4963C7.13271 13.4988 7.20209 13.5 7.27125 13.5C8.27838 13.5026 9.2664 13.2252 10.125 12.6988C12.8125 11.0738 14.2456 7.26314 13.9656 2.50439Z"
      fill="currentColor"
    />
  </svg> `,
  recommendation: f`<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.34842 1.13728C6.42866 1.08403 6.53967 1.08403 6.6199 1.13728C7.45209 1.66905 8.16816 2.33492 8.73123 3.10114C9.50953 4.21309 9.82635 5.53608 9.62772 6.83747C9.44067 8.05766 8.8114 9.18614 7.84061 10.0494L7.64236 10.2183L7.55643 10.2906C7.03199 10.7229 6.81127 11.3737 6.97049 11.9898L7.00662 12.1129C7.27508 12.8961 7.74927 13.704 8.29666 14.6031C8.34614 14.6806 8.33219 14.7783 8.26248 14.8424C8.19274 14.9057 8.08557 14.9209 7.99783 14.8804C6.3834 14.1296 5.16359 13.3634 4.26151 12.5357C3.41515 11.7466 2.94297 10.6926 2.9451 9.59626C2.94734 8.50027 3.42385 7.44727 4.2742 6.66071C4.76745 6.20526 5.32947 5.74828 5.85721 5.3238C6.27038 4.9895 6.5721 4.5566 6.72733 4.07673C6.88167 3.59636 6.88499 3.08708 6.73514 2.60603C6.62195 2.24488 6.46608 1.83965 6.2742 1.36872C6.23975 1.28592 6.26989 1.19123 6.34842 1.13728ZM10.1492 4.56501C10.2445 4.52968 10.3558 4.55265 10.4217 4.62263C12.2855 6.5894 13.8457 8.7043 12.618 10.9029C12.1027 11.835 10.9923 12.9294 9.11209 14.3609C9.06872 14.3922 9.01433 14.4097 8.95779 14.4097C8.92526 14.4097 8.89348 14.4037 8.86404 14.3922C8.78425 14.3616 8.72962 14.2951 8.72342 14.2183C8.71569 13.6062 8.55892 13.0022 8.26151 12.4478C7.86406 11.7215 7.9223 10.8655 8.4158 10.1861C8.8233 9.65414 9.28852 9.1585 9.80447 8.70466C10.1523 8.38599 10.3256 7.95021 10.2791 7.5113L10.0027 4.77204C9.99501 4.68242 10.0548 4.599 10.1492 4.56501Z"
      fill="currentColor"
    />
  </svg> `,
  "coffee-bean": f`<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.85487 1.6118C8.70839 0.651453 10.6968 1.80695 11.1049 2.07372C15.2271 4.81246 14.2646 14.1752 8.15468 14.8159C6.05162 11.0457 9.73432 8.2004 9.53554 4.59911C9.48323 3.63 9.00143 2.57205 8.85487 1.6118ZM7.79823 1.18407C8.33185 2.92692 8.74005 4.53686 8.4994 6.36864C8.17505 8.88506 5.05768 11.8191 7.45351 14.6645C6.88859 14.9935 5.52859 14.1671 5.00526 13.7847C0.673618 10.6191 1.81354 2.46465 7.79823 1.18407Z"
      fill="currentColor"
    />
  </svg> `
}, Mh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"/></svg>', Lh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"/></svg>', Rh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"/></svg>', Hh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z"/></svg>', Dh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z"/></svg>', zh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"/></svg>', Nh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg>', Bh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg>', jh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>', Fh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"/></svg>', Wh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>', Uh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/></svg>', qh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M228,175a8,8,0,0,1-10.92-3l-19-33.2A123.23,123.23,0,0,1,162,155.46l5.87,35.22a8,8,0,0,1-6.58,9.21A8.4,8.4,0,0,1,160,200a8,8,0,0,1-7.88-6.69l-5.77-34.58a133.06,133.06,0,0,1-36.68,0l-5.77,34.58A8,8,0,0,1,96,200a8.4,8.4,0,0,1-1.32-.11,8,8,0,0,1-6.58-9.21L94,155.46a123.23,123.23,0,0,1-36.06-16.69L39,172A8,8,0,1,1,25.06,164l20-35a153.47,153.47,0,0,1-19.3-20A8,8,0,1,1,38.22,99c16.6,20.54,45.64,45,89.78,45s73.18-24.49,89.78-45A8,8,0,1,1,230.22,109a153.47,153.47,0,0,1-19.3,20l20,35A8,8,0,0,1,228,175Z"/></svg>', Kh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"/></svg>', Zh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M176,80a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H184A8,8,0,0,1,176,80ZM40,88H144v16a8,8,0,0,0,16,0V56a8,8,0,0,0-16,0V72H40a8,8,0,0,0,0,16Zm176,80H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16ZM88,144a8,8,0,0,0-8,8v16H40a8,8,0,0,0,0,16H80v16a8,8,0,0,0,16,0V152A8,8,0,0,0,88,144Z"/></svg>', Gh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>', Yh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Zm-68-56a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z"/></svg>', Xh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"/></svg>', Jh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z"/></svg>', Qh = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z"/></svg>', tu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.34,44-29.77,16.3-80.35-44ZM128,120,47.66,76l33.9-18.56,80.34,44ZM40,90l80,43.78v85.79L40,175.82Zm176,85.78h0l-80,43.79V133.82l32-17.51V152a8,8,0,0,0,16,0V107.55L216,90v85.77Z"/></svg>', eu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"/></svg>', su = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V72H40V56Zm0,144H40V88H216V200Zm-40-88a48,48,0,0,1-96,0,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0Z"/></svg>', iu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM176,88a48,48,0,0,1-96,0,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0Z"/></svg>', ru = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z"/></svg>', nu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"/></svg>', ou = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"/></svg>', au = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"/></svg>', lu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"/></svg>', cu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>', du = {
  account: ou,
  bell: zh,
  edit: Qh,
  "arrow-left": Lh,
  "arrow-right": Rh,
  "arrow-up": Dh,
  "arrow-down": Mh,
  "arrow-up-right": Hh,
  cart: iu,
  "cart-open": su,
  check: Uh,
  "check-circle": Wh,
  "chevron-down": Nh,
  "chevron-up": Fh,
  "chevron-left": Bh,
  "chevron-right": jh,
  close: cu,
  eye: Kh,
  "eye-off": qh,
  filters: Zh,
  lock: Yh,
  menu: Gh,
  minus: Jh,
  package: tu,
  plus: eu,
  search: Xh,
  star: ru,
  trash: nu,
  warning: lu,
  "warning-circle": au
};
var hu = Object.defineProperty, Ps = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && hu(t, e, i), i;
};
const Ka = {
  ...du,
  ...Ph
}, p0 = Object.keys(Ka);
class De extends b {
  constructor() {
    super(...arguments), this.name = "search", this.size = "md", this.color = "currentColor", this.decorative = !0, this.ariaLabel = null, this.originalCustomClass = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses());
  }
  _syncHostClasses() {
    const t = "inline-flex items-center justify-center";
    this.className = g(t, this.originalCustomClass);
  }
  _sizeToPx() {
    if (typeof this.size == "number") return this.size;
    switch (this.size) {
      case "sm":
        return 14;
      case "lg":
        return 24;
      case "md":
      default:
        return 18;
    }
  }
  _addSvgDimensions(t, e) {
    return /width\s*=/i.test(t) && /height\s*=/i.test(t) ? t : t.replace(/<svg\s+([^>]*)>/i, (r, i) => /width\s*=/i.test(i) || /height\s*=/i.test(i) ? r : `<svg ${i} width="${e}" height="${e}">`);
  }
  render() {
    const t = Ka[this.name];
    if (!t)
      return f``;
    const e = this.decorative ? "presentation" : "img", r = this.decorative ? "true" : "false", i = this.decorative ? null : this.ariaLabel, n = this._sizeToPx();
    this.style.setProperty("--ck-icon-size", `${n}px`), this.style.setProperty("--ck-icon-color", this.color);
    const o = typeof t == "string" ? this._addSvgDimensions(t, n) : t;
    return f`
      <span
        role=${e}
        aria-hidden=${r}
        aria-label=${i}
        class="inline-flex items-center justify-center size-(--ck-icon-size) text-(--ck-icon-color)"
      >
        ${typeof o == "string" ? sr(o) : o}
      </span>
    `;
  }
}
Ps([
  u({ type: String })
], De.prototype, "name");
Ps([
  u({ type: String })
], De.prototype, "size");
Ps([
  u({ type: String })
], De.prototype, "color");
Ps([
  u({ type: Boolean })
], De.prototype, "decorative");
Ps([
  u({ type: String, attribute: "aria-label" })
], De.prototype, "ariaLabel");
customElements.get("ck-icon") || customElements.define("ck-icon", De);
var uu = Object.defineProperty, Ms = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && uu(t, e, i), i;
};
const pu = /* @__PURE__ */ new Set(["class", "checked", "disabled", "name", "value", "variant"]);
class ze extends b {
  constructor() {
    super(...arguments), this.checked = !1, this.disabled = !1, this.name = "", this.value = "", this.variant = "default", this.originalCustomClass = "", this.labelObservers = /* @__PURE__ */ new Map();
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses(), this._setupLabelAssociation();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._cleanupLabelAssociation();
  }
  firstUpdated() {
    this.radioElement = this.querySelector('input[type="radio"]'), this.syncAttributes(), this.syncEventHandlers(), this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses(), this.currentId = this.getAttribute("id") || void 0, this._setupLabelAssociation();
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers(), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses()), t.has("checked") && this.radioElement && (this.radioElement.className = this.getRadioClasses());
    const e = this.getAttribute("id") || void 0;
    this.currentId !== e && (this._cleanupLabelAssociation(), this.currentId = e, this._setupLabelAssociation());
  }
  _syncHostClasses() {
    const t = this.getRadioClasses(), e = g(t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  getRadioClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "", e = this.variant === "hidden" ? "absolute size-0 -m-px opacity-0 pointer-events-none" : "appearance-none relative size-5 shrink-0 outline-none rounded-full border border-border bg-white shadow-xs enabled:cursor-pointer flex items-center justify-center enabled:not-checked:hover:border-mix-border/8 focus-visible:ring-4 ring-ring transition", r = this.variant === "hidden" ? "" : "checked:enabled:border-foreground-tertiary checked:enabled:bg-white checked:enabled:hover:border-mix-foreground/8 checked:enabled:hover:mix-with-foreground-secondary", i = this.variant === "hidden" ? "" : "checked:before:absolute checked:before:w-2 checked:before:h-2 checked:before:bg-foreground-tertiary checked:before:rounded-full", n = this.variant === "hidden" ? "disabled:pointer-events-none" : "disabled:cursor-not-allowed disabled:border-foreground/5 disabled:bg-foreground/10 disabled:checked:before:bg-foreground/50";
    return g(e, r, i, n, t);
  }
  render() {
    return f`
      <input
        type="radio"
        class="${this.getRadioClasses()}"
        ?checked="${this.checked}"
        ?disabled="${this.disabled}"
        name="${this.name}"
        value="${this.value}"
        @change="${this._handleChange}"
      />
    `;
  }
  syncAttributes() {
    if (this.radioElement)
      for (const t of this.attributes)
        pu.has(t.name) || this.radioElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.radioElement && q(this, this.radioElement, [
      "onChange"
    ]);
  }
  _handleChange(t) {
    const e = t.target;
    this.checked = e.checked;
    const r = this.onChange;
    typeof r == "function" && r(t), t.defaultPrevented || this.dispatchEvent(
      new CustomEvent("ck-change", {
        detail: { checked: this.checked, value: this.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  /**
   * Programmatically click the radio button.
   * Useful for making parent elements clickable.
   */
  click() {
    this.radioElement && !this.disabled && this.radioElement.click();
  }
  /**
   * Set up label association so labels with for attribute can toggle this radio
   */
  _setupLabelAssociation() {
    const t = this.currentId || this.getAttribute("id");
    if (!t || !this.radioElement) return;
    this.labelClickHandler || (this.labelClickHandler = (r) => {
      !this.disabled && r.target !== this.radioElement && (r.preventDefault(), this.click());
    }), document.querySelectorAll(`label[for="${t}"], ck-label[for="${t}"]`).forEach((r) => {
      if (r.tagName.toLowerCase() === "ck-label") {
        const i = r.querySelector("label");
        if (i)
          i.addEventListener("click", this.labelClickHandler), i.classList.add("cursor-pointer");
        else {
          const n = new MutationObserver(() => {
            const o = r.querySelector("label");
            o && (o.addEventListener("click", this.labelClickHandler), o.classList.add("cursor-pointer"), n.disconnect(), this.labelObservers.delete(r));
          });
          n.observe(r, { childList: !0, subtree: !0 }), this.labelObservers.set(r, n);
        }
      } else
        r.addEventListener("click", this.labelClickHandler), r.classList.add("cursor-pointer");
    });
  }
  /**
   * Clean up label association listeners
   */
  _cleanupLabelAssociation() {
    const t = this.currentId || this.getAttribute("id");
    if (!t) return;
    document.querySelectorAll(`label[for="${t}"], ck-label[for="${t}"]`).forEach((r) => {
      if (r.tagName.toLowerCase() === "ck-label") {
        const i = r.querySelector("label");
        i && this.labelClickHandler && (i.removeEventListener("click", this.labelClickHandler), i.classList.remove("cursor-pointer"));
        const n = this.labelObservers.get(r);
        n && (n.disconnect(), this.labelObservers.delete(r));
      } else
        this.labelClickHandler && r.removeEventListener("click", this.labelClickHandler), r.classList.remove("cursor-pointer");
    });
  }
}
Ms([
  u({ type: Boolean })
], ze.prototype, "checked");
Ms([
  u({ type: Boolean })
], ze.prototype, "disabled");
Ms([
  u({ type: String })
], ze.prototype, "name");
Ms([
  u({ type: String })
], ze.prototype, "value");
Ms([
  u({ type: String })
], ze.prototype, "variant");
customElements.get("ck-radio") || customElements.define("ck-radio", ze);
const Za = Symbol("radio-card-group");
class fu extends HTMLElement {
  static get observedAttributes() {
    return ["class"];
  }
  connectedCallback() {
    this.render();
  }
  attributeChangedCallback(t) {
    t === "class" && this.render();
  }
  render() {
    if (!this.isConnected) return;
    if (!this.paragraph || !this.contains(this.paragraph)) {
      this.paragraph = document.createElement("p"), this.paragraph.setAttribute("part", "description");
      const r = document.createDocumentFragment();
      for (; this.firstChild; )
        r.appendChild(this.firstChild);
      this.paragraph.appendChild(r), this.appendChild(this.paragraph);
    }
    const t = "text-sm text-foreground-secondary whitespace-nowrap", e = this.getAttribute("class") || "";
    this.paragraph.className = g(t, e);
  }
}
customElements.get("ck-radio-card-description") || customElements.define("ck-radio-card-description", fu);
class gu extends HTMLElement {
  static get observedAttributes() {
    return ["class"];
  }
  connectedCallback() {
    this.render();
  }
  attributeChangedCallback(t) {
    t === "class" && this.render();
  }
  render() {
    if (!this.isConnected) return;
    if (!this.heading || !this.contains(this.heading)) {
      this.heading = document.createElement("h5"), this.heading.setAttribute("part", "title");
      const r = document.createDocumentFragment();
      for (; this.firstChild; )
        r.appendChild(this.firstChild);
      this.heading.appendChild(r), this.appendChild(this.heading);
    }
    const t = "text-sm font-mono! tracking-wide uppercase text-foreground", e = this.getAttribute("class") || "";
    this.heading.className = g(t, e);
  }
}
customElements.get("ck-radio-card-title") || customElements.define("ck-radio-card-title", gu);
var mu = Object.defineProperty, Ls = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && mu(t, e, i), i;
};
const Ln = class Ln extends b {
  constructor() {
    super(...arguments), this.name = "", this.value = "", this.checked = !1, this.disabled = !1, this.originalCustomClass = "", this.layoutClasses = "", this.visualClasses = "", this.radioId = "";
  }
  connectedCallback() {
    super.connectedCallback();
    const t = this.getAttribute("class") || "";
    this.processCustomClasses(t), this.name || (this.name = `radio-card-${Math.random().toString(36).substring(2, 9)}`), this.radioId = `${this.name}-${this.value || Math.random().toString(36).substring(2, 9)}`;
  }
  firstUpdated() {
    this._syncCheckedWithContext();
  }
  willUpdate(t) {
    const e = this.getAttribute("class") || "";
    e !== this.originalCustomClass && this.processCustomClasses(e);
  }
  updated(t) {
    (t.has("checked") || t.has("value")) && this.requestUpdate(), (t.has("groupContext") || this.groupContext) && this._syncCheckedWithContext();
  }
  _handleChange(t) {
    if (this.disabled) {
      t.preventDefault();
      return;
    }
    const e = t.detail?.checked ?? !1;
    this.groupContext ? e && this.groupContext.selectCard(this) : (e && this._uncheckSiblings(), this.checked = e), this.dispatchEvent(
      new CustomEvent("ck-change", {
        detail: { checked: this.checked, value: this.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  _getCardClasses() {
    const t = this.groupContext ? this.groupContext.selectedRadioId === this.radioId : this.checked, e = "relative flex h-full w-full flex-col items-center justify-center gap-2 p-3 border transition-all duration-200 cursor-pointer focus-within:ring-4 focus-within:ring-ring focus-within:ring-offset-2 focus-within:ring-offset-background hover:bg-alpha-mid", r = this.disabled ? "cursor-not-allowed opacity-50 border-border" : t ? "border-border-hard bg-alpha-mid" : "border-border";
    return g(e, r, this.visualClasses);
  }
  _syncCheckedWithContext() {
    if (!this.groupContext) return;
    const t = this.groupContext.selectedRadioId === this.radioId;
    this.checked !== t && (this.checked = t);
  }
  processCustomClasses(t) {
    if (!t) {
      this.layoutClasses = "", this.visualClasses = "", this.originalCustomClass = "";
      return;
    }
    this.originalCustomClass = t;
    const e = H(t);
    this.layoutClasses = e.join(" ");
    const r = t.split(/\s+/).map((o) => o.trim()).filter(Boolean), i = new Set(e), n = r.filter((o) => !i.has(o));
    this.visualClasses = n.join(" "), r.forEach((o) => {
      this.classList.contains(o) && this.classList.remove(o);
    }), this.layoutClasses && this.classList.add(...this.layoutClasses.split(/\s+/).filter(Boolean));
  }
  _uncheckSiblings() {
    if (!this.name) return;
    const t = this.getRootNode(), r = `ck-radio-card[name="${typeof CSS < "u" && CSS.escape ? CSS.escape(this.name) : this.name.replace(/(["\\])/g, "\\$1")}"]`;
    Array.from(t.querySelectorAll(r)).forEach((n) => {
      n !== this && n.checked && (n.checked = !1);
    });
  }
  _handleLabelClick(t) {
    if (this.disabled) {
      t.preventDefault();
      return;
    }
    this._handleChange(
      new CustomEvent("ck-change", {
        detail: { checked: !0, value: this.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  get controlId() {
    return this.radioId;
  }
  render() {
    const t = this._getCardClasses(), e = this.groupContext ? this.groupContext.selectedRadioId === this.radioId : this.checked;
    return f`
      <label for="${this.radioId}" class="${t}" @click="${this._handleLabelClick}">
        <ck-radio
          id="${this.radioId}"
          name="${this.groupContext?.name || this.name}"
          value="${this.value}"
          ?checked="${e}"
          ?disabled="${this.disabled}"
          variant="hidden"
          @ck-change="${this._handleChange}"
        ></ck-radio>
        <div class="flex flex-col items-center text-center">
          <slot></slot>
        </div>
      </label>
    `;
  }
};
Ln.styles = [...b.styles];
let Ft = Ln;
Ls([
  u({ type: String })
], Ft.prototype, "name");
Ls([
  u({ type: String })
], Ft.prototype, "value");
Ls([
  u({ type: Boolean, reflect: !0 })
], Ft.prototype, "checked");
Ls([
  u({ type: Boolean })
], Ft.prototype, "disabled");
Ls([
  L({ context: Za, subscribe: !0 })
], Ft.prototype, "groupContext");
customElements.get("ck-radio-card") || customElements.define("ck-radio-card", Ft);
var bu = Object.defineProperty, Rs = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && bu(t, e, i), i;
};
const vu = ["-ml-px", "z-10", "z-0"], Rn = class Rn extends b {
  constructor() {
    super(...arguments), this.orientation = "horizontal", this.name = "", this.autoGroupName = "", this.selectedRadioId = null, this.sharedName = "", this.contextValue = {
      name: "",
      selectedRadioId: null,
      selectCard: (t) => this._handleSelectCard(t)
    }, this._handleRadioChange = (t) => {
      if (!(t.target instanceof HTMLElement) || t.target.tagName !== "CK-RADIO-CARD")
        return;
      t.detail?.checked ? this._handleSelectCard(t.target) : this._applyGrouping();
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("ck-change", this._handleRadioChange);
  }
  disconnectedCallback() {
    this.removeEventListener("ck-change", this._handleRadioChange), super.disconnectedCallback();
  }
  firstUpdated() {
    this._applyGrouping();
  }
  updated(t) {
    (t.has("orientation") || t.has("class") || t.has("name")) && this.requestUpdate(), this._applyGrouping();
  }
  _getCards() {
    return this.slotElement ? this.slotElement.assignedElements({ flatten: !0 }).filter((t) => t.tagName === "CK-RADIO-CARD") : [];
  }
  _applyGrouping() {
    const t = this._getCards();
    if (t.length === 0)
      return;
    this.autoGroupName || (this.autoGroupName = `radio-card-group-${Math.random().toString(36).substring(2, 9)}`);
    let e = t.find((i) => i.checked);
    !e && t.length > 0 && (e = t[0], e.checked = !0);
    const r = this.name?.trim() || t.find((i) => i.name)?.name || this.autoGroupName;
    this.sharedName = r, this.selectedRadioId = e?.controlId ?? t[0]?.controlId ?? null, this._updateContextValue(), t.forEach((i, n) => {
      i.classList.remove(...vu), i.name !== r && (i.name = r);
      const o = n === 0, a = e === i;
      this.orientation === "horizontal" && !o && i.classList.add("-ml-px"), i.classList.add(a ? "z-10" : "z-0");
    });
  }
  _handleSelectCard(t) {
    if (t.disabled) return;
    this.selectedRadioId = t.controlId, this._getCards().forEach((r) => {
      r.checked = r === t;
    }), this._updateContextValue(), this._applyGrouping();
  }
  _updateContextValue() {
    this.contextValue = {
      ...this.contextValue,
      name: this.sharedName,
      selectedRadioId: this.selectedRadioId
    };
  }
  _wrapperClasses() {
    const t = this.getAttribute("class") || "";
    return g(
      "flex w-full",
      this.orientation === "horizontal" ? "flex-row" : "flex-col",
      t
    );
  }
  render() {
    return f`
      <div
        class="${this._wrapperClasses()}"
        role="radiogroup"
        aria-labelledby=${this.ariaLabelledBy || void 0}
      >
        <slot @slotchange="${this._applyGrouping}"></slot>
      </div>
    `;
  }
};
Rn.styles = [...b.styles];
let Wt = Rn;
Rs([
  u({ type: String })
], Wt.prototype, "orientation");
Rs([
  u({ type: String })
], Wt.prototype, "name");
Rs([
  u({ type: String, attribute: "aria-labelledby" })
], Wt.prototype, "ariaLabelledBy");
Rs([
  Kt("slot")
], Wt.prototype, "slotElement");
Rs([
  qa({ context: Za })
], Wt.prototype, "contextValue");
customElements.get("ck-radio-card-group") || customElements.define("ck-radio-card-group", Wt);
var yu = Object.defineProperty, Ei = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && yu(t, e, i), i;
};
const Hn = class Hn extends b {
  constructor() {
    super(...arguments), this.label = "", this.href = null, this.separator = "›", this.last = !1, this.baseClasses = "inline-flex min-w-0 shrink items-center gap-2 text-xs font-mono uppercase tracking-wide text-foreground-tertiary";
  }
  get itemClasses() {
    return g(this.baseClasses, this.last && "text-foreground");
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "listitem"), this.syncCurrentState();
  }
  updated(t) {
    super.updated(t), t.has("last") && this.syncCurrentState();
  }
  syncCurrentState() {
    this.last ? this.setAttribute("aria-current", "page") : this.removeAttribute("aria-current");
  }
  get contentTemplate() {
    const t = f`<slot>${this.label}</slot>`;
    return this.href && !this.last ? f`
        <a
          class="block min-w-0 truncate text-inherit transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-0"
          href=${this.href}
        >
          ${t}
        </a>
      ` : f`<span class="block min-w-0 truncate">${t}</span>`;
  }
  render() {
    return f`
      <span class=${this.itemClasses}>
        ${this.contentTemplate}
        ${this.last ? W : f`<span class="text-foreground/50" aria-hidden="true">${this.separator}</span>`}
      </span>
    `;
  }
};
Hn.styles = [
  ...b.styles,
  N`
      :host {
        display: inline-flex;
      }

      :host([hidden]) {
        display: none;
      }
    `
];
let le = Hn;
Ei([
  u({ type: String })
], le.prototype, "label");
Ei([
  u({ type: String })
], le.prototype, "href");
Ei([
  u({ type: String })
], le.prototype, "separator");
Ei([
  u({ type: Boolean, reflect: !0 })
], le.prototype, "last");
customElements.get("ck-breadcrumb-item") || customElements.define("ck-breadcrumb-item", le);
var wu = Object.defineProperty, Ga = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && wu(t, e, i), i;
};
const Dn = class Dn extends b {
  constructor() {
    super(...arguments), this.separator = f`<ck-icon name="chevron-right"></ck-icon>`, this.slotListenerAttached = !1, this.originalCustomClass = "", this.handleSlotChange = () => {
      this.updateSlottedItems();
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.syncHostClasses();
  }
  firstUpdated() {
    this.attachSlotListener(), this.updateSlottedItems();
  }
  disconnectedCallback() {
    this.slotListenerAttached && this.itemsSlot && (this.itemsSlot.removeEventListener("slotchange", this.handleSlotChange), this.slotListenerAttached = !1), super.disconnectedCallback();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this.syncHostClasses()), this.attachSlotListener(), t.has("separator") && this.updateSlottedItems();
  }
  syncHostClasses() {
    const t = g("block", this.originalCustomClass), e = H(t), r = this.extractMarginClasses();
    this.className = g(...e, ...r);
  }
  extractMarginClasses() {
    if (!this.originalCustomClass) return [];
    const t = this.originalCustomClass.split(/\s+/).filter(Boolean), e = /^-?m[trblxy]?-.+/;
    return t.filter((r) => {
      const i = r.split(":").pop() ?? r;
      return e.test(i);
    });
  }
  removeMarginClasses() {
    if (!this.originalCustomClass) return "";
    const t = this.originalCustomClass.split(/\s+/).filter(Boolean), e = /^-?m[trblxy]?-.+/;
    return t.filter((r) => {
      const i = r.split(":").pop() ?? r;
      return !e.test(i);
    }).join(" ");
  }
  updateSlottedItems() {
    if (!this.itemsSlot) return;
    const t = this.itemsSlot.assignedElements({ flatten: !0 }).filter((e) => e.tagName === "CK-BREADCRUMB-ITEM");
    t.length && t.forEach((e, r) => {
      e.separator = this.separator, e.last = r === t.length - 1;
    });
  }
  attachSlotListener() {
    !this.itemsSlot || this.slotListenerAttached || (this.itemsSlot.addEventListener("slotchange", this.handleSlotChange), this.slotListenerAttached = !0);
  }
  get containerClasses() {
    return g(
      "inline-flex w-full flex-nowrap items-center gap-2 overflow-x-auto hide-scrollbar text-foreground sm:overflow-x-hidden",
      this.removeMarginClasses()
    );
  }
  render() {
    return f`
      <nav aria-label="Breadcrumb">
        <ol class=${this.containerClasses} role="list">
          <slot></slot>
        </ol>
      </nav>
    `;
  }
};
Dn.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
      }

      :host([hidden]) {
        display: none;
      }
    `
];
let gs = Dn;
Ga([
  u({ type: String })
], gs.prototype, "separator");
Ga([
  Kt("slot")
], gs.prototype, "itemsSlot");
customElements.get("ck-breadcrumbs") || customElements.define("ck-breadcrumbs", gs);
const Ne = Symbol("input-group-context");
class xu extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "block text-sm text-foreground-secondary mt-1";
  }
  // Use light DOM so Tailwind classes work directly
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this.pElement = document.createElement("p"), Array.from(this.childNodes).forEach((e) => {
      this.pElement.appendChild(e);
    }), this.appendChild(this.pElement), this._updateClasses(), this._syncHostClasses();
  }
  updated() {
    this.hasAttribute("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._updateClasses(), this._syncHostClasses();
  }
  _updateClasses() {
    if (!this.pElement) return;
    const t = g(this.baseClasses, this.originalCustomClass);
    this.pElement.className = t;
  }
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-form-help-text") || customElements.define("ck-form-help-text", xu);
var Cu = Object.defineProperty, ge = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Cu(t, e, i), i;
};
class Yt extends b {
  constructor() {
    super(...arguments), this.type = "text", this.placeholder = "", this.disabled = !1, this.required = !1, this.invalid = !1, this.variant = "default", this.size = "md", this.originalCustomClass = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.inputElement = this.querySelector("input"), this.syncAttributes(), this.syncEventHandlers(), this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = this.getInputClasses(), e = g(t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers(), this.inputElement && (this.invalid ? this.inputElement.setAttribute("data-invalid", "") : this.inputElement.removeAttribute("data-invalid")), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses()), (t.has("variant") || t.has("size") || t.has("class")) && this.inputElement && (this.inputElement.className = this.getInputClasses());
  }
  syncAttributes() {
    if (this.inputElement)
      for (const t of this.attributes)
        [
          "type",
          "placeholder",
          "disabled",
          "required",
          "class",
          "invalid",
          "variant",
          "size"
        ].includes(t.name) || this.inputElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.inputElement && q(this, this.inputElement);
  }
  getInputClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "", e = {
      default: "border-border bg-transparent hover:border-mix-border/8 hover:bg-alpha-hard shadow-xs",
      minimal: "border-transparent bg-transparent hover:bg-background-secondary focus-visible:bg-background"
    };
    return g(
      // Base styles
      "transition duration-200 w-full border px-3.5 py-2.5 text-sm font-mono uppercase tracking-wide",
      "focus:outline-none focus-visible:border-foreground focus-visible:ring-4 focus-visible:ring-ring focus-visible:text-foreground",
      "disabled:cursor-not-allowed disabled:opacity-50 text-foreground/80 placeholder:text-foreground/55",
      // Invalid state
      "data-invalid:border-red-500 data-invalid:hover:border-red-600 data-invalid:focus-visible:border-red-500 data-invalid:focus-visible:ring-red-500/20",
      // Dynamic padding based on prefix/suffix
      "pl-[var(--prefix-width,calc(var(--spacing)*4))]",
      "pr-[var(--suffix-width,calc(var(--spacing)*4))]",
      // Size styles
      {
        xs: "h-8",
        sm: "h-10",
        md: "h-14"
      }[this.size],
      // Variant styles
      e[this.variant],
      t
    );
  }
  render() {
    return f`
      <input
        type="${this.type}"
        placeholder="${this.placeholder}"
        ?disabled="${this.disabled}"
        ?required="${this.required}"
        aria-invalid="${this.invalid}"
        class="${this.getInputClasses()}"
      />
    `;
  }
}
ge([
  u({ type: String })
], Yt.prototype, "type");
ge([
  u({ type: String })
], Yt.prototype, "placeholder");
ge([
  u({ type: Boolean })
], Yt.prototype, "disabled");
ge([
  u({ type: Boolean })
], Yt.prototype, "required");
ge([
  u({ type: Boolean })
], Yt.prototype, "invalid");
ge([
  u({ type: String })
], Yt.prototype, "variant");
ge([
  u({ type: String })
], Yt.prototype, "size");
customElements.get("ck-input") || customElements.define("ck-input", Yt);
var ku = Object.defineProperty, Ya = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && ku(t, e, i), i;
};
class Or extends b {
  constructor() {
    super(...arguments), this.prefixWidth = 0, this.suffixWidth = 0, this.originalCustomClass = "", this.baseClasses = "relative", this._provider = new ft(this, {
      context: Ne,
      initialValue: {
        prefixWidth: 0,
        suffixWidth: 0,
        setPrefixWidth: () => {
        },
        setSuffixWidth: () => {
        }
      }
    });
  }
  createRenderRoot() {
    return this;
  }
  _updateContext() {
    this._provider.setValue({
      prefixWidth: this.prefixWidth,
      suffixWidth: this.suffixWidth,
      setPrefixWidth: (t) => {
        this.prefixWidth = t, this._updateContext();
      },
      setSuffixWidth: (t) => {
        this.suffixWidth = t, this._updateContext();
      }
    });
  }
  getStyles() {
    const t = [];
    return this.prefixWidth > 0 && t.push(`--prefix-width: calc(${this.prefixWidth}px + var(--spacing) * 5.5)`), this.suffixWidth > 0 && t.push(`--suffix-width: calc(${this.suffixWidth}px + var(--spacing) * 5.5)`), t.join("; ");
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._updateContext(), this._applyStyles(), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._updateContext(), this._applyStyles(), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _applyStyles() {
    const t = this.getStyles();
    t ? this.setAttribute("style", t) : this.removeAttribute("style");
  }
  render() {
    return f`<slot></slot>`;
  }
}
Ya([
  R()
], Or.prototype, "prefixWidth");
Ya([
  R()
], Or.prototype, "suffixWidth");
customElements.get("ck-input-group") || customElements.define("ck-input-group", Or);
var _u = Object.defineProperty, Xa = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && _u(t, e, i), i;
};
class Ir extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.addonElement = null, this.resizeObserver = null;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.updateComplete.then(() => {
      this._setupWidthTracking();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  _setupWidthTracking() {
    const t = this.asChild ? this.firstElementChild : this;
    if (!t || t === this.addonElement) return;
    this.resizeObserver && this.resizeObserver.disconnect(), this.addonElement = t;
    const e = t.offsetWidth;
    e > 0 && this.contextValue?.setPrefixWidth && this.contextValue.setPrefixWidth(Math.round(e)), this.resizeObserver = new ResizeObserver((r) => {
      const i = r[0];
      i?.contentRect.width && this.contextValue?.setPrefixWidth && this.contextValue.setPrefixWidth(Math.round(i.contentRect.width));
    }), this.resizeObserver.observe(t);
  }
  updated(t) {
    super.updated(t), this.updateComplete.then(() => {
      if (this._setupWidthTracking(), this.asChild) {
        const e = this.firstElementChild;
        if (e) {
          const r = this.getAttribute("class") || "", i = g(
            "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
            "text-foreground pointer-events-none left-4",
            r
          );
          Zt(this.asChild, e, {
            className: i,
            "data-input-addon": !0
          });
        }
      } else {
        const e = this.getAttribute("class") || "", r = g(
          "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
          "text-foreground pointer-events-none left-4",
          e
        );
        this.className = r, this.setAttribute("data-input-addon", "");
      }
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
Xa([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Ir.prototype, "asChild");
Xa([
  L({ context: Ne })
], Ir.prototype, "contextValue");
customElements.get("ck-input-prefix") || customElements.define("ck-input-prefix", Ir);
var Eu = Object.defineProperty, Ja = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Eu(t, e, i), i;
};
class Vr extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.addonElement = null, this.resizeObserver = null;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.updateComplete.then(() => {
      this._setupWidthTracking();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  _setupWidthTracking() {
    const t = this.asChild ? this.firstElementChild : this;
    if (!t || t === this.addonElement) return;
    this.resizeObserver && this.resizeObserver.disconnect(), this.addonElement = t;
    const e = t.offsetWidth;
    e > 0 && this.contextValue?.setSuffixWidth && this.contextValue.setSuffixWidth(Math.round(e)), this.resizeObserver = new ResizeObserver((r) => {
      const i = r[0];
      i?.contentRect.width && this.contextValue?.setSuffixWidth && this.contextValue.setSuffixWidth(Math.round(i.contentRect.width));
    }), this.resizeObserver.observe(t);
  }
  updated(t) {
    super.updated(t), this.updateComplete.then(() => {
      if (this._setupWidthTracking(), this.asChild) {
        const e = this.firstElementChild;
        if (e) {
          const r = this.getAttribute("class") || "", i = g(
            "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
            "text-foreground pointer-events-none right-4",
            r
          );
          Zt(this.asChild, e, {
            className: i,
            "data-input-addon": !0
          });
        }
      } else {
        const e = this.getAttribute("class") || "", r = g(
          "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
          "text-foreground pointer-events-none right-4",
          e
        );
        this.className = r, this.setAttribute("data-input-addon", "");
      }
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
Ja([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Vr.prototype, "asChild");
Ja([
  L({ context: Ne })
], Vr.prototype, "contextValue");
customElements.get("ck-input-suffix") || customElements.define("ck-input-suffix", Vr);
const Co = (s) => s ?? W;
var Au = Object.defineProperty, wt = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Au(t, e, i), i;
};
const zn = class zn extends b {
  constructor() {
    super(...arguments), this.value = 1, this.min = 1, this.max = null, this.step = 1, this.disabled = !1, this.removeAtMin = !1, this.disableIncrement = !1, this.name = null, this.ariaLabel = "Quantity", this.size = "md", this.handleInput = (t) => {
      const e = t.target, r = Number(e?.value);
      Number.isNaN(r) || this.updateValue(r);
    }, this.increment = () => {
      this.disabled || this.disableIncrement || this.isAtMax || this.updateValue(this.value + this.step);
    }, this.decrement = () => {
      if (!this.disabled) {
        if (this.isAtMin) {
          this.removeAtMin && this.emitRemove();
          return;
        }
        this.updateValue(this.value - this.step);
      }
    };
  }
  lockNativeInput() {
    this.nativeInput && (this.nativeInput.readOnly = !0, this.nativeInput.inputMode = "none", this.nativeInput.autocomplete = "off", this.nativeInput.autocorrect = !1, this.nativeInput.autocapitalize = "off", this.nativeInput.spellcheck = !1);
  }
  get isAtMin() {
    return this.value <= this.min;
  }
  get isAtMax() {
    return this.max !== null && this.value >= this.max;
  }
  clampValue(t) {
    let e = Number.isFinite(t) ? t : this.value;
    e = Math.max(this.min, e);
    const r = this.disableIncrement ? this.value : this.max;
    return r !== null && (e = Math.min(r, e)), e;
  }
  emitChange() {
    this.dispatchEvent(
      new CustomEvent("quantity-change", {
        detail: { value: this.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  emitRemove() {
    this.dispatchEvent(
      new CustomEvent("quantity-remove", {
        detail: { value: this.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  updateValue(t) {
    const e = this.clampValue(t);
    if (e === this.value) {
      this.syncNativeValue();
      return;
    }
    this.value = e, this.emitChange();
  }
  syncNativeValue() {
    this.nativeInput && (this.nativeInput.value = String(this.value));
  }
  firstUpdated() {
    this.value = this.clampValue(this.value), this.syncNativeValue(), this.lockNativeInput();
  }
  updated(t) {
    if (t.has("value") && this.syncNativeValue(), t.has("min") || t.has("max")) {
      const e = this.clampValue(this.value);
      e !== this.value ? this.value = e : this.syncNativeValue();
    }
    this.lockNativeInput();
  }
  render() {
    const t = g("flex bg-background text-foreground min-w-[145px] w-full"), e = g(
      "cursor-pointer shrink-0 inline-flex h-full w-[42px] items-center justify-center text-2xl font-light text-foreground transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
    ), r = g(
      "text-sm text-center font-mono tracking-[0.3em] placeholder:text-ring focus-visible:border-none focus-visible:ring-0 text-foreground flex items-center justify-center w-full px-0 min-w-0"
    ), i = g("flex border border-border w-full min-w-0");
    return f`
      <div class="${i}">
        <ck-input-group class="${t}">
          <ck-input-prefix class="pointer-events-auto contents">
            <button
              type="button"
              class="${e}"
              @click=${this.decrement}
              ?disabled=${this.disabled || this.isAtMin && !this.removeAtMin}
              aria-label=${this.isAtMin && this.removeAtMin ? "Remove item" : "Decrease quantity"}
            >
              <ck-icon name=${this.isAtMin && this.removeAtMin ? "trash" : "minus"}></ck-icon>
            </button>
          </ck-input-prefix>
          <ck-input
            type="number"
            variant="minimal"
            size=${this.size}
            inputmode="numeric"
            class="${r}"
            value="${this.value}"
            min=${this.min}
            step=${this.step}
            max=${Co((this.disableIncrement ? this.value : this.max) ?? void 0)}
            ?disabled=${this.disabled}
            name=${Co(this.name ?? void 0)}
            aria-label=${this.ariaLabel}
            @input=${this.handleInput}
          ></ck-input>
          <ck-input-suffix class="pointer-events-auto contents">
            <button
              type="button"
              class="${e}"
              @click=${this.increment}
              ?disabled=${this.disabled || this.disableIncrement || this.isAtMax}
              aria-label="Increase quantity"
            >
              <ck-icon name="plus"></ck-icon>
            </button>
          </ck-input-suffix>
        </ck-input-group>
      </div>
    `;
  }
};
zn.styles = [
  ...b.styles,
  N`
      :host {
        display: flex;
        min-width: 0;
        width: 100%;
      }

      :host > div {
        width: 100%;
        min-width: 0;
      }

      :host ck-input-group {
        width: 100%;
        min-width: 0;
      }

      :host ck-input {
        width: 100%;
        min-width: 0;
      }

      :host ck-input input::-webkit-outer-spin-button,
      :host ck-input input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      :host ck-input input[type='number'] {
        -moz-appearance: textfield;
      }
    `
];
let nt = zn;
wt([
  u({ type: Number, reflect: !0 })
], nt.prototype, "value");
wt([
  u({ type: Number })
], nt.prototype, "min");
wt([
  u({
    converter: {
      fromAttribute: (s) => {
        if (s == null || s === "") return null;
        const t = Number(s);
        return Number.isNaN(t) ? null : t;
      }
    }
  })
], nt.prototype, "max");
wt([
  u({ type: Number })
], nt.prototype, "step");
wt([
  u({ type: Boolean })
], nt.prototype, "disabled");
wt([
  u({ type: Boolean, attribute: "remove-at-min" })
], nt.prototype, "removeAtMin");
wt([
  u({ type: Boolean, attribute: "disable-increment" })
], nt.prototype, "disableIncrement");
wt([
  u({ type: String })
], nt.prototype, "name");
wt([
  u({ type: String, attribute: "aria-label" })
], nt.prototype, "ariaLabel");
wt([
  u({ type: String })
], nt.prototype, "size");
wt([
  Kt("ck-input input")
], nt.prototype, "nativeInput");
customElements.get("ck-quantity-input") || customElements.define("ck-quantity-input", nt);
function Su(s, t, e) {
  return Math.max(t, Math.min(s, e));
}
const J = {
  toVector(s, t) {
    return s === void 0 && (s = t), Array.isArray(s) ? s : [s, s];
  },
  add(s, t) {
    return [s[0] + t[0], s[1] + t[1]];
  },
  sub(s, t) {
    return [s[0] - t[0], s[1] - t[1]];
  },
  addTo(s, t) {
    s[0] += t[0], s[1] += t[1];
  },
  subTo(s, t) {
    s[0] -= t[0], s[1] -= t[1];
  }
};
function ko(s, t, e) {
  return t === 0 || Math.abs(t) === 1 / 0 ? Math.pow(s, e * 5) : s * t * e / (t + e * s);
}
function _o(s, t, e, r = 0.15) {
  return r === 0 ? Su(s, t, e) : s < t ? -ko(t - s, e - t, r) + t : s > e ? +ko(s - e, e - t, r) + e : s;
}
function $u(s, [t, e], [r, i]) {
  const [[n, o], [a, l]] = s;
  return [_o(t, n, o, r), _o(e, a, l, i)];
}
function Tu(s, t) {
  if (typeof s != "object" || s === null) return s;
  var e = s[Symbol.toPrimitive];
  if (e !== void 0) {
    var r = e.call(s, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(s);
}
function Ou(s) {
  var t = Tu(s, "string");
  return typeof t == "symbol" ? t : String(t);
}
function it(s, t, e) {
  return t = Ou(t), t in s ? Object.defineProperty(s, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[t] = e, s;
}
function Eo(s, t) {
  var e = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(s);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(s, i).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function j(s) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Eo(Object(e), !0).forEach(function(r) {
      it(s, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(e)) : Eo(Object(e)).forEach(function(r) {
      Object.defineProperty(s, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return s;
}
const Qa = {
  pointer: {
    start: "down",
    change: "move",
    end: "up"
  },
  mouse: {
    start: "down",
    change: "move",
    end: "up"
  },
  touch: {
    start: "start",
    change: "move",
    end: "end"
  },
  gesture: {
    start: "start",
    change: "change",
    end: "end"
  }
};
function Ao(s) {
  return s ? s[0].toUpperCase() + s.slice(1) : "";
}
const Iu = ["enter", "leave"];
function Vu(s = !1, t) {
  return s && !Iu.includes(t);
}
function Pu(s, t = "", e = !1) {
  const r = Qa[s], i = r && r[t] || t;
  return "on" + Ao(s) + Ao(i) + (Vu(e, i) ? "Capture" : "");
}
const Mu = ["gotpointercapture", "lostpointercapture"];
function Lu(s) {
  let t = s.substring(2).toLowerCase();
  const e = !!~t.indexOf("passive");
  e && (t = t.replace("passive", ""));
  const r = Mu.includes(t) ? "capturecapture" : "capture", i = !!~t.indexOf(r);
  return i && (t = t.replace("capture", "")), {
    device: t,
    capture: i,
    passive: e
  };
}
function Ru(s, t = "") {
  const e = Qa[s], r = e && e[t] || t;
  return s + r;
}
function Ai(s) {
  return "touches" in s;
}
function tl(s) {
  return Ai(s) ? "touch" : "pointerType" in s ? s.pointerType : "mouse";
}
function Hu(s) {
  return Array.from(s.touches).filter((t) => {
    var e, r;
    return t.target === s.currentTarget || ((e = s.currentTarget) === null || e === void 0 || (r = e.contains) === null || r === void 0 ? void 0 : r.call(e, t.target));
  });
}
function Du(s) {
  return s.type === "touchend" || s.type === "touchcancel" ? s.changedTouches : s.targetTouches;
}
function el(s) {
  return Ai(s) ? Du(s)[0] : s;
}
function zu(s) {
  return Hu(s).map((t) => t.identifier);
}
function Ui(s) {
  const t = el(s);
  return Ai(s) ? t.identifier : t.pointerId;
}
function So(s) {
  const t = el(s);
  return [t.clientX, t.clientY];
}
function Nu(s) {
  const t = {};
  if ("buttons" in s && (t.buttons = s.buttons), "shiftKey" in s) {
    const {
      shiftKey: e,
      altKey: r,
      metaKey: i,
      ctrlKey: n
    } = s;
    Object.assign(t, {
      shiftKey: e,
      altKey: r,
      metaKey: i,
      ctrlKey: n
    });
  }
  return t;
}
function fi(s, ...t) {
  return typeof s == "function" ? s(...t) : s;
}
function Bu() {
}
function ju(...s) {
  return s.length === 0 ? Bu : s.length === 1 ? s[0] : function() {
    let t;
    for (const e of s)
      t = e.apply(this, arguments) || t;
    return t;
  };
}
function $o(s, t) {
  return Object.assign({}, t, s || {});
}
const Fu = 32;
class Wu {
  constructor(t, e, r) {
    this.ctrl = t, this.args = e, this.key = r, this.state || (this.state = {}, this.computeValues([0, 0]), this.computeInitial(), this.init && this.init(), this.reset());
  }
  get state() {
    return this.ctrl.state[this.key];
  }
  set state(t) {
    this.ctrl.state[this.key] = t;
  }
  get shared() {
    return this.ctrl.state.shared;
  }
  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }
  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }
  get config() {
    return this.ctrl.config[this.key];
  }
  get sharedConfig() {
    return this.ctrl.config.shared;
  }
  get handler() {
    return this.ctrl.handlers[this.key];
  }
  reset() {
    const {
      state: t,
      shared: e,
      ingKey: r,
      args: i
    } = this;
    e[r] = t._active = t.active = t._blocked = t._force = !1, t._step = [!1, !1], t.intentional = !1, t._movement = [0, 0], t._distance = [0, 0], t._direction = [0, 0], t._delta = [0, 0], t._bounds = [[-1 / 0, 1 / 0], [-1 / 0, 1 / 0]], t.args = i, t.axis = void 0, t.memo = void 0, t.elapsedTime = t.timeDelta = 0, t.direction = [0, 0], t.distance = [0, 0], t.overflow = [0, 0], t._movementBound = [!1, !1], t.velocity = [0, 0], t.movement = [0, 0], t.delta = [0, 0], t.timeStamp = 0;
  }
  start(t) {
    const e = this.state, r = this.config;
    e._active || (this.reset(), this.computeInitial(), e._active = !0, e.target = t.target, e.currentTarget = t.currentTarget, e.lastOffset = r.from ? fi(r.from, e) : e.offset, e.offset = e.lastOffset, e.startTime = e.timeStamp = t.timeStamp);
  }
  computeValues(t) {
    const e = this.state;
    e._values = t, e.values = this.config.transform(t);
  }
  computeInitial() {
    const t = this.state;
    t._initial = t._values, t.initial = t.values;
  }
  compute(t) {
    const {
      state: e,
      config: r,
      shared: i
    } = this;
    e.args = this.args;
    let n = 0;
    if (t && (e.event = t, r.preventDefault && t.cancelable && e.event.preventDefault(), e.type = t.type, i.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size, i.locked = !!document.pointerLockElement, Object.assign(i, Nu(t)), i.down = i.pressed = i.buttons % 2 === 1 || i.touches > 0, n = t.timeStamp - e.timeStamp, e.timeStamp = t.timeStamp, e.elapsedTime = e.timeStamp - e.startTime), e._active) {
      const O = e._delta.map(Math.abs);
      J.addTo(e._distance, O);
    }
    this.axisIntent && this.axisIntent(t);
    const [o, a] = e._movement, [l, d] = r.threshold, {
      _step: c,
      values: h
    } = e;
    if (r.hasCustomTransform ? (c[0] === !1 && (c[0] = Math.abs(o) >= l && h[0]), c[1] === !1 && (c[1] = Math.abs(a) >= d && h[1])) : (c[0] === !1 && (c[0] = Math.abs(o) >= l && Math.sign(o) * l), c[1] === !1 && (c[1] = Math.abs(a) >= d && Math.sign(a) * d)), e.intentional = c[0] !== !1 || c[1] !== !1, !e.intentional) return;
    const p = [0, 0];
    if (r.hasCustomTransform) {
      const [O, P] = h;
      p[0] = c[0] !== !1 ? O - c[0] : 0, p[1] = c[1] !== !1 ? P - c[1] : 0;
    } else
      p[0] = c[0] !== !1 ? o - c[0] : 0, p[1] = c[1] !== !1 ? a - c[1] : 0;
    this.restrictToAxis && !e._blocked && this.restrictToAxis(p);
    const m = e.offset, v = e._active && !e._blocked || e.active;
    v && (e.first = e._active && !e.active, e.last = !e._active && e.active, e.active = i[this.ingKey] = e._active, t && (e.first && ("bounds" in r && (e._bounds = fi(r.bounds, e)), this.setup && this.setup()), e.movement = p, this.computeOffset()));
    const [w, x] = e.offset, [[C, $], [S, T]] = e._bounds;
    e.overflow = [w < C ? -1 : w > $ ? 1 : 0, x < S ? -1 : x > T ? 1 : 0], e._movementBound[0] = e.overflow[0] ? e._movementBound[0] === !1 ? e._movement[0] : e._movementBound[0] : !1, e._movementBound[1] = e.overflow[1] ? e._movementBound[1] === !1 ? e._movement[1] : e._movementBound[1] : !1;
    const k = e._active ? r.rubberband || [0, 0] : [0, 0];
    if (e.offset = $u(e._bounds, e.offset, k), e.delta = J.sub(e.offset, m), this.computeMovement(), v && (!e.last || n > Fu)) {
      e.delta = J.sub(e.offset, m);
      const O = e.delta.map(Math.abs);
      J.addTo(e.distance, O), e.direction = e.delta.map(Math.sign), e._direction = e._delta.map(Math.sign), !e.first && n > 0 && (e.velocity = [O[0] / n, O[1] / n], e.timeDelta = n);
    }
  }
  emit() {
    const t = this.state, e = this.shared, r = this.config;
    if (t._active || this.clean(), (t._blocked || !t.intentional) && !t._force && !r.triggerAllEvents) return;
    const i = this.handler(j(j(j({}, e), t), {}, {
      [this.aliasKey]: t.values
    }));
    i !== void 0 && (t.memo = i);
  }
  clean() {
    this.eventStore.clean(), this.timeoutStore.clean();
  }
}
function Uu([s, t], e) {
  const r = Math.abs(s), i = Math.abs(t);
  if (r > i && r > e)
    return "x";
  if (i > r && i > e)
    return "y";
}
class qu extends Wu {
  constructor(...t) {
    super(...t), it(this, "aliasKey", "xy");
  }
  reset() {
    super.reset(), this.state.axis = void 0;
  }
  init() {
    this.state.offset = [0, 0], this.state.lastOffset = [0, 0];
  }
  computeOffset() {
    this.state.offset = J.add(this.state.lastOffset, this.state.movement);
  }
  computeMovement() {
    this.state.movement = J.sub(this.state.offset, this.state.lastOffset);
  }
  axisIntent(t) {
    const e = this.state, r = this.config;
    if (!e.axis && t) {
      const i = typeof r.axisThreshold == "object" ? r.axisThreshold[tl(t)] : r.axisThreshold;
      e.axis = Uu(e._movement, i);
    }
    e._blocked = (r.lockDirection || !!r.axis) && !e.axis || !!r.axis && r.axis !== e.axis;
  }
  restrictToAxis(t) {
    if (this.config.axis || this.config.lockDirection)
      switch (this.state.axis) {
        case "x":
          t[1] = 0;
          break;
        case "y":
          t[0] = 0;
          break;
      }
  }
}
const Ku = (s) => s, To = 0.15, sl = {
  enabled(s = !0) {
    return s;
  },
  eventOptions(s, t, e) {
    return j(j({}, e.shared.eventOptions), s);
  },
  preventDefault(s = !1) {
    return s;
  },
  triggerAllEvents(s = !1) {
    return s;
  },
  rubberband(s = 0) {
    switch (s) {
      case !0:
        return [To, To];
      case !1:
        return [0, 0];
      default:
        return J.toVector(s);
    }
  },
  from(s) {
    if (typeof s == "function") return s;
    if (s != null) return J.toVector(s);
  },
  transform(s, t, e) {
    const r = s || e.shared.transform;
    return this.hasCustomTransform = !!r, r || Ku;
  },
  threshold(s) {
    return J.toVector(s, 0);
  }
}, Zu = 0, Hs = j(j({}, sl), {}, {
  axis(s, t, {
    axis: e
  }) {
    if (this.lockDirection = e === "lock", !this.lockDirection) return e;
  },
  axisThreshold(s = Zu) {
    return s;
  },
  bounds(s = {}) {
    if (typeof s == "function")
      return (n) => Hs.bounds(s(n));
    if ("current" in s)
      return () => s.current;
    if (typeof HTMLElement == "function" && s instanceof HTMLElement)
      return s;
    const {
      left: t = -1 / 0,
      right: e = 1 / 0,
      top: r = -1 / 0,
      bottom: i = 1 / 0
    } = s;
    return [[t, e], [r, i]];
  }
}), Oo = {
  ArrowRight: (s, t = 1) => [s * t, 0],
  ArrowLeft: (s, t = 1) => [-1 * s * t, 0],
  ArrowUp: (s, t = 1) => [0, -1 * s * t],
  ArrowDown: (s, t = 1) => [0, s * t]
};
class Gu extends qu {
  constructor(...t) {
    super(...t), it(this, "ingKey", "dragging");
  }
  reset() {
    super.reset();
    const t = this.state;
    t._pointerId = void 0, t._pointerActive = !1, t._keyboardActive = !1, t._preventScroll = !1, t._delayed = !1, t.swipe = [0, 0], t.tap = !1, t.canceled = !1, t.cancel = this.cancel.bind(this);
  }
  setup() {
    const t = this.state;
    if (t._bounds instanceof HTMLElement) {
      const e = t._bounds.getBoundingClientRect(), r = t.currentTarget.getBoundingClientRect(), i = {
        left: e.left - r.left + t.offset[0],
        right: e.right - r.right + t.offset[0],
        top: e.top - r.top + t.offset[1],
        bottom: e.bottom - r.bottom + t.offset[1]
      };
      t._bounds = Hs.bounds(i);
    }
  }
  cancel() {
    const t = this.state;
    t.canceled || (t.canceled = !0, t._active = !1, setTimeout(() => {
      this.compute(), this.emit();
    }, 0));
  }
  setActive() {
    this.state._active = this.state._pointerActive || this.state._keyboardActive;
  }
  clean() {
    this.pointerClean(), this.state._pointerActive = !1, this.state._keyboardActive = !1, super.clean();
  }
  pointerDown(t) {
    const e = this.config, r = this.state;
    if (t.buttons != null && (Array.isArray(e.pointerButtons) ? !e.pointerButtons.includes(t.buttons) : e.pointerButtons !== -1 && e.pointerButtons !== t.buttons)) return;
    const i = this.ctrl.setEventIds(t);
    e.pointerCapture && t.target.setPointerCapture(t.pointerId), !(i && i.size > 1 && r._pointerActive) && (this.start(t), this.setupPointer(t), r._pointerId = Ui(t), r._pointerActive = !0, this.computeValues(So(t)), this.computeInitial(), e.preventScrollAxis && tl(t) !== "mouse" ? (r._active = !1, this.setupScrollPrevention(t)) : e.delay > 0 ? (this.setupDelayTrigger(t), e.triggerAllEvents && (this.compute(t), this.emit())) : this.startPointerDrag(t));
  }
  startPointerDrag(t) {
    const e = this.state;
    e._active = !0, e._preventScroll = !0, e._delayed = !1, this.compute(t), this.emit();
  }
  pointerMove(t) {
    const e = this.state, r = this.config;
    if (!e._pointerActive) return;
    const i = Ui(t);
    if (e._pointerId !== void 0 && i !== e._pointerId) return;
    const n = So(t);
    if (document.pointerLockElement === t.target ? e._delta = [t.movementX, t.movementY] : (e._delta = J.sub(n, e._values), this.computeValues(n)), J.addTo(e._movement, e._delta), this.compute(t), e._delayed && e.intentional) {
      this.timeoutStore.remove("dragDelay"), e.active = !1, this.startPointerDrag(t);
      return;
    }
    if (r.preventScrollAxis && !e._preventScroll)
      if (e.axis)
        if (e.axis === r.preventScrollAxis || r.preventScrollAxis === "xy") {
          e._active = !1, this.clean();
          return;
        } else {
          this.timeoutStore.remove("startPointerDrag"), this.startPointerDrag(t);
          return;
        }
      else
        return;
    this.emit();
  }
  pointerUp(t) {
    this.ctrl.setEventIds(t);
    try {
      this.config.pointerCapture && t.target.hasPointerCapture(t.pointerId) && t.target.releasePointerCapture(t.pointerId);
    } catch {
    }
    const e = this.state, r = this.config;
    if (!e._active || !e._pointerActive) return;
    const i = Ui(t);
    if (e._pointerId !== void 0 && i !== e._pointerId) return;
    this.state._pointerActive = !1, this.setActive(), this.compute(t);
    const [n, o] = e._distance;
    if (e.tap = n <= r.tapsThreshold && o <= r.tapsThreshold, e.tap && r.filterTaps)
      e._force = !0;
    else {
      const [a, l] = e._delta, [d, c] = e._movement, [h, p] = r.swipe.velocity, [m, v] = r.swipe.distance, w = r.swipe.duration;
      if (e.elapsedTime < w) {
        const x = Math.abs(a / e.timeDelta), C = Math.abs(l / e.timeDelta);
        x > h && Math.abs(d) > m && (e.swipe[0] = Math.sign(a)), C > p && Math.abs(c) > v && (e.swipe[1] = Math.sign(l));
      }
    }
    this.emit();
  }
  pointerClick(t) {
    !this.state.tap && t.detail > 0 && (t.preventDefault(), t.stopPropagation());
  }
  setupPointer(t) {
    const e = this.config, r = e.device;
    e.pointerLock && t.currentTarget.requestPointerLock(), e.pointerCapture || (this.eventStore.add(this.sharedConfig.window, r, "change", this.pointerMove.bind(this)), this.eventStore.add(this.sharedConfig.window, r, "end", this.pointerUp.bind(this)), this.eventStore.add(this.sharedConfig.window, r, "cancel", this.pointerUp.bind(this)));
  }
  pointerClean() {
    this.config.pointerLock && document.pointerLockElement === this.state.currentTarget && document.exitPointerLock();
  }
  preventScroll(t) {
    this.state._preventScroll && t.cancelable && t.preventDefault();
  }
  setupScrollPrevention(t) {
    this.state._preventScroll = !1, Yu(t);
    const e = this.eventStore.add(this.sharedConfig.window, "touch", "change", this.preventScroll.bind(this), {
      passive: !1
    });
    this.eventStore.add(this.sharedConfig.window, "touch", "end", e), this.eventStore.add(this.sharedConfig.window, "touch", "cancel", e), this.timeoutStore.add("startPointerDrag", this.startPointerDrag.bind(this), this.config.preventScrollDelay, t);
  }
  setupDelayTrigger(t) {
    this.state._delayed = !0, this.timeoutStore.add("dragDelay", () => {
      this.state._step = [0, 0], this.startPointerDrag(t);
    }, this.config.delay);
  }
  keyDown(t) {
    const e = Oo[t.key];
    if (e) {
      const r = this.state, i = t.shiftKey ? 10 : t.altKey ? 0.1 : 1;
      this.start(t), r._delta = e(this.config.keyboardDisplacement, i), r._keyboardActive = !0, J.addTo(r._movement, r._delta), this.compute(t), this.emit();
    }
  }
  keyUp(t) {
    t.key in Oo && (this.state._keyboardActive = !1, this.setActive(), this.compute(t), this.emit());
  }
  bind(t) {
    const e = this.config.device;
    t(e, "start", this.pointerDown.bind(this)), this.config.pointerCapture && (t(e, "change", this.pointerMove.bind(this)), t(e, "end", this.pointerUp.bind(this)), t(e, "cancel", this.pointerUp.bind(this)), t("lostPointerCapture", "", this.pointerUp.bind(this))), this.config.keys && (t("key", "down", this.keyDown.bind(this)), t("key", "up", this.keyUp.bind(this))), this.config.filterTaps && t("click", "", this.pointerClick.bind(this), {
      capture: !0,
      passive: !1
    });
  }
}
function Yu(s) {
  "persist" in s && typeof s.persist == "function" && s.persist();
}
const Ds = typeof window < "u" && window.document && window.document.createElement;
function il() {
  return Ds && "ontouchstart" in window;
}
function Xu() {
  return il() || Ds && window.navigator.maxTouchPoints > 1;
}
function Ju() {
  return Ds && "onpointerdown" in window;
}
function Qu() {
  return Ds && "exitPointerLock" in window.document;
}
function tp() {
  try {
    return "constructor" in GestureEvent;
  } catch {
    return !1;
  }
}
const ut = {
  isBrowser: Ds,
  gesture: tp(),
  touch: il(),
  touchscreen: Xu(),
  pointer: Ju(),
  pointerLock: Qu()
}, ep = 250, sp = 180, ip = 0.5, rp = 50, np = 250, op = 10, Io = {
  mouse: 0,
  touch: 0,
  pen: 8
}, ap = j(j({}, Hs), {}, {
  device(s, t, {
    pointer: {
      touch: e = !1,
      lock: r = !1,
      mouse: i = !1
    } = {}
  }) {
    return this.pointerLock = r && ut.pointerLock, ut.touch && e ? "touch" : this.pointerLock ? "mouse" : ut.pointer && !i ? "pointer" : ut.touch ? "touch" : "mouse";
  },
  preventScrollAxis(s, t, {
    preventScroll: e
  }) {
    if (this.preventScrollDelay = typeof e == "number" ? e : e || e === void 0 && s ? ep : void 0, !(!ut.touchscreen || e === !1))
      return s || (e !== void 0 ? "y" : void 0);
  },
  pointerCapture(s, t, {
    pointer: {
      capture: e = !0,
      buttons: r = 1,
      keys: i = !0
    } = {}
  }) {
    return this.pointerButtons = r, this.keys = i, !this.pointerLock && this.device === "pointer" && e;
  },
  threshold(s, t, {
    filterTaps: e = !1,
    tapsThreshold: r = 3,
    axis: i = void 0
  }) {
    const n = J.toVector(s, e ? r : i ? 1 : 0);
    return this.filterTaps = e, this.tapsThreshold = r, n;
  },
  swipe({
    velocity: s = ip,
    distance: t = rp,
    duration: e = np
  } = {}) {
    return {
      velocity: this.transform(J.toVector(s)),
      distance: this.transform(J.toVector(t)),
      duration: e
    };
  },
  delay(s = 0) {
    switch (s) {
      case !0:
        return sp;
      case !1:
        return 0;
      default:
        return s;
    }
  },
  axisThreshold(s) {
    return s ? j(j({}, Io), s) : Io;
  },
  keyboardDisplacement(s = op) {
    return s;
  }
});
j(j({}, sl), {}, {
  device(s, t, {
    shared: e,
    pointer: {
      touch: r = !1
    } = {}
  }) {
    if (e.target && !ut.touch && ut.gesture) return "gesture";
    if (ut.touch && r) return "touch";
    if (ut.touchscreen) {
      if (ut.pointer) return "pointer";
      if (ut.touch) return "touch";
    }
  },
  bounds(s, t, {
    scaleBounds: e = {},
    angleBounds: r = {}
  }) {
    const i = (o) => {
      const a = $o(fi(e, o), {
        min: -1 / 0,
        max: 1 / 0
      });
      return [a.min, a.max];
    }, n = (o) => {
      const a = $o(fi(r, o), {
        min: -1 / 0,
        max: 1 / 0
      });
      return [a.min, a.max];
    };
    return typeof e != "function" && typeof r != "function" ? [i(), n()] : (o) => [i(o), n(o)];
  },
  threshold(s, t, e) {
    return this.lockDirection = e.axis === "lock", J.toVector(s, this.lockDirection ? [0.1, 3] : 0);
  },
  modifierKey(s) {
    return s === void 0 ? "ctrlKey" : s;
  },
  pinchOnWheel(s = !0) {
    return s;
  }
});
j(j({}, Hs), {}, {
  mouseOnly: (s = !0) => s
});
j(j({}, Hs), {}, {
  mouseOnly: (s = !0) => s
});
const rl = /* @__PURE__ */ new Map(), ir = /* @__PURE__ */ new Map();
function lp(s) {
  rl.set(s.key, s.engine), ir.set(s.key, s.resolver);
}
const cp = {
  key: "drag",
  engine: Gu,
  resolver: ap
};
function dp(s, t) {
  if (s == null) return {};
  var e = {}, r = Object.keys(s), i, n;
  for (n = 0; n < r.length; n++)
    i = r[n], !(t.indexOf(i) >= 0) && (e[i] = s[i]);
  return e;
}
function hp(s, t) {
  if (s == null) return {};
  var e = dp(s, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(s);
    for (i = 0; i < n.length; i++)
      r = n[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(s, r) && (e[r] = s[r]);
  }
  return e;
}
const up = {
  target(s) {
    if (s)
      return () => "current" in s ? s.current : s;
  },
  enabled(s = !0) {
    return s;
  },
  window(s = ut.isBrowser ? window : void 0) {
    return s;
  },
  eventOptions({
    passive: s = !0,
    capture: t = !1
  } = {}) {
    return {
      passive: s,
      capture: t
    };
  },
  transform(s) {
    return s;
  }
}, pp = ["target", "eventOptions", "window", "enabled", "transform"];
function li(s = {}, t) {
  const e = {};
  for (const [r, i] of Object.entries(t))
    switch (typeof i) {
      case "function":
        e[r] = i.call(e, s[r], r, s);
        break;
      case "object":
        e[r] = li(s[r], i);
        break;
      case "boolean":
        i && (e[r] = s[r]);
        break;
    }
  return e;
}
function fp(s, t, e = {}) {
  const r = s, {
    target: i,
    eventOptions: n,
    window: o,
    enabled: a,
    transform: l
  } = r, d = hp(r, pp);
  if (e.shared = li({
    target: i,
    eventOptions: n,
    window: o,
    enabled: a,
    transform: l
  }, up), t) {
    const c = ir.get(t);
    e[t] = li(j({
      shared: e.shared
    }, d), c);
  } else
    for (const c in d) {
      const h = ir.get(c);
      h && (e[c] = li(j({
        shared: e.shared
      }, d[c]), h));
    }
  return e;
}
class nl {
  constructor(t, e) {
    it(this, "_listeners", /* @__PURE__ */ new Set()), this._ctrl = t, this._gestureKey = e;
  }
  add(t, e, r, i, n) {
    const o = this._listeners, a = Ru(e, r), l = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {}, d = j(j({}, l), n);
    t.addEventListener(a, i, d);
    const c = () => {
      t.removeEventListener(a, i, d), o.delete(c);
    };
    return o.add(c), c;
  }
  clean() {
    this._listeners.forEach((t) => t()), this._listeners.clear();
  }
}
class gp {
  constructor() {
    it(this, "_timeouts", /* @__PURE__ */ new Map());
  }
  add(t, e, r = 140, ...i) {
    this.remove(t), this._timeouts.set(t, window.setTimeout(e, r, ...i));
  }
  remove(t) {
    const e = this._timeouts.get(t);
    e && window.clearTimeout(e);
  }
  clean() {
    this._timeouts.forEach((t) => void window.clearTimeout(t)), this._timeouts.clear();
  }
}
class mp {
  constructor(t) {
    it(this, "gestures", /* @__PURE__ */ new Set()), it(this, "_targetEventStore", new nl(this)), it(this, "gestureEventStores", {}), it(this, "gestureTimeoutStores", {}), it(this, "handlers", {}), it(this, "config", {}), it(this, "pointerIds", /* @__PURE__ */ new Set()), it(this, "touchIds", /* @__PURE__ */ new Set()), it(this, "state", {
      shared: {
        shiftKey: !1,
        metaKey: !1,
        ctrlKey: !1,
        altKey: !1
      }
    }), bp(this, t);
  }
  setEventIds(t) {
    if (Ai(t))
      return this.touchIds = new Set(zu(t)), this.touchIds;
    if ("pointerId" in t)
      return t.type === "pointerup" || t.type === "pointercancel" ? this.pointerIds.delete(t.pointerId) : t.type === "pointerdown" && this.pointerIds.add(t.pointerId), this.pointerIds;
  }
  applyHandlers(t, e) {
    this.handlers = t, this.nativeHandlers = e;
  }
  applyConfig(t, e) {
    this.config = fp(t, e, this.config);
  }
  clean() {
    this._targetEventStore.clean();
    for (const t of this.gestures)
      this.gestureEventStores[t].clean(), this.gestureTimeoutStores[t].clean();
  }
  effect() {
    return this.config.shared.target && this.bind(), () => this._targetEventStore.clean();
  }
  bind(...t) {
    const e = this.config.shared, r = {};
    let i;
    if (!(e.target && (i = e.target(), !i))) {
      if (e.enabled) {
        for (const o of this.gestures) {
          const a = this.config[o], l = Vo(r, a.eventOptions, !!i);
          if (a.enabled) {
            const d = rl.get(o);
            new d(this, t, o).bind(l);
          }
        }
        const n = Vo(r, e.eventOptions, !!i);
        for (const o in this.nativeHandlers)
          n(o, "", (a) => this.nativeHandlers[o](j(j({}, this.state.shared), {}, {
            event: a,
            args: t
          })), void 0, !0);
      }
      for (const n in r)
        r[n] = ju(...r[n]);
      if (!i) return r;
      for (const n in r) {
        const {
          device: o,
          capture: a,
          passive: l
        } = Lu(n);
        this._targetEventStore.add(i, o, "", r[n], {
          capture: a,
          passive: l
        });
      }
    }
  }
}
function Ce(s, t) {
  s.gestures.add(t), s.gestureEventStores[t] = new nl(s, t), s.gestureTimeoutStores[t] = new gp();
}
function bp(s, t) {
  t.drag && Ce(s, "drag"), t.wheel && Ce(s, "wheel"), t.scroll && Ce(s, "scroll"), t.move && Ce(s, "move"), t.pinch && Ce(s, "pinch"), t.hover && Ce(s, "hover");
}
const Vo = (s, t, e) => (r, i, n, o = {}, a = !1) => {
  var l, d;
  const c = (l = o.capture) !== null && l !== void 0 ? l : t.capture, h = (d = o.passive) !== null && d !== void 0 ? d : t.passive;
  let p = a ? r : Pu(r, i, c);
  e && h && (p += "Passive"), s[p] = s[p] || [], s[p].push(n);
};
function vp(s, t) {
  if (typeof s != "object" || s === null) return s;
  var e = s[Symbol.toPrimitive];
  if (e !== void 0) {
    var r = e.call(s, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(s);
}
function yp(s) {
  var t = vp(s, "string");
  return typeof t == "symbol" ? t : String(t);
}
function wp(s, t, e) {
  return t = yp(t), t in s ? Object.defineProperty(s, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[t] = e, s;
}
function Po(s, t) {
  var e = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(s);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(s, i).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function ii(s) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Po(Object(e), !0).forEach(function(r) {
      wp(s, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(e)) : Po(Object(e)).forEach(function(r) {
      Object.defineProperty(s, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return s;
}
class xp {
  constructor(t, e, r, i, n) {
    this._target = t, this._gestureKey = i, this._ctrl = new mp(e), this._ctrl.applyHandlers(e, n), this._ctrl.applyConfig(ii(ii({}, r), {}, {
      target: t
    }), i), this._ctrl.effect();
  }
  destroy() {
    this._ctrl.clean();
  }
  setConfig(t) {
    this._ctrl.clean(), this._ctrl.applyConfig(ii(ii({}, t), {}, {
      target: this._target
    }), this._gestureKey), this._ctrl.effect();
  }
}
const Cp = function(t, e, r) {
  return lp(cp), new xp(t, {
    drag: e
  }, r || {}, "drag");
};
var kp = Object.defineProperty, me = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && kp(t, e, i), i;
};
const Nn = class Nn extends b {
  constructor() {
    super(...arguments), this.activeIndex = 0, this.itemCount = 0, this.indicatorScale = 1, this.goToSlide = (t) => {
      if (!this.itemCount) return;
      const e = Math.max(0, Math.min(t, this.itemCount - 1));
      e !== this.activeIndex && (this.activeIndex = e);
    }, this.nextSlide = () => {
      this.goToSlide(this.activeIndex + 1);
    }, this.previousSlide = () => {
      this.goToSlide(this.activeIndex - 1);
    }, this.handleIndicatorJump = (t) => {
      typeof t.detail?.index == "number" && this.goToSlide(t.detail.index);
    }, this.handleKeydown = (t) => {
      t.key === "ArrowRight" ? (t.preventDefault(), this.nextSlide()) : t.key === "ArrowLeft" && (t.preventDefault(), this.previousSlide());
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "region"), this.setAttribute("aria-roledescription", "carousel"), this.addEventListener("ck-carousel-indicator-jump", this.handleIndicatorJump);
  }
  firstUpdated() {
    this.setupGesture(), this.setupSlotListeners(), this.setupResizeObserver(), this.updateFromSlots(), this.calculateIndicatorSize();
  }
  updated(t) {
    super.updated(t), t.has("activeIndex") && this.updateFromSlots();
  }
  disconnectedCallback() {
    this.removeEventListener(
      "ck-carousel-indicator-jump",
      this.handleIndicatorJump
    ), this.gesture?.destroy(), this.gesture = void 0, this.resizeObserver?.disconnect(), this.resizeObserver = void 0, super.disconnectedCallback();
  }
  // --- Slot / children management ------------------------------------------
  setupSlotListeners() {
    this.defaultSlot?.addEventListener("slotchange", () => this.updateFromSlots()), this.indicatorsSlot?.addEventListener("slotchange", () => this.updateFromSlots());
  }
  getItems() {
    return this.defaultSlot ? this.defaultSlot.assignedElements({ flatten: !0 }).filter((t) => t.tagName.toLowerCase() === "ck-carousel-item") : [];
  }
  getIndicators() {
    return this.indicatorsSlot ? this.indicatorsSlot.assignedElements({ flatten: !0 }).filter((t) => t.tagName.toLowerCase() === "ck-carousel-indicator") : [];
  }
  updateFromSlots() {
    const t = this.getItems(), e = this.getIndicators(), r = t.length;
    this.itemCount = r, r === 0 ? this.activeIndex = 0 : this.activeIndex > r - 1 ? this.activeIndex = r - 1 : this.activeIndex < 0 && (this.activeIndex = 0), t.forEach((i, n) => {
      i.index = n, i.total = r, i.active = n === this.activeIndex;
    }), e.forEach((i, n) => {
      i.index = n, i.size = r, i.active = n === this.activeIndex;
    }), this.calculateIndicatorSize();
  }
  setupResizeObserver() {
    this.containerElement && (this.resizeObserver = new ResizeObserver(() => {
      this.calculateIndicatorSize();
    }), this.resizeObserver.observe(this.containerElement));
  }
  calculateIndicatorSize() {
    if (!this.containerElement || this.itemCount === 0) {
      this.indicatorScale = 1, this.updateIndicatorSizes();
      return;
    }
    const e = this.containerElement.offsetWidth * 0.85, o = 48 + (this.itemCount - 1) * 40 + (this.itemCount - 1) * 7;
    o > e ? this.indicatorScale = e / o : this.indicatorScale = 1, this.updateIndicatorSizes();
  }
  updateIndicatorSizes() {
    this.getIndicators().forEach((e) => {
      e.scale = this.indicatorScale;
    });
  }
  // --- Gestures & keyboard -------------------------------------------------
  setupGesture() {
    const t = this.viewportElement;
    t && (this.gesture?.destroy(), this.gesture = new Cp(
      t,
      ({ swipe: [e = 0] = [0, 0], movement: [r = 0] = [0, 0] }) => {
        if (e === -1 || r < -60) {
          this.nextSlide();
          return;
        }
        (e === 1 || r > 60) && this.previousSlide();
      },
      {
        axis: "x",
        filterTaps: !0,
        threshold: 10
      }
    ));
  }
  render() {
    const t = Ee({
      transform: `translateX(-${this.activeIndex * 100}%)`
    }), r = 7 * this.indicatorScale, i = Ee({
      gap: `${r}px`
    }), n = Ee({
      background: "linear-gradient(to top, var(--color-background-product), transparent)"
    });
    return f`
      <div class="ck-carousel-container relative w-full overflow-hidden">
        <div
          class="ck-carousel-viewport h-full w-full outline-none focus-visible:ring-4 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          tabindex="0"
          @keydown=${this.handleKeydown}
          aria-live="polite"
        >
          <div
            class="flex h-full w-full transition-transform duration-450 ease-[cubic-bezier(0.22,1,0.36,1)]"
            style=${t}
          >
            <slot></slot>
          </div>
        </div>
        <!-- Indicators outer container -->
        <div class="absolute bottom-0 left-0 right-0 h-10.5 z-10" style=${n}>
          <!-- Indicators inner container -->
          <div
            class="absolute left-1/2 top-1/2 inline-flex -translate-x-1/2 -translate-y-1/2 items-center"
            style=${i}
          >
            <slot name="indicators"></slot>
          </div>
        </div>
      </div>
    `;
  }
};
Nn.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
        width: 100%;
      }

      :host([hidden]) {
        display: none;
      }
    `
];
let St = Nn;
me([
  u({ type: Number, attribute: "active-index" })
], St.prototype, "activeIndex");
me([
  R()
], St.prototype, "itemCount");
me([
  R()
], St.prototype, "indicatorScale");
me([
  Kt(".ck-carousel-viewport")
], St.prototype, "viewportElement");
me([
  Kt(".ck-carousel-container")
], St.prototype, "containerElement");
me([
  Kt("slot:not([name])")
], St.prototype, "defaultSlot");
me([
  Kt('slot[name="indicators"]')
], St.prototype, "indicatorsSlot");
customElements.get("ck-carousel") || customElements.define("ck-carousel", St);
var _p = Object.defineProperty, Si = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && _p(t, e, i), i;
};
const Bn = class Bn extends b {
  constructor() {
    super(...arguments), this.index = 0, this.size = 0, this.active = !1, this.scale = 1, this.handleClick = () => {
      this.dispatchEvent(
        new CustomEvent("ck-carousel-indicator-jump", {
          detail: { index: this.index },
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.hasAttribute("slot") || this.setAttribute("slot", "indicators");
  }
  render() {
    const t = this.size || 1, e = `Go to slide ${this.index + 1} of ${t}`, o = (this.active ? 48 : 40) * this.scale, a = g(
      "inline-flex items-center justify-center border-0 p-0 outline-none transition-[width] duration-200 ease-in-out cursor-pointer focus-visible:ring-4 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
    ), l = Ee({
      width: `${o}px`,
      minHeight: "24px"
    }), d = Ee({
      width: "100%",
      height: "2px",
      backgroundColor: this.active ? "var(--color-brown-975)" : "var(--color-border)",
      transition: "background-color 200ms ease-in-out"
    });
    return f`
      <button
        part="indicator"
        class=${a}
        style=${l}
        type="button"
        @click=${this.handleClick}
        aria-label=${e}
        aria-current=${this.active ? "true" : "false"}
        data-active=${this.active ? "true" : "false"}
      >
        <div style=${d}></div>
      </button>
    `;
  }
};
Bn.styles = [...b.styles];
let ce = Bn;
Si([
  u({ type: Number, reflect: !0 })
], ce.prototype, "index");
Si([
  u({ type: Number })
], ce.prototype, "size");
Si([
  u({ type: Boolean, reflect: !0 })
], ce.prototype, "active");
Si([
  u({ type: Number })
], ce.prototype, "scale");
customElements.get("ck-carousel-indicator") || customElements.define("ck-carousel-indicator", ce);
var Ep = Object.defineProperty, Pr = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ep(t, e, i), i;
};
const jn = class jn extends b {
  constructor() {
    super(...arguments), this.index = 0, this.total = 0, this.active = !1;
  }
  getSlideClasses() {
    const t = "relative block h-full w-full transition-opacity duration-500 ease-out", e = this.active ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none";
    return g(t, e);
  }
  render() {
    const t = `Slide ${this.index + 1} of ${this.total || 1}`;
    return f`
      <div
        class="${this.getSlideClasses()}"
        role="group"
        aria-roledescription="slide"
        aria-label=${t}
        aria-hidden=${this.active ? "false" : "true"}
        data-active=${this.active ? "true" : "false"}
      >
        <slot></slot>
      </div>
    `;
  }
};
jn.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
        width: 100%;
        height: 100%;
        flex: 0 0 100%;
      }

      :host([hidden]) {
        display: none;
      }

      ::slotted(img),
      ::slotted(picture),
      ::slotted(video) {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    `
];
let Te = jn;
Pr([
  u({ type: Number, reflect: !0 })
], Te.prototype, "index");
Pr([
  u({ type: Number })
], Te.prototype, "total");
Pr([
  u({ type: Boolean, reflect: !0 })
], Te.prototype, "active");
customElements.get("ck-carousel-item") || customElements.define("ck-carousel-item", Te);
var Ap = Object.defineProperty, ol = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ap(t, e, i), i;
};
const Fn = class Fn extends b {
  constructor() {
    super(...arguments), this.variant = "orange", this.size = "md", this.originalCustomClass = "", this.baseClasses = "inline-flex items-center justify-center gap-1 px-1.5 font-mono uppercase tracking-wide shadow-sm transition-colors duration-200";
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), (t.has("class") || t.has("variant") || t.has("size")) && this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = H(this.getBadgeClasses());
    this.className = g(...t);
  }
  getBadgeClasses() {
    const t = {
      orange: "bg-(--color-accent-secondary) text-foreground",
      cream: "bg-brown-200 text-foreground",
      outline: "bg-transparent border border-border text-foreground-tertiary"
    }, e = {
      sm: "text-2xs h-4.5",
      md: "text-xs h-5",
      lg: "text-sm h-6.5 px-2"
    };
    return g(
      this.baseClasses,
      t[this.variant ?? "orange"],
      e[this.size ?? "md"],
      this.originalCustomClass
    );
  }
  render() {
    return f`
      <div class="${this.getBadgeClasses()}">
        <slot></slot>
      </div>
    `;
  }
};
Fn.styles = [
  ...b.styles,
  N`
      :host {
        display: inline-flex;
      }

      :host([hidden]) {
        display: none;
      }

      :host ::slotted(*) {
        letter-spacing: var(--tracking-wide);
      }
    `
];
let ms = Fn;
ol([
  u({ type: String })
], ms.prototype, "variant");
ol([
  u({ type: String })
], ms.prototype, "size");
customElements.get("ck-badge") || customElements.define("ck-badge", ms);
var Sp = Object.defineProperty, al = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Sp(t, e, i), i;
};
class Mr extends b {
  constructor() {
    super(...arguments), this.orientation = "horizontal", this.decorative = !1, this.originalCustomClass = "", this.defaultClasses = "bg-border shrink-0";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses());
  }
  _syncHostClasses() {
    const t = this.orientation === "horizontal" ? "h-px w-full" : "h-full w-px min-h-[1em]", e = g(this.defaultClasses, t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  _classes() {
    const t = this.orientation === "horizontal" ? "h-px w-full" : "h-full w-px min-h-[1em]";
    return g(this.defaultClasses, t, this.originalCustomClass);
  }
  render() {
    const t = this.orientation === "vertical" ? this.orientation : void 0;
    return f`
      <div
        class="${this._classes()}"
        role="${this.decorative ? "none" : "separator"}"
        ?aria-orientation="${t}"
      ></div>
    `;
  }
}
al([
  u({ type: String })
], Mr.prototype, "orientation");
al([
  u({ type: Boolean })
], Mr.prototype, "decorative");
customElements.get("ck-divider") || customElements.define("ck-divider", Mr);
var $p = Object.defineProperty, Be = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && $p(t, e, i), i;
};
class be extends b {
  constructor() {
    super(...arguments), this.checked = !1, this.disabled = !1, this.required = !1, this.indeterminate = !1, this.name = "", this.value = "", this.originalCustomClass = "", this.labelObservers = /* @__PURE__ */ new Map();
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses(), this._setupLabelAssociation();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._cleanupLabelAssociation();
  }
  firstUpdated() {
    this.checkboxElement = this.querySelector('input[type="checkbox"]'), this._updateIndeterminate(), this.syncEventHandlers(), this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses(), this.currentId = this.getAttribute("id") || void 0, this._setupLabelAssociation();
  }
  _syncHostClasses() {
    const t = this.getCheckboxClasses(), e = g(t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  updated(t) {
    if (super.updated(t), this.checkboxElement || (this.checkboxElement = this.querySelector('input[type="checkbox"]')), this.syncEventHandlers(), (t.has("indeterminate") || t.has("checked")) && this._updateIndeterminate(), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses()), (t.has("checked") || t.has("indeterminate")) && this.checkboxElement && (this.checkboxElement.className = this.getCheckboxClasses()), this.checkboxElement) {
      const r = this.getAttribute("form");
      r ? this.checkboxElement.setAttribute("form", r) : this.checkboxElement.removeAttribute("form");
    }
    const e = this.getAttribute("id") || void 0;
    this.currentId !== e && (this._cleanupLabelAssociation(), this.currentId = e, this._setupLabelAssociation());
  }
  _updateIndeterminate() {
    this.checkboxElement && (this.checkboxElement.indeterminate = !!this.indeterminate);
  }
  getCheckboxClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "";
    return g(
      // Base styles
      "appearance-none relative size-5 shrink-0 outline-none border border-border bg-white shadow-xs enabled:cursor-pointer enabled:not-checked:hover:border-mix-border/8 flex items-center justify-center focus-visible:ring-4 ring-ring transition",
      // Checked state
      "checked:enabled:border-foreground-tertiary checked:enabled:bg-foreground-tertiary checked:enabled:hover:border-mix-foreground/8 checked:enabled:hover:mix-with-foreground-secondary",
      // Indeterminate state
      "indeterminate:enabled:border-foreground-tertiary indeterminate:enabled:bg-foreground-tertiary indeterminate:enabled:hover:border-mix-foreground/8 indeterminate:enabled:hover:mix-with-foreground-secondary",
      // Checked checkmark (using before pseudo-element)
      "before:absolute checked:before:content-['✓'] before:text-white checked:before:text-xs checked:before:font-bold",
      // Indeterminate dash
      "indeterminate:before:w-1.5 indeterminate:before:h-0.5 indeterminate:before:bg-white",
      // Disabled state
      "disabled:cursor-not-allowed disabled:border-foreground/5 disabled:bg-foreground/10 disabled:checked:before:text-foreground/50 disabled:indeterminate:before:bg-foreground/50",
      t
    );
  }
  render() {
    const t = this.getAttribute("form");
    return f`
      <input
        type="checkbox"
        class="${this.getCheckboxClasses()}"
        ?checked="${this.checked}"
        ?disabled="${this.disabled}"
        ?required="${this.required}"
        .name="${this.name || void 0}"
        .value="${this.value || void 0}"
        ${t ? f`form="${t}"` : ""}
        @change="${this._handleChange}"
      />
    `;
  }
  syncEventHandlers() {
    this.checkboxElement && q(this, this.checkboxElement, [
      "onChange"
    ]);
  }
  _handleChange(t) {
    const e = t.target;
    this.checked = e.checked, this.indeterminate && (this.indeterminate = !1);
    const r = this.onChange;
    typeof r == "function" && r(t), t.defaultPrevented || this.dispatchEvent(
      new CustomEvent("ck-change", {
        detail: { checked: this.checked },
        bubbles: !0,
        composed: !0
      })
    );
  }
  /**
   * Programmatically click the checkbox.
   * Useful for making parent elements clickable.
   */
  click() {
    this.checkboxElement && !this.disabled && this.checkboxElement.click();
  }
  /**
   * Set up label association so labels with for attribute can toggle this checkbox
   */
  _setupLabelAssociation() {
    const t = this.currentId || this.getAttribute("id");
    if (!t || !this.checkboxElement) return;
    this.labelClickHandler || (this.labelClickHandler = (r) => {
      !this.disabled && r.target !== this.checkboxElement && (r.preventDefault(), this.click());
    }), document.querySelectorAll(`label[for="${t}"], ck-label[for="${t}"]`).forEach((r) => {
      if (r.tagName.toLowerCase() === "ck-label") {
        const i = r.querySelector("label");
        if (i)
          i.addEventListener("click", this.labelClickHandler), i.classList.add("cursor-pointer");
        else {
          const n = new MutationObserver(() => {
            const o = r.querySelector("label");
            o && (o.addEventListener("click", this.labelClickHandler), o.classList.add("cursor-pointer"), n.disconnect(), this.labelObservers.delete(r));
          });
          n.observe(r, { childList: !0, subtree: !0 }), this.labelObservers.set(r, n);
        }
      } else
        r.addEventListener("click", this.labelClickHandler), r.classList.add("cursor-pointer");
    });
  }
  /**
   * Clean up label association listeners
   */
  _cleanupLabelAssociation() {
    const t = this.currentId || this.getAttribute("id");
    if (!t) return;
    document.querySelectorAll(`label[for="${t}"], ck-label[for="${t}"]`).forEach((r) => {
      if (r.tagName.toLowerCase() === "ck-label") {
        const i = r.querySelector("label");
        i && this.labelClickHandler && (i.removeEventListener("click", this.labelClickHandler), i.classList.remove("cursor-pointer"));
        const n = this.labelObservers.get(r);
        n && (n.disconnect(), this.labelObservers.delete(r));
      } else
        this.labelClickHandler && r.removeEventListener("click", this.labelClickHandler), r.classList.remove("cursor-pointer");
    });
  }
}
Be([
  u({ type: Boolean })
], be.prototype, "checked");
Be([
  u({ type: Boolean })
], be.prototype, "disabled");
Be([
  u({ type: Boolean })
], be.prototype, "required");
Be([
  u({ type: Boolean })
], be.prototype, "indeterminate");
Be([
  u({ type: String })
], be.prototype, "name");
Be([
  u({ type: String })
], be.prototype, "value");
customElements.get("ck-checkbox") || customElements.define("ck-checkbox", be);
const qi = {};
function Ot(s = "id") {
  return qi[s] || (qi[s] = 0), `${s}-${++qi[s]}`;
}
class Tp extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "text-foreground block text-base font-medium";
  }
  // Use light DOM instead of shadow DOM for simpler attribute handling
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this.id || (this.generatedId = Ot("ck-label")), this.labelElement = document.createElement("label"), Array.from(this.childNodes).forEach((n) => {
      this.labelElement.appendChild(n);
    });
    const e = this.getAttribute("id") || this.generatedId || "", r = this.getAttribute("for") || void 0, i = this.getAttribute("form") || void 0;
    e && (this.labelElement.id = e), r && (this.labelElement.htmlFor = r), i && this.labelElement.setAttribute("form", i), this.labelElement.className = g(this.baseClasses, this.originalCustomClass), this.appendChild(this.labelElement), this._syncHostClasses();
  }
  updated() {
    if (this.hasAttribute("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this.labelElement) {
      this.labelElement.className = g(this.baseClasses, this.originalCustomClass), this._syncHostClasses();
      const t = this.getAttribute("id") || this.generatedId || "", e = this.getAttribute("for") || void 0, r = this.getAttribute("form") || void 0;
      t ? this.labelElement.id = t : this.labelElement.removeAttribute("id"), e ? this.labelElement.htmlFor = e : this.labelElement.removeAttribute("for"), r ? this.labelElement.setAttribute("form", r) : this.labelElement.removeAttribute("form"), Array.from(this.childNodes).forEach((n) => {
        n !== this.labelElement && n.nodeType === Node.ELEMENT_NODE && this.labelElement.appendChild(n);
      });
    }
  }
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-label") || customElements.define("ck-label", Tp);
var Op = Object.defineProperty, ll = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Op(t, e, i), i;
};
class Lr extends b {
  constructor() {
    super(...arguments), this.checked = !1, this.disabled = !1, this.originalCustomClass = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.switchElement = this.querySelector('input[type="checkbox"]'), this.syncAttributes(), this.syncEventHandlers(), this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = this.getSwitchClasses(), e = g(t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers(), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses()), t.has("checked") && this.switchElement && (this.switchElement.className = this.getSwitchClasses());
  }
  syncAttributes() {
    if (this.switchElement)
      for (const t of this.attributes)
        ["checked", "disabled", "class"].includes(t.name) || this.switchElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.switchElement && q(this, this.switchElement, [
      "onChange"
    ]);
  }
  getSwitchClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "";
    return g(
      // Base styles
      "appearance-none",
      "bg-foreground/20 relative inline-flex items-center h-6 w-11 cursor-pointer rounded-xl transition",
      // Circle (using before pseudo-element)
      "before:ease-out-expo before:bg-background before:absolute before:top-0.5 before:left-0.5 before:size-5 before:rounded-xl before:transition-transform before:duration-200",
      // Disabled state
      "disabled:before:opacity-30",
      // Checked state
      "checked:bg-foreground checked:before:translate-x-full",
      // Focus state
      "focus-visible:ring-ring focus-visible:ring-4 focus-visible:outline-none",
      // Stretch animation on active
      "before:origin-left active:before:scale-x-110 active:before:rounded-[calc(var(--spacing)*2.25)] active:checked:before:origin-right",
      t
    );
  }
  render() {
    return f`
      <input
        type="checkbox"
        class="${this.getSwitchClasses()}"
        ?checked="${this.checked}"
        ?disabled="${this.disabled}"
        @change="${this._handleChange}"
      />
    `;
  }
  _handleChange(t) {
    const e = t.target;
    this.checked = e.checked;
    const r = this.onChange;
    typeof r == "function" && r(t), t.defaultPrevented || this.dispatchEvent(
      new CustomEvent("ck-change", {
        detail: { checked: this.checked },
        bubbles: !0,
        composed: !0
      })
    );
  }
}
ll([
  u({ type: Boolean })
], Lr.prototype, "checked");
ll([
  u({ type: Boolean })
], Lr.prototype, "disabled");
customElements.get("ck-switch") || customElements.define("ck-switch", Lr);
var Ip = Object.defineProperty, xt = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ip(t, e, i), i;
};
class je extends b {
  constructor() {
    super(...arguments), this.placeholder = "", this.disabled = !1, this.required = !1, this.invalid = !1, this.variant = "default", this.originalCustomClass = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.textareaElement = this.querySelector("textarea"), this.syncAttributes(), this.syncEventHandlers(), this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = this.getTextareaClasses(), e = g(t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers(), this.textareaElement && (this.invalid ? this.textareaElement.setAttribute("data-invalid", "") : this.textareaElement.removeAttribute("data-invalid")), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses()), (t.has("variant") || t.has("class")) && this.textareaElement && (this.textareaElement.className = this.getTextareaClasses());
  }
  syncAttributes() {
    if (this.textareaElement)
      for (const t of this.attributes)
        ["placeholder", "disabled", "required", "class", "invalid", "variant"].includes(t.name) || this.textareaElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.textareaElement && q(this, this.textareaElement);
  }
  getTextareaClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "";
    return g(
      // Base styles
      "transition w-full border px-4 py-2 text-base font-mono",
      "focus:outline-none focus-visible:border-foreground focus-visible:ring-4 focus-visible:ring-ring focus-visible:text-foreground",
      "disabled:cursor-not-allowed disabled:opacity-50 text-foreground/80 placeholder:text-foreground/55",
      // Textarea specific styles
      "h-auto resize-none leading-snug",
      // Invalid state
      "data-invalid:border-red-500 data-invalid:hover:border-red-600 data-invalid:focus-visible:border-red-500 data-invalid:focus-visible:ring-red-500/20",
      // Variant styles
      {
        default: "border-border bg-background hover:border-mix-border/8 shadow-xs",
        minimal: "border-transparent bg-transparent hover:bg-background-secondary focus-visible:bg-background"
      }[this.variant],
      t
    );
  }
  render() {
    return f`
      <textarea
        placeholder="${this.placeholder}"
        ?disabled="${this.disabled}"
        ?required="${this.required}"
        aria-invalid="${this.invalid}"
        class="${this.getTextareaClasses()}"
      ></textarea>
    `;
  }
}
xt([
  u({ type: String })
], je.prototype, "placeholder");
xt([
  u({ type: Boolean })
], je.prototype, "disabled");
xt([
  u({ type: Boolean })
], je.prototype, "required");
xt([
  u({ type: Boolean })
], je.prototype, "invalid");
xt([
  u({ type: String })
], je.prototype, "variant");
customElements.get("ck-textarea") || customElements.define("ck-textarea", je);
class ve extends b {
  constructor() {
    super(...arguments), this.placeholder = "", this.disabled = !1, this.required = !1, this.invalid = !1, this.variant = "default", this.value = "", this.internalValue = "";
  }
  createRenderRoot() {
    return this;
  }
  firstUpdated() {
    this.textareaElement = this.querySelector("textarea"), this.textareaElement && (this.internalValue = this.value || this.textareaElement.value || "", this.syncAttributes(), this.syncEventHandlers(), this.adjustHeight(), this.textareaElement.addEventListener("input", this.handleInput.bind(this)));
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers(), this.textareaElement && (this.invalid ? this.textareaElement.setAttribute("data-invalid", "") : this.textareaElement.removeAttribute("data-invalid"), t.has("value") && (this.internalValue = this.value || "", this.textareaElement.value !== this.internalValue && (this.textareaElement.value = this.internalValue), this.adjustHeight()));
  }
  handleInput(t) {
    const e = t.target;
    this.internalValue = e.value, this.value = e.value, this.adjustHeight(), this.dispatchEvent(
      new CustomEvent("input", {
        detail: { value: e.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  adjustHeight() {
    this.textareaElement && requestAnimationFrame(() => {
      this.textareaElement && (this.textareaElement.style.height = "auto", this.textareaElement.style.height = `${this.textareaElement.scrollHeight}px`);
    });
  }
  syncAttributes() {
    if (this.textareaElement)
      for (const t of this.attributes)
        ["placeholder", "disabled", "required", "class", "invalid", "variant", "value"].includes(
          t.name
        ) || this.textareaElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.textareaElement && q(this, this.textareaElement, [
      "onInput"
    ]);
  }
  getTextareaClasses() {
    const t = this.getAttribute("class") || "";
    return g(
      // Base styles
      "transition w-full border px-4 py-2 text-base font-mono",
      "focus:outline-none focus-visible:border-foreground focus-visible:ring-4 focus-visible:ring-ring focus-visible:text-foreground",
      "disabled:cursor-not-allowed disabled:opacity-50 text-foreground/80 placeholder:text-foreground/55",
      // Textarea specific styles
      "h-auto resize-none leading-snug",
      // Invalid state
      "data-invalid:border-red-500 data-invalid:hover:border-red-600 data-invalid:focus-visible:border-red-500 data-invalid:focus-visible:ring-red-500/20",
      // Variant styles
      {
        default: "border-border bg-background hover:border-mix-border/8 shadow-xs",
        minimal: "border-transparent bg-transparent hover:bg-background-secondary focus-visible:bg-background"
      }[this.variant],
      t
    );
  }
  render() {
    return f`
      <textarea
        placeholder="${this.placeholder}"
        ?disabled="${this.disabled}"
        ?required="${this.required}"
        aria-invalid="${this.invalid}"
        .value="${this.internalValue || this.value}"
        class="${this.getTextareaClasses()}"
      ></textarea>
    `;
  }
}
xt([
  u({ type: String })
], ve.prototype, "placeholder");
xt([
  u({ type: Boolean })
], ve.prototype, "disabled");
xt([
  u({ type: Boolean })
], ve.prototype, "required");
xt([
  u({ type: Boolean })
], ve.prototype, "invalid");
xt([
  u({ type: String })
], ve.prototype, "variant");
xt([
  u({ type: String })
], ve.prototype, "value");
customElements.get("ck-textarea-resize") || customElements.define("ck-textarea-resize", ve);
var Vp = Object.defineProperty, zs = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Vp(t, e, i), i;
};
class Fe extends b {
  constructor() {
    super(...arguments), this.disabled = !1, this.required = !1, this.invalid = !1, this.variant = "default", this.size = "md", this.originalCustomClass = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = this.getSelectClasses(), e = g(t, this.originalCustomClass), r = H(e);
    this.className = g(...r);
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this.selectElement = document.createElement("select"), Array.from(this.querySelectorAll("option")).forEach((e) => {
      this.selectElement.appendChild(e);
    }), this.selectElement.disabled = this.disabled, this.selectElement.required = this.required, this.selectElement.setAttribute("aria-invalid", String(this.invalid)), this.selectElement.className = this.getSelectClasses(), this.selectElement.addEventListener("change", (e) => {
      this.hasAttribute("form") && e.preventDefault();
    }), this.appendChild(this.selectElement), this.syncAttributes(), this.syncEventHandlers(), this.applyChevronIcon(), this._syncHostClasses();
  }
  syncAttributes() {
    if (this.selectElement) {
      for (const t of this.attributes)
        ["disabled", "required", "class", "invalid", "variant", "size", "form"].includes(t.name) || this.selectElement.setAttribute(t.name, t.value);
      this.hasAttribute("form") ? this.selectElement.setAttribute("form", this.getAttribute("form") || "") : this.selectElement.removeAttribute("form");
    }
  }
  syncEventHandlers() {
    this.selectElement && q(this, this.selectElement);
  }
  getSelectClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "", e = {
      default: "border-border bg-background hover:border-mix-border/8 shadow-xs",
      minimal: "border-transparent bg-transparent hover:bg-background-secondary focus-visible:bg-background"
    };
    return g(
      // Base styles (same as input)
      "transition w-full border px-4 py-1 text-base font-medium",
      "focus:outline-none focus-visible:border-foreground focus-visible:ring-4 focus-visible:ring-ring focus-visible:text-foreground",
      "disabled:cursor-not-allowed disabled:opacity-50 text-foreground/80",
      // Invalid state
      "data-[invalid]:border-red-500 data-[invalid]:hover:border-red-600 data-[invalid]:focus-visible:border-red-500 data-[invalid]:focus-visible:ring-red-500/20",
      // Dynamic padding based on prefix/suffix
      "pl-[var(--prefix-width,calc(var(--spacing)*4))]",
      "pr-[var(--suffix-width,calc(var(--spacing)*4))]",
      // Select-specific styles (chevron icon will be applied via inline style)
      "appearance-none bg-no-repeat pr-10",
      // Size styles
      {
        xs: "h-8",
        sm: "h-10",
        md: "h-14"
      }[this.size],
      // Variant styles
      e[this.variant],
      t
    );
  }
  applyChevronIcon() {
    if (!this.selectElement) return;
    const t = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSJibGFjayIgZD0iTTMuNyA1LjNsNC4zIDQuMyA0LjMtNC4zLjcuNy01IDUtNS01eiIvPjwvc3ZnPg==";
    this.selectElement.style.backgroundImage = `url("${t}")`, this.selectElement.style.backgroundSize = "1em", this.selectElement.style.backgroundPosition = "right calc(var(--spacing) * 2) center";
  }
  updated(t) {
    if (super.updated(t), !this.selectElement) {
      this.firstUpdated();
      return;
    }
    Array.from(this.querySelectorAll(":scope > option")).forEach((r) => {
      r.parentElement === this && this.selectElement.appendChild(r);
    }), t.has("disabled") && (this.selectElement.disabled = this.disabled), t.has("required") && (this.selectElement.required = this.required), t.has("invalid") && (this.selectElement.setAttribute("aria-invalid", String(this.invalid)), this.invalid ? this.selectElement.setAttribute("data-invalid", "") : this.selectElement.removeAttribute("data-invalid")), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses()), (t.has("variant") || t.has("size") || t.has("class")) && (this.selectElement.className = this.getSelectClasses()), this.syncAttributes(), this.syncEventHandlers(), this.applyChevronIcon();
  }
  render() {
    return f`<slot></slot>`;
  }
}
zs([
  u({ type: Boolean })
], Fe.prototype, "disabled");
zs([
  u({ type: Boolean })
], Fe.prototype, "required");
zs([
  u({ type: Boolean })
], Fe.prototype, "invalid");
zs([
  u({ type: String })
], Fe.prototype, "variant");
zs([
  u({ type: String })
], Fe.prototype, "size");
customElements.get("ck-select") || customElements.define("ck-select", Fe);
var Pp = Object.defineProperty, cl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Pp(t, e, i), i;
};
class Rr extends b {
  constructor() {
    super(...arguments), this.prefixWidth = 0, this.suffixWidth = 0, this.originalCustomClass = "", this.baseClasses = "relative", this._provider = new ft(this, {
      context: Ne,
      initialValue: {
        prefixWidth: 0,
        suffixWidth: 0,
        setPrefixWidth: () => {
        },
        setSuffixWidth: () => {
        }
      }
    });
  }
  createRenderRoot() {
    return this;
  }
  _updateContext() {
    this._provider.setValue({
      prefixWidth: this.prefixWidth,
      suffixWidth: this.suffixWidth,
      setPrefixWidth: (t) => {
        this.prefixWidth = t, this._updateContext();
      },
      setSuffixWidth: (t) => {
        this.suffixWidth = t, this._updateContext();
      }
    });
  }
  getStyles() {
    const t = [];
    return this.prefixWidth > 0 && t.push(`--prefix-width: calc(${this.prefixWidth}px + var(--spacing) * 5.5)`), this.suffixWidth > 0 && t.push(`--suffix-width: calc(${this.suffixWidth}px + var(--spacing) * 5.5)`), t.join("; ");
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._updateContext(), this._applyStyles(), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._updateContext(), this._applyStyles(), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _applyStyles() {
    const t = this.getStyles();
    t ? this.setAttribute("style", t) : this.removeAttribute("style");
  }
  render() {
    return f`<slot></slot>`;
  }
}
cl([
  R()
], Rr.prototype, "prefixWidth");
cl([
  R()
], Rr.prototype, "suffixWidth");
customElements.get("ck-select-group") || customElements.define("ck-select-group", Rr);
var Mp = Object.defineProperty, dl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Mp(t, e, i), i;
};
class Hr extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.addonElement = null, this.resizeObserver = null;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.updateComplete.then(() => {
      this._setupWidthTracking();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  _setupWidthTracking() {
    const t = this.asChild ? this.firstElementChild : this;
    if (!t || t === this.addonElement) return;
    this.resizeObserver && this.resizeObserver.disconnect(), this.addonElement = t;
    const e = t.offsetWidth;
    e > 0 && this.contextValue?.setPrefixWidth && this.contextValue.setPrefixWidth(Math.round(e)), this.resizeObserver = new ResizeObserver((r) => {
      const i = r[0];
      i?.contentRect.width && this.contextValue?.setPrefixWidth && this.contextValue.setPrefixWidth(Math.round(i.contentRect.width));
    }), this.resizeObserver.observe(t);
  }
  updated(t) {
    super.updated(t), this.updateComplete.then(() => {
      if (this._setupWidthTracking(), this.asChild) {
        const e = this.firstElementChild;
        if (e) {
          const r = this.getAttribute("class") || "", i = g(
            "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
            "text-foreground pointer-events-none left-4",
            r
          );
          Zt(this.asChild, e, {
            className: i,
            "data-input-addon": !0
          });
        }
      } else {
        const e = this.getAttribute("class") || "", r = g(
          "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
          "text-foreground pointer-events-none left-4",
          e
        );
        this.className = r, this.setAttribute("data-input-addon", "");
      }
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
dl([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Hr.prototype, "asChild");
dl([
  L({ context: Ne })
], Hr.prototype, "contextValue");
customElements.get("ck-select-prefix") || customElements.define("ck-select-prefix", Hr);
var Lp = Object.defineProperty, hl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Lp(t, e, i), i;
};
class Dr extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.addonElement = null, this.resizeObserver = null;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.updateComplete.then(() => {
      this._setupWidthTracking();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  _setupWidthTracking() {
    const t = this.asChild ? this.firstElementChild : this;
    if (!t || t === this.addonElement) return;
    this.resizeObserver && this.resizeObserver.disconnect(), this.addonElement = t;
    const e = t.offsetWidth;
    e > 0 && this.contextValue?.setSuffixWidth && this.contextValue.setSuffixWidth(Math.round(e)), this.resizeObserver = new ResizeObserver((r) => {
      const i = r[0];
      i?.contentRect.width && this.contextValue?.setSuffixWidth && this.contextValue.setSuffixWidth(Math.round(i.contentRect.width));
    }), this.resizeObserver.observe(t);
  }
  updated(t) {
    super.updated(t), this.updateComplete.then(() => {
      if (this._setupWidthTracking(), this.asChild) {
        const e = this.firstElementChild;
        if (e) {
          const r = this.getAttribute("class") || "", i = g(
            "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
            "text-foreground pointer-events-none right-4",
            r
          );
          Zt(this.asChild, e, {
            className: i,
            "data-input-addon": !0
          });
        }
      } else {
        const e = this.getAttribute("class") || "", r = g(
          "absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-base font-medium",
          "text-foreground pointer-events-none right-4",
          e
        );
        this.className = r, this.setAttribute("data-input-addon", "");
      }
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
hl([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Dr.prototype, "asChild");
hl([
  L({ context: Ne })
], Dr.prototype, "contextValue");
customElements.get("ck-select-suffix") || customElements.define("ck-select-suffix", Dr);
const We = "modal-context";
var Rp = Object.defineProperty, Ns = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Rp(t, e, i), i;
};
class Ue extends rt {
  constructor() {
    super(), this.internalOpen = !1, this.isControlled = !1, this._provider = new ft(this, {
      context: We,
      initialValue: {
        open: !1,
        setOpen: () => {
        },
        labelId: void 0,
        descriptionId: void 0,
        setLabelId: () => {
        },
        setDescriptionId: () => {
        }
      }
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.isControlled = this.open !== void 0, this.isControlled && (this.internalOpen = this.open ?? !1), this._updateContext();
  }
  updated(t) {
    t.has("open") && (this.isControlled ? this.internalOpen = this.open ?? !1 : this.open !== void 0 && (this.internalOpen = this.open)), this._updateContext();
  }
  _updateContext() {
    this._provider.setValue({
      open: this.internalOpen,
      setOpen: (t) => {
        this.isControlled ? this.onOpenChange?.(t) : (this.internalOpen = t, this.onOpenChange?.(t));
      },
      labelId: this.labelId,
      descriptionId: this.descriptionId,
      setLabelId: (t) => this.labelId = t,
      setDescriptionId: (t) => this.descriptionId = t
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
Ns([
  u({ type: Boolean })
], Ue.prototype, "open");
Ns([
  R()
], Ue.prototype, "internalOpen");
Ns([
  R()
], Ue.prototype, "labelId");
Ns([
  R()
], Ue.prototype, "descriptionId");
Ns([
  R()
], Ue.prototype, "isControlled");
customElements.get("ck-modal") || customElements.define("ck-modal", Ue);
var Hp = Object.defineProperty, ul = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Hp(t, e, i), i;
};
const Dp = /* @__PURE__ */ new Set(["class", "as-child"]), Wn = class Wn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), t.defaultPrevented || (this.dispatchEvent(new Event("ck-modal-close-click", { bubbles: !0, composed: !0 })), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateClickHandler();
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    super.updated?.(t), t.has("asChild") && this._updateClickHandler(), this.asChild || (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick);
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this.asChild && this.addEventListener("click", this._handleClick);
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes)
        Dp.has(t.name) || this.buttonElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
Wn.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let bs = Wn;
ul([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], bs.prototype, "asChild");
ul([
  L({ context: We, subscribe: !1 })
], bs.prototype, "contextValue");
customElements.get("ck-modal-close") || customElements.define("ck-modal-close", bs);
var zp = Object.defineProperty, zr = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && zp(t, e, i), i;
};
const Un = class Un extends b {
  constructor() {
    super(...arguments), this.inert = !1, this.catchFocus = !0, this.originalCustomClass = "", this.defaultClasses = "m-auto min-w-xs border-border shadow-lg space-y-6 p-4", this.scrollLocked = !1, this.previousBodyOverflow = "", this.previousBodyPaddingRight = "";
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.dialogEl = this.shadowRoot?.querySelector("dialog"), this.dialogEl && (this.dialogEl.open || (this.dialogEl.close(), this.dialogEl.removeAttribute("data-status")), this._updateDialogClasses(), this._updateDialogState(), this._setupEventListeners());
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses(), this.dialogEl && this._updateDialogClasses()), this.dialogEl && this.contextValue && this._updateDialogState(), t.has("inert") && this.dialogEl && (this.inert ? this.dialogEl.setAttribute("inert", "") : this.dialogEl.removeAttribute("inert"));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.abortController && (this.abortController.abort(), this.abortController = void 0), this._unlockBodyScroll();
  }
  _syncHostClasses() {
    const t = g(this.defaultClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _getDialogClasses() {
    return g(this.defaultClasses, this.originalCustomClass);
  }
  _updateDialogClasses() {
    if (!this.dialogEl) return;
    const t = this._getDialogClasses();
    this.dialogEl.className = t;
  }
  _updateDialogState() {
    if (!this.dialogEl || !this.contextValue) return;
    const { open: t } = this.contextValue;
    t && !this.dialogEl.open ? (this.dialogEl.showModal(), requestAnimationFrame(() => {
      this.dialogEl && this.dialogEl.setAttribute("data-status", "open");
    }), this._lockBodyScroll()) : !t && this.dialogEl.open ? (this.dialogEl.removeAttribute("data-status"), setTimeout(() => {
      this.dialogEl && !this.contextValue?.open && this.dialogEl.close(), this._unlockBodyScroll();
    }, 300)) : t && this.dialogEl.open && !this.dialogEl.hasAttribute("data-status") ? (this.dialogEl.setAttribute("data-status", "open"), this._lockBodyScroll()) : !t && !this.dialogEl.open && this.dialogEl.hasAttribute("data-status") && (this.dialogEl.removeAttribute("data-status"), this._unlockBodyScroll());
  }
  _lockBodyScroll() {
    if (this.scrollLocked || typeof document > "u") return;
    const t = document.body, e = document.documentElement;
    this.previousBodyOverflow = t.style.overflow || "", this.previousBodyPaddingRight = t.style.paddingRight || "";
    const r = window.innerWidth - e.clientWidth;
    t.style.overflow = "hidden", t.style.paddingRight = r > 0 ? `${r}px` : "", e.style.overflow = "hidden", this.scrollLocked = !0;
  }
  _unlockBodyScroll() {
    if (!this.scrollLocked || typeof document > "u") return;
    const t = document.body, e = document.documentElement;
    t.style.overflow = this.previousBodyOverflow, t.style.paddingRight = this.previousBodyPaddingRight, e.style.overflow = "", this.scrollLocked = !1, this.previousBodyOverflow = "", this.previousBodyPaddingRight = "";
  }
  _setupEventListeners() {
    if (!this.dialogEl || !this.contextValue) return;
    this.abortController && this.abortController.abort(), this.abortController = new AbortController();
    const { signal: t } = this.abortController;
    this.dialogEl.addEventListener(
      "cancel",
      (e) => {
        e.preventDefault(), !this.inert && this.contextValue?.setOpen && this.contextValue.setOpen(!1);
      },
      { signal: t }
    ), this.dialogEl.addEventListener(
      "keydown",
      (e) => {
        e.key === "Escape" && this.contextValue?.open && !this.inert && (e.preventDefault(), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
      },
      { signal: t }
    ), window.addEventListener(
      "keydown",
      (e) => {
        e.key === "Escape" && this.dialogEl?.inert && this.contextValue?.open && (e.preventDefault(), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
      },
      { signal: t }
    ), this.dialogEl.addEventListener(
      "click",
      (e) => {
        !this.inert && this.contextValue?.setOpen && e.target === this.dialogEl && (e.stopPropagation(), this.contextValue.setOpen(!1));
      },
      { signal: t }
    );
  }
  render() {
    const { labelId: t, descriptionId: e } = this.contextValue || {}, r = this._getDialogClasses();
    return f`
      <dialog
        aria-labelledby=${t || ""}
        aria-describedby=${e || ""}
        ?inert=${this.inert}
        class="${r}"
      >
        ${this.catchFocus ? f` <div class="sr-only" autofocus tabindex="-1" data-modal-focus-catcher=""></div> ` : ""}
        <slot></slot>
      </dialog>
    `;
  }
};
Un.styles = [
  ...b.styles,
  N`
      :host {
        display: contents;
      }

      /* Override browser default max-height for dialog elements */
      /* Chrome applies dialog:-internal-dialog-in-top-layer with max-height calc(100% - 2em - 6px) */
      /* This internal pseudo-class has higher specificity, so we use attribute + class selector with !important */
      /* Match both max-h-none and max-h-none! (Tailwind's !important modifier) */
      dialog[open][class*='max-h-none'] {
        max-height: none !important;
      }
    `
];
let Oe = Un;
zr([
  u({ type: Boolean })
], Oe.prototype, "inert");
zr([
  u({ type: Boolean, attribute: "catch-focus" })
], Oe.prototype, "catchFocus");
zr([
  L({ context: We, subscribe: !0 })
], Oe.prototype, "contextValue");
customElements.get("ck-modal-content") || customElements.define("ck-modal-content", Oe);
var Np = Object.defineProperty, pl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Np(t, e, i), i;
};
class Nr extends rt {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.baseClasses = "block";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
    const t = Ot("ck-modal-desc");
    this.id = t, this.contextValue.setDescriptionId(t), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.contextValue.setDescriptionId(void 0);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.baseClasses, this.originalCustomClass);
    return f`<p id=${this.id} class=${t}><slot></slot></p>`;
  }
}
pl([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Nr.prototype, "asChild");
pl([
  L({ context: We, subscribe: !1 })
], Nr.prototype, "contextValue");
customElements.get("ck-modal-description") || customElements.define("ck-modal-description", Nr);
var Bp = Object.defineProperty, fl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Bp(t, e, i), i;
};
class Br extends rt {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.baseClasses = "block text-lg mt-0 font-semibold";
  }
  // Use light DOM instead of shadow DOM so Tailwind classes work
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
    const t = Ot("ck-modal-title");
    this.id = t, this.contextValue.setLabelId(t), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.contextValue.setLabelId(void 0);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.baseClasses, this.originalCustomClass);
    return f`<h2 id=${this.id} class=${t}><slot></slot></h2>`;
  }
}
fl([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Br.prototype, "asChild");
fl([
  L({ context: We, subscribe: !1 })
], Br.prototype, "contextValue");
customElements.get("ck-modal-title") || customElements.define("ck-modal-title", Br);
var jp = Object.defineProperty, gl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && jp(t, e, i), i;
};
const Fp = /* @__PURE__ */ new Set(["class", "as-child"]), qn = class qn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), !t.defaultPrevented && this.contextValue?.setOpen && this.contextValue.setOpen(!0);
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateClickHandler();
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    super.updated?.(t), t.has("asChild") && this._updateClickHandler(), this.asChild || (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick);
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this.asChild && this.addEventListener("click", this._handleClick);
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes)
        Fp.has(t.name) || this.buttonElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
qn.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let vs = qn;
gl([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], vs.prototype, "asChild");
gl([
  L({ context: We })
], vs.prototype, "contextValue");
customElements.get("ck-modal-trigger") || customElements.define("ck-modal-trigger", vs);
const $i = "popover-context", Wp = ["top", "right", "bottom", "left"], Ie = Math.min, at = Math.max, gi = Math.round, ri = Math.floor, _t = (s) => ({
  x: s,
  y: s
}), Up = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, qp = {
  start: "end",
  end: "start"
};
function Mo(s, t, e) {
  return at(s, Ie(t, e));
}
function qe(s, t) {
  return typeof s == "function" ? s(t) : s;
}
function Ut(s) {
  return s.split("-")[0];
}
function Bs(s) {
  return s.split("-")[1];
}
function ml(s) {
  return s === "x" ? "y" : "x";
}
function bl(s) {
  return s === "y" ? "height" : "width";
}
const Kp = /* @__PURE__ */ new Set(["top", "bottom"]);
function Pt(s) {
  return Kp.has(Ut(s)) ? "y" : "x";
}
function vl(s) {
  return ml(Pt(s));
}
function Zp(s, t, e) {
  e === void 0 && (e = !1);
  const r = Bs(s), i = vl(s), n = bl(i);
  let o = i === "x" ? r === (e ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[n] > t.floating[n] && (o = mi(o)), [o, mi(o)];
}
function Gp(s) {
  const t = mi(s);
  return [rr(s), t, rr(t)];
}
function rr(s) {
  return s.replace(/start|end/g, (t) => qp[t]);
}
const Lo = ["left", "right"], Ro = ["right", "left"], Yp = ["top", "bottom"], Xp = ["bottom", "top"];
function Jp(s, t, e) {
  switch (s) {
    case "top":
    case "bottom":
      return e ? t ? Ro : Lo : t ? Lo : Ro;
    case "left":
    case "right":
      return t ? Yp : Xp;
    default:
      return [];
  }
}
function Qp(s, t, e, r) {
  const i = Bs(s);
  let n = Jp(Ut(s), e === "start", r);
  return i && (n = n.map((o) => o + "-" + i), t && (n = n.concat(n.map(rr)))), n;
}
function mi(s) {
  return s.replace(/left|right|bottom|top/g, (t) => Up[t]);
}
function tf(s) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...s
  };
}
function ef(s) {
  return typeof s != "number" ? tf(s) : {
    top: s,
    right: s,
    bottom: s,
    left: s
  };
}
function bi(s) {
  const {
    x: t,
    y: e,
    width: r,
    height: i
  } = s;
  return {
    width: r,
    height: i,
    top: e,
    left: t,
    right: t + r,
    bottom: e + i,
    x: t,
    y: e
  };
}
function Ho(s, t, e) {
  let {
    reference: r,
    floating: i
  } = s;
  const n = Pt(t), o = vl(t), a = bl(o), l = Ut(t), d = n === "y", c = r.x + r.width / 2 - i.width / 2, h = r.y + r.height / 2 - i.height / 2, p = r[a] / 2 - i[a] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: c,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: h
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Bs(t)) {
    case "start":
      m[o] -= p * (e && d ? -1 : 1);
      break;
    case "end":
      m[o] += p * (e && d ? -1 : 1);
      break;
  }
  return m;
}
const sf = async (s, t, e) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: n = [],
    platform: o
  } = e, a = n.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let d = await o.getElementRects({
    reference: s,
    floating: t,
    strategy: i
  }), {
    x: c,
    y: h
  } = Ho(d, r, l), p = r, m = {}, v = 0;
  for (let w = 0; w < a.length; w++) {
    const {
      name: x,
      fn: C
    } = a[w], {
      x: $,
      y: S,
      data: T,
      reset: k
    } = await C({
      x: c,
      y: h,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: m,
      rects: d,
      platform: o,
      elements: {
        reference: s,
        floating: t
      }
    });
    c = $ ?? c, h = S ?? h, m = {
      ...m,
      [x]: {
        ...m[x],
        ...T
      }
    }, k && v <= 50 && (v++, typeof k == "object" && (k.placement && (p = k.placement), k.rects && (d = k.rects === !0 ? await o.getElementRects({
      reference: s,
      floating: t,
      strategy: i
    }) : k.rects), {
      x: c,
      y: h
    } = Ho(d, p, l)), w = -1);
  }
  return {
    x: c,
    y: h,
    placement: p,
    strategy: i,
    middlewareData: m
  };
};
async function ys(s, t) {
  var e;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: n,
    rects: o,
    elements: a,
    strategy: l
  } = s, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: h = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = qe(t, s), v = ef(m), x = a[p ? h === "floating" ? "reference" : "floating" : h], C = bi(await n.getClippingRect({
    element: (e = await (n.isElement == null ? void 0 : n.isElement(x))) == null || e ? x : x.contextElement || await (n.getDocumentElement == null ? void 0 : n.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), $ = h === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, S = await (n.getOffsetParent == null ? void 0 : n.getOffsetParent(a.floating)), T = await (n.isElement == null ? void 0 : n.isElement(S)) ? await (n.getScale == null ? void 0 : n.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = bi(n.convertOffsetParentRelativeRectToViewportRelativeRect ? await n.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: $,
    offsetParent: S,
    strategy: l
  }) : $);
  return {
    top: (C.top - k.top + v.top) / T.y,
    bottom: (k.bottom - C.bottom + v.bottom) / T.y,
    left: (C.left - k.left + v.left) / T.x,
    right: (k.right - C.right + v.right) / T.x
  };
}
const rf = function(s) {
  return s === void 0 && (s = {}), {
    name: "flip",
    options: s,
    async fn(t) {
      var e, r;
      const {
        placement: i,
        middlewareData: n,
        rects: o,
        initialPlacement: a,
        platform: l,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: h = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: w = !0,
        ...x
      } = qe(s, t);
      if ((e = n.arrow) != null && e.alignmentOffset)
        return {};
      const C = Ut(i), $ = Pt(a), S = Ut(a) === a, T = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), k = p || (S || !w ? [mi(a)] : Gp(a)), O = v !== "none";
      !p && O && k.push(...Qp(a, w, v, T));
      const P = [a, ...k], y = await ys(t, x), V = [];
      let D = ((r = n.flip) == null ? void 0 : r.overflows) || [];
      if (c && V.push(y[C]), h) {
        const ht = Zp(i, o, T);
        V.push(y[ht[0]], y[ht[1]]);
      }
      if (D = [...D, {
        placement: i,
        overflows: V
      }], !V.every((ht) => ht <= 0)) {
        var K, et;
        const ht = (((K = n.flip) == null ? void 0 : K.index) || 0) + 1, gt = P[ht];
        if (gt && (!(h === "alignment" ? $ !== Pt(gt) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((_) => Pt(_.placement) === $ ? _.overflows[0] > 0 : !0)))
          return {
            data: {
              index: ht,
              overflows: D
            },
            reset: {
              placement: gt
            }
          };
        let Y = (et = D.filter((z) => z.overflows[0] <= 0).sort((z, _) => z.overflows[1] - _.overflows[1])[0]) == null ? void 0 : et.placement;
        if (!Y)
          switch (m) {
            case "bestFit": {
              var ot;
              const z = (ot = D.filter((_) => {
                if (O) {
                  const st = Pt(_.placement);
                  return st === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  st === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((st) => st > 0).reduce((st, Jt) => st + Jt, 0)]).sort((_, st) => _[1] - st[1])[0]) == null ? void 0 : ot[0];
              z && (Y = z);
              break;
            }
            case "initialPlacement":
              Y = a;
              break;
          }
        if (i !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
function Do(s, t) {
  return {
    top: s.top - t.height,
    right: s.right - t.width,
    bottom: s.bottom - t.height,
    left: s.left - t.width
  };
}
function zo(s) {
  return Wp.some((t) => s[t] >= 0);
}
const nf = function(s) {
  return s === void 0 && (s = {}), {
    name: "hide",
    options: s,
    async fn(t) {
      const {
        rects: e
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = qe(s, t);
      switch (r) {
        case "referenceHidden": {
          const n = await ys(t, {
            ...i,
            elementContext: "reference"
          }), o = Do(n, e.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: zo(o)
            }
          };
        }
        case "escaped": {
          const n = await ys(t, {
            ...i,
            altBoundary: !0
          }), o = Do(n, e.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: zo(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, of = /* @__PURE__ */ new Set(["left", "top"]);
async function af(s, t) {
  const {
    placement: e,
    platform: r,
    elements: i
  } = s, n = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Ut(e), a = Bs(e), l = Pt(e) === "y", d = of.has(o) ? -1 : 1, c = n && l ? -1 : 1, h = qe(t, s);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: v
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return a && typeof v == "number" && (m = a === "end" ? v * -1 : v), l ? {
    x: m * c,
    y: p * d
  } : {
    x: p * d,
    y: m * c
  };
}
const lf = function(s) {
  return s === void 0 && (s = 0), {
    name: "offset",
    options: s,
    async fn(t) {
      var e, r;
      const {
        x: i,
        y: n,
        placement: o,
        middlewareData: a
      } = t, l = await af(t, s);
      return o === ((e = a.offset) == null ? void 0 : e.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: n + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, cf = function(s) {
  return s === void 0 && (s = {}), {
    name: "shift",
    options: s,
    async fn(t) {
      const {
        x: e,
        y: r,
        placement: i
      } = t, {
        mainAxis: n = !0,
        crossAxis: o = !1,
        limiter: a = {
          fn: (x) => {
            let {
              x: C,
              y: $
            } = x;
            return {
              x: C,
              y: $
            };
          }
        },
        ...l
      } = qe(s, t), d = {
        x: e,
        y: r
      }, c = await ys(t, l), h = Pt(Ut(i)), p = ml(h);
      let m = d[p], v = d[h];
      if (n) {
        const x = p === "y" ? "top" : "left", C = p === "y" ? "bottom" : "right", $ = m + c[x], S = m - c[C];
        m = Mo($, m, S);
      }
      if (o) {
        const x = h === "y" ? "top" : "left", C = h === "y" ? "bottom" : "right", $ = v + c[x], S = v - c[C];
        v = Mo($, v, S);
      }
      const w = a.fn({
        ...t,
        [p]: m,
        [h]: v
      });
      return {
        ...w,
        data: {
          x: w.x - e,
          y: w.y - r,
          enabled: {
            [p]: n,
            [h]: o
          }
        }
      };
    }
  };
}, df = function(s) {
  return s === void 0 && (s = {}), {
    name: "size",
    options: s,
    async fn(t) {
      var e, r;
      const {
        placement: i,
        rects: n,
        platform: o,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...d
      } = qe(s, t), c = await ys(t, d), h = Ut(i), p = Bs(i), m = Pt(i) === "y", {
        width: v,
        height: w
      } = n.floating;
      let x, C;
      h === "top" || h === "bottom" ? (x = h, C = p === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (C = h, x = p === "end" ? "top" : "bottom");
      const $ = w - c.top - c.bottom, S = v - c.left - c.right, T = Ie(w - c[x], $), k = Ie(v - c[C], S), O = !t.middlewareData.shift;
      let P = T, y = k;
      if ((e = t.middlewareData.shift) != null && e.enabled.x && (y = S), (r = t.middlewareData.shift) != null && r.enabled.y && (P = $), O && !p) {
        const D = at(c.left, 0), K = at(c.right, 0), et = at(c.top, 0), ot = at(c.bottom, 0);
        m ? y = v - 2 * (D !== 0 || K !== 0 ? D + K : at(c.left, c.right)) : P = w - 2 * (et !== 0 || ot !== 0 ? et + ot : at(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: y,
        availableHeight: P
      });
      const V = await o.getDimensions(a.floating);
      return v !== V.width || w !== V.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ti() {
  return typeof window < "u";
}
function Ke(s) {
  return yl(s) ? (s.nodeName || "").toLowerCase() : "#document";
}
function lt(s) {
  var t;
  return (s == null || (t = s.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function It(s) {
  var t;
  return (t = (yl(s) ? s.ownerDocument : s.document) || window.document) == null ? void 0 : t.documentElement;
}
function yl(s) {
  return Ti() ? s instanceof Node || s instanceof lt(s).Node : !1;
}
function vt(s) {
  return Ti() ? s instanceof Element || s instanceof lt(s).Element : !1;
}
function $t(s) {
  return Ti() ? s instanceof HTMLElement || s instanceof lt(s).HTMLElement : !1;
}
function No(s) {
  return !Ti() || typeof ShadowRoot > "u" ? !1 : s instanceof ShadowRoot || s instanceof lt(s).ShadowRoot;
}
const hf = /* @__PURE__ */ new Set(["inline", "contents"]);
function js(s) {
  const {
    overflow: t,
    overflowX: e,
    overflowY: r,
    display: i
  } = yt(s);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + e) && !hf.has(i);
}
const uf = /* @__PURE__ */ new Set(["table", "td", "th"]);
function pf(s) {
  return uf.has(Ke(s));
}
const ff = [":popover-open", ":modal"];
function Oi(s) {
  return ff.some((t) => {
    try {
      return s.matches(t);
    } catch {
      return !1;
    }
  });
}
const gf = ["transform", "translate", "scale", "rotate", "perspective"], mf = ["transform", "translate", "scale", "rotate", "perspective", "filter"], bf = ["paint", "layout", "strict", "content"];
function jr(s) {
  const t = Fr(), e = vt(s) ? yt(s) : s;
  return gf.some((r) => e[r] ? e[r] !== "none" : !1) || (e.containerType ? e.containerType !== "normal" : !1) || !t && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !t && (e.filter ? e.filter !== "none" : !1) || mf.some((r) => (e.willChange || "").includes(r)) || bf.some((r) => (e.contain || "").includes(r));
}
function vf(s) {
  let t = qt(s);
  for (; $t(t) && !Ve(t); ) {
    if (jr(t))
      return t;
    if (Oi(t))
      return null;
    t = qt(t);
  }
  return null;
}
function Fr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const yf = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ve(s) {
  return yf.has(Ke(s));
}
function yt(s) {
  return lt(s).getComputedStyle(s);
}
function Ii(s) {
  return vt(s) ? {
    scrollLeft: s.scrollLeft,
    scrollTop: s.scrollTop
  } : {
    scrollLeft: s.scrollX,
    scrollTop: s.scrollY
  };
}
function qt(s) {
  if (Ke(s) === "html")
    return s;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    s.assignedSlot || // DOM Element detected.
    s.parentNode || // ShadowRoot detected.
    No(s) && s.host || // Fallback.
    It(s)
  );
  return No(t) ? t.host : t;
}
function wl(s) {
  const t = qt(s);
  return Ve(t) ? s.ownerDocument ? s.ownerDocument.body : s.body : $t(t) && js(t) ? t : wl(t);
}
function ws(s, t, e) {
  var r;
  t === void 0 && (t = []), e === void 0 && (e = !0);
  const i = wl(s), n = i === ((r = s.ownerDocument) == null ? void 0 : r.body), o = lt(i);
  if (n) {
    const a = nr(o);
    return t.concat(o, o.visualViewport || [], js(i) ? i : [], a && e ? ws(a) : []);
  }
  return t.concat(i, ws(i, [], e));
}
function nr(s) {
  return s.parent && Object.getPrototypeOf(s.parent) ? s.frameElement : null;
}
function xl(s) {
  const t = yt(s);
  let e = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = $t(s), n = i ? s.offsetWidth : e, o = i ? s.offsetHeight : r, a = gi(e) !== n || gi(r) !== o;
  return a && (e = n, r = o), {
    width: e,
    height: r,
    $: a
  };
}
function Wr(s) {
  return vt(s) ? s : s.contextElement;
}
function Ae(s) {
  const t = Wr(s);
  if (!$t(t))
    return _t(1);
  const e = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: n
  } = xl(t);
  let o = (n ? gi(e.width) : e.width) / r, a = (n ? gi(e.height) : e.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: o,
    y: a
  };
}
const wf = /* @__PURE__ */ _t(0);
function Cl(s) {
  const t = lt(s);
  return !Fr() || !t.visualViewport ? wf : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function xf(s, t, e) {
  return t === void 0 && (t = !1), !e || t && e !== lt(s) ? !1 : t;
}
function de(s, t, e, r) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  const i = s.getBoundingClientRect(), n = Wr(s);
  let o = _t(1);
  t && (r ? vt(r) && (o = Ae(r)) : o = Ae(s));
  const a = xf(n, e, r) ? Cl(n) : _t(0);
  let l = (i.left + a.x) / o.x, d = (i.top + a.y) / o.y, c = i.width / o.x, h = i.height / o.y;
  if (n) {
    const p = lt(n), m = r && vt(r) ? lt(r) : r;
    let v = p, w = nr(v);
    for (; w && r && m !== v; ) {
      const x = Ae(w), C = w.getBoundingClientRect(), $ = yt(w), S = C.left + (w.clientLeft + parseFloat($.paddingLeft)) * x.x, T = C.top + (w.clientTop + parseFloat($.paddingTop)) * x.y;
      l *= x.x, d *= x.y, c *= x.x, h *= x.y, l += S, d += T, v = lt(w), w = nr(v);
    }
  }
  return bi({
    width: c,
    height: h,
    x: l,
    y: d
  });
}
function Vi(s, t) {
  const e = Ii(s).scrollLeft;
  return t ? t.left + e : de(It(s)).left + e;
}
function kl(s, t) {
  const e = s.getBoundingClientRect(), r = e.left + t.scrollLeft - Vi(s, e), i = e.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function Cf(s) {
  let {
    elements: t,
    rect: e,
    offsetParent: r,
    strategy: i
  } = s;
  const n = i === "fixed", o = It(r), a = t ? Oi(t.floating) : !1;
  if (r === o || a && n)
    return e;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = _t(1);
  const c = _t(0), h = $t(r);
  if ((h || !h && !n) && ((Ke(r) !== "body" || js(o)) && (l = Ii(r)), $t(r))) {
    const m = de(r);
    d = Ae(r), c.x = m.x + r.clientLeft, c.y = m.y + r.clientTop;
  }
  const p = o && !h && !n ? kl(o, l) : _t(0);
  return {
    width: e.width * d.x,
    height: e.height * d.y,
    x: e.x * d.x - l.scrollLeft * d.x + c.x + p.x,
    y: e.y * d.y - l.scrollTop * d.y + c.y + p.y
  };
}
function kf(s) {
  return Array.from(s.getClientRects());
}
function _f(s) {
  const t = It(s), e = Ii(s), r = s.ownerDocument.body, i = at(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), n = at(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -e.scrollLeft + Vi(s);
  const a = -e.scrollTop;
  return yt(r).direction === "rtl" && (o += at(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: n,
    x: o,
    y: a
  };
}
const Bo = 25;
function Ef(s, t) {
  const e = lt(s), r = It(s), i = e.visualViewport;
  let n = r.clientWidth, o = r.clientHeight, a = 0, l = 0;
  if (i) {
    n = i.width, o = i.height;
    const c = Fr();
    (!c || c && t === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  const d = Vi(r);
  if (d <= 0) {
    const c = r.ownerDocument, h = c.body, p = getComputedStyle(h), m = c.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, v = Math.abs(r.clientWidth - h.clientWidth - m);
    v <= Bo && (n -= v);
  } else d <= Bo && (n += d);
  return {
    width: n,
    height: o,
    x: a,
    y: l
  };
}
const Af = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Sf(s, t) {
  const e = de(s, !0, t === "fixed"), r = e.top + s.clientTop, i = e.left + s.clientLeft, n = $t(s) ? Ae(s) : _t(1), o = s.clientWidth * n.x, a = s.clientHeight * n.y, l = i * n.x, d = r * n.y;
  return {
    width: o,
    height: a,
    x: l,
    y: d
  };
}
function jo(s, t, e) {
  let r;
  if (t === "viewport")
    r = Ef(s, e);
  else if (t === "document")
    r = _f(It(s));
  else if (vt(t))
    r = Sf(t, e);
  else {
    const i = Cl(s);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return bi(r);
}
function _l(s, t) {
  const e = qt(s);
  return e === t || !vt(e) || Ve(e) ? !1 : yt(e).position === "fixed" || _l(e, t);
}
function $f(s, t) {
  const e = t.get(s);
  if (e)
    return e;
  let r = ws(s, [], !1).filter((a) => vt(a) && Ke(a) !== "body"), i = null;
  const n = yt(s).position === "fixed";
  let o = n ? qt(s) : s;
  for (; vt(o) && !Ve(o); ) {
    const a = yt(o), l = jr(o);
    !l && a.position === "fixed" && (i = null), (n ? !l && !i : !l && a.position === "static" && !!i && Af.has(i.position) || js(o) && !l && _l(s, o)) ? r = r.filter((c) => c !== o) : i = a, o = qt(o);
  }
  return t.set(s, r), r;
}
function Tf(s) {
  let {
    element: t,
    boundary: e,
    rootBoundary: r,
    strategy: i
  } = s;
  const o = [...e === "clippingAncestors" ? Oi(t) ? [] : $f(t, this._c) : [].concat(e), r], a = o[0], l = o.reduce((d, c) => {
    const h = jo(t, c, i);
    return d.top = at(h.top, d.top), d.right = Ie(h.right, d.right), d.bottom = Ie(h.bottom, d.bottom), d.left = at(h.left, d.left), d;
  }, jo(t, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Of(s) {
  const {
    width: t,
    height: e
  } = xl(s);
  return {
    width: t,
    height: e
  };
}
function If(s, t, e) {
  const r = $t(t), i = It(t), n = e === "fixed", o = de(s, !0, n, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = _t(0);
  function d() {
    l.x = Vi(i);
  }
  if (r || !r && !n)
    if ((Ke(t) !== "body" || js(i)) && (a = Ii(t)), r) {
      const m = de(t, !0, n, t);
      l.x = m.x + t.clientLeft, l.y = m.y + t.clientTop;
    } else i && d();
  n && !r && i && d();
  const c = i && !r && !n ? kl(i, a) : _t(0), h = o.left + a.scrollLeft - l.x - c.x, p = o.top + a.scrollTop - l.y - c.y;
  return {
    x: h,
    y: p,
    width: o.width,
    height: o.height
  };
}
function Ki(s) {
  return yt(s).position === "static";
}
function Fo(s, t) {
  if (!$t(s) || yt(s).position === "fixed")
    return null;
  if (t)
    return t(s);
  let e = s.offsetParent;
  return It(s) === e && (e = e.ownerDocument.body), e;
}
function El(s, t) {
  const e = lt(s);
  if (Oi(s))
    return e;
  if (!$t(s)) {
    let i = qt(s);
    for (; i && !Ve(i); ) {
      if (vt(i) && !Ki(i))
        return i;
      i = qt(i);
    }
    return e;
  }
  let r = Fo(s, t);
  for (; r && pf(r) && Ki(r); )
    r = Fo(r, t);
  return r && Ve(r) && Ki(r) && !jr(r) ? e : r || vf(s) || e;
}
const Vf = async function(s) {
  const t = this.getOffsetParent || El, e = this.getDimensions, r = await e(s.floating);
  return {
    reference: If(s.reference, await t(s.floating), s.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Pf(s) {
  return yt(s).direction === "rtl";
}
const Mf = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Cf,
  getDocumentElement: It,
  getClippingRect: Tf,
  getOffsetParent: El,
  getElementRects: Vf,
  getClientRects: kf,
  getDimensions: Of,
  getScale: Ae,
  isElement: vt,
  isRTL: Pf
};
function Al(s, t) {
  return s.x === t.x && s.y === t.y && s.width === t.width && s.height === t.height;
}
function Lf(s, t) {
  let e = null, r;
  const i = It(s);
  function n() {
    var a;
    clearTimeout(r), (a = e) == null || a.disconnect(), e = null;
  }
  function o(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), n();
    const d = s.getBoundingClientRect(), {
      left: c,
      top: h,
      width: p,
      height: m
    } = d;
    if (a || t(), !p || !m)
      return;
    const v = ri(h), w = ri(i.clientWidth - (c + p)), x = ri(i.clientHeight - (h + m)), C = ri(c), S = {
      rootMargin: -v + "px " + -w + "px " + -x + "px " + -C + "px",
      threshold: at(0, Ie(1, l)) || 1
    };
    let T = !0;
    function k(O) {
      const P = O[0].intersectionRatio;
      if (P !== l) {
        if (!T)
          return o();
        P ? o(!1, P) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !Al(d, s.getBoundingClientRect()) && o(), T = !1;
    }
    try {
      e = new IntersectionObserver(k, {
        ...S,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(k, S);
    }
    e.observe(s);
  }
  return o(!0), n;
}
function Rf(s, t, e, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: n = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, d = Wr(s), c = i || n ? [...d ? ws(d) : [], ...ws(t)] : [];
  c.forEach((C) => {
    i && C.addEventListener("scroll", e, {
      passive: !0
    }), n && C.addEventListener("resize", e);
  });
  const h = d && a ? Lf(d, e) : null;
  let p = -1, m = null;
  o && (m = new ResizeObserver((C) => {
    let [$] = C;
    $ && $.target === d && m && (m.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), e();
  }), d && !l && m.observe(d), m.observe(t));
  let v, w = l ? de(s) : null;
  l && x();
  function x() {
    const C = de(s);
    w && !Al(w, C) && e(), w = C, v = requestAnimationFrame(x);
  }
  return e(), () => {
    var C;
    c.forEach(($) => {
      i && $.removeEventListener("scroll", e), n && $.removeEventListener("resize", e);
    }), h?.(), (C = m) == null || C.disconnect(), m = null, l && cancelAnimationFrame(v);
  };
}
const Hf = lf, Df = cf, zf = rf, Nf = df, Bf = nf, jf = (s, t, e) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Mf,
    ...e
  }, n = {
    ...i.platform,
    _c: r
  };
  return sf(s, t, {
    ...i,
    platform: n
  });
};
var Ff = Object.defineProperty, ye = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ff(t, e, i), i;
};
class Xt extends b {
  constructor() {
    super(...arguments), this.placement = "bottom-start", this.offset = 4, this.modal = !1, this.returnFocus = !0, this.internalOpen = !1, this.isControlled = !1, this.referenceEl = null, this.contentEl = null, this.cleanupAutoUpdate = null, this.previouslyFocused = null, this._provider = new ft(this, {
      context: $i,
      initialValue: {
        open: !1,
        setOpen: () => {
        }
      }
    }), this._onRegisterTrigger = (t) => this._handleRegisterTrigger(t), this._onRegisterContent = (t) => this._handleRegisterContent(t), this._onToggleRequest = () => this.toggle(), this._onCloseRequest = () => this.close(), this._onDocumentKeydown = (t) => this._handleKeydown(t), this._onDocumentMousedown = (t) => this._handleDocumentClick(t);
  }
  connectedCallback() {
    super.connectedCallback(), this.isControlled = this.open !== void 0, this.isControlled && (this.internalOpen = this.open ?? !1), this.addEventListener("ck-popover-register-trigger", this._onRegisterTrigger), this.addEventListener("ck-popover-register-content", this._onRegisterContent), this.addEventListener("ck-popover-toggle", this._onToggleRequest), this.addEventListener("ck-popover-close", this._onCloseRequest), this._updateContext();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._teardownAutoUpdate(), this._removeGlobalListeners(), this.removeEventListener(
      "ck-popover-register-trigger",
      this._onRegisterTrigger
    ), this.removeEventListener(
      "ck-popover-register-content",
      this._onRegisterContent
    ), this.removeEventListener("ck-popover-toggle", this._onToggleRequest), this.removeEventListener("ck-popover-close", this._onCloseRequest);
  }
  updated(t) {
    t.has("open") && (this.isControlled ? this.internalOpen = this.open ?? !1 : this.open !== void 0 && (this.internalOpen = this.open)), this._updateContext();
  }
  _updateContext() {
    this._provider.setValue({
      open: this.internalOpen,
      setOpen: (t) => {
        this.isControlled ? this.onOpenChange?.(t) : (this.internalOpen = t, this.onOpenChange?.(t), this._updateContext()), t ? this.updateComplete.then(() => {
          this._setupFloating(), this._addGlobalListeners();
        }) : (this._teardownAutoUpdate(), this._removeGlobalListeners());
      }
    });
  }
  _handleRegisterTrigger(t) {
    t.stopPropagation(), this.referenceEl = t.detail.el, this._syncTriggerState();
  }
  _handleRegisterContent(t) {
    t.stopPropagation(), this.contentEl = t.detail.el, this.internalOpen && this._setupFloating();
  }
  // --- Public control API ---
  openPopover() {
    this.internalOpen || (this.previouslyFocused = document.activeElement, this.internalOpen = !0, this._syncTriggerState(), this._setupFloating(), this._addGlobalListeners(), this._updateContext(), this.dispatchEvent(
      new CustomEvent("ck-popover-open-change", {
        detail: { open: this.internalOpen },
        bubbles: !0,
        composed: !0
      })
    ), this.modal && this.contentEl && this._focusFirstElement());
  }
  close() {
    this.internalOpen && (this.internalOpen = !1, this._syncTriggerState(), this._teardownAutoUpdate(), this._removeGlobalListeners(), this._updateContext(), this.dispatchEvent(
      new CustomEvent("ck-popover-open-change", {
        detail: { open: this.internalOpen },
        bubbles: !0,
        composed: !0
      })
    ), this.returnFocus && this.previouslyFocused && (this.previouslyFocused.focus(), this.previouslyFocused = null));
  }
  toggle() {
    this.internalOpen ? this.close() : this.openPopover();
  }
  _syncTriggerState() {
    this.referenceEl && this.referenceEl.setAttribute("data-state", this.internalOpen ? "open" : "closed");
  }
  // --- Floating UI setup ---
  _setupFloating() {
    !this.referenceEl || !this.contentEl || (this.contentEl.style.display === "none" && (this.contentEl.style.display = ""), this._teardownAutoUpdate(), this.cleanupAutoUpdate = Rf(
      this.referenceEl,
      this.contentEl,
      () => {
        jf(this.referenceEl, this.contentEl, {
          placement: this.placement,
          middleware: [
            zf({ padding: 8 }),
            Df({ padding: 8 }),
            Hf(this.offset),
            Nf({
              padding: 4,
              apply: ({ rects: t, elements: e, availableHeight: r }) => {
                e.floating.style.setProperty("--max-height", `${r}px`), e.floating.style.setProperty("--width", `${t.reference.width}px`);
              }
            }),
            Bf()
          ]
        }).then(({ x: t, y: e, middlewareData: r, placement: i, strategy: n }) => {
          const o = i.split("-")[0];
          this.contentEl.setAttribute("data-state", this.internalOpen ? "open" : "closed"), this.contentEl.setAttribute("data-side", o), Object.assign(this.contentEl.style, {
            position: n,
            top: `${e ?? 0}px`,
            left: `${t ?? 0}px`,
            visibility: r.hide?.referenceHidden ? "hidden" : "visible",
            "--transform-origin": this._placementToTransformOrigin(i)
          });
        });
      },
      {
        layoutShift: !1
      }
    ));
  }
  _teardownAutoUpdate() {
    this.cleanupAutoUpdate && (this.cleanupAutoUpdate(), this.cleanupAutoUpdate = null);
  }
  _placementToTransformOrigin(t) {
    switch (t) {
      case "top":
        return "bottom";
      case "bottom":
        return "top";
      case "left":
        return "right";
      case "right":
        return "left";
      case "top-start":
        return "bottom left";
      case "top-end":
        return "bottom right";
      case "bottom-start":
        return "top left";
      case "bottom-end":
        return "top right";
      case "left-start":
        return "right top";
      case "left-end":
        return "right bottom";
      case "right-start":
        return "left top";
      case "right-end":
        return "left bottom";
      default:
        return "top";
    }
  }
  // --- Global listeners (Escape, Tab trap, click outside) ---
  _addGlobalListeners() {
    document.addEventListener("keydown", this._onDocumentKeydown, !0), document.addEventListener("mousedown", this._onDocumentMousedown, !0);
  }
  _removeGlobalListeners() {
    document.removeEventListener("keydown", this._onDocumentKeydown, !0), document.removeEventListener("mousedown", this._onDocumentMousedown, !0);
  }
  _handleKeydown(t) {
    if (this.internalOpen) {
      if (t.key === "Escape") {
        t.stopPropagation(), t.preventDefault(), this.close();
        return;
      }
      if (!(!this.modal || !this.contentEl) && t.key === "Tab") {
        const e = this._getFocusableElements();
        if (!e.length) {
          t.preventDefault(), this.contentEl.focus();
          return;
        }
        const r = e[0], i = e[e.length - 1], n = document.activeElement;
        if (!n || !this.contentEl.contains(n)) {
          t.preventDefault(), r.focus();
          return;
        }
        !t.shiftKey && n === i ? (t.preventDefault(), r.focus()) : t.shiftKey && n === r && (t.preventDefault(), i.focus());
      }
    }
  }
  _handleDocumentClick(t) {
    if (!this.internalOpen) return;
    const e = t.target;
    e && (this.referenceEl?.contains(e) || this.contentEl?.contains(e) || this.modal || this.close());
  }
  _getFocusableElements() {
    return this.contentEl ? Array.from(this.contentEl.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter((r) => !r.hasAttribute("disabled") && !r.getAttribute("aria-hidden")) : [];
  }
  _focusFirstElement() {
    const t = this._getFocusableElements();
    t.length ? t[0].focus() : this.contentEl && (this.contentEl.tabIndex = -1, this.contentEl.focus());
  }
  // Root just renders its light DOM children
  render() {
    return f`<slot></slot>`;
  }
}
ye([
  u({ type: String })
], Xt.prototype, "placement");
ye([
  u({ type: Number })
], Xt.prototype, "offset");
ye([
  u({ type: Boolean })
], Xt.prototype, "modal");
ye([
  u({ type: Boolean, attribute: "return-focus" })
], Xt.prototype, "returnFocus");
ye([
  u({ type: Boolean })
], Xt.prototype, "open");
ye([
  R()
], Xt.prototype, "internalOpen");
ye([
  R()
], Xt.prototype, "isControlled");
customElements.get("ck-popover") || customElements.define("ck-popover", Xt);
var Wf = Object.defineProperty, Sl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Wf(t, e, i), i;
};
const Kn = class Kn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation(), this.dispatchEvent(
        new CustomEvent("ck-popover-close", {
          bubbles: !0,
          composed: !0
        })
      ), this.contextValue?.setOpen && this.contextValue.setOpen(!1);
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.asChild && this.addEventListener("click", this._handleClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.asChild && this.removeEventListener("click", this._handleClick);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button variant="ghost" square @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
Kn.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let xs = Kn;
Sl([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], xs.prototype, "asChild");
Sl([
  L({ context: $i, subscribe: !1 })
], xs.prototype, "contextValue");
customElements.get("ck-popover-close") || customElements.define("ck-popover-close", xs);
var Uf = Object.defineProperty, qf = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Uf(t, e, i), i;
};
class $l extends b {
  constructor() {
    super(...arguments), this.transitionEndHandler = null;
  }
  // Use light DOM so Floating UI can position the element directly
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback();
    const t = this.contextValue?.open === !0;
    t || (this.style.display = "none"), this.setAttribute("data-state", t ? "open" : "closed"), this.className = this._classes(), this.dispatchEvent(
      new CustomEvent("ck-popover-register-content", {
        detail: { el: this },
        bubbles: !0,
        composed: !0
      })
    );
  }
  updated() {
    this.className = this._classes();
    const t = this.contextValue?.open === !0;
    this.setAttribute("data-state", t ? "open" : "closed"), this.transitionEndHandler && (this.removeEventListener("transitionend", this.transitionEndHandler), this.transitionEndHandler = null), t ? this.style.display = "" : (this.transitionEndHandler = (e) => {
      e.target === this && !this.contextValue?.open && (this.style.display = "none", this.style.position = "", this.style.top = "", this.style.left = "", this.style.visibility = "", this.removeEventListener("transitionend", this.transitionEndHandler), this.transitionEndHandler = null);
    }, this.addEventListener("transitionend", this.transitionEndHandler));
  }
  _classes() {
    const t = this.getAttribute("class") ?? "";
    return g(
      "z-50 w-72 overflow-auto rounded-xl border border-border bg-white p-3 text-foreground shadow-md outline-none",
      "max-h-(--max-height)",
      "origin-(--transform-origin) transition duration-300 ease-out-expo",
      // Transition classes matching React version
      "data-[state=closed]:data-[side=bottom]:-translate-y-2",
      "data-[state=closed]:data-[side=left]:translate-x-2",
      "data-[state=closed]:data-[side=right]:-translate-x-2",
      "data-[state=closed]:data-[side=top]:translate-y-2",
      "data-[state=closed]:scale-95",
      "data-[state=closed]:opacity-0",
      "data-[state=closed]:duration-150",
      "data-[state=open]:translate-x-0",
      "data-[state=open]:translate-y-0",
      "data-[state=open]:scale-100",
      "data-[state=open]:opacity-100",
      t
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.transitionEndHandler && (this.removeEventListener("transitionend", this.transitionEndHandler), this.transitionEndHandler = null);
  }
  render() {
    return f`<slot></slot>`;
  }
}
qf([
  L({ context: $i, subscribe: !0 })
], $l.prototype, "contextValue");
customElements.get("ck-popover-content") || customElements.define("ck-popover-content", $l);
class Kf extends b {
  createRenderRoot() {
    return this;
  }
  render() {
    const t = this.getAttribute("class") || "", e = g(
      "text-foreground-secondary pt-4 pb-5 text-center text-sm font-medium",
      t
    );
    return f`
      <div class="${e}">
        <slot></slot>
      </div>
    `;
  }
}
customElements.get("ck-popover-empty") || customElements.define("ck-popover-empty", Kf);
var Zf = Object.defineProperty, Gf = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Zf(t, e, i), i;
};
class Tl extends b {
  constructor() {
    super(...arguments), this.selectionMode = "single";
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("ck-list-item-select", this._handleItemSelect);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("ck-list-item-select", this._handleItemSelect);
  }
  _handleItemSelect(t) {
    const e = t;
    t.stopPropagation();
    const { value: r, item: i } = e.detail;
    this.selectionMode === "single" && this._updateSingleSelection(i), this.dispatchEvent(
      new CustomEvent("ck-list-select", {
        detail: { value: r, item: i },
        bubbles: !0,
        composed: !0
      })
    );
  }
  _updateSingleSelection(t) {
    this.querySelectorAll("ck-popover-list-item").forEach((r) => {
      r === t ? r.setAttribute("selected", "") : r.removeAttribute("selected");
    });
  }
  _classes() {
    const t = this.getAttribute("class") ?? "";
    return g("max-h-60 overflow-auto py-1", "flex flex-col gap-0.5", t);
  }
  render() {
    return f`<div class="${this._classes()}" role="listbox">
      <slot></slot>
    </div>`;
  }
}
Gf([
  u({ type: String, attribute: "selection-mode" })
], Tl.prototype, "selectionMode");
customElements.get("ck-popover-list") || customElements.define("ck-popover-list", Tl);
var Yf = Object.defineProperty, Ur = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Yf(t, e, i), i;
};
class Pi extends b {
  constructor() {
    super(...arguments), this.value = null, this.disabled = !1, this.selected = !1, this._handleClick = (t) => {
      if (this.disabled) {
        t.preventDefault();
        return;
      }
      this._emitSelect();
    }, this._handleKeydown = (t) => {
      this.disabled || (t.key === "Enter" || t.key === " ") && (t.preventDefault(), this._emitSelect());
    };
  }
  _emitSelect() {
    this.dispatchEvent(
      new CustomEvent("ck-list-item-select", {
        detail: {
          value: this.value,
          item: this
        },
        bubbles: !0,
        composed: !0
      })
    );
  }
  _classes() {
    const t = this.getAttribute("class") ?? "";
    return g(
      "w-full text-left rounded-lg px-3 py-2 text-sm font-medium",
      "hover:bg-foreground/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "cursor-pointer",
      this.disabled && "opacity-40 cursor-not-allowed hover:bg-transparent",
      this.selected && "bg-foreground/5",
      t
    );
  }
  render() {
    return f`
      <button
        type="button"
        class="${this._classes()}"
        ?disabled=${this.disabled}
        role="option"
        aria-selected=${this.selected ? "true" : "false"}
        @click=${this._handleClick}
        @keydown=${this._handleKeydown}
      >
        <slot></slot>
      </button>
    `;
  }
}
Ur([
  u({ type: String })
], Pi.prototype, "value");
Ur([
  u({ type: Boolean, reflect: !0 })
], Pi.prototype, "disabled");
Ur([
  u({ type: Boolean, reflect: !0 })
], Pi.prototype, "selected");
customElements.get("ck-popover-list-item") || customElements.define("ck-popover-list-item", Pi);
var Xf = Object.defineProperty, Ol = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Xf(t, e, i), i;
};
const Jf = /* @__PURE__ */ new Set(["class", "value", "placeholder"]);
class qr extends b {
  constructor() {
    super(...arguments), this.value = "", this.placeholder = "", this._handleInput = (t) => {
      const e = t.target;
      this.value = e.value;
      const r = this.onInput;
      typeof r == "function" && r(t), !t.defaultPrevented && this.dispatchEvent(
        new CustomEvent("ck-input", {
          detail: { value: this.value },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._handleChange = (t) => {
      const e = this.onChange;
      typeof e == "function" && e(t);
    };
  }
  firstUpdated() {
    this.inputElement = this.shadowRoot?.querySelector("input"), this.syncAttributes(), this.syncEventHandlers();
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers();
  }
  syncAttributes() {
    if (this.inputElement)
      for (const t of this.attributes)
        Jf.has(t.name) || this.inputElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.inputElement && q(this, this.inputElement, [
      "onInput",
      "onChange"
    ]);
  }
  _classes() {
    const t = this.getAttribute("class") ?? "";
    return g(
      "border-border relative mb-1 flex items-center rounded-t-lg border-b bg-transparent",
      t
    );
  }
  _inputClasses() {
    return g(
      "placeholder:text-foreground-secondary h-10 w-full border-0 bg-transparent p-4 pl-9 text-base font-medium transition-colors outline-none focus:ring-0"
    );
  }
  render() {
    return f`
      <div class="${this._classes()}">
        <ck-icon
          name="search"
          size="sm"
          class="text-foreground absolute left-3 h-4 w-4 shrink-0"
          decorative
        ></ck-icon>

        <input
          class="${this._inputClasses()}"
          .value="${this.value}"
          .placeholder="${this.placeholder}"
          @input="${this._handleInput}"
          @change="${this._handleChange}"
        />
      </div>
      <slot></slot>
    `;
  }
}
Ol([
  u({ type: String })
], qr.prototype, "value");
Ol([
  u({ type: String })
], qr.prototype, "placeholder");
customElements.get("ck-popover-search-input") || customElements.define("ck-popover-search-input", qr);
var Qf = Object.defineProperty, Il = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Qf(t, e, i), i;
};
const Wo = /* @__PURE__ */ new Set(["class", "as-child"]), Zn = class Zn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.triggerEl = null, this.previousChild = null, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), !t.defaultPrevented && (this.dispatchEvent(
        new CustomEvent("ck-popover-toggle", {
          bubbles: !0,
          composed: !0
        })
      ), this.contextValue?.setOpen && this.contextValue.setOpen(!this.contextValue.open));
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.updateComplete.then(() => {
      this._registerTrigger();
    });
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    if (super.updated?.(t), this.asChild) {
      const e = this.firstElementChild;
      e && (this.previousChild && this._removeEventListeners(this.previousChild), Zt(this.asChild, e, {
        "data-state": this.contextValue?.open ? "open" : "closed"
      }), this._syncChildAttributes(e), this._syncChildEventHandlers(e), e.addEventListener("click", this._handleClick), this.previousChild = e);
    } else
      this.syncAttributes(), this.syncEventHandlers();
    this.updateComplete.then(() => {
      this._registerTrigger();
    });
  }
  _registerTrigger() {
    const t = yh(
      this,
      this.asChild,
      "ck-button",
      // Shadow selector for non-asChild case
      "button"
      // Inner selector for ck-button's shadow DOM
    );
    t && t !== this.triggerEl && (this.triggerEl = t, this.dispatchEvent(
      new CustomEvent("ck-popover-register-trigger", {
        detail: { el: this.triggerEl },
        bubbles: !0,
        composed: !0
      })
    ));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.asChild && this.previousChild && (this._removeEventListeners(this.previousChild), this.previousChild = null);
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes)
        Wo.has(t.name) || this.buttonElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  _syncChildAttributes(t) {
    for (const e of this.attributes)
      Wo.has(e.name) || t.setAttribute(e.name, e.value);
  }
  _syncChildEventHandlers(t) {
    q(this, t, [
      "onClick"
    ]);
  }
  _removeEventListeners(t) {
    const e = t;
    e.removeEventListener("click", this._handleClick), Object.keys(this).filter(
      (i) => i.startsWith("on") && typeof this[i] == "function" && i !== "onClick"
    ).forEach((i) => {
      const n = i.slice(2).toLowerCase(), o = this[i];
      typeof o == "function" && e.removeEventListener(n, o);
    });
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
Zn.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let Cs = Zn;
Il([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Cs.prototype, "asChild");
Il([
  L({ context: $i })
], Cs.prototype, "contextValue");
customElements.get("ck-popover-trigger") || customElements.define("ck-popover-trigger", Cs);
const Vl = "disclosure-group-context", Mi = "disclosure-context";
var tg = Object.defineProperty, Li = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && tg(t, e, i), i;
};
class Fs extends b {
  constructor() {
    super(...arguments), this.defaultOpen = !1, this.internalOpen = !1, this._provider = new ft(this, {
      context: Mi,
      initialValue: {
        id: "",
        open: !1,
        setOpen: () => {
        }
      }
    }), this.generatedId = Ot("disclosure"), this.disclosureId = "";
  }
  connectedCallback() {
    super.connectedCallback();
    const t = this.getAttribute("id");
    t ? this.disclosureId = t : (this.disclosureId = this.generatedId, this.setAttribute("id", this.disclosureId)), this.internalOpen = this.open ?? this.defaultOpen, this._updateContext();
  }
  updated(t) {
    t.has("open") && this.open !== void 0 && (this.internalOpen = this.open), this._updateContext();
  }
  _updateContext() {
    let t = this.open ?? this.internalOpen, e = (r) => {
      this.internalOpen = r, this.onOpenChange?.(r), this._updateContext();
    };
    this.groupContext && (t = this.groupContext.open === this.disclosureId, e = (r) => {
      this.groupContext?.setOpen(r ? this.disclosureId : null);
    }), this._provider.setValue({
      id: this.disclosureId,
      open: t,
      setOpen: e
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
Li([
  u({ type: Boolean, attribute: "default-open" })
], Fs.prototype, "defaultOpen");
Li([
  u({ type: Boolean })
], Fs.prototype, "open");
Li([
  R()
], Fs.prototype, "internalOpen");
Li([
  L({ context: Vl, subscribe: !0 })
], Fs.prototype, "groupContext");
customElements.get("ck-disclosure") || customElements.define("ck-disclosure", Fs);
var eg = Object.defineProperty, Pl = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && eg(t, e, i), i;
};
class Kr extends b {
  constructor() {
    super(...arguments), this.icon = "plus", this.originalCustomClass = "", this.baseClasses = "p-1";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.setAttribute("aria-hidden", "true"), this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _getContentClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "";
    return g(this.baseClasses, t);
  }
  _getIconName() {
    const t = this.contextValue?.open === !0;
    return this.icon === "chevron" ? t ? "chevron-up" : "chevron-down" : t ? "minus" : "plus";
  }
  render() {
    return f`
      <span class="${this._getContentClasses()}" aria-hidden="true">
        <ck-icon name="${this._getIconName()}" decorative></ck-icon>
      </span>
    `;
  }
}
Pl([
  L({ context: Mi, subscribe: !0 })
], Kr.prototype, "contextValue");
Pl([
  u({ type: String })
], Kr.prototype, "icon");
customElements.get("ck-disclosure-chevron") || customElements.define("ck-disclosure-chevron", Kr);
function sg(s, t) {
  s.indexOf(t) === -1 && s.push(t);
}
function Ml(s, t) {
  const e = s.indexOf(t);
  e > -1 && s.splice(e, 1);
}
const he = (s, t, e) => e > t ? t : e < s ? s : e;
let Zr = () => {
};
const Lt = {}, Ll = (s) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(s);
function ig(s) {
  return typeof s == "object" && s !== null;
}
const Rl = (s) => /^0[^.\s]+$/u.test(s);
// @__NO_SIDE_EFFECTS__
function Gr(s) {
  let t;
  return () => (t === void 0 && (t = s()), t);
}
const Ze = /* @__NO_SIDE_EFFECTS__ */ (s) => s, rg = (s, t) => (e) => t(s(e)), Yr = (...s) => s.reduce(rg), Xr = /* @__NO_SIDE_EFFECTS__ */ (s, t, e) => {
  const r = t - s;
  return r === 0 ? 1 : (e - s) / r;
};
class Hl {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return sg(this.subscriptions, t), () => Ml(this.subscriptions, t);
  }
  notify(t, e, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, e, r);
      else
        for (let n = 0; n < i; n++) {
          const o = this.subscriptions[n];
          o && o(t, e, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Et = /* @__NO_SIDE_EFFECTS__ */ (s) => s * 1e3, mt = /* @__NO_SIDE_EFFECTS__ */ (s) => s / 1e3;
function Dl(s, t) {
  return t ? s * (1e3 / t) : 0;
}
const ng = (s, t, e) => {
  const r = t - s;
  return ((e - s) % r + r) % r + s;
}, zl = (s, t, e) => (((1 - 3 * e + 3 * t) * s + (3 * e - 6 * t)) * s + 3 * t) * s, og = 1e-7, ag = 12;
function lg(s, t, e, r, i) {
  let n, o, a = 0;
  do
    o = t + (e - t) / 2, n = zl(o, r, i) - s, n > 0 ? e = o : t = o;
  while (Math.abs(n) > og && ++a < ag);
  return o;
}
function Ws(s, t, e, r) {
  if (s === t && e === r)
    return Ze;
  const i = (n) => lg(n, 0, 1, s, e);
  return (n) => n === 0 || n === 1 ? n : zl(i(n), t, r);
}
const Nl = (s) => (t) => t <= 0.5 ? s(2 * t) / 2 : (2 - s(2 * (1 - t))) / 2, Bl = (s) => (t) => 1 - s(1 - t), jl = /* @__PURE__ */ Ws(0.33, 1.53, 0.69, 0.99), Jr = /* @__PURE__ */ Bl(jl), Fl = /* @__PURE__ */ Nl(Jr), Wl = (s) => (s *= 2) < 1 ? 0.5 * Jr(s) : 0.5 * (2 - Math.pow(2, -10 * (s - 1))), Qr = (s) => 1 - Math.sin(Math.acos(s)), cg = Bl(Qr), Ul = Nl(Qr), dg = /* @__PURE__ */ Ws(0.42, 0, 1, 1), hg = /* @__PURE__ */ Ws(0, 0, 0.58, 1), ql = /* @__PURE__ */ Ws(0.42, 0, 0.58, 1), Kl = (s) => Array.isArray(s) && typeof s[0] != "number";
function Zl(s, t) {
  return Kl(s) ? s[ng(0, s.length, t)] : s;
}
const Gl = (s) => Array.isArray(s) && typeof s[0] == "number", ug = {
  linear: Ze,
  easeIn: dg,
  easeInOut: ql,
  easeOut: hg,
  circIn: Qr,
  circInOut: Ul,
  circOut: cg,
  backIn: Jr,
  backInOut: Fl,
  backOut: jl,
  anticipate: Wl
}, pg = (s) => typeof s == "string", Uo = (s) => {
  if (Gl(s)) {
    Zr(s.length === 4);
    const [t, e, r, i] = s;
    return Ws(t, e, r, i);
  } else if (pg(s))
    return ug[s];
  return s;
}, ni = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function fg(s, t) {
  let e = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, n = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    o.has(c) && (d.schedule(c), s()), c(a);
  }
  const d = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, h = !1, p = !1) => {
      const v = p && i ? e : r;
      return h && o.add(c), v.has(c) || v.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      r.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, i) {
        n = !0;
        return;
      }
      i = !0, [e, r] = [r, e], e.forEach(l), e.clear(), i = !1, n && (n = !1, d.process(c));
    }
  };
  return d;
}
const gg = 40;
function Yl(s, t) {
  let e = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, n = () => e = !0, o = ni.reduce((S, T) => (S[T] = fg(n), S), {}), { setup: a, read: l, resolveKeyframes: d, preUpdate: c, update: h, preRender: p, render: m, postRender: v } = o, w = () => {
    const S = Lt.useManualTiming ? i.timestamp : performance.now();
    e = !1, Lt.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(S - i.timestamp, gg), 1)), i.timestamp = S, i.isProcessing = !0, a.process(i), l.process(i), d.process(i), c.process(i), h.process(i), p.process(i), m.process(i), v.process(i), i.isProcessing = !1, e && t && (r = !1, s(w));
  }, x = () => {
    e = !0, r = !0, i.isProcessing || s(w);
  };
  return { schedule: ni.reduce((S, T) => {
    const k = o[T];
    return S[T] = (O, P = !1, y = !1) => (e || x(), k.schedule(O, P, y)), S;
  }, {}), cancel: (S) => {
    for (let T = 0; T < ni.length; T++)
      o[ni[T]].cancel(S);
  }, state: i, steps: o };
}
const { schedule: Rt, cancel: or, state: vi } = /* @__PURE__ */ Yl(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ze, !0);
let ci;
function mg() {
  ci = void 0;
}
const pt = {
  now: () => (ci === void 0 && pt.set(vi.isProcessing || Lt.useManualTiming ? vi.timestamp : performance.now()), ci),
  set: (s) => {
    ci = s, queueMicrotask(mg);
  }
}, Xl = (s) => (t) => typeof t == "string" && t.startsWith(s), Jl = /* @__PURE__ */ Xl("--"), bg = /* @__PURE__ */ Xl("var(--"), tn = (s) => bg(s) ? vg.test(s.split("/*")[0].trim()) : !1, vg = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Ge = {
  test: (s) => typeof s == "number",
  parse: parseFloat,
  transform: (s) => s
}, ks = {
  ...Ge,
  transform: (s) => he(0, 1, s)
}, oi = {
  ...Ge,
  default: 1
}, ds = (s) => Math.round(s * 1e5) / 1e5, en = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function yg(s) {
  return s == null;
}
const wg = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, sn = (s, t) => (e) => !!(typeof e == "string" && wg.test(e) && e.startsWith(s) || t && !yg(e) && Object.prototype.hasOwnProperty.call(e, t)), Ql = (s, t, e) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, n, o, a] = r.match(en);
  return {
    [s]: parseFloat(i),
    [t]: parseFloat(n),
    [e]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, xg = (s) => he(0, 255, s), Zi = {
  ...Ge,
  transform: (s) => Math.round(xg(s))
}, ie = {
  test: /* @__PURE__ */ sn("rgb", "red"),
  parse: /* @__PURE__ */ Ql("red", "green", "blue"),
  transform: ({ red: s, green: t, blue: e, alpha: r = 1 }) => "rgba(" + Zi.transform(s) + ", " + Zi.transform(t) + ", " + Zi.transform(e) + ", " + ds(ks.transform(r)) + ")"
};
function Cg(s) {
  let t = "", e = "", r = "", i = "";
  return s.length > 5 ? (t = s.substring(1, 3), e = s.substring(3, 5), r = s.substring(5, 7), i = s.substring(7, 9)) : (t = s.substring(1, 2), e = s.substring(2, 3), r = s.substring(3, 4), i = s.substring(4, 5), t += t, e += e, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(e, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const ar = {
  test: /* @__PURE__ */ sn("#"),
  parse: Cg,
  transform: ie.transform
}, Us = /* @__NO_SIDE_EFFECTS__ */ (s) => ({
  test: (t) => typeof t == "string" && t.endsWith(s) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${s}`
}), Nt = /* @__PURE__ */ Us("deg"), Se = /* @__PURE__ */ Us("%"), I = /* @__PURE__ */ Us("px"), kg = /* @__PURE__ */ Us("vh"), _g = /* @__PURE__ */ Us("vw"), qo = {
  ...Se,
  parse: (s) => Se.parse(s) / 100,
  transform: (s) => Se.transform(s * 100)
}, _e = {
  test: /* @__PURE__ */ sn("hsl", "hue"),
  parse: /* @__PURE__ */ Ql("hue", "saturation", "lightness"),
  transform: ({ hue: s, saturation: t, lightness: e, alpha: r = 1 }) => "hsla(" + Math.round(s) + ", " + Se.transform(ds(t)) + ", " + Se.transform(ds(e)) + ", " + ds(ks.transform(r)) + ")"
}, U = {
  test: (s) => ie.test(s) || ar.test(s) || _e.test(s),
  parse: (s) => ie.test(s) ? ie.parse(s) : _e.test(s) ? _e.parse(s) : ar.parse(s),
  transform: (s) => typeof s == "string" ? s : s.hasOwnProperty("red") ? ie.transform(s) : _e.transform(s),
  getAnimatableNone: (s) => {
    const t = U.parse(s);
    return t.alpha = 0, U.transform(t);
  }
}, Eg = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Ag(s) {
  return isNaN(s) && typeof s == "string" && (s.match(en)?.length || 0) + (s.match(Eg)?.length || 0) > 0;
}
const tc = "number", ec = "color", Sg = "var", $g = "var(", Ko = "${}", Tg = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function _s(s) {
  const t = s.toString(), e = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let n = 0;
  const a = t.replace(Tg, (l) => (U.test(l) ? (r.color.push(n), i.push(ec), e.push(U.parse(l))) : l.startsWith($g) ? (r.var.push(n), i.push(Sg), e.push(l)) : (r.number.push(n), i.push(tc), e.push(parseFloat(l))), ++n, Ko)).split(Ko);
  return { values: e, split: a, indexes: r, types: i };
}
function sc(s) {
  return _s(s).values;
}
function ic(s) {
  const { split: t, types: e } = _s(s), r = t.length;
  return (i) => {
    let n = "";
    for (let o = 0; o < r; o++)
      if (n += t[o], i[o] !== void 0) {
        const a = e[o];
        a === tc ? n += ds(i[o]) : a === ec ? n += U.transform(i[o]) : n += i[o];
      }
    return n;
  };
}
const Og = (s) => typeof s == "number" ? 0 : U.test(s) ? U.getAnimatableNone(s) : s;
function Ig(s) {
  const t = sc(s);
  return ic(s)(t.map(Og));
}
const Ye = {
  test: Ag,
  parse: sc,
  createTransformer: ic,
  getAnimatableNone: Ig
};
function Gi(s, t, e) {
  return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? s + (t - s) * 6 * e : e < 1 / 2 ? t : e < 2 / 3 ? s + (t - s) * (2 / 3 - e) * 6 : s;
}
function Vg({ hue: s, saturation: t, lightness: e, alpha: r }) {
  s /= 360, t /= 100, e /= 100;
  let i = 0, n = 0, o = 0;
  if (!t)
    i = n = o = e;
  else {
    const a = e < 0.5 ? e * (1 + t) : e + t - e * t, l = 2 * e - a;
    i = Gi(l, a, s + 1 / 3), n = Gi(l, a, s), o = Gi(l, a, s - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(n * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function yi(s, t) {
  return (e) => e > 0 ? t : s;
}
const qs = (s, t, e) => s + (t - s) * e, Yi = (s, t, e) => {
  const r = s * s, i = e * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, Pg = [ar, ie, _e], Mg = (s) => Pg.find((t) => t.test(s));
function Zo(s) {
  const t = Mg(s);
  if (!t)
    return !1;
  let e = t.parse(s);
  return t === _e && (e = Vg(e)), e;
}
const Go = (s, t) => {
  const e = Zo(s), r = Zo(t);
  if (!e || !r)
    return yi(s, t);
  const i = { ...e };
  return (n) => (i.red = Yi(e.red, r.red, n), i.green = Yi(e.green, r.green, n), i.blue = Yi(e.blue, r.blue, n), i.alpha = qs(e.alpha, r.alpha, n), ie.transform(i));
}, lr = /* @__PURE__ */ new Set(["none", "hidden"]);
function Lg(s, t) {
  return lr.has(s) ? (e) => e <= 0 ? s : t : (e) => e >= 1 ? t : s;
}
function Rg(s, t) {
  return (e) => qs(s, t, e);
}
function rn(s) {
  return typeof s == "number" ? Rg : typeof s == "string" ? tn(s) ? yi : U.test(s) ? Go : zg : Array.isArray(s) ? rc : typeof s == "object" ? U.test(s) ? Go : Hg : yi;
}
function rc(s, t) {
  const e = [...s], r = e.length, i = s.map((n, o) => rn(n)(n, t[o]));
  return (n) => {
    for (let o = 0; o < r; o++)
      e[o] = i[o](n);
    return e;
  };
}
function Hg(s, t) {
  const e = { ...s, ...t }, r = {};
  for (const i in e)
    s[i] !== void 0 && t[i] !== void 0 && (r[i] = rn(s[i])(s[i], t[i]));
  return (i) => {
    for (const n in r)
      e[n] = r[n](i);
    return e;
  };
}
function Dg(s, t) {
  const e = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const n = t.types[i], o = s.indexes[n][r[n]], a = s.values[o] ?? 0;
    e[i] = a, r[n]++;
  }
  return e;
}
const zg = (s, t) => {
  const e = Ye.createTransformer(t), r = _s(s), i = _s(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? lr.has(s) && !i.values.length || lr.has(t) && !r.values.length ? Lg(s, t) : Yr(rc(Dg(r, i), i.values), e) : yi(s, t);
};
function nc(s, t, e) {
  return typeof s == "number" && typeof t == "number" && typeof e == "number" ? qs(s, t, e) : rn(s)(s, t);
}
const Ng = (s) => {
  const t = ({ timestamp: e }) => s(e);
  return {
    start: (e = !0) => Rt.update(t, e),
    stop: () => or(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => vi.isProcessing ? vi.timestamp : pt.now()
  };
}, oc = (s, t, e = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / e), 2);
  for (let n = 0; n < i; n++)
    r += Math.round(s(n / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, wi = 2e4;
function nn(s) {
  let t = 0;
  const e = 50;
  let r = s.next(t);
  for (; !r.done && t < wi; )
    t += e, r = s.next(t);
  return t >= wi ? 1 / 0 : t;
}
function ac(s, t = 100, e) {
  const r = e({ ...s, keyframes: [0, t] }), i = Math.min(nn(r), wi);
  return {
    type: "keyframes",
    ease: (n) => r.next(i * n).value / t,
    duration: /* @__PURE__ */ mt(i)
  };
}
const Bg = 5;
function lc(s, t, e) {
  const r = Math.max(t - Bg, 0);
  return Dl(e - s(r), t - r);
}
const F = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Xi = 1e-3;
function jg({ duration: s = F.duration, bounce: t = F.bounce, velocity: e = F.velocity, mass: r = F.mass }) {
  let i, n, o = 1 - t;
  o = he(F.minDamping, F.maxDamping, o), s = he(F.minDuration, F.maxDuration, /* @__PURE__ */ mt(s)), o < 1 ? (i = (d) => {
    const c = d * o, h = c * s, p = c - e, m = cr(d, o), v = Math.exp(-h);
    return Xi - p / m * v;
  }, n = (d) => {
    const h = d * o * s, p = h * e + e, m = Math.pow(o, 2) * Math.pow(d, 2) * s, v = Math.exp(-h), w = cr(Math.pow(d, 2), o);
    return (-i(d) + Xi > 0 ? -1 : 1) * ((p - m) * v) / w;
  }) : (i = (d) => {
    const c = Math.exp(-d * s), h = (d - e) * s + 1;
    return -Xi + c * h;
  }, n = (d) => {
    const c = Math.exp(-d * s), h = (e - d) * (s * s);
    return c * h;
  });
  const a = 5 / s, l = Wg(i, n, a);
  if (s = /* @__PURE__ */ Et(s), isNaN(l))
    return {
      stiffness: F.stiffness,
      damping: F.damping,
      duration: s
    };
  {
    const d = Math.pow(l, 2) * r;
    return {
      stiffness: d,
      damping: o * 2 * Math.sqrt(r * d),
      duration: s
    };
  }
}
const Fg = 12;
function Wg(s, t, e) {
  let r = e;
  for (let i = 1; i < Fg; i++)
    r = r - s(r) / t(r);
  return r;
}
function cr(s, t) {
  return s * Math.sqrt(1 - t * t);
}
const Ug = ["duration", "bounce"], qg = ["stiffness", "damping", "mass"];
function Yo(s, t) {
  return t.some((e) => s[e] !== void 0);
}
function Kg(s) {
  let t = {
    velocity: F.velocity,
    stiffness: F.stiffness,
    damping: F.damping,
    mass: F.mass,
    isResolvedFromDuration: !1,
    ...s
  };
  if (!Yo(s, qg) && Yo(s, Ug))
    if (s.visualDuration) {
      const e = s.visualDuration, r = 2 * Math.PI / (e * 1.2), i = r * r, n = 2 * he(0.05, 1, 1 - (s.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: F.mass,
        stiffness: i,
        damping: n
      };
    } else {
      const e = jg(s);
      t = {
        ...t,
        ...e,
        mass: F.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Pe(s = F.visualDuration, t = F.bounce) {
  const e = typeof s != "object" ? {
    visualDuration: s,
    keyframes: [0, 1],
    bounce: t
  } : s;
  let { restSpeed: r, restDelta: i } = e;
  const n = e.keyframes[0], o = e.keyframes[e.keyframes.length - 1], a = { done: !1, value: n }, { stiffness: l, damping: d, mass: c, duration: h, velocity: p, isResolvedFromDuration: m } = Kg({
    ...e,
    velocity: -/* @__PURE__ */ mt(e.velocity || 0)
  }), v = p || 0, w = d / (2 * Math.sqrt(l * c)), x = o - n, C = /* @__PURE__ */ mt(Math.sqrt(l / c)), $ = Math.abs(x) < 5;
  r || (r = $ ? F.restSpeed.granular : F.restSpeed.default), i || (i = $ ? F.restDelta.granular : F.restDelta.default);
  let S;
  if (w < 1) {
    const k = cr(C, w);
    S = (O) => {
      const P = Math.exp(-w * C * O);
      return o - P * ((v + w * C * x) / k * Math.sin(k * O) + x * Math.cos(k * O));
    };
  } else if (w === 1)
    S = (k) => o - Math.exp(-C * k) * (x + (v + C * x) * k);
  else {
    const k = C * Math.sqrt(w * w - 1);
    S = (O) => {
      const P = Math.exp(-w * C * O), y = Math.min(k * O, 300);
      return o - P * ((v + w * C * x) * Math.sinh(y) + k * x * Math.cosh(y)) / k;
    };
  }
  const T = {
    calculatedDuration: m && h || null,
    next: (k) => {
      const O = S(k);
      if (m)
        a.done = k >= h;
      else {
        let P = k === 0 ? v : 0;
        w < 1 && (P = k === 0 ? /* @__PURE__ */ Et(v) : lc(S, k, O));
        const y = Math.abs(P) <= r, V = Math.abs(o - O) <= i;
        a.done = y && V;
      }
      return a.value = a.done ? o : O, a;
    },
    toString: () => {
      const k = Math.min(nn(T), wi), O = oc((P) => T.next(k * P).value, k, 30);
      return k + "ms " + O;
    },
    toTransition: () => {
    }
  };
  return T;
}
Pe.applyToOptions = (s) => {
  const t = ac(s, 100, Pe);
  return s.ease = t.ease, s.duration = /* @__PURE__ */ Et(t.duration), s.type = "keyframes", s;
};
function dr({ keyframes: s, velocity: t = 0, power: e = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: n = 500, modifyTarget: o, min: a, max: l, restDelta: d = 0.5, restSpeed: c }) {
  const h = s[0], p = {
    done: !1,
    value: h
  }, m = (y) => a !== void 0 && y < a || l !== void 0 && y > l, v = (y) => a === void 0 ? l : l === void 0 || Math.abs(a - y) < Math.abs(l - y) ? a : l;
  let w = e * t;
  const x = h + w, C = o === void 0 ? x : o(x);
  C !== x && (w = C - h);
  const $ = (y) => -w * Math.exp(-y / r), S = (y) => C + $(y), T = (y) => {
    const V = $(y), D = S(y);
    p.done = Math.abs(V) <= d, p.value = p.done ? C : D;
  };
  let k, O;
  const P = (y) => {
    m(p.value) && (k = y, O = Pe({
      keyframes: [p.value, v(p.value)],
      velocity: lc(S, y, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: n,
      restDelta: d,
      restSpeed: c
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (y) => {
      let V = !1;
      return !O && k === void 0 && (V = !0, T(y), P(y)), k !== void 0 && y >= k ? O.next(y - k) : (!V && T(y), p);
    }
  };
}
function Zg(s, t, e) {
  const r = [], i = e || Lt.mix || nc, n = s.length - 1;
  for (let o = 0; o < n; o++) {
    let a = i(s[o], s[o + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[o] || Ze : t;
      a = Yr(l, a);
    }
    r.push(a);
  }
  return r;
}
function Gg(s, t, { clamp: e = !0, ease: r, mixer: i } = {}) {
  const n = s.length;
  if (Zr(n === t.length), n === 1)
    return () => t[0];
  if (n === 2 && t[0] === t[1])
    return () => t[1];
  const o = s[0] === s[1];
  s[0] > s[n - 1] && (s = [...s].reverse(), t = [...t].reverse());
  const a = Zg(t, r, i), l = a.length, d = (c) => {
    if (o && c < s[0])
      return t[0];
    let h = 0;
    if (l > 1)
      for (; h < s.length - 2 && !(c < s[h + 1]); h++)
        ;
    const p = /* @__PURE__ */ Xr(s[h], s[h + 1], c);
    return a[h](p);
  };
  return e ? (c) => d(he(s[0], s[n - 1], c)) : d;
}
function cc(s, t) {
  const e = s[s.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ Xr(0, t, r);
    s.push(qs(e, 1, i));
  }
}
function dc(s) {
  const t = [0];
  return cc(t, s.length - 1), t;
}
function Yg(s, t) {
  return s.map((e) => e * t);
}
function Xg(s, t) {
  return s.map(() => t || ql).splice(0, s.length - 1);
}
function hs({ duration: s = 300, keyframes: t, times: e, ease: r = "easeInOut" }) {
  const i = Kl(r) ? r.map(Uo) : Uo(r), n = {
    done: !1,
    value: t[0]
  }, o = Yg(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    e && e.length === t.length ? e : dc(t),
    s
  ), a = Gg(o, t, {
    ease: Array.isArray(i) ? i : Xg(t, i)
  });
  return {
    calculatedDuration: s,
    next: (l) => (n.value = a(l), n.done = l >= s, n)
  };
}
const Jg = (s) => s !== null;
function on(s, { repeat: t, repeatType: e = "loop" }, r, i = 1) {
  const n = s.filter(Jg), a = i < 0 || t && e !== "loop" && t % 2 === 1 ? 0 : n.length - 1;
  return !a || r === void 0 ? n[a] : r;
}
const Qg = {
  decay: dr,
  inertia: dr,
  tween: hs,
  keyframes: hs,
  spring: Pe
};
function hc(s) {
  typeof s.type == "string" && (s.type = Qg[s.type]);
}
class an {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, e) {
    return this.finished.then(t, e);
  }
}
const tm = (s) => s / 100;
class ln extends an {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      const { motionValue: e } = this.options;
      e && e.updatedAt !== pt.now() && this.tick(pt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    hc(t);
    const { type: e = hs, repeat: r = 0, repeatDelay: i = 0, repeatType: n, velocity: o = 0 } = t;
    let { keyframes: a } = t;
    const l = e || hs;
    l !== hs && typeof a[0] != "number" && (this.mixKeyframes = Yr(tm, nc(a[0], a[1])), a = [0, 100]);
    const d = l({ ...t, keyframes: a });
    n === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...a].reverse(),
      velocity: -o
    })), d.calculatedDuration === null && (d.calculatedDuration = nn(d));
    const { calculatedDuration: c } = d;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = d;
  }
  updateTime(t) {
    const e = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = e;
  }
  tick(t, e = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: n, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: d = 0, keyframes: c, repeat: h, repeatType: p, repeatDelay: m, type: v, onUpdate: w, finalKeyframe: x } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), e ? this.currentTime = t : this.updateTime(t);
    const C = this.currentTime - d * (this.playbackSpeed >= 0 ? 1 : -1), $ = this.playbackSpeed >= 0 ? C < 0 : C > i;
    this.currentTime = Math.max(C, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let S = this.currentTime, T = r;
    if (h) {
      const y = Math.min(this.currentTime, i) / a;
      let V = Math.floor(y), D = y % 1;
      !D && y >= 1 && (D = 1), D === 1 && V--, V = Math.min(V, h + 1), !!(V % 2) && (p === "reverse" ? (D = 1 - D, m && (D -= m / a)) : p === "mirror" && (T = o)), S = he(0, 1, D) * a;
    }
    const k = $ ? { done: !1, value: c[0] } : T.next(S);
    n && (k.value = n(k.value));
    let { done: O } = k;
    !$ && l !== null && (O = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && O);
    return P && v !== dr && (k.value = on(c, this.options, x, this.speed)), w && w(k.value), P && this.finish(), k;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, e) {
    return this.finished.then(t, e);
  }
  get duration() {
    return /* @__PURE__ */ mt(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ mt(t);
  }
  get time() {
    return /* @__PURE__ */ mt(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Et(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver?.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(pt.now());
    const e = this.playbackSpeed !== t;
    this.playbackSpeed = t, e && (this.time = /* @__PURE__ */ mt(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = Ng, startTime: e } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), this.options.onPlay?.();
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = e ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(pt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
  }
}
function em(s) {
  for (let t = 1; t < s.length; t++)
    s[t] ?? (s[t] = s[t - 1]);
}
const re = (s) => s * 180 / Math.PI, hr = (s) => {
  const t = re(Math.atan2(s[1], s[0]));
  return ur(t);
}, sm = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (s) => (Math.abs(s[0]) + Math.abs(s[3])) / 2,
  rotate: hr,
  rotateZ: hr,
  skewX: (s) => re(Math.atan(s[1])),
  skewY: (s) => re(Math.atan(s[2])),
  skew: (s) => (Math.abs(s[1]) + Math.abs(s[2])) / 2
}, ur = (s) => (s = s % 360, s < 0 && (s += 360), s), Xo = hr, Jo = (s) => Math.sqrt(s[0] * s[0] + s[1] * s[1]), Qo = (s) => Math.sqrt(s[4] * s[4] + s[5] * s[5]), im = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Jo,
  scaleY: Qo,
  scale: (s) => (Jo(s) + Qo(s)) / 2,
  rotateX: (s) => ur(re(Math.atan2(s[6], s[5]))),
  rotateY: (s) => ur(re(Math.atan2(-s[2], s[0]))),
  rotateZ: Xo,
  rotate: Xo,
  skewX: (s) => re(Math.atan(s[4])),
  skewY: (s) => re(Math.atan(s[1])),
  skew: (s) => (Math.abs(s[1]) + Math.abs(s[4])) / 2
};
function pr(s) {
  return s.includes("scale") ? 1 : 0;
}
function fr(s, t) {
  if (!s || s === "none")
    return pr(t);
  const e = s.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (e)
    r = im, i = e;
  else {
    const a = s.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = sm, i = a;
  }
  if (!i)
    return pr(t);
  const n = r[t], o = i[1].split(",").map(nm);
  return typeof n == "function" ? n(o) : o[n];
}
const rm = (s, t) => {
  const { transform: e = "none" } = getComputedStyle(s);
  return fr(e, t);
};
function nm(s) {
  return parseFloat(s.trim());
}
const Xe = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Je = new Set(Xe), ta = (s) => s === Ge || s === I, om = /* @__PURE__ */ new Set(["x", "y", "z"]), am = Xe.filter((s) => !om.has(s));
function lm(s) {
  const t = [];
  return am.forEach((e) => {
    const r = s.getValue(e);
    r !== void 0 && (t.push([e, r.get()]), r.set(e.startsWith("scale") ? 1 : 0));
  }), t;
}
const ne = {
  // Dimensions
  width: ({ x: s }, { paddingLeft: t = "0", paddingRight: e = "0" }) => s.max - s.min - parseFloat(t) - parseFloat(e),
  height: ({ y: s }, { paddingTop: t = "0", paddingBottom: e = "0" }) => s.max - s.min - parseFloat(t) - parseFloat(e),
  top: (s, { top: t }) => parseFloat(t),
  left: (s, { left: t }) => parseFloat(t),
  bottom: ({ y: s }, { top: t }) => parseFloat(t) + (s.max - s.min),
  right: ({ x: s }, { left: t }) => parseFloat(t) + (s.max - s.min),
  // Transform
  x: (s, { transform: t }) => fr(t, "x"),
  y: (s, { transform: t }) => fr(t, "y")
};
ne.translateX = ne.x;
ne.translateY = ne.y;
const oe = /* @__PURE__ */ new Set();
let gr = !1, mr = !1, br = !1;
function uc() {
  if (mr) {
    const s = Array.from(oe).filter((r) => r.needsMeasurement), t = new Set(s.map((r) => r.element)), e = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = lm(r);
      i.length && (e.set(r, i), r.render());
    }), s.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = e.get(r);
      i && i.forEach(([n, o]) => {
        r.getValue(n)?.set(o);
      });
    }), s.forEach((r) => r.measureEndState()), s.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  mr = !1, gr = !1, oe.forEach((s) => s.complete(br)), oe.clear();
}
function pc() {
  oe.forEach((s) => {
    s.readKeyframes(), s.needsMeasurement && (mr = !0);
  });
}
function cm() {
  br = !0, pc(), uc(), br = !1;
}
class cn {
  constructor(t, e, r, i, n, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = e, this.name = r, this.motionValue = i, this.element = n, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (oe.add(this), gr || (gr = !0, Rt.read(pc), Rt.resolveKeyframes(uc))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: e, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const n = i?.get(), o = t[t.length - 1];
      if (n !== void 0)
        t[0] = n;
      else if (r && e) {
        const a = r.readValue(e, o);
        a != null && (t[0] = a);
      }
      t[0] === void 0 && (t[0] = o), i && n === void 0 && i.set(t[0]);
    }
    em(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), oe.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (oe.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const dm = (s) => s.startsWith("--");
function hm(s, t, e) {
  dm(t) ? s.style.setProperty(t, e) : s.style[t] = e;
}
const um = /* @__PURE__ */ Gr(() => window.ScrollTimeline !== void 0), pm = {};
function fm(s, t) {
  const e = /* @__PURE__ */ Gr(s);
  return () => pm[t] ?? e();
}
const fc = /* @__PURE__ */ fm(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), ls = ([s, t, e, r]) => `cubic-bezier(${s}, ${t}, ${e}, ${r})`, ea = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ ls([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ ls([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ ls([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ ls([0.33, 1.53, 0.69, 0.99])
};
function gc(s, t) {
  if (s)
    return typeof s == "function" ? fc() ? oc(s, t) : "ease-out" : Gl(s) ? ls(s) : Array.isArray(s) ? s.map((e) => gc(e, t) || ea.easeOut) : ea[s];
}
function gm(s, t, e, { delay: r = 0, duration: i = 300, repeat: n = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, d = void 0) {
  const c = {
    [t]: e
  };
  l && (c.offset = l);
  const h = gc(a, i);
  Array.isArray(h) && (c.easing = h);
  const p = {
    delay: r,
    duration: i,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: n + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return d && (p.pseudoElement = d), s.animate(c, p);
}
function dn(s) {
  return typeof s == "function" && "applyToOptions" in s;
}
function mm({ type: s, ...t }) {
  return dn(s) && fc() ? s.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class bm extends an {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: e, name: r, keyframes: i, pseudoElement: n, allowFlatten: o = !1, finalKeyframe: a, onComplete: l } = t;
    this.isPseudoElement = !!n, this.allowFlatten = o, this.options = t, Zr(typeof t.type != "string");
    const d = mm(t);
    this.animation = gm(e, r, i, d, n), d.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !n) {
        const c = on(i, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : hm(e, r, c), this.animation.cancel();
      }
      l?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    this.isPseudoElement || this.animation.commitStyles?.();
  }
  get duration() {
    const t = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ mt(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ mt(t);
  }
  get time() {
    return /* @__PURE__ */ mt(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Et(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: e }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, t && um() ? (this.animation.timeline = t, Ze) : e(this);
  }
}
const mc = {
  anticipate: Wl,
  backInOut: Fl,
  circInOut: Ul
};
function vm(s) {
  return s in mc;
}
function ym(s) {
  typeof s.ease == "string" && vm(s.ease) && (s.ease = mc[s.ease]);
}
const sa = 10;
class wm extends bm {
  constructor(t) {
    ym(t), hc(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: e, onUpdate: r, onComplete: i, element: n, ...o } = this.options;
    if (!e)
      return;
    if (t !== void 0) {
      e.set(t);
      return;
    }
    const a = new ln({
      ...o,
      autoplay: !1
    }), l = /* @__PURE__ */ Et(this.finishedTime ?? this.time);
    e.setWithVelocity(a.sample(l - sa).value, a.sample(l).value, sa), a.stop();
  }
}
const ia = (s, t) => t === "zIndex" ? !1 : !!(typeof s == "number" || Array.isArray(s) || typeof s == "string" && // It's animatable if we have a string
(Ye.test(s) || s === "0") && // And it contains numbers and/or colors
!s.startsWith("url("));
function xm(s) {
  const t = s[0];
  if (s.length === 1)
    return !0;
  for (let e = 0; e < s.length; e++)
    if (s[e] !== t)
      return !0;
}
function Cm(s, t, e, r) {
  const i = s[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const n = s[s.length - 1], o = ia(i, t), a = ia(n, t);
  return !o || !a ? !1 : xm(s) || (e === "spring" || dn(e)) && r;
}
function vr(s) {
  s.duration = 0, s.type = "keyframes";
}
const km = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), _m = /* @__PURE__ */ Gr(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Em(s) {
  const { motionValue: t, name: e, repeatDelay: r, repeatType: i, damping: n, type: o } = s;
  if (!(t?.owner?.current instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: d } = t.owner.getProps();
  return _m() && e && km.has(e) && (e !== "transform" || !d) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !r && i !== "mirror" && n !== 0 && o !== "inertia";
}
const Am = 40;
class Sm extends an {
  constructor({ autoplay: t = !0, delay: e = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: n = 0, repeatType: o = "loop", keyframes: a, name: l, motionValue: d, element: c, ...h }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = pt.now();
    const p = {
      autoplay: t,
      delay: e,
      type: r,
      repeat: i,
      repeatDelay: n,
      repeatType: o,
      name: l,
      motionValue: d,
      element: c,
      ...h
    }, m = c?.KeyframeResolver || cn;
    this.keyframeResolver = new m(a, (v, w, x) => this.onKeyframesResolved(v, w, p, !x), l, d, c), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(t, e, r, i) {
    this.keyframeResolver = void 0;
    const { name: n, type: o, velocity: a, delay: l, isHandoff: d, onUpdate: c } = r;
    this.resolvedAt = pt.now(), Cm(t, n, o, a) || ((Lt.instantAnimations || !l) && c?.(on(t, r, e)), t[0] = t[t.length - 1], vr(r), r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > Am ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: e,
      ...r,
      keyframes: t
    }, m = !d && Em(p) ? new wm({
      ...p,
      element: p.motionValue.owner.current
    }) : new ln(p);
    m.finished.then(() => this.notifyFinished()).catch(Ze), this.pendingTimeline && (this.stopTimeline = m.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = m;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, e) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), cm()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
class $m {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((t) => t.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, e) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = e;
  }
  attachTimeline(t) {
    const e = this.animations.map((r) => r.attachTimeline(t));
    return () => {
      e.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return ra(this.animations, "duration");
  }
  get iterationDuration() {
    return ra(this.animations, "iterationDuration");
  }
  runAll(t) {
    this.animations.forEach((e) => e[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function ra(s, t) {
  let e = 0;
  for (let r = 0; r < s.length; r++) {
    const i = s[r][t];
    i !== null && i > e && (e = i);
  }
  return e;
}
class Tm extends $m {
  then(t, e) {
    return this.finished.finally(t).then(() => {
    });
  }
}
const Om = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Im(s) {
  const t = Om.exec(s);
  if (!t)
    return [,];
  const [, e, r, i] = t;
  return [`--${e ?? r}`, i];
}
function bc(s, t, e = 1) {
  const [r, i] = Im(s);
  if (!r)
    return;
  const n = window.getComputedStyle(t).getPropertyValue(r);
  if (n) {
    const o = n.trim();
    return Ll(o) ? parseFloat(o) : o;
  }
  return tn(i) ? bc(i, t, e + 1) : i;
}
function vc(s, t) {
  return s?.[t] ?? s?.default ?? s;
}
const yc = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Xe
]), Vm = {
  test: (s) => s === "auto",
  parse: (s) => s
}, wc = (s) => (t) => t.test(s), xc = [Ge, I, Se, Nt, _g, kg, Vm], na = (s) => xc.find(wc(s));
function Pm(s) {
  return typeof s == "number" ? s === 0 : s !== null ? s === "none" || s === "0" || Rl(s) : !0;
}
const Mm = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Lm(s) {
  const [t, e] = s.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return s;
  const [r] = e.match(en) || [];
  if (!r)
    return s;
  const i = e.replace(r, "");
  let n = Mm.has(t) ? 1 : 0;
  return r !== e && (n *= 100), t + "(" + n + i + ")";
}
const Rm = /\b([a-z-]*)\(.*?\)/gu, yr = {
  ...Ye,
  getAnimatableNone: (s) => {
    const t = s.match(Rm);
    return t ? t.map(Lm).join(" ") : s;
  }
}, oa = {
  ...Ge,
  transform: Math.round
}, Hm = {
  rotate: Nt,
  rotateX: Nt,
  rotateY: Nt,
  rotateZ: Nt,
  scale: oi,
  scaleX: oi,
  scaleY: oi,
  scaleZ: oi,
  skew: Nt,
  skewX: Nt,
  skewY: Nt,
  distance: I,
  translateX: I,
  translateY: I,
  translateZ: I,
  x: I,
  y: I,
  z: I,
  perspective: I,
  transformPerspective: I,
  opacity: ks,
  originX: qo,
  originY: qo,
  originZ: I
}, hn = {
  // Border props
  borderWidth: I,
  borderTopWidth: I,
  borderRightWidth: I,
  borderBottomWidth: I,
  borderLeftWidth: I,
  borderRadius: I,
  radius: I,
  borderTopLeftRadius: I,
  borderTopRightRadius: I,
  borderBottomRightRadius: I,
  borderBottomLeftRadius: I,
  // Positioning props
  width: I,
  maxWidth: I,
  height: I,
  maxHeight: I,
  top: I,
  right: I,
  bottom: I,
  left: I,
  // Spacing props
  padding: I,
  paddingTop: I,
  paddingRight: I,
  paddingBottom: I,
  paddingLeft: I,
  margin: I,
  marginTop: I,
  marginRight: I,
  marginBottom: I,
  marginLeft: I,
  // Misc
  backgroundPositionX: I,
  backgroundPositionY: I,
  ...Hm,
  zIndex: oa,
  // SVG
  fillOpacity: ks,
  strokeOpacity: ks,
  numOctaves: oa
}, Dm = {
  ...hn,
  // Color props
  color: U,
  backgroundColor: U,
  outlineColor: U,
  fill: U,
  stroke: U,
  // Border props
  borderColor: U,
  borderTopColor: U,
  borderRightColor: U,
  borderBottomColor: U,
  borderLeftColor: U,
  filter: yr,
  WebkitFilter: yr
}, Cc = (s) => Dm[s];
function kc(s, t) {
  let e = Cc(s);
  return e !== yr && (e = Ye), e.getAnimatableNone ? e.getAnimatableNone(t) : void 0;
}
const zm = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function Nm(s, t, e) {
  let r = 0, i;
  for (; r < s.length && !i; ) {
    const n = s[r];
    typeof n == "string" && !zm.has(n) && _s(n).values.length && (i = s[r]), r++;
  }
  if (i && e)
    for (const n of t)
      s[n] = kc(e, i);
}
class Bm extends cn {
  constructor(t, e, r, i, n) {
    super(t, e, r, i, n, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: e, name: r } = this;
    if (!e || !e.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let d = t[l];
      if (typeof d == "string" && (d = d.trim(), tn(d))) {
        const c = bc(d, e.current);
        c !== void 0 && (t[l] = c), l === t.length - 1 && (this.finalKeyframe = d);
      }
    }
    if (this.resolveNoneKeyframes(), !yc.has(r) || t.length !== 2)
      return;
    const [i, n] = t, o = na(i), a = na(n);
    if (o !== a)
      if (ta(o) && ta(a))
        for (let l = 0; l < t.length; l++) {
          const d = t[l];
          typeof d == "string" && (t[l] = parseFloat(d));
        }
      else ne[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: e } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || Pm(t[i])) && r.push(i);
    r.length && Nm(t, r, e);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: e, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = ne[r](t.measureViewportBox(), window.getComputedStyle(t.current)), e[0] = this.measuredOrigin;
    const i = e[e.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    const { element: t, name: e, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(e);
    i && i.jump(this.measuredOrigin, !1);
    const n = r.length - 1, o = r[n];
    r[n] = ne[e](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), this.removedTransforms?.length && this.removedTransforms.forEach(([a, l]) => {
      t.getValue(a).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function jm(s, t, e) {
  if (s instanceof EventTarget)
    return [s];
  if (typeof s == "string") {
    let r = document;
    const i = e?.[s] ?? r.querySelectorAll(s);
    return i ? Array.from(i) : [];
  }
  return Array.from(s);
}
const _c = (s, t) => t && typeof s == "number" ? t.transform(s) : s, aa = 30, Fm = (s) => !isNaN(parseFloat(s));
class Wm {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, e = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      const i = pt.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const n of this.dependents)
          n.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = e.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = pt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = Fm(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return this.on("change", t);
  }
  on(t, e) {
    this.events[t] || (this.events[t] = new Hl());
    const r = this.events[t].add(e);
    return t === "change" ? () => {
      r(), Rt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, e) {
    this.passiveEffect = t, this.stopPassiveEffect = e;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, e, r) {
    this.set(e), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, e = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, e && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = pt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > aa)
      return 0;
    const e = Math.min(this.updatedAt - this.prevUpdatedAt, aa);
    return Dl(parseFloat(this.current) - parseFloat(this.prevFrameValue), e);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((e) => {
      this.hasAnimated = !0, this.animation = t(e), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Es(s, t) {
  return new Wm(s, t);
}
const { schedule: Um } = /* @__PURE__ */ Yl(queueMicrotask, !1);
function Ec(s) {
  return ig(s) && "ownerSVGElement" in s;
}
function qm(s) {
  return Ec(s) && s.tagName === "svg";
}
const tt = (s) => !!(s && s.getVelocity), Km = [...xc, U, Ye], Zm = (s) => Km.find(wc(s));
function un(s) {
  return typeof s == "object" && !Array.isArray(s);
}
function Ac(s, t, e, r) {
  return typeof s == "string" && un(t) ? jm(s, e, r) : s instanceof NodeList ? Array.from(s) : Array.isArray(s) ? s : [s];
}
function Gm(s, t, e) {
  return s * (t + 1);
}
function la(s, t, e, r) {
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, s + parseFloat(t)) : t === "<" ? e : t.startsWith("<") ? Math.max(0, e + parseFloat(t.slice(1))) : r.get(t) ?? s;
}
function Ym(s, t, e) {
  for (let r = 0; r < s.length; r++) {
    const i = s[r];
    i.at > t && i.at < e && (Ml(s, i), r--);
  }
}
function Xm(s, t, e, r, i, n) {
  Ym(s, i, n);
  for (let o = 0; o < t.length; o++)
    s.push({
      value: t[o],
      at: qs(i, n, r[o]),
      easing: Zl(e, o)
    });
}
function Jm(s, t) {
  for (let e = 0; e < s.length; e++)
    s[e] = s[e] / (t + 1);
}
function Qm(s, t) {
  return s.at === t.at ? s.value === null ? 1 : t.value === null ? -1 : 0 : s.at - t.at;
}
const tb = "easeInOut";
function eb(s, { defaultTransition: t = {}, ...e } = {}, r, i) {
  const n = t.duration || 0.3, o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = {}, d = /* @__PURE__ */ new Map();
  let c = 0, h = 0, p = 0;
  for (let m = 0; m < s.length; m++) {
    const v = s[m];
    if (typeof v == "string") {
      d.set(v, h);
      continue;
    } else if (!Array.isArray(v)) {
      d.set(v.name, la(h, v.at, c, d));
      continue;
    }
    let [w, x, C = {}] = v;
    C.at !== void 0 && (h = la(h, C.at, c, d));
    let $ = 0;
    const S = (T, k, O, P = 0, y = 0) => {
      const V = sb(T), { delay: D = 0, times: K = dc(V), type: et = "keyframes", repeat: ot, repeatType: ht, repeatDelay: gt = 0, ...Y } = k;
      let { ease: z = t.ease || "easeOut", duration: _ } = k;
      const st = typeof D == "function" ? D(P, y) : D, Jt = V.length, ns = dn(et) ? et : i?.[et || "keyframes"];
      if (Jt <= 2 && ns) {
        let Ct = 100;
        if (Jt === 2 && nb(V)) {
          const Dt = V[1] - V[0];
          Ct = Math.abs(Dt);
        }
        const Qt = { ...Y };
        _ !== void 0 && (Qt.duration = /* @__PURE__ */ Et(_));
        const B = ac(Qt, Ct, ns);
        z = B.ease, _ = B.duration;
      }
      _ ?? (_ = n);
      const we = h + st;
      K.length === 1 && K[0] === 0 && (K[1] = 1);
      const G = K.length - V.length;
      if (G > 0 && cc(K, G), V.length === 1 && V.unshift(null), ot) {
        _ = Gm(_, ot);
        const Ct = [...V], Qt = [...K];
        z = Array.isArray(z) ? [...z] : [z];
        const B = [...z];
        for (let Dt = 0; Dt < ot; Dt++) {
          V.push(...Ct);
          for (let kt = 0; kt < Ct.length; kt++)
            K.push(Qt[kt] + (Dt + 1)), z.push(kt === 0 ? "linear" : Zl(B, kt - 1));
        }
        Jm(K, ot);
      }
      const X = we + _;
      Xm(O, V, z, K, we, X), $ = Math.max(st + _, $), p = Math.max(X, p);
    };
    if (tt(w)) {
      const T = ca(w, a);
      S(x, C, da("default", T));
    } else {
      const T = Ac(w, x, r, l), k = T.length;
      for (let O = 0; O < k; O++) {
        x = x, C = C;
        const P = T[O], y = ca(P, a);
        for (const V in x)
          S(x[V], ib(C, V), da(V, y), O, k);
      }
    }
    c = h, h += $;
  }
  return a.forEach((m, v) => {
    for (const w in m) {
      const x = m[w];
      x.sort(Qm);
      const C = [], $ = [], S = [];
      for (let k = 0; k < x.length; k++) {
        const { at: O, value: P, easing: y } = x[k];
        C.push(P), $.push(/* @__PURE__ */ Xr(0, p, O)), S.push(y || "easeOut");
      }
      $[0] !== 0 && ($.unshift(0), C.unshift(C[0]), S.unshift(tb)), $[$.length - 1] !== 1 && ($.push(1), C.push(null)), o.has(v) || o.set(v, {
        keyframes: {},
        transition: {}
      });
      const T = o.get(v);
      T.keyframes[w] = C, T.transition[w] = {
        ...t,
        duration: p,
        ease: S,
        times: $,
        ...e
      };
    }
  }), o;
}
function ca(s, t) {
  return !t.has(s) && t.set(s, {}), t.get(s);
}
function da(s, t) {
  return t[s] || (t[s] = []), t[s];
}
function sb(s) {
  return Array.isArray(s) ? s : [s];
}
function ib(s, t) {
  return s && s[t] ? {
    ...s,
    ...s[t]
  } : { ...s };
}
const rb = (s) => typeof s == "number", nb = (s) => s.every(rb), As = /* @__PURE__ */ new WeakMap(), ob = (s) => Array.isArray(s);
function ha(s) {
  const t = [{}, {}];
  return s?.values.forEach((e, r) => {
    t[0][r] = e.get(), t[1][r] = e.getVelocity();
  }), t;
}
function Sc(s, t, e, r) {
  if (typeof t == "function") {
    const [i, n] = ha(r);
    t = t(e !== void 0 ? e : s.custom, i, n);
  }
  if (typeof t == "string" && (t = s.variants && s.variants[t]), typeof t == "function") {
    const [i, n] = ha(r);
    t = t(e !== void 0 ? e : s.custom, i, n);
  }
  return t;
}
function ab(s, t, e) {
  const r = s.getProps();
  return Sc(r, t, r.custom, s);
}
function lb(s, t, e) {
  s.hasValue(t) ? s.getValue(t).set(e) : s.addValue(t, Es(e));
}
function cb(s) {
  return ob(s) ? s[s.length - 1] || 0 : s;
}
function db(s, t) {
  const e = ab(s, t);
  let { transitionEnd: r = {}, transition: i = {}, ...n } = e || {};
  n = { ...n, ...r };
  for (const o in n) {
    const a = cb(n[o]);
    lb(s, o, a);
  }
}
function hb(s) {
  return !!(tt(s) && s.add);
}
function ub(s, t) {
  const e = s.getValue("willChange");
  if (hb(e))
    return e.add(t);
  if (!e && Lt.WillChange) {
    const r = new Lt.WillChange("auto");
    s.addValue("willChange", r), r.add(t);
  }
}
const pn = (s) => s.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), pb = "framerAppearId", fb = "data-" + pn(pb);
function gb(s) {
  return s.props[fb];
}
const mb = (s) => s !== null;
function bb(s, { repeat: t, repeatType: e = "loop" }, r) {
  const i = s.filter(mb), n = t && e !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return i[n];
}
const vb = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, yb = (s) => ({
  type: "spring",
  stiffness: 550,
  damping: s === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), wb = {
  type: "keyframes",
  duration: 0.8
}, xb = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Cb = (s, { keyframes: t }) => t.length > 2 ? wb : Je.has(s) ? s.startsWith("scale") ? yb(t[1]) : vb : xb;
function kb({ when: s, delay: t, delayChildren: e, staggerChildren: r, staggerDirection: i, repeat: n, repeatType: o, repeatDelay: a, from: l, elapsed: d, ...c }) {
  return !!Object.keys(c).length;
}
const $c = (s, t, e, r = {}, i, n) => (o) => {
  const a = vc(r, s) || {}, l = a.delay || r.delay || 0;
  let { elapsed: d = 0 } = r;
  d = d - /* @__PURE__ */ Et(l);
  const c = {
    keyframes: Array.isArray(e) ? e : [null, e],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -d,
    onUpdate: (p) => {
      t.set(p), a.onUpdate && a.onUpdate(p);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: s,
    motionValue: t,
    element: n ? void 0 : i
  };
  kb(a) || Object.assign(c, Cb(s, c)), c.duration && (c.duration = /* @__PURE__ */ Et(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ Et(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let h = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (vr(c), c.delay === 0 && (h = !0)), (Lt.instantAnimations || Lt.skipAnimations) && (h = !0, vr(c), c.delay = 0), c.allowFlatten = !a.type && !a.ease, h && !n && t.get() !== void 0) {
    const p = bb(c.keyframes, a);
    if (p !== void 0) {
      Rt.update(() => {
        c.onUpdate(p), c.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new ln(c) : new Sm(c);
};
function _b({ protectedKeys: s, needsAnimating: t }, e) {
  const r = s.hasOwnProperty(e) && t[e] !== !0;
  return t[e] = !1, r;
}
function Eb(s, t, { delay: e = 0, transitionOverride: r, type: i } = {}) {
  let { transition: n = s.getDefaultTransition(), transitionEnd: o, ...a } = t;
  r && (n = r);
  const l = [], d = i && s.animationState && s.animationState.getState()[i];
  for (const c in a) {
    const h = s.getValue(c, s.latestValues[c] ?? null), p = a[c];
    if (p === void 0 || d && _b(d, c))
      continue;
    const m = {
      delay: e,
      ...vc(n || {}, c)
    }, v = h.get();
    if (v !== void 0 && !h.isAnimating && !Array.isArray(p) && p === v && !m.velocity)
      continue;
    let w = !1;
    if (window.MotionHandoffAnimation) {
      const C = gb(s);
      if (C) {
        const $ = window.MotionHandoffAnimation(C, c, Rt);
        $ !== null && (m.startTime = $, w = !0);
      }
    }
    ub(s, c), h.start($c(c, h, p, s.shouldReduceMotion && yc.has(c) ? { type: !1 } : m, s, w));
    const x = h.animation;
    x && l.push(x);
  }
  return o && Promise.all(l).then(() => {
    Rt.update(() => {
      o && db(s, o);
    });
  }), l;
}
function Ab({ top: s, left: t, right: e, bottom: r }) {
  return {
    x: { min: t, max: e },
    y: { min: s, max: r }
  };
}
function Sb(s, t) {
  if (!t)
    return s;
  const e = t({ x: s.left, y: s.top }), r = t({ x: s.right, y: s.bottom });
  return {
    top: e.y,
    left: e.x,
    bottom: r.y,
    right: r.x
  };
}
function $b(s, t) {
  return Ab(Sb(s.getBoundingClientRect(), t));
}
const ua = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, wr = {};
for (const s in ua)
  wr[s] = {
    isEnabled: (t) => ua[s].some((e) => !!t[e])
  };
const pa = () => ({ min: 0, max: 0 }), fn = () => ({
  x: pa(),
  y: pa()
}), Tb = typeof window < "u", xr = { current: null }, Tc = { current: !1 };
function Ob() {
  if (Tc.current = !0, !!Tb)
    if (window.matchMedia) {
      const s = window.matchMedia("(prefers-reduced-motion)"), t = () => xr.current = s.matches;
      s.addEventListener("change", t), t();
    } else
      xr.current = !1;
}
function Ib(s) {
  return s !== null && typeof s == "object" && typeof s.start == "function";
}
function Vb(s) {
  return typeof s == "string" || Array.isArray(s);
}
const Pb = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Mb = ["initial", ...Pb];
function Oc(s) {
  return Ib(s.animate) || Mb.some((t) => Vb(s[t]));
}
function Lb(s) {
  return !!(Oc(s) || s.variants);
}
function Rb(s, t, e) {
  for (const r in t) {
    const i = t[r], n = e[r];
    if (tt(i))
      s.addValue(r, i);
    else if (tt(n))
      s.addValue(r, Es(i, { owner: s }));
    else if (n !== i)
      if (s.hasValue(r)) {
        const o = s.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = s.getStaticValue(r);
        s.addValue(r, Es(o !== void 0 ? o : i, { owner: s }));
      }
  }
  for (const r in e)
    t[r] === void 0 && s.removeValue(r);
  return t;
}
const fa = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Ic {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, e, r) {
    return {};
  }
  constructor({ parent: t, props: e, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: n, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = cn, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = pt.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Rt.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: d } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = e.initial ? { ...l } : {}, this.renderState = d, this.parent = t, this.props = e, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!n, this.isControllingVariants = Oc(e), this.isVariantNode = Lb(e), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: c, ...h } = this.scrapeMotionValuesFromProps(e, {}, this);
    for (const p in h) {
      const m = h[p];
      l[p] !== void 0 && tt(m) && m.set(l[p]);
    }
  }
  mount(t) {
    this.current = t, As.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((e, r) => this.bindToMotionValue(r, e)), Tc.current || Ob(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : xr.current, this.parent?.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), or(this.notifyUpdate), or(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const e = this.features[t];
      e && (e.unmount(), e.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, e) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Je.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = e.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && Rt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let n;
    window.MotionCheckAppearSync && (n = window.MotionCheckAppearSync(this, t, e)), this.valueSubscriptions.set(t, () => {
      i(), n && n(), e.owner && e.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in wr) {
      const e = wr[t];
      if (!e)
        continue;
      const { isEnabled: r, Feature: i } = e;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const n = this.features[t];
        n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : fn();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, e) {
    this.latestValues[t] = e;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, e) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = e;
    for (let r = 0; r < fa.length; r++) {
      const i = fa[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const n = "on" + i, o = t[n];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = Rb(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const e = this.getClosestVariantNode();
    if (e)
      return e.variantChildren && e.variantChildren.add(t), () => e.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, e) {
    const r = this.values.get(t);
    e !== r && (r && this.removeValue(t), this.bindToMotionValue(t, e), this.values.set(t, e), this.latestValues[t] = e.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const e = this.valueSubscriptions.get(t);
    e && (e(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, e) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && e !== void 0 && (r = Es(e === null ? void 0 : e, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, e) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (Ll(r) || Rl(r)) ? r = parseFloat(r) : !Zm(r) && Ye.test(e) && (r = kc(t, e)), this.setBaseTarget(t, tt(r) ? r.get() : r)), tt(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, e) {
    this.baseTarget[t] = e;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    const { initial: e } = this.props;
    let r;
    if (typeof e == "string" || typeof e == "object") {
      const n = Sc(this.props, e, this.presenceContext?.custom);
      n && (r = n[t]);
    }
    if (e && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !tt(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, e) {
    return this.events[t] || (this.events[t] = new Hl()), this.events[t].add(e);
  }
  notify(t, ...e) {
    this.events[t] && this.events[t].notify(...e);
  }
  scheduleRenderMicrotask() {
    Um.render(this.render);
  }
}
class Vc extends Ic {
  constructor() {
    super(...arguments), this.KeyframeResolver = Bm;
  }
  sortInstanceNodePosition(t, e) {
    return t.compareDocumentPosition(e) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, e) {
    return t.style ? t.style[e] : void 0;
  }
  removeValueFromRenderState(t, { vars: e, style: r }) {
    delete e[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    tt(t) && (this.childSubscription = t.on("change", (e) => {
      this.current && (this.current.textContent = `${e}`);
    }));
  }
}
const Hb = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Db = Xe.length;
function zb(s, t, e) {
  let r = "", i = !0;
  for (let n = 0; n < Db; n++) {
    const o = Xe[n], a = s[o];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || e) {
      const d = _c(a, hn[o]);
      if (!l) {
        i = !1;
        const c = Hb[o] || o;
        r += `${c}(${d}) `;
      }
      e && (t[o] = d);
    }
  }
  return r = r.trim(), e ? r = e(t, i ? "" : r) : i && (r = "none"), r;
}
function Pc(s, t, e) {
  const { style: r, vars: i, transformOrigin: n } = s;
  let o = !1, a = !1;
  for (const l in t) {
    const d = t[l];
    if (Je.has(l)) {
      o = !0;
      continue;
    } else if (Jl(l)) {
      i[l] = d;
      continue;
    } else {
      const c = _c(d, hn[l]);
      l.startsWith("origin") ? (a = !0, n[l] = c) : r[l] = c;
    }
  }
  if (t.transform || (o || e ? r.transform = zb(t, s.transform, e) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: d = "50%", originZ: c = 0 } = n;
    r.transformOrigin = `${l} ${d} ${c}`;
  }
}
function Mc(s, { style: t, vars: e }, r, i) {
  const n = s.style;
  let o;
  for (o in t)
    n[o] = t[o];
  i?.applyProjectionStyles(n, r);
  for (o in e)
    n.setProperty(o, e[o]);
}
const Nb = {};
function Bb(s, { layout: t, layoutId: e }) {
  return Je.has(s) || s.startsWith("origin") || (t || e !== void 0) && (!!Nb[s] || s === "opacity");
}
function Lc(s, t, e) {
  const { style: r } = s, i = {};
  for (const n in r)
    (tt(r[n]) || t.style && tt(t.style[n]) || Bb(n, s) || e?.getValue(n)?.liveStyle !== void 0) && (i[n] = r[n]);
  return i;
}
function jb(s) {
  return window.getComputedStyle(s);
}
class Fb extends Vc {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Mc;
  }
  readValueFromInstance(t, e) {
    if (Je.has(e))
      return this.projection?.isProjecting ? pr(e) : rm(t, e);
    {
      const r = jb(t), i = (Jl(e) ? r.getPropertyValue(e) : r[e]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: e }) {
    return $b(t, e);
  }
  build(t, e, r) {
    Pc(t, e, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, e, r) {
    return Lc(t, e, r);
  }
}
function Wb(s, t) {
  return s in t;
}
class Ub extends Ic {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(t, e) {
    if (Wb(e, t)) {
      const r = t[e];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(t, e) {
    delete e.output[t];
  }
  measureInstanceViewportBox() {
    return fn();
  }
  build(t, e) {
    Object.assign(t.output, e);
  }
  renderInstance(t, { output: e }) {
    Object.assign(t, e);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
const qb = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Kb = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Zb(s, t, e = 1, r = 0, i = !0) {
  s.pathLength = 1;
  const n = i ? qb : Kb;
  s[n.offset] = I.transform(-r);
  const o = I.transform(t), a = I.transform(e);
  s[n.array] = `${o} ${a}`;
}
function Gb(s, {
  attrX: t,
  attrY: e,
  attrScale: r,
  pathLength: i,
  pathSpacing: n = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, d, c) {
  if (Pc(s, a, d), l) {
    s.style.viewBox && (s.attrs.viewBox = s.style.viewBox);
    return;
  }
  s.attrs = s.style, s.style = {};
  const { attrs: h, style: p } = s;
  h.transform && (p.transform = h.transform, delete h.transform), (p.transform || h.transformOrigin) && (p.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), p.transform && (p.transformBox = c?.transformBox ?? "fill-box", delete h.transformBox), t !== void 0 && (h.x = t), e !== void 0 && (h.y = e), r !== void 0 && (h.scale = r), i !== void 0 && Zb(h, i, n, o, !1);
}
const Rc = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), Yb = (s) => typeof s == "string" && s.toLowerCase() === "svg";
function Xb(s, t, e, r) {
  Mc(s, t, void 0, r);
  for (const i in t.attrs)
    s.setAttribute(Rc.has(i) ? i : pn(i), t.attrs[i]);
}
function Jb(s, t, e) {
  const r = Lc(s, t, e);
  for (const i in s)
    if (tt(s[i]) || tt(t[i])) {
      const n = Xe.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[n] = s[i];
    }
  return r;
}
class Qb extends Vc {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = fn;
  }
  getBaseTargetFromProps(t, e) {
    return t[e];
  }
  readValueFromInstance(t, e) {
    if (Je.has(e)) {
      const r = Cc(e);
      return r && r.default || 0;
    }
    return e = Rc.has(e) ? e : pn(e), t.getAttribute(e);
  }
  scrapeMotionValuesFromProps(t, e, r) {
    return Jb(t, e, r);
  }
  build(t, e, r) {
    Gb(t, e, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, e, r, i) {
    Xb(t, e, r, i);
  }
  mount(t) {
    this.isSVGTag = Yb(t.tagName), super.mount(t);
  }
}
function tv(s) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, e = Ec(s) && !qm(s) ? new Qb(t) : new Fb(t);
  e.mount(s), As.set(s, e);
}
function ev(s) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, e = new Ub(t);
  e.mount(s), As.set(s, e);
}
function sv(s, t, e) {
  const r = tt(s) ? s : Es(s);
  return r.start($c("", r, t, e)), r.animation;
}
function iv(s, t) {
  return tt(s) || typeof s == "number" || typeof s == "string" && !un(t);
}
function Hc(s, t, e, r) {
  const i = [];
  if (iv(s, t))
    i.push(sv(s, un(t) && t.default || t, e && (e.default || e)));
  else {
    const n = Ac(s, t, r), o = n.length;
    for (let a = 0; a < o; a++) {
      const l = n[a], d = l instanceof Element ? tv : ev;
      As.has(l) || d(l);
      const c = As.get(l), h = { ...e };
      "delay" in h && typeof h.delay == "function" && (h.delay = h.delay(a, o)), i.push(...Eb(c, { ...t, transition: h }, {}));
    }
  }
  return i;
}
function rv(s, t, e) {
  const r = [];
  return eb(s, t, e, { spring: Pe }).forEach(({ keyframes: n, transition: o }, a) => {
    r.push(...Hc(a, n, o));
  }), r;
}
function nv(s) {
  return Array.isArray(s) && s.some(Array.isArray);
}
function ov(s) {
  function t(e, r, i) {
    let n = [], o;
    if (nv(e))
      n = rv(e, r, s);
    else {
      const { onComplete: l, ...d } = i || {};
      typeof l == "function" && (o = l), n = Hc(e, r, d, s);
    }
    const a = new Tm(n);
    return o && a.finished.then(o), a;
  }
  return t;
}
const ga = ov();
var av = Object.defineProperty, lv = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && av(t, e, i), i;
};
class Dc extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "overflow-hidden", this.transition = {
      type: Pe,
      bounce: 0,
      visualDuration: 0.15
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.contentElement = this, this._syncHostClasses(), requestAnimationFrame(() => {
      this.contextValue?.id && this.setAttribute("id", `${this.contextValue.id}-Disclosure-content`), this.contextValue?.open ? (this.style.display = "block", this.setAttribute("data-open", "true")) : (this.style.display = "none", this.style.height = "0px", this.style.overflow = "hidden"), this._updateVisibility();
    });
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this.contentElement = this, this._syncHostClasses(), this._updateVisibility();
  }
  updated() {
    this._updateVisibility(), this._syncHostClasses();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.animation && "stop" in this.animation && typeof this.animation.stop == "function" && this.animation.stop();
  }
  _syncHostClasses() {
    this.className = g(this.baseClasses, this.originalCustomClass);
  }
  _updateVisibility() {
    if (!this.contentElement) return;
    const t = this.contextValue?.open === !0;
    this.animation && "stop" in this.animation && typeof this.animation.stop == "function" && this.animation.stop(), t ? this._show() : this._hide();
  }
  _show() {
    if (!this.contentElement) return;
    this.style.display = "block", this.setAttribute("data-open", "true"), this.style.overflow = "hidden";
    const t = this.contentElement.scrollHeight;
    this.animation = ga(
      this.contentElement,
      { height: ["0px", `${t}px`] },
      this.transition
    ), this.animation && "then" in this.animation && this.animation.then(() => {
      this.style.height = "auto", this.style.overflow = "";
    });
  }
  _hide() {
    if (!this.contentElement) return;
    const t = this.contentElement.scrollHeight;
    this.style.height = `${t}px`, this.style.overflow = "hidden", this.animation = ga(
      this.contentElement,
      { height: [`${t}px`, "0px"] },
      this.transition
    ), this.animation && "then" in this.animation && this.animation.then(() => {
      this.style.height = "", this.style.overflow = "", this.style.display = "none", this.removeAttribute("data-open");
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
lv([
  L({ context: Mi, subscribe: !0 })
], Dc.prototype, "contextValue");
customElements.get("ck-disclosure-content") || customElements.define("ck-disclosure-content", Dc);
var cv = Object.defineProperty, dv = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && cv(t, e, i), i;
};
class zc extends b {
  constructor() {
    super(...arguments), this.open = null, this._provider = new ft(this, {
      context: Vl,
      initialValue: {
        open: null,
        setOpen: () => {
        }
      }
    });
  }
  connectedCallback() {
    super.connectedCallback(), this._updateContext();
  }
  updated() {
    this._updateContext();
  }
  _updateContext() {
    this._provider.setValue({
      open: this.open,
      setOpen: (t) => {
        this.open = t, this._updateContext();
      }
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
dv([
  R()
], zc.prototype, "open");
customElements.get("ck-disclosure-group") || customElements.define("ck-disclosure-group", zc);
var hv = Object.defineProperty, Nc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && hv(t, e, i), i;
};
const ma = /* @__PURE__ */ new Set(["class", "as-child"]), Gn = class Gn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.hasElementChild = !1, this.baseClasses = "ring-ring cursor-pointer flex w-full items-center justify-between text-left outline-none focus-visible:ring-4", this._handleClick = (t) => {
      const e = this.onClick;
      typeof e == "function" && e(t), !t.defaultPrevented && this.contextValue && this.contextValue.setOpen(!this.contextValue.open);
    };
  }
  _isAsChildActive() {
    return this.asChild && this.hasElementChild;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._updateHasElementChild(), this._syncHostClasses(), this._syncChildObserver(), this._updateClickHandler();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._updateHasElementChild(), this._syncHostClasses(), this._syncChildObserver(), this._isAsChildActive() ? this._updateElement() : (this.buttonElement = this.shadowRoot?.querySelector("button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._updateHasElementChild(), t.has("asChild") && this._syncChildObserver(), this._updateClickHandler(), this._syncHostClasses(), this._isAsChildActive() ? this._updateElement() : (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick), this.childObserver?.disconnect(), this.childObserver = void 0;
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this._isAsChildActive() && this.addEventListener("click", this._handleClick);
  }
  _updateHasElementChild() {
    this.hasElementChild = !!this.firstElementChild, this.toggleAttribute("data-has-element-child", this.hasElementChild);
  }
  _syncChildObserver() {
    if (!this.asChild) {
      this.childObserver?.disconnect(), this.childObserver = void 0;
      return;
    }
    this.childObserver || (this.childObserver = new MutationObserver(() => {
      const t = this.hasElementChild;
      this._updateHasElementChild(), t !== this.hasElementChild && (this._updateClickHandler(), this._syncHostClasses(), this._isAsChildActive() && this._updateElement(), this.requestUpdate());
    }), this.childObserver.observe(this, { childList: !0 }));
  }
  _syncHostClasses() {
    if (this.asChild) {
      this.className = this.originalCustomClass || "";
      return;
    }
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _getContentClasses() {
    const t = this.originalCustomClass || this.getAttribute("class") || "";
    return g(this.baseClasses, t);
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes)
        ma.has(t.name) || this.buttonElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  _updateElement() {
    if (this._isAsChildActive()) {
      const t = this.firstElementChild;
      t && (Zt(this.asChild, t, {
        className: this._getContentClasses(),
        type: "button",
        "aria-expanded": this.contextValue?.open ? "true" : "false",
        "aria-controls": this.contextValue?.open ? `${this.contextValue.id}-Disclosure-content` : void 0,
        "data-open": this.contextValue?.open ? "true" : ""
      }), this._syncChildAttributes(t), this._syncChildEventHandlers(t));
    }
  }
  _syncChildAttributes(t) {
    for (const e of this.attributes)
      ma.has(e.name) || t.setAttribute(e.name, e.value);
  }
  _syncChildEventHandlers(t) {
    q(this, t, [
      "onClick"
    ]);
  }
  render() {
    return this._isAsChildActive() ? f`<slot></slot>` : f`
      <button
        type="button"
        class="${this._getContentClasses()}"
        aria-expanded="${this.contextValue?.open ? "true" : "false"}"
        aria-controls="${this.contextValue?.open ? `${this.contextValue.id}-Disclosure-content` : ""}"
        data-open="${this.contextValue?.open ? "true" : ""}"
        @click=${this._handleClick}
      >
        <slot></slot>
      </button>
    `;
  }
};
Gn.styles = [
  ...b.styles,
  N`
      /**
       * Safari has longstanding rendering bugs with "display: contents" on custom elements.
       * In particular, slotted *text nodes* can disappear when the host is "display: contents".
       *
       * We only opt into "display: contents" when there is an actual element child to "be" the trigger.
       * If there's no element child (only text nodes), we fall back to rendering our internal <button>.
       */
      :host([as-child][data-has-element-child]) {
        display: contents;
      }
    `
];
let Ss = Gn;
Nc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Ss.prototype, "asChild");
Nc([
  L({ context: Mi, subscribe: !0 })
], Ss.prototype, "contextValue");
customElements.get("ck-disclosure-trigger") || customElements.define("ck-disclosure-trigger", Ss);
const gn = "ck-dropdown-context";
var uv = Object.defineProperty, mn = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && uv(t, e, i), i;
};
class Ri extends b {
  constructor() {
    super(...arguments), this._provider = new ft(this, {
      context: gn,
      initialValue: this._computeContextValue()
    }), this._elementsRef = [], this.highlightedIndex = null, this.searchInputRef = null, this.items = {}, this._setHighlightedIndex = (t) => {
      this.highlightedIndex = t, this._updateContext();
    }, this._setSearchInputRef = (t) => {
      this.searchInputRef = t, this._updateContext();
    }, this._registerItem = (t) => (this.items = {
      ...this.items,
      [t.id]: t
    }, this._updateContext(), () => {
      const e = { ...this.items };
      delete e[t.id], this.items = e, this._updateContext();
    }), this._setElementAtIndex = (t, e) => {
      this._elementsRef[t] = e;
    }, this._handleItemClick = (t, e) => {
      if (t == null) return;
      const i = this._elementsRef[t]?.dataset.itemId;
      if (!i) return;
      const n = this.items[i];
      n && n.onSelect && n.onSelect(e), this.dispatchEvent(
        new CustomEvent("ck-dropdown-select", {
          detail: { id: i, item: n },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._handleItemEnterKey = (t, e) => {
      t != null && this._handleItemClick(t, e);
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateContext();
  }
  _computeContextValue() {
    return {
      elementsRef: this._elementsRef,
      labelsRef: this.items ? Object.values(this.items).map((t) => t.label) : [],
      highlightedIndex: this.highlightedIndex,
      setHighlightedIndex: this._setHighlightedIndex,
      searchInputRef: this.searchInputRef,
      setSearchInputRef: this._setSearchInputRef,
      items: this.items,
      registerItem: this._registerItem,
      handleItemClick: this._handleItemClick,
      handleItemEnterKey: this._handleItemEnterKey,
      setElementAtIndex: this._setElementAtIndex
    };
  }
  _updateContext() {
    this._provider.setValue(this._computeContextValue());
  }
  updated() {
    this._updateContext();
  }
  render() {
    return f`<slot></slot>`;
  }
}
mn([
  R()
], Ri.prototype, "highlightedIndex");
mn([
  R()
], Ri.prototype, "searchInputRef");
mn([
  R()
], Ri.prototype, "items");
customElements.get("ck-dropdown") || customElements.define("ck-dropdown", Ri);
var pv = Object.defineProperty, fv = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && pv(t, e, i), i;
};
class Bc extends b {
  constructor() {
    super(...arguments), this.decorative = !1;
  }
  render() {
    return f`<ck-divider decorative="${this.decorative}"></ck-divider>`;
  }
}
fv([
  u({ type: Boolean })
], Bc.prototype, "decorative");
customElements.get("ck-dropdown-divider") || customElements.define("ck-dropdown-divider", Bc);
class gv extends b {
  render() {
    return f`<ck-popover-empty><slot></slot></ck-popover-empty>`;
  }
}
customElements.get("ck-dropdown-empty") || customElements.define("ck-dropdown-empty", gv);
var mv = Object.defineProperty, Hi = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && mv(t, e, i), i;
};
let bv = 0;
class Ks extends b {
  constructor() {
    super(...arguments), this.disabled = !1, this._index = null, this._id = `ck-dropdown-item-${++bv}`;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated() {
    const t = this.buttonEl?.textContent?.trim() ?? "";
    t && (this._unregister = this.ctx.registerItem({
      id: this._id,
      label: t,
      onSelect: (e) => {
        this.onSelect?.(e);
      }
    }), this._updateIndexFromDom());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._unregister?.();
  }
  _updateIndexFromDom() {
    const t = this.closest('[role="menu"], ck-dropdown-items, ck-popover-content') ?? this.parentElement;
    if (!t) return;
    const e = Array.from(t.querySelectorAll("ck-dropdown-item"));
    this._index = e.indexOf(this), this._index >= 0 && this.buttonEl && this.ctx.setElementAtIndex(this._index, this.buttonEl);
  }
  _isHighlighted() {
    return this._index == null ? !1 : this.ctx.highlightedIndex === this._index;
  }
  _handleMouseEnter() {
    this._index != null && this.ctx.setHighlightedIndex(this._index);
  }
  _handleClick(t) {
    if (this.disabled) {
      t.preventDefault();
      return;
    }
    this.ctx.handleItemClick(this._index, t);
  }
  _handleKeyDown(t) {
    if (t.key === "Enter") {
      t.preventDefault(), this.ctx.handleItemEnterKey(this._index, t);
      return;
    }
    this.ctx.searchInputRef && t.key.length === 1 && this.ctx.searchInputRef.focus();
  }
  _classes() {
    const t = this.getAttribute("class") ?? "", e = this._isHighlighted();
    return g(
      "data-highlighted:bg-background-low text-foreground/80",
      "relative mx-1 flex w-[calc(100%-calc(var(--spacing)*2))] cursor-pointer select-none items-center gap-1.5 rounded-lg px-3 py-1.5 text-base font-medium outline-none",
      "hover:bg-background-low transition-colors",
      "first-of-type:mt-1 last-of-type:mb-1",
      "data-disabled:pointer-events-none data-disabled:opacity-50",
      t,
      e && "bg-background-low",
      this.disabled && "pointer-events-none opacity-50"
    );
  }
  render() {
    const t = this._isHighlighted();
    return f`
      <button
        data-item-id=${this._id}
        role="menuitem"
        class="${this._classes()}"
        ?disabled=${this.disabled}
        ?data-disabled=${this.disabled}
        ?data-highlighted=${t}
        tabindex=${t ? 0 : -1}
        @mouseenter=${this._handleMouseEnter}
        @click=${this._handleClick}
        @keydown=${this._handleKeyDown}
      >
        <slot></slot>
      </button>
    `;
  }
}
Hi([
  u({ type: Boolean })
], Ks.prototype, "disabled");
Hi([
  u({ attribute: !1 })
], Ks.prototype, "onSelect");
Hi([
  L({ context: gn, subscribe: !0 })
], Ks.prototype, "ctx");
Hi([
  Kt("button")
], Ks.prototype, "buttonEl");
customElements.get("ck-dropdown-item") || customElements.define("ck-dropdown-item", Ks);
class vv extends b {
  createRenderRoot() {
    return this;
  }
  _classes() {
    const t = this.getAttribute("class") ?? "";
    return g("p-0", t);
  }
  firstUpdated() {
    this.popoverContentElement = document.createElement("ck-popover-content"), this.popoverContentElement.className = this._classes(), this.wrapperElement = document.createElement("div"), Array.from(this.childNodes).forEach((e) => {
      this.wrapperElement.appendChild(e);
    }), this.popoverContentElement.appendChild(this.wrapperElement), this.appendChild(this.popoverContentElement);
  }
  updated() {
    this.wrapperElement && Array.from(this.childNodes).forEach((e) => {
      e !== this.popoverContentElement && e.nodeType === Node.ELEMENT_NODE && this.wrapperElement.appendChild(e);
    }), this.popoverContentElement && (this.popoverContentElement.className = this._classes());
  }
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-dropdown-items") || customElements.define("ck-dropdown-items", vv);
var yv = Object.defineProperty, jc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && yv(t, e, i), i;
};
const wv = /* @__PURE__ */ new Set(["class", "placeholder"]);
class bn extends b {
  constructor() {
    super(...arguments), this.placeholder = "", this._onChange = (t) => {
      const e = this.onInput;
      typeof e == "function" && e(t), !t.defaultPrevented && (this.ctx.setHighlightedIndex(0), this.dispatchEvent(new Event("input", { bubbles: !0, composed: !0 })));
    };
  }
  createRenderRoot() {
    return this;
  }
  firstUpdated() {
    this.popoverSearchInput = this.querySelector("ck-popover-search-input"), this.syncAttributes(), this.syncEventHandlers();
    const t = this.popoverSearchInput?.querySelector("input");
    t && this.ctx.setSearchInputRef(t);
  }
  updated(t) {
    super.updated(t), this.syncAttributes(), this.syncEventHandlers();
  }
  syncAttributes() {
    if (this.popoverSearchInput)
      for (const t of this.attributes)
        wv.has(t.name) || this.popoverSearchInput.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.popoverSearchInput && q(this, this.popoverSearchInput, [
      "onInput",
      "onKeyDown"
    ]);
  }
  _onKeyDown(t) {
    const e = this.onKeyDown;
    if (typeof e == "function" && e(t), !t.defaultPrevented && t.key === "Enter" && this.ctx.highlightedIndex !== null) {
      const r = this.ctx.elementsRef[this.ctx.highlightedIndex]?.dataset.itemId;
      r && this.ctx.items[r] && this.ctx.items[r].onSelect?.(t);
    }
  }
  render() {
    return f`
      <ck-popover-search-input
        placeholder=${this.placeholder}
        @input=${this._onChange}
        @keydown=${this._onKeyDown}
      ></ck-popover-search-input>
    `;
  }
}
jc([
  L({ context: gn, subscribe: !0 })
], bn.prototype, "ctx");
jc([
  u({ type: String })
], bn.prototype, "placeholder");
customElements.get("ck-dropdown-search-input") || customElements.define("ck-dropdown-search-input", bn);
var xv = Object.defineProperty, vn = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && xv(t, e, i), i;
};
const Fc = "ck-dropdown-section-title";
class Wc extends b {
  constructor() {
    super(...arguments), this._setTitleId = (t) => {
      this._titleId = t, this._updateWrapper();
    };
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this._updateWrapper();
  }
  firstUpdated() {
    this.wrapperElement = document.createElement("div"), Array.from(this.childNodes).forEach((e) => {
      this.wrapperElement.appendChild(e);
    }), this.appendChild(this.wrapperElement), this._updateWrapper();
  }
  updated() {
    this.wrapperElement && Array.from(this.childNodes).forEach((e) => {
      e !== this.wrapperElement && e.nodeType === Node.ELEMENT_NODE && this.wrapperElement.appendChild(e);
    }), this._updateWrapper();
  }
  _updateWrapper() {
    if (!this.wrapperElement) return;
    const t = this.getAttribute("class") ?? "", r = this._isFirstSection() ? "" : "border-t border-border", i = g("flex flex-col items-stretch", r, t);
    this.wrapperElement.className = i, this.wrapperElement.setAttribute("role", "group"), this.wrapperElement.setAttribute("aria-labelledby", this._titleId ?? "");
  }
  _isFirstSection() {
    const t = this.parentElement;
    return t ? Array.from(t.querySelectorAll("ck-dropdown-section")).indexOf(this) === 0 : !0;
  }
  render() {
    return f`<slot></slot>`;
  }
}
vn([
  qa({ context: Fc })
], Wc.prototype, "_setTitleId");
customElements.get("ck-dropdown-section") || customElements.define("ck-dropdown-section", Wc);
class yn extends b {
  constructor() {
    super(...arguments), this.id = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback();
    const t = this.id || `ck-dropdown-heading-${crypto.randomUUID?.() ?? ""}`;
    this.id = t, this._setTitleId?.(t);
  }
  firstUpdated() {
    this.headingElement = document.createElement("div"), this.headingElement.id = this.id, Array.from(this.childNodes).forEach((e) => {
      this.headingElement.appendChild(e);
    }), this.appendChild(this.headingElement), this._updateHeading();
  }
  updated() {
    this.headingElement && Array.from(this.childNodes).forEach((e) => {
      e !== this.headingElement && e.nodeType === Node.ELEMENT_NODE && this.headingElement.appendChild(e);
    }), this._updateHeading();
  }
  _updateHeading() {
    if (!this.headingElement) return;
    const t = this.getAttribute("class") ?? "", e = g("text-foreground-secondary px-3.5 pt-3 pb-1 text-sm font-medium", t);
    this.headingElement.className = e, this.headingElement.id = this.id;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._setTitleId?.(void 0);
  }
  render() {
    return f`<slot></slot>`;
  }
}
vn([
  u({ type: String })
], yn.prototype, "id");
vn([
  L({ context: Fc, subscribe: !1 })
], yn.prototype, "_setTitleId");
customElements.get("ck-dropdown-heading") || customElements.define("ck-dropdown-heading", yn);
class Cv extends b {
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-dropdown-trigger") || customElements.define("ck-dropdown-trigger", Cv);
const Zs = "tabs-context";
var kv = Object.defineProperty, Gs = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && kv(t, e, i), i;
};
class Qe extends b {
  constructor() {
    super(...arguments), this.orientation = "horizontal", this.internalSelectedIndex = 0, this.tabs = [], this.tabsId = Ot("tabs"), this._provider = new ft(this, {
      context: Zs,
      initialValue: {
        id: this.tabsId,
        tabs: [],
        selectedTab: void 0,
        setSelectedTab: () => {
        },
        next: () => {
        },
        previous: () => {
        },
        orientation: this.orientation,
        registerTab: () => () => {
        }
      }
    }), this._handleTabsChange = (t) => {
      const e = t.detail.index;
      this.selectedIndex === void 0 && (this.internalSelectedIndex = e), this.dispatchEvent(
        new CustomEvent("change", {
          detail: { index: e },
          bubbles: !0,
          composed: !0
        })
      ), this._updateContext();
    };
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("ck-tabs-change", this._handleTabsChange), this.defaultIndex !== void 0 ? this.internalSelectedIndex = this.defaultIndex : this.selectedIndex !== void 0 && (this.internalSelectedIndex = this.selectedIndex), this._updateContext();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("ck-tabs-change", this._handleTabsChange);
  }
  updated(t) {
    super.updated(t), (t.has("orientation") || t.has("tabs") || t.has("internalSelectedIndex") || t.has("selectedIndex") || t.has("defaultIndex")) && (t.has("selectedIndex") && this.selectedIndex !== void 0 && (this.internalSelectedIndex = this.selectedIndex), this._updateContext());
  }
  _updateContext() {
    const t = this.selectedIndex ?? this.internalSelectedIndex, e = this.tabs[t], r = (l) => {
      this.selectedIndex === void 0 && (this.internalSelectedIndex = l), this.dispatchEvent(
        new CustomEvent("ck-tabs-change", {
          detail: { index: l },
          bubbles: !0,
          composed: !0
        })
      );
      const d = this._getItemId(this.tabs[l]);
      d && requestAnimationFrame(() => {
        document.getElementById(d)?.focus();
      });
    }, i = () => {
      r((t + 1) % this.tabs.length);
    }, n = () => {
      r(t <= 0 ? this.tabs.length - 1 : t - 1);
    }, o = (l) => (this.tabs.includes(l) || (this.tabs = [...this.tabs, l]), () => {
      this.tabs = this.tabs.filter((d) => d !== l);
    }), a = (l) => {
      const d = this.tabs.indexOf(l);
      d !== -1 && r(d);
    };
    this._provider.setValue({
      id: this.tabsId,
      tabs: this.tabs,
      selectedTab: e,
      setSelectedTab: a,
      next: i,
      previous: n,
      orientation: this.orientation,
      registerTab: o
    });
  }
  _getItemId(t) {
    return t ? `tab${t}` : void 0;
  }
  render() {
    return f`<slot></slot>`;
  }
}
Gs([
  u({ type: Number, attribute: "default-index" })
], Qe.prototype, "defaultIndex");
Gs([
  u({ type: Number, attribute: "selected-index" })
], Qe.prototype, "selectedIndex");
Gs([
  u({ type: String })
], Qe.prototype, "orientation");
Gs([
  R()
], Qe.prototype, "internalSelectedIndex");
Gs([
  R()
], Qe.prototype, "tabs");
customElements.get("ck-tabs") || customElements.define("ck-tabs", Qe);
var _v = Object.defineProperty, Uc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && _v(t, e, i), i;
};
const ba = (s) => s ? `tab${s}` : void 0, va = (s) => s ? `tab-panel${s}` : void 0;
class wn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this.itemId = Ot("tab-item"), this._handleClick = (t) => {
      t.stopPropagation(), this.contextValue?.setSelectedTab && this.itemId && this.contextValue.setSelectedTab(this.itemId);
    }, this._handleKeyDown = (t) => {
      if (!this.contextValue) return;
      const { orientation: e, next: r, previous: i, setSelectedTab: n } = this.contextValue;
      if (t.key === "Enter" || t.key === " ") {
        t.preventDefault(), this.itemId && n(this.itemId);
        return;
      }
      const o = {
        horizontal: {
          next: "ArrowRight",
          prev: "ArrowLeft"
        },
        vertical: {
          next: "ArrowDown",
          prev: "ArrowUp"
        }
      };
      o[e].next === t.key ? (t.preventDefault(), r()) : o[e].prev === t.key && (t.preventDefault(), i());
    };
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.contextValue?.registerTab && (this.unregisterTab = this.contextValue.registerTab(this.itemId));
  }
  updated(t) {
    super.updated(t), t.has("contextValue") && this.contextValue?.registerTab && (this.unregisterTab && this.unregisterTab(), this.unregisterTab = this.contextValue.registerTab(this.itemId)), this.contextValue && (this.asChild ? this._updateAsChild() : this._updateButton());
  }
  _updateAsChild() {
    const t = this.firstElementChild;
    if (!t) return;
    const e = this.contextValue.selectedTab === this.itemId, r = this.getAttribute("class") || "", i = g(
      "ring-ring text-foreground/50 hover:text-foreground data-selected:text-foreground relative flex cursor-pointer items-center justify-center gap-1.5 rounded-xl px-4 py-2 transition outline-none focus-visible:ring-4",
      "[&>*:not([data-tab-indicator])]:z-10",
      r
    );
    Zt(this.asChild, t, {
      className: i,
      id: ba(this.itemId),
      type: "button",
      role: "tab",
      "aria-controls": va(this.itemId),
      "aria-selected": e ? "true" : "false",
      "data-selected": e ? "" : void 0,
      tabindex: e ? 0 : -1
    }), t.removeEventListener("click", this._handleClick), t.removeEventListener("keydown", this._handleKeyDown), t.addEventListener("click", this._handleClick), t.addEventListener("keydown", this._handleKeyDown);
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = document.createElement("button"), Array.from(this.childNodes).forEach((e) => {
      this.buttonElement.appendChild(e);
    }), this.appendChild(this.buttonElement), this._updateButton());
  }
  _updateButton() {
    if (!this.buttonElement || this.asChild || !this.contextValue) return;
    Array.from(this.childNodes).forEach((a) => {
      a !== this.buttonElement && a.nodeType === Node.ELEMENT_NODE && this.buttonElement.appendChild(a);
    });
    const e = this.contextValue.selectedTab === this.itemId, r = this.getAttribute("class") || "", i = g(
      "ring-ring text-foreground/50 hover:text-foreground data-selected:text-foreground relative flex cursor-pointer items-center justify-center gap-1.5 rounded-xl px-4 py-2 transition outline-none focus-visible:ring-4",
      "[&>*:not([data-tab-indicator])]:z-10",
      r
    );
    this.buttonElement.id = ba(this.itemId) || "", this.buttonElement.type = "button", this.buttonElement.className = i, this.buttonElement.setAttribute("role", "tab"), this.buttonElement.setAttribute("aria-controls", va(this.itemId) || ""), this.buttonElement.setAttribute("aria-selected", e ? "true" : "false"), e ? this.buttonElement.setAttribute("data-selected", "true") : this.buttonElement.removeAttribute("data-selected"), this.buttonElement.tabIndex = e ? 0 : -1, this.buttonElement.removeEventListener("click", this._handleClick), this.buttonElement.removeEventListener("keydown", this._handleKeyDown), this.buttonElement.addEventListener("click", this._handleClick), this.buttonElement.addEventListener("keydown", this._handleKeyDown);
    const n = this.buttonElement.querySelector(
      "[data-tab-indicator]"
    ), o = this.contextValue.id;
    if (e)
      if (n)
        o && n.setAttribute("data-layout-id", o), n.style.opacity = "1", n.style.transform = "scale(1)";
      else {
        const a = document.querySelector(
          `[data-tab-indicator][data-layout-id="${o}"]`
        ), l = document.createElement("span");
        if (l.setAttribute("data-tab-indicator", "true"), l.setAttribute("aria-hidden", "true"), o && l.setAttribute("data-layout-id", o), l.className = "bg-background-secondary absolute inset-0 z-0 rounded-xl transition-all duration-300 ease-out", this.buttonElement.insertBefore(l, this.buttonElement.firstChild), a && a !== l) {
          const d = a.getBoundingClientRect(), c = this.buttonElement.getBoundingClientRect(), h = d.left - c.left, p = d.top - c.top, m = d.width / c.width, v = d.height / c.height;
          l.style.transform = `translate(${h}px, ${p}px) scale(${m}, ${v})`, l.style.opacity = "1", requestAnimationFrame(() => {
            l.style.transform = "translate(0, 0) scale(1, 1)";
          }), a.remove();
        } else
          l.style.opacity = "0", l.style.transform = "scale(0.8)", requestAnimationFrame(() => {
            l.style.opacity = "1", l.style.transform = "scale(1)";
          });
      }
    else
      n && (n.style.opacity = "0", n.style.transform = "scale(0.8)", setTimeout(() => {
        n.parentElement && n.remove();
      }, 200));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.unregisterTab && this.unregisterTab();
  }
  render() {
    return f`<slot></slot>`;
  }
}
Uc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], wn.prototype, "asChild");
Uc([
  L({ context: Zs, subscribe: !0 })
], wn.prototype, "contextValue");
customElements.get("ck-tabs-item") || customElements.define("ck-tabs-item", wn);
var Ev = Object.defineProperty, Av = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ev(t, e, i), i;
};
class qc extends b {
  createRenderRoot() {
    return this;
  }
  firstUpdated() {
    this.wrapperElement = document.createElement("div"), Array.from(this.childNodes).forEach((e) => {
      this.wrapperElement.appendChild(e);
    }), this.appendChild(this.wrapperElement), this._updateWrapper();
  }
  updated() {
    this.wrapperElement && Array.from(this.childNodes).forEach((e) => {
      e !== this.wrapperElement && e.nodeType === Node.ELEMENT_NODE && this.wrapperElement.appendChild(e);
    }), this._updateWrapper();
  }
  _updateWrapper() {
    if (!this.wrapperElement) return;
    const t = this.getAttribute("class") || "", e = this.contextValue?.orientation || "horizontal", r = g(
      "flex gap-1.5",
      e === "horizontal" ? "items-center mb-4 border-border border-b " : "flex-col items-start mr-4 border-border border-r",
      t
    );
    this.wrapperElement.className = r, this.wrapperElement.setAttribute("role", "tablist"), this.wrapperElement.setAttribute("aria-orientation", e);
  }
  render() {
    return f`<slot></slot>`;
  }
}
Av([
  L({ context: Zs })
], qc.prototype, "contextValue");
customElements.get("ck-tabs-items") || customElements.define("ck-tabs-items", qc);
var Sv = Object.defineProperty, Kc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Sv(t, e, i), i;
};
const ya = (s) => s ? `tab${s}` : void 0, wa = (s) => s ? `tab-panel${s}` : void 0;
class xn extends b {
  constructor() {
    super(...arguments), this.asChild = !1;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this._updatePanelTabId();
  }
  firstUpdated() {
    this.asChild || (this.wrapperElement = document.createElement("div"), Array.from(this.childNodes).forEach((e) => {
      this.wrapperElement.appendChild(e);
    }), this.appendChild(this.wrapperElement)), this._updatePanelTabId(), this._updateVisibility();
  }
  updated(t) {
    (t.has("contextValue") || this.panelTabId === void 0) && this._updatePanelTabId(), this._updateVisibility();
  }
  _updatePanelTabId() {
    let t = this.parentElement;
    for (; t && t.tagName !== "CK-TABS-PANELS"; )
      t = t.parentElement;
    if (!t || !this.contextValue?.tabs || this.contextValue.tabs.length === 0) return;
    const r = Array.from(t.querySelectorAll("ck-tabs-panel")).indexOf(this);
    r >= 0 && r < this.contextValue.tabs.length && (this.panelTabId = this.contextValue.tabs[r]);
  }
  _updateVisibility() {
    if (!this.contextValue || this.panelTabId === void 0) {
      if (this.wrapperElement && (this.wrapperElement.style.display = "none"), this.asChild) {
        const i = this.firstElementChild;
        i && (i.style.display = "none");
      }
      return;
    }
    const t = this.contextValue.selectedTab === this.panelTabId, e = this.getAttribute("class") || "", r = g("outline-none", e);
    if (this.asChild) {
      const i = this.firstElementChild;
      i && (Zt(this.asChild, i, {
        className: r,
        id: wa(this.panelTabId),
        role: "tabpanel",
        "aria-labelledby": ya(this.panelTabId),
        "aria-hidden": t ? "false" : "true",
        "data-selected": t ? "" : void 0,
        tabindex: t ? 0 : -1
      }), i.style.display = t ? "" : "none");
    } else this.wrapperElement && (Array.from(this.childNodes).forEach((n) => {
      n !== this.wrapperElement && n.nodeType === Node.ELEMENT_NODE && this.wrapperElement.appendChild(n);
    }), this.wrapperElement.className = r, this.wrapperElement.id = wa(this.panelTabId) || "", this.wrapperElement.setAttribute("role", "tabpanel"), this.wrapperElement.setAttribute("aria-labelledby", ya(this.panelTabId) || ""), this.wrapperElement.setAttribute("aria-hidden", t ? "false" : "true"), t ? this.wrapperElement.setAttribute("data-selected", "") : this.wrapperElement.removeAttribute("data-selected"), this.wrapperElement.tabIndex = t ? 0 : -1, this.wrapperElement.style.display = t ? "" : "none");
  }
  render() {
    return f`<slot></slot>`;
  }
}
Kc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], xn.prototype, "asChild");
Kc([
  L({ context: Zs, subscribe: !0 })
], xn.prototype, "contextValue");
customElements.get("ck-tabs-panel") || customElements.define("ck-tabs-panel", xn);
var $v = Object.defineProperty, Tv = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && $v(t, e, i), i;
};
class Zc extends b {
  createRenderRoot() {
    return this;
  }
  firstUpdated() {
    this.wrapperElement = document.createElement("div"), Array.from(this.childNodes).forEach((e) => {
      this.wrapperElement.appendChild(e);
    }), this.appendChild(this.wrapperElement), this._updateWrapper();
  }
  updated() {
    this.wrapperElement && Array.from(this.childNodes).forEach((e) => {
      e !== this.wrapperElement && e.nodeType === Node.ELEMENT_NODE && this.wrapperElement.appendChild(e);
    }), this._updateWrapper();
  }
  _updateWrapper() {
    if (!this.wrapperElement) return;
    const t = this.getAttribute("class") || "", e = g("ring-ring transition has-focus-visible:ring-4", t);
    this.wrapperElement.className = e;
  }
  render() {
    return f`<slot></slot>`;
  }
}
Tv([
  L({ context: Zs })
], Zc.prototype, "contextValue");
customElements.get("ck-tabs-panels") || customElements.define("ck-tabs-panels", Zc);
const ts = "dialog-context";
var Ov = Object.defineProperty, Ys = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Ov(t, e, i), i;
};
class es extends rt {
  constructor() {
    super(), this.internalOpen = !1, this.isControlled = !1, this._provider = new ft(this, {
      context: ts,
      initialValue: {
        open: !1,
        setOpen: () => {
        },
        labelId: void 0,
        descriptionId: void 0,
        setLabelId: () => {
        },
        setDescriptionId: () => {
        }
      }
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.isControlled = this.open !== void 0, this.isControlled && (this.internalOpen = this.open ?? !1), this._updateContext();
  }
  updated(t) {
    t.has("open") && (this.isControlled = this.open !== void 0, this.isControlled ? this.internalOpen = this.open ?? !1 : this.open !== void 0 && (this.internalOpen = this.open)), this._updateContext();
  }
  _updateContext() {
    this._provider.setValue({
      open: this.internalOpen,
      setOpen: (t) => {
        this.isControlled ? this.onOpenChange?.(t) : (this.internalOpen = t, this.onOpenChange?.(t));
      },
      labelId: this.labelId,
      descriptionId: this.descriptionId,
      setLabelId: (t) => this.labelId = t,
      setDescriptionId: (t) => this.descriptionId = t
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
Ys([
  u({ type: Boolean })
], es.prototype, "open");
Ys([
  R()
], es.prototype, "internalOpen");
Ys([
  R()
], es.prototype, "labelId");
Ys([
  R()
], es.prototype, "descriptionId");
Ys([
  R()
], es.prototype, "isControlled");
customElements.get("ck-dialog") || customElements.define("ck-dialog", es);
class Iv extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "flex flex-col gap-2 pt-4 sm:flex-row sm:justify-start";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-dialog-actions") || customElements.define("ck-dialog-actions", Iv);
var Vv = Object.defineProperty, Gc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Vv(t, e, i), i;
};
const Pv = /* @__PURE__ */ new Set(["class", "as-child"]), Yn = class Yn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), t.defaultPrevented || (this.dispatchEvent(new Event("ck-dialog-close-click", { bubbles: !0, composed: !0 })), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateClickHandler();
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    super.updated?.(t), t.has("asChild") && this._updateClickHandler(), this.asChild || (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick);
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this.asChild && this.addEventListener("click", this._handleClick);
  }
  syncAttributes() {
    if (!this.buttonElement) return;
    const t = this.getAttribute("class");
    t && this.buttonElement.setAttribute("class", t);
    for (const e of this.attributes)
      Pv.has(e.name) || this.buttonElement.setAttribute(e.name, e.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
Yn.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let $s = Yn;
Gc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], $s.prototype, "asChild");
Gc([
  L({ context: ts, subscribe: !1 })
], $s.prototype, "contextValue");
customElements.get("ck-dialog-close") || customElements.define("ck-dialog-close", $s);
var Mv = Object.defineProperty, Di = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Mv(t, e, i), i;
};
const Xn = class Xn extends b {
  constructor() {
    super(...arguments), this.align = "center", this.inert = !1, this.catchFocus = !0, this.originalCustomClass = "", this.defaultClasses = "bg-background border-border m-auto w-full max-w-md border p-4 shadow-lg max-h-[calc(100svh-2rem)] overflow-y-auto backdrop:bg-black/20 backdrop:backdrop-blur-sm transition-all duration-300 backdrop:transition-all motion-reduce:transition-none motion-reduce:backdrop:transition-none not-data-[status=open]:translate-y-2 not-data-[status=open]:scale-95 not-data-[status=open]:opacity-0 not-data-[status=open]:duration-150 not-data-[status=open]:backdrop:opacity-0", this.scrollLocked = !1, this.previousBodyOverflow = "", this.previousBodyPaddingRight = "", this.dialogToaster = null;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.dialogEl = this.shadowRoot?.querySelector("dialog"), this.dialogEl && (this.dialogEl.open || (this.dialogEl.close(), this.dialogEl.removeAttribute("data-status")), this._updateDialogClasses(), this._updateDialogState(), this._setupEventListeners());
  }
  updated(t) {
    (t.has("class") || t.has("align")) && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses(), this.dialogEl && this._updateDialogClasses()), this.dialogEl && this.contextValue && this._updateDialogState(), t.has("inert") && this.dialogEl && (this.inert ? this.dialogEl.setAttribute("inert", "") : this.dialogEl.removeAttribute("inert"));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.abortController && (this.abortController.abort(), this.abortController = void 0), this._unregisterDialogToaster(), this._unlockBodyScroll();
  }
  _syncHostClasses() {
    const t = g(
      this.defaultClasses,
      this.align === "top" ? "mt-4" : "",
      this.originalCustomClass
    ), e = H(t);
    this.className = g(...e);
  }
  _getDialogClasses() {
    return g(this.defaultClasses, this.align === "top" ? "mt-4" : "", this.originalCustomClass);
  }
  _updateDialogClasses() {
    if (!this.dialogEl) return;
    const t = this._getDialogClasses();
    this.dialogEl.className = t;
  }
  _registerDialogToaster() {
    !this.dialogEl || this.dialogToaster || (this.dialogToaster = this.dialogEl.querySelector("ck-toaster"), this.dialogToaster || (this.dialogToaster = document.createElement("ck-toaster"), this.dialogToaster.setAttribute("position", "top-right"), this.dialogEl.appendChild(this.dialogToaster)));
  }
  _unregisterDialogToaster() {
    this.dialogToaster && this.dialogToaster.parentElement && (this.dialogToaster.remove(), this.dialogToaster = null);
  }
  _updateDialogState() {
    if (!this.dialogEl || !this.contextValue) return;
    const { open: t } = this.contextValue;
    t && !this.dialogEl.open ? (this.dialogEl.showModal(), requestAnimationFrame(() => {
      this.dialogEl && (this.dialogEl.setAttribute("data-status", "open"), this._registerDialogToaster());
    }), this._lockBodyScroll()) : !t && this.dialogEl.open ? (this._unregisterDialogToaster(), this.dialogEl.removeAttribute("data-status"), setTimeout(() => {
      this.dialogEl && !this.contextValue?.open && this.dialogEl.close(), this._unlockBodyScroll();
    }, 150)) : t && this.dialogEl.open && !this.dialogEl.hasAttribute("data-status") ? (this.dialogEl.setAttribute("data-status", "open"), this._registerDialogToaster(), this._lockBodyScroll()) : !t && !this.dialogEl.open && this.dialogEl.hasAttribute("data-status") && (this._unregisterDialogToaster(), this.dialogEl.removeAttribute("data-status"), this._unlockBodyScroll());
  }
  _lockBodyScroll() {
    if (this.scrollLocked || typeof document > "u") return;
    const t = document.body, e = document.documentElement;
    this.previousBodyOverflow = t.style.overflow || "", this.previousBodyPaddingRight = t.style.paddingRight || "";
    const r = window.innerWidth - e.clientWidth;
    t.style.overflow = "hidden", t.style.paddingRight = r > 0 ? `${r}px` : "", e.style.overflow = "hidden", this.scrollLocked = !0;
  }
  _unlockBodyScroll() {
    if (!this.scrollLocked || typeof document > "u") return;
    const t = document.body, e = document.documentElement;
    t.style.overflow = this.previousBodyOverflow, t.style.paddingRight = this.previousBodyPaddingRight, e.style.overflow = "", this.scrollLocked = !1, this.previousBodyOverflow = "", this.previousBodyPaddingRight = "";
  }
  _setupEventListeners() {
    if (!this.dialogEl || !this.contextValue) return;
    this.abortController && this.abortController.abort(), this.abortController = new AbortController();
    const { signal: t } = this.abortController;
    this.dialogEl.addEventListener(
      "cancel",
      (e) => {
        e.preventDefault(), !this.inert && this.contextValue?.setOpen && this.contextValue.setOpen(!1);
      },
      { signal: t }
    ), this.dialogEl.addEventListener(
      "keydown",
      (e) => {
        e.key === "Escape" && this.contextValue?.open && !this.inert && (e.preventDefault(), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
      },
      { signal: t }
    ), window.addEventListener(
      "keydown",
      (e) => {
        e.key === "Escape" && this.dialogEl?.inert && this.contextValue?.open && (e.preventDefault(), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
      },
      { signal: t }
    ), this.dialogEl.addEventListener(
      "click",
      (e) => {
        !this.inert && this.contextValue?.setOpen && e.target === this.dialogEl && (e.stopPropagation(), this.contextValue.setOpen(!1));
      },
      { signal: t }
    );
  }
  render() {
    const { labelId: t, descriptionId: e } = this.contextValue || {}, r = this._getDialogClasses();
    return f`
      <dialog
        aria-labelledby=${t || ""}
        aria-describedby=${e || ""}
        ?inert=${this.inert}
        class="${r}"
      >
        ${this.catchFocus ? f` <div class="sr-only" autofocus tabindex="-1" data-dialog-focus-catcher=""></div> ` : ""}
        <slot></slot>
      </dialog>
    `;
  }
};
Xn.styles = [
  ...b.styles,
  N`
      :host {
        display: contents;
      }

      /* Override browser default max-height for dialog elements */
      /* Chrome applies dialog:-internal-dialog-in-top-layer with max-height calc(100% - 2em - 6px) */
      /* This internal pseudo-class has higher specificity, so we use attribute + class selector with !important */
      /* Match both max-h-none and max-h-none! (Tailwind's !important modifier) */
      dialog[open][class*='max-h-none'] {
        max-height: none !important;
      }
    `
];
let ue = Xn;
Di([
  u({ type: String })
], ue.prototype, "align");
Di([
  u({ type: Boolean })
], ue.prototype, "inert");
Di([
  u({ type: Boolean, attribute: "catch-focus" })
], ue.prototype, "catchFocus");
Di([
  L({ context: ts, subscribe: !0 })
], ue.prototype, "contextValue");
customElements.get("ck-dialog-content") || customElements.define("ck-dialog-content", ue);
var Lv = Object.defineProperty, Yc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Lv(t, e, i), i;
};
class Cn extends rt {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.baseClasses = "block pb-2";
  }
  // Use light DOM instead of shadow DOM so Tailwind classes work
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
    const t = Ot("ck-dialog-desc");
    this.id = t, this.contextValue.setDescriptionId(t), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.contextValue.setDescriptionId(void 0);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.baseClasses, this.originalCustomClass);
    return f`<p id=${this.id} class=${t}><slot></slot></p>`;
  }
}
Yc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Cn.prototype, "asChild");
Yc([
  L({ context: ts, subscribe: !1 })
], Cn.prototype, "contextValue");
customElements.get("ck-dialog-description") || customElements.define("ck-dialog-description", Cn);
var Rv = Object.defineProperty, Xc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Rv(t, e, i), i;
};
class kn extends rt {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.baseClasses = "block text-lg mt-0 pb-2 font-semibold";
  }
  // Use light DOM instead of shadow DOM so Tailwind classes work
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
    const t = Ot("ck-dialog-title");
    this.id = t, this.contextValue.setLabelId(t), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.contextValue.setLabelId(void 0);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.baseClasses, this.originalCustomClass);
    return f`<h2 id=${this.id} class=${t}><slot></slot></h2>`;
  }
}
Xc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], kn.prototype, "asChild");
Xc([
  L({ context: ts, subscribe: !1 })
], kn.prototype, "contextValue");
customElements.get("ck-dialog-title") || customElements.define("ck-dialog-title", kn);
var Hv = Object.defineProperty, Jc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Hv(t, e, i), i;
};
const Dv = /* @__PURE__ */ new Set(["class", "as-child"]), Jn = class Jn extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), !t.defaultPrevented && this.contextValue?.setOpen && this.contextValue.setOpen(!0);
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateClickHandler();
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    super.updated?.(t), t.has("asChild") && this._updateClickHandler(), this.asChild || (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick);
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this.asChild && this.addEventListener("click", this._handleClick);
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes)
        Dv.has(t.name) || this.buttonElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
Jn.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let Ts = Jn;
Jc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Ts.prototype, "asChild");
Jc([
  L({ context: ts })
], Ts.prototype, "contextValue");
customElements.get("ck-dialog-trigger") || customElements.define("ck-dialog-trigger", Ts);
const ss = "drawer-context";
var zv = Object.defineProperty, Xs = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && zv(t, e, i), i;
};
class is extends rt {
  constructor() {
    super(), this.internalOpen = !1, this.isControlled = !1, this._provider = new ft(this, {
      context: ss,
      initialValue: {
        open: !1,
        setOpen: () => {
        },
        labelId: void 0,
        descriptionId: void 0,
        setLabelId: () => {
        },
        setDescriptionId: () => {
        }
      }
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.isControlled = this.open !== void 0, this.isControlled && (this.internalOpen = this.open ?? !1), this._updateContext();
  }
  updated(t) {
    t.has("open") && (this.isControlled = this.open !== void 0, this.isControlled ? this.internalOpen = this.open ?? !1 : this.open !== void 0 && (this.internalOpen = this.open)), this._updateContext();
  }
  _updateContext() {
    this._provider.setValue({
      open: this.internalOpen,
      setOpen: (t) => {
        this.isControlled ? this.onOpenChange?.(t) : (this.internalOpen = t, this.onOpenChange?.(t));
      },
      labelId: this.labelId,
      descriptionId: this.descriptionId,
      setLabelId: (t) => this.labelId = t,
      setDescriptionId: (t) => this.descriptionId = t
    });
  }
  render() {
    return f`<slot></slot>`;
  }
}
Xs([
  u({ type: Boolean })
], is.prototype, "open");
Xs([
  R()
], is.prototype, "internalOpen");
Xs([
  R()
], is.prototype, "labelId");
Xs([
  R()
], is.prototype, "descriptionId");
Xs([
  R()
], is.prototype, "isControlled");
customElements.get("ck-drawer") || customElements.define("ck-drawer", is);
class Nv extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "bg-background border-border sticky bottom-0 mt-auto flex w-full gap-2 border-t p-(--drawer-p)";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.setAttribute("data-drawer-actions", ""), this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass);
    this.className = t;
  }
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-drawer-actions") || customElements.define("ck-drawer-actions", Nv);
const Qn = class Qn extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "-mx-(--drawer-p)";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass);
    this.className = t;
  }
  render() {
    return f`<slot></slot>`;
  }
};
Qn.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
      }
    `
];
let Cr = Qn;
customElements.get("ck-drawer-bleed") || customElements.define("ck-drawer-bleed", Cr);
var Bv = Object.defineProperty, Qc = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Bv(t, e, i), i;
};
const jv = /* @__PURE__ */ new Set(["class", "as-child"]), to = class to extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), t.defaultPrevented || (this.dispatchEvent(new Event("ck-drawer-close-click", { bubbles: !0, composed: !0 })), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateClickHandler();
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    super.updated?.(t), t.has("asChild") && this._updateClickHandler(), this.asChild || (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick);
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this.asChild && this.addEventListener("click", this._handleClick);
  }
  syncAttributes() {
    if (!this.buttonElement) return;
    const t = this.getAttribute("class");
    t && (this.buttonElement.setAttribute("class", t), this.removeAttribute("class"));
    for (const e of this.attributes)
      jv.has(e.name) || this.buttonElement.setAttribute(e.name, e.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
to.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
      /* Host acts as a pass-through - classes are applied to the button, not the host */
      :host {
        display: contents;
      }
    `
];
let Os = to;
Qc([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Os.prototype, "asChild");
Qc([
  L({ context: ss, subscribe: !1 })
], Os.prototype, "contextValue");
customElements.get("ck-drawer-close") || customElements.define("ck-drawer-close", Os);
var Fv = Object.defineProperty, _n = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Fv(t, e, i), i;
};
const eo = class eo extends b {
  constructor() {
    super(...arguments), this.inert = !1, this.catchFocus = !0, this.originalCustomClass = "", this.defaultClasses = "[--drawer-p:--spacing(5)] bg-background border-border mx-auto w-full max-w-screen overflow-x-hidden! overflow-y-auto border px-(--drawer-p) py-0 *:shrink-0 has-[[data-drawer-actions]:last-child]:pb-0 has-[[data-drawer-focus-catcher]:first-child+[data-drawer-header],[data-drawer-header]:first-child]:pt-0 backdrop:bg-foreground/20 not-data-[status=open]:backdrop:opacity-0 md:mr-0 h-screen max-h-screen md:w-full md:max-w-[578px] md:not-data-[status=open]:translate-x-full max-md:mb-0 max-md:w-full max-md:not-data-[status=open]:translate-y-full ease-emphasized-decelerate not-data-[status=open]:ease-emphasized-accelerate transition-transform backdrop:transition-opacity backdrop:ease-in-out motion-reduce:transition-none motion-reduce:backdrop:transition-none duration-400 not-data-[status=open]:duration-250 not-data-[status=open]:backdrop:delay-150 not-data-[status=open]:backdrop:duration-200", this.scrollLocked = !1, this.previousBodyOverflow = "", this.previousBodyPaddingRight = "", this.dialogToaster = null;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.dialogEl = this.shadowRoot?.querySelector("dialog"), this.dialogEl && (this.dialogEl.open || (this.dialogEl.close(), this.dialogEl.removeAttribute("data-status")), this._updateDialogClasses(), this._updateDialogState(), this._setupEventListeners());
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses(), this.dialogEl && this._updateDialogClasses()), this.dialogEl && this.contextValue && this._updateDialogState(), t.has("inert") && this.dialogEl && (this.inert ? this.dialogEl.setAttribute("inert", "") : this.dialogEl.removeAttribute("inert"));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.abortController && (this.abortController.abort(), this.abortController = void 0), this._unregisterDialogToaster(), this._unlockBodyScroll();
  }
  _syncHostClasses() {
    const t = g(this.defaultClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  _getDialogClasses() {
    return g(this.defaultClasses, this.originalCustomClass);
  }
  _updateDialogClasses() {
    if (!this.dialogEl) return;
    const t = this._getDialogClasses();
    this.dialogEl.className = t;
  }
  _registerDialogToaster() {
    !this.dialogEl || this.dialogToaster || (this.dialogToaster = this.dialogEl.querySelector("ck-toaster"), this.dialogToaster || (this.dialogToaster = document.createElement("ck-toaster"), this.dialogToaster.setAttribute("position", "top-right"), this.dialogEl.appendChild(this.dialogToaster)));
  }
  _unregisterDialogToaster() {
    this.dialogToaster && this.dialogToaster.parentElement && (this.dialogToaster.remove(), this.dialogToaster = null);
  }
  _updateDialogState() {
    if (!this.dialogEl || !this.contextValue) return;
    const { open: t } = this.contextValue;
    t && !this.dialogEl.open ? (this.dialogEl.showModal(), requestAnimationFrame(() => {
      this.dialogEl && (this.dialogEl.setAttribute("data-status", "open"), this._registerDialogToaster());
    }), this._lockBodyScroll()) : !t && this.dialogEl.open ? (this._unregisterDialogToaster(), this.dialogEl.removeAttribute("data-status"), setTimeout(() => {
      this.dialogEl && !this.contextValue?.open && this.dialogEl.close(), this._unlockBodyScroll();
    }, 250)) : t && this.dialogEl.open && !this.dialogEl.hasAttribute("data-status") ? (this.dialogEl.setAttribute("data-status", "open"), this._registerDialogToaster(), this._lockBodyScroll()) : !t && !this.dialogEl.open && this.dialogEl.hasAttribute("data-status") && (this._unregisterDialogToaster(), this.dialogEl.removeAttribute("data-status"), this._unlockBodyScroll());
  }
  _lockBodyScroll() {
    if (this.scrollLocked || typeof document > "u") return;
    const t = document.body, e = document.documentElement;
    this.previousBodyOverflow = t.style.overflow || "", this.previousBodyPaddingRight = t.style.paddingRight || "";
    const r = window.innerWidth - e.clientWidth;
    t.style.overflow = "hidden", t.style.paddingRight = r > 0 ? `${r}px` : "", e.style.overflow = "hidden", this.scrollLocked = !0;
  }
  _unlockBodyScroll() {
    if (!this.scrollLocked || typeof document > "u") return;
    const t = document.body, e = document.documentElement;
    t.style.overflow = this.previousBodyOverflow, t.style.paddingRight = this.previousBodyPaddingRight, e.style.overflow = "", this.scrollLocked = !1, this.previousBodyOverflow = "", this.previousBodyPaddingRight = "";
  }
  _setupEventListeners() {
    if (!this.dialogEl || !this.contextValue) return;
    this.abortController && this.abortController.abort(), this.abortController = new AbortController();
    const { signal: t } = this.abortController;
    this.dialogEl.addEventListener(
      "cancel",
      (e) => {
        e.preventDefault(), !this.inert && this.contextValue?.setOpen && this.contextValue.setOpen(!1);
      },
      { signal: t }
    ), this.dialogEl.addEventListener(
      "keydown",
      (e) => {
        e.key === "Escape" && this.contextValue?.open && !this.inert && (e.preventDefault(), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
      },
      { signal: t }
    ), window.addEventListener(
      "keydown",
      (e) => {
        e.key === "Escape" && this.dialogEl?.inert && this.contextValue?.open && (e.preventDefault(), this.contextValue?.setOpen && this.contextValue.setOpen(!1));
      },
      { signal: t }
    ), this.dialogEl.addEventListener(
      "click",
      (e) => {
        !this.inert && this.contextValue?.setOpen && e.target === this.dialogEl && (e.stopPropagation(), this.contextValue.setOpen(!1));
      },
      { signal: t }
    );
  }
  render() {
    const { labelId: t, descriptionId: e } = this.contextValue || {}, r = this._getDialogClasses();
    return f`
      <dialog
        aria-labelledby=${t || ""}
        aria-describedby=${e || ""}
        ?inert=${this.inert}
        class="${r}"
      >
        ${this.catchFocus ? f` <div class="sr-only" autofocus tabindex="-1" data-drawer-focus-catcher=""></div> ` : ""}
        <div class="flex flex-col h-full relative -mx-(--drawer-p)">
          <slot></slot>
        </div>
      </dialog>
    `;
  }
};
eo.styles = [
  ...b.styles,
  N`
      :host {
        display: contents;
      }

      /* Override browser default max-height for dialog elements */
      /* Chrome applies dialog:-internal-dialog-in-top-layer with max-height calc(100% - 2em - 6px) */
      /* This internal pseudo-class has higher specificity, so we use attribute + class selector with !important */
      /* Match both max-h-none and max-h-none! (Tailwind's !important modifier) */
      dialog[open][class*='max-h-none'] {
        max-height: calc(100dvh - var(--ck-drawer-top-offset, 0px)) !important;
      }

      /**
       * Optional top offset support.
       *
       * Useful for shells with a sticky promo bar (e.g. 32px tall).
       * Set on <ck-drawer-content style="--ck-drawer-top-offset: 32px">.
       */
      dialog {
        top: var(--ck-drawer-top-offset, 0px);
        height: calc(100dvh - var(--ck-drawer-top-offset, 0px)) !important;
        max-height: calc(100dvh - var(--ck-drawer-top-offset, 0px)) !important;
      }
    `
];
let Me = eo;
_n([
  u({ type: Boolean })
], Me.prototype, "inert");
_n([
  u({ type: Boolean, attribute: "catch-focus" })
], Me.prototype, "catchFocus");
_n([
  L({ context: ss, subscribe: !0 })
], Me.prototype, "contextValue");
customElements.get("ck-drawer-content") || customElements.define("ck-drawer-content", Me);
var Wv = Object.defineProperty, td = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Wv(t, e, i), i;
};
class En extends rt {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.baseClasses = "block p-(--drawer-p) pb-2 ";
  }
  // Use light DOM instead of shadow DOM so Tailwind classes work
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
    const t = Ot("ck-drawer-desc");
    this.id = t, this.contextValue.setDescriptionId(t), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.contextValue.setDescriptionId(void 0);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.baseClasses, this.originalCustomClass);
    return f`<div id=${this.id} class=${t}><slot></slot></div>`;
  }
}
td([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], En.prototype, "asChild");
td([
  L({ context: ss, subscribe: !1 })
], En.prototype, "contextValue");
customElements.get("ck-drawer-description") || customElements.define("ck-drawer-description", En);
class Uv extends b {
  constructor() {
    super(...arguments), this.originalCustomClass = "", this.baseClasses = "bg-white border-border sticky top-0 z-10 mb-(--drawer-p) border-b p-(--drawer-p)";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this.setAttribute("data-drawer-header", ""), this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass);
    this.className = t;
  }
  render() {
    return f`<slot></slot>`;
  }
}
customElements.get("ck-drawer-header") || customElements.define("ck-drawer-header", Uv);
var qv = Object.defineProperty, ed = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && qv(t, e, i), i;
};
class An extends rt {
  constructor() {
    super(...arguments), this.asChild = !1, this.originalCustomClass = "", this.baseClasses = "block text-lg mt-0 font-semibold";
  }
  // Use light DOM instead of shadow DOM so Tailwind classes work
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "";
    const t = Ot("ck-drawer-title");
    this.id = t, this.contextValue.setLabelId(t), this._syncHostClasses();
  }
  updated(t) {
    super.updated(t), t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    const t = g(this.baseClasses, this.originalCustomClass), e = H(t);
    this.className = g(...e);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.contextValue.setLabelId(void 0);
  }
  render() {
    if (this.asChild)
      return f`<slot></slot>`;
    const t = g(this.baseClasses, this.originalCustomClass);
    return f`<h2 id=${this.id} class=${t}><slot></slot></h2>`;
  }
}
ed([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], An.prototype, "asChild");
ed([
  L({ context: ss, subscribe: !1 })
], An.prototype, "contextValue");
customElements.get("ck-drawer-title") || customElements.define("ck-drawer-title", An);
var Kv = Object.defineProperty, sd = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Kv(t, e, i), i;
};
const Zv = /* @__PURE__ */ new Set(["class", "as-child"]), so = class so extends b {
  constructor() {
    super(...arguments), this.asChild = !1, this._handleClick = (t) => {
      t.stopPropagation();
      const e = this.onClick;
      typeof e == "function" && e(t), !t.defaultPrevented && this.contextValue?.setOpen && this.contextValue.setOpen(!0);
    };
  }
  connectedCallback() {
    super.connectedCallback(), this._updateClickHandler();
  }
  firstUpdated() {
    this.asChild || (this.buttonElement = this.shadowRoot?.querySelector("ck-button"), this.syncAttributes(), this.syncEventHandlers());
  }
  updated(t) {
    super.updated?.(t), t.has("asChild") && this._updateClickHandler(), this.asChild || (this.syncAttributes(), this.syncEventHandlers());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("click", this._handleClick);
  }
  _updateClickHandler() {
    this.removeEventListener("click", this._handleClick), this.asChild && this.addEventListener("click", this._handleClick);
  }
  syncAttributes() {
    if (this.buttonElement)
      for (const t of this.attributes)
        Zv.has(t.name) || this.buttonElement.setAttribute(t.name, t.value);
  }
  syncEventHandlers() {
    this.buttonElement && q(this, this.buttonElement, [
      "onClick"
    ]);
  }
  render() {
    return this.asChild ? f`<slot></slot>` : f`
      <ck-button @click=${this._handleClick}>
        <slot></slot>
      </ck-button>
    `;
  }
};
so.styles = [
  ...b.styles,
  N`
      :host([as-child]) {
        display: contents;
      }
    `
];
let Is = so;
sd([
  u({ type: Boolean, attribute: "as-child", reflect: !0 })
], Is.prototype, "asChild");
sd([
  L({ context: ss })
], Is.prototype, "contextValue");
customElements.get("ck-drawer-trigger") || customElements.define("ck-drawer-trigger", Is);
var Gv = Object.defineProperty, id = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Gv(t, e, i), i;
};
class Sn extends b {
  constructor() {
    super(...arguments), this.description = "", this.product = null, this.originalCustomClass = "";
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    if (this.product) {
      const e = g("flex h-[112px] border-t border-border overflow-hidden", this.originalCustomClass);
      this.className = e;
    } else {
      const e = g("", this.originalCustomClass);
      this.className = e;
    }
  }
  render() {
    return this.product ? f`
        <img
          src="${this.product.image}"
          alt="${this.product.name}"
          class="w-[87px] h-full max-h-[112px] object-cover shrink-0"
        />
        <div class="flex-1 py-5 px-3.5">
          <div class="font-header font-black uppercase tracking-wide text-foreground text-sm">
            ${this.product.name}
          </div>
          ${this.product.description ? f`
                <div class="mt-0.5 text-sm text-foreground-secondary normal-case">
                  ${this.product.description}
                </div>
              ` : ""}
        </div>
      ` : this.description ? f`
            <div class="mt-0.5 text-sm text-foreground-secondary normal-case wrap-break-word">
              ${this.description}
            </div>
          ` : f``;
  }
}
id([
  u({ type: String })
], Sn.prototype, "description");
id([
  u({ type: Object })
], Sn.prototype, "product");
customElements.get("ck-toaster-item-body") || customElements.define("ck-toaster-item-body", Sn);
var Yv = Object.defineProperty, zi = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Yv(t, e, i), i;
};
function Xv(s) {
  switch (s) {
    case "success":
      return "check-circle";
    case "warning":
      return "warning";
    case "error":
      return "warning-circle";
    case "neutral":
    default:
      return "bell";
  }
}
class Js extends b {
  constructor() {
    super(...arguments), this.variant = "neutral", this.title = "", this.closable = !0, this.isProductType = !1, this.originalCustomClass = "", this._handleClose = (t) => {
      t.stopPropagation(), this.dispatchEvent(
        new CustomEvent("ck-toast-close", {
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback(), this.originalCustomClass = this.getAttribute("class") || "", this._syncHostClasses();
  }
  firstUpdated() {
    this.originalCustomClass || (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  updated(t) {
    t.has("class") && (this.originalCustomClass = this.getAttribute("class") || ""), this._syncHostClasses();
  }
  _syncHostClasses() {
    if (this.isProductType) {
      const e = g("flex items-center h-[52px] px-3.5", this.originalCustomClass);
      this.className = e;
    } else {
      const e = g("flex items-start", this.originalCustomClass);
      this.className = e;
    }
  }
  render() {
    const t = Xv(this.variant);
    return this.isProductType ? f`
        <ck-icon name="${t}" size="20" decorative></ck-icon>
        <div class="grow ml-2">
          <div class="text-sm text-foreground line-clamp-1">${this.title}</div>
        </div>
        ${this.closable ? f`
              <button
                @click=${this._handleClose}
                type="button"
                class="shrink-0 size-5 flex items-center justify-center text-foreground hover:opacity-70 transition-opacity"
                aria-label="Close notification"
              >
                <ck-icon name="close" size="20" decorative></ck-icon>
              </button>
            ` : ""}
      ` : f`
        <ck-icon name="${t}" size="20" decorative></ck-icon>
        <div class="grow ml-2">
          ${this.title ? f`<div class="text-sm text-foreground">${this.title}</div>` : ""}
        </div>
        ${this.closable ? f`
              <button
                @click=${this._handleClose}
                type="button"
                class="cursor-pointer shrink-0 size-5 flex items-center justify-center text-foreground hover:opacity-70 transition-opacity ml-2"
                aria-label="Close notification"
              >
                <ck-icon name="close" size="20" decorative></ck-icon>
              </button>
            ` : ""}
      `;
  }
}
zi([
  u({ type: String })
], Js.prototype, "variant");
zi([
  u({ type: String })
], Js.prototype, "title");
zi([
  u({ type: Boolean })
], Js.prototype, "closable");
zi([
  u({ type: Boolean })
], Js.prototype, "isProductType");
customElements.get("ck-toaster-item-header") || customElements.define("ck-toaster-item-header", Js);
var Jv = Object.defineProperty, rs = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && Jv(t, e, i), i;
};
const io = class io extends b {
  constructor() {
    super(...arguments), this.variant = "neutral", this.title = "", this.description = "", this.productJson = "", this._product = null, this.duration = 4e3, this.closable = !0, this.dismissTimer = null, this.isVisible = !1, this.isExiting = !1, this._handleClose = () => {
      this._dismiss();
    }, this._handleKeyDown = (t) => {
      t.key === "Escape" && this.closable && (t.preventDefault(), t.stopPropagation(), this._dismiss());
    };
  }
  createRenderRoot() {
    return this;
  }
  get product() {
    return this._product;
  }
  set product(t) {
    this._product = t, this._setType();
  }
  connectedCallback() {
    if (super.connectedCallback(), this.productJson)
      try {
        this._product = JSON.parse(this.productJson);
      } catch (t) {
        console.warn("[toast] Failed to parse product JSON:", t), this._product = null;
      }
    this._setType(), this._setAriaAttributes(), this.addEventListener("ck-toast-close", this._handleClose), this.addEventListener("keydown", this._handleKeyDown), this.setAttribute("tabindex", "0");
  }
  _applyBaseClasses() {
    const e = !this._product ? "min-w-[280px] max-w-[440px] py-3.5 px-3 max-sm:w-[calc(100vw-32px)] max-sm:max-w-[calc(100vw-32px)]" : "w-[440px] max-w-[calc(100vw-32px)] max-sm:w-[calc(100vw-32px)] max-sm:max-w-[calc(100vw-32px)]", r = g("bg-background border border-border-softer", e), i = this.className || "";
    this.className = g(r, i);
  }
  updated(t) {
    if (super.updated(t), t.has("productJson") && this.productJson)
      try {
        this._product = JSON.parse(this.productJson), this._setType();
      } catch (e) {
        console.warn("[toast] Failed to parse product JSON:", e), this._product = null, this._setType();
      }
    t.has("product") && this._setType();
  }
  firstUpdated() {
    requestAnimationFrame(() => {
      this.isVisible = !0, this.setAttribute("data-visible", ""), this._startDismissTimer();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._clearDismissTimer(), this.removeEventListener("ck-toast-close", this._handleClose), this.removeEventListener("keydown", this._handleKeyDown);
  }
  _setType() {
    const t = this._product ? "product" : "default";
    this.setAttribute("data-type", t), this._applyBaseClasses();
  }
  _setAriaAttributes() {
    const t = this.variant === "error" || this.variant === "warning";
    this.setAttribute("aria-live", t ? "assertive" : "polite"), this.setAttribute("aria-atomic", "true"), this.setAttribute("role", t ? "alert" : "status");
    const e = [];
    this.title && e.push(this.title), this.description && e.push(this.description), this._product && (e.push(this._product.name), this._product.description && e.push(this._product.description)), e.length > 0 && this.setAttribute("aria-label", e.join(". "));
  }
  _startDismissTimer() {
    this.duration > 0 && (this._clearDismissTimer(), this.dismissTimer = window.setTimeout(() => {
      this._dismiss();
    }, this.duration));
  }
  _clearDismissTimer() {
    this.dismissTimer !== null && (clearTimeout(this.dismissTimer), this.dismissTimer = null);
  }
  _dismiss() {
    this.isExiting || (this.isExiting = !0, this._clearDismissTimer(), this.removeAttribute("data-visible"), this.setAttribute("data-exiting", ""), setTimeout(() => {
      this.dispatchEvent(
        new CustomEvent("ck-toast-dismissed", {
          bubbles: !0,
          composed: !0
        })
      ), this.remove();
    }, 150));
  }
  render() {
    const t = !!this._product;
    return t ? f`
        <ck-toaster-item-header
          variant="${this.variant}"
          title="${this.title}"
          ?closable="${this.closable}"
          ?isProductType="${t}"
        ></ck-toaster-item-header>
        <ck-toaster-item-body .product="${this._product}"></ck-toaster-item-body>
      ` : f`
        <ck-toaster-item-header
          variant="${this.variant}"
          title="${this.title}"
          ?closable="${this.closable}"
          ?isProductType="${t}"
        ></ck-toaster-item-header>
        ${this.description ? f` <ck-toaster-item-body description="${this.description}"></ck-toaster-item-body> ` : ""}
      `;
  }
};
io.styles = [
  ...b.styles,
  N`
      :host {
        display: block;
        pointer-events: auto;
        opacity: 0;
        transform: translateY(-10px);
        transition:
          opacity 0.2s ease-out,
          transform 0.2s ease-out;
      }

      :host([data-visible]) {
        opacity: 1;
        transform: translateY(0);
      }

      :host([data-exiting]) {
        opacity: 0;
        transform: translateY(-10px);
        transition:
          opacity 0.15s ease-in,
          transform 0.15s ease-in;
      }

      /* Respect reduced motion */
      @media (prefers-reduced-motion: reduce) {
        :host {
          transition: none;
        }
      }
    `
];
let Ht = io;
rs([
  u({ type: String })
], Ht.prototype, "variant");
rs([
  u({ type: String })
], Ht.prototype, "title");
rs([
  u({ type: String })
], Ht.prototype, "description");
rs([
  u({ type: String, attribute: "product" })
], Ht.prototype, "productJson");
rs([
  u({ type: Number })
], Ht.prototype, "duration");
rs([
  u({ type: Boolean })
], Ht.prototype, "closable");
customElements.get("ck-toaster-item") || customElements.define("ck-toaster-item", Ht);
function Ni(s) {
  return typeof s == "string" ? { description: s } : s ?? {};
}
function Qv() {
  const s = document, t = (n) => {
    let o = n.querySelector("ck-toaster");
    return o || (o = s.createElement("ck-toaster"), o.setAttribute("position", "top-right"), n.appendChild(o)), o;
  }, e = s.querySelectorAll("ck-drawer-content, ck-dialog-content");
  for (const n of e) {
    const o = n.shadowRoot;
    if (o) {
      const a = o.querySelector(
        'dialog[open], dialog[data-status="open"]'
      );
      if (a) {
        const l = t(a);
        if (l) return l;
      }
    }
  }
  const r = s.querySelectorAll(
    'dialog[open], dialog[data-status="open"]'
  );
  for (const n of r) {
    const o = t(n);
    if (o)
      return o;
  }
  let i = s.querySelector("ck-toaster");
  return i || (i = s.createElement("ck-toaster"), i.setAttribute("position", "top-right"), s.body.appendChild(i)), i;
}
function t0(s) {
  s.product && !s.title && (console.warn("[toast] Product type requires a title. Providing empty title as fallback."), s.title = "");
}
const pe = (s) => {
  const t = Ni(s);
  t0(t);
  const e = Qv(), r = document.createElement("ck-toaster-item");
  return r.variant = t.variant ?? "neutral", r.duration = t.duration ?? 4e3, r.closable = t.closable ?? !0, t.title !== void 0 && r.setAttribute("title", t.title), t.description !== void 0 && r.setAttribute("description", t.description), t.product && (r.product = t.product, r.setAttribute("product", JSON.stringify(t.product))), t.className && (r.className = g(r.className, t.className)), e.appendChild(r), r;
};
pe.success = (s) => pe({ ...Ni(s), variant: "success" });
pe.error = (s) => pe({ ...Ni(s), variant: "error" });
pe.warning = (s) => pe({ ...Ni(s), variant: "warning" });
var e0 = Object.defineProperty, s0 = (s, t, e, r) => {
  for (var i = void 0, n = s.length - 1, o; n >= 0; n--)
    (o = s[n]) && (i = o(t, e, i) || i);
  return i && e0(t, e, i), i;
};
const ro = class ro extends b {
  constructor() {
    super(...arguments), this.position = "top-right";
  }
  _applyLayoutClasses() {
    const t = this.getAttribute("position") || this.position;
    let e = "";
    t.includes("right") ? e = "items-end" : t.includes("left") ? e = "items-start" : e = "items-center";
    const r = `flex flex-col gap-3 ${e} max-sm:items-stretch`;
    this.className = r;
  }
  connectedCallback() {
    super.connectedCallback(), this.hasAttribute("position") || this.setAttribute("position", this.position), this._applyLayoutClasses(), this.setAttribute("aria-live", "polite"), this.setAttribute("aria-atomic", "true"), this.setAttribute("role", "status");
  }
  updated(t) {
    super.updated(t), t.has("position") && (this.setAttribute("position", this.position), this._applyLayoutClasses());
  }
  render() {
    return f`<slot></slot>`;
  }
};
ro.styles = [
  ...b.styles,
  N`
      /* Very high z-index to ensure toasts appear above dialogs, modals, Storybook wrappers, and iframes */
      :host {
        position: fixed;
        z-index: 999999 !important;
      }

      /* Position variants - positioning requires CSS attribute selectors */
      :host([position='top-right']) {
        top: 16px;
        right: 16px;
      }

      :host([position='top-left']) {
        top: 16px;
        left: 16px;
      }

      :host([position='top-center']) {
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
      }

      :host([position='bottom-right']) {
        bottom: 16px;
        right: 16px;
      }

      :host([position='bottom-left']) {
        bottom: 16px;
        left: 16px;
      }

      :host([position='bottom-center']) {
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
      }

      /* Mobile: full width for top/bottom positions (640px and below) */
      @media (max-width: 640px) {
        :host([position^='top']) {
          top: 16px;
          left: 16px;
          right: 16px;
          width: calc(100vw - 32px);
          max-width: calc(100vw - 32px);
          transform: none;
        }

        :host([position^='bottom']) {
          bottom: 16px;
          left: 16px;
          right: 16px;
          width: calc(100vw - 32px);
          max-width: calc(100vw - 32px);
          transform: none;
        }
      }
    `
];
let xi = ro;
s0([
  u({ type: String })
], xi.prototype, "position");
customElements.get("ck-toaster") || customElements.define("ck-toaster", xi);
typeof window < "u" && (window.toast = pe);
export {
  p0 as ALL_ICONS_KEYS,
  ms as Badge,
  b as BaseComponent,
  gs as Breadcrumb,
  Mt as Button,
  St as Carousel,
  ce as CarouselIndicator,
  Te as CarouselItem,
  be as Checkbox,
  De as CkIcon,
  At as ColorPicker,
  ct as ColorPickerOption,
  es as Dialog,
  Iv as DialogActions,
  $s as DialogClose,
  ue as DialogContent,
  Cn as DialogDescription,
  kn as DialogTitle,
  Ts as DialogTrigger,
  Fs as Disclosure,
  Kr as DisclosureChevron,
  Dc as DisclosureContent,
  zc as DisclosureGroup,
  Ss as DisclosureTrigger,
  Mr as Divider,
  is as Drawer,
  Nv as DrawerActions,
  Cr as DrawerBleed,
  Os as DrawerClose,
  Me as DrawerContent,
  En as DrawerDescription,
  Uv as DrawerHeader,
  An as DrawerTitle,
  Is as DrawerTrigger,
  Ri as Dropdown,
  Bc as DropdownDivider,
  gv as DropdownEmpty,
  yn as DropdownHeading,
  Ks as DropdownItem,
  vv as DropdownItems,
  bn as DropdownSearchInput,
  Wc as DropdownSection,
  Cv as DropdownTrigger,
  xu as FormHelpText,
  Yt as Input,
  Or as InputGroup,
  Ir as InputPrefix,
  Vr as InputSuffix,
  Tp as Label,
  Ue as Modal,
  bs as ModalClose,
  Oe as ModalContent,
  Nr as ModalDescription,
  Br as ModalTitle,
  vs as ModalTrigger,
  Xt as Popover,
  xs as PopoverClose,
  $l as PopoverContent,
  Kf as PopoverEmpty,
  Tl as PopoverList,
  Pi as PopoverListItem,
  qr as PopoverSearchInput,
  Cs as PopoverTrigger,
  pi as ProductCard,
  Qi as ProductCardBody,
  Q as ProductCardFooter,
  nt as QuantityInput,
  ze as Radio,
  Ft as RadioCard,
  fu as RadioCardDescription,
  Wt as RadioCardGroup,
  gu as RadioCardTitle,
  bt as Rating,
  Fe as Select,
  Rr as SelectGroup,
  Hr as SelectPrefix,
  Dr as SelectSuffix,
  Na as Spinner,
  Lr as Switch,
  Qe as Tabs,
  wn as TabsItem,
  qc as TabsItems,
  xn as TabsPanel,
  Zc as TabsPanels,
  je as Textarea,
  xi as Toaster,
  H as cleanupClasses,
  g as cn,
  Mi as disclosureContext,
  Vl as disclosureGroupContext,
  gn as dropdownContext,
  o0 as extractLayoutClasses,
  a0 as filterProps,
  Ne as inputGroupContext,
  We as modalContext,
  $i as popoverContext,
  Zs as tabsContext,
  pe as toast
};
